/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 669:
/***/ (function(module) {

"use strict";
module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/* provided dependency */ var $ = __webpack_require__(669);
/* provided dependency */ var theme_dev_jQuery = __webpack_require__(669);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
* @license
* Pipeline Theme (c) Groupthought Themes
*
* This file is included for advanced development by
* Shopify Agencies.  Modified versions of the theme
* code are not supported by Shopify or Groupthought.
*
* In order to use this file you will need to change
* theme.js to theme.dev.js in /layout/theme.liquid
*
*/

(function (AOS, FlickityFade, bodyScrollLock, Flickity, Sqrl, MicroModal, axios, Rellax, themeCurrency, themeAddresses, FlickitySync) {
  'use strict';

  function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function get() {
              return e[k];
            }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }
  var Sqrl__namespace = /*#__PURE__*/_interopNamespaceDefault(Sqrl);

  // From https://developer.chrome.com/blog/using-requestidlecallback/#checking-for-requestidlecallback

  window.requestIdleCallback = window.requestIdleCallback || function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function timeRemaining() {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  };
  window.cancelIdleCallback = window.cancelIdleCallback || function (id) {
    clearTimeout(id);
  };
  function moveModals(container) {
    var modals = container.querySelectorAll('[data-modal]');
    var modalBin = document.querySelector('[data-modal-container]');
    modals.forEach(function (element) {
      var alreadyAdded = modalBin.querySelector("[id=\"".concat(element.id, "\"]"));
      if (!alreadyAdded) {
        modalBin.appendChild(element);
      }
    });
  }
  function floatLabels(container) {
    var floats = container.querySelectorAll('.float__wrapper');
    floats.forEach(function (element) {
      var label = element.querySelector('label');
      var input = element.querySelector('input, textarea');
      if (label) {
        input.addEventListener('keyup', function (event) {
          if (event.target.value !== '') {
            label.classList.add('label--float');
          } else {
            label.classList.remove('label--float');
          }
        });
      }
      if (input && input.value && input.value.length) {
        label.classList.add('label--float');
      }
    });
  }
  function errorTabIndex(container) {
    var errata = container.querySelectorAll('.errors');
    errata.forEach(function (element) {
      element.setAttribute('tabindex', '0');
      element.setAttribute('aria-live', 'assertive');
      element.setAttribute('role', 'alert');
    });
  }

  // Remove loading class from all already loaded images
  function removeLoadingClassFromLoadedImages(container) {
    container.querySelectorAll('img.loading-shimmer').forEach(function (el) {
      if (el.complete) {
        el.classList.remove('loading-shimmer');
      }
    });
  }

  // Remove loading class from image on `load` event
  function handleImageLoaded(el) {
    if (el.tagName == 'IMG' && el.classList.contains('loading-shimmer')) {
      el.classList.remove('loading-shimmer');
    }
  }
  function readHeights() {
    var h = {};
    h.windowHeight = window.innerHeight;
    h.announcementHeight = getHeight('#shopify-section-announcement');
    h.footerHeight = getHeight('[data-section-type*="footer"]');
    h.menuHeight = getHeight('[data-header-height]');
    h.headerHeight = h.menuHeight + h.announcementHeight;
    h.logoHeight = getFooterLogoWithPadding();
    h.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? h.menuHeight : 0;
    h.backfillHeight = getHeight('[data-header-backfill]');
    return h;
  }
  function setVarsOnResize() {
    document.addEventListener('theme:resize', resizeVars);
    setVars();
  }
  function setVars() {
    var _readHeights = readHeights(),
      windowHeight = _readHeights.windowHeight,
      announcementHeight = _readHeights.announcementHeight,
      headerHeight = _readHeights.headerHeight,
      logoHeight = _readHeights.logoHeight,
      menuHeight = _readHeights.menuHeight,
      footerHeight = _readHeights.footerHeight,
      stickyHeader = _readHeights.stickyHeader,
      backfillHeight = _readHeights.backfillHeight;
    document.documentElement.style.setProperty('--scrollbar-width', "".concat(getScrollbarWidth(), "px"));
    document.documentElement.style.setProperty('--footer-logo', "".concat(logoHeight, "px"));
    document.documentElement.style.setProperty('--full-screen', "".concat(windowHeight, "px"));
    document.documentElement.style.setProperty('--three-quarters', "".concat(windowHeight * 0.75, "px"));
    document.documentElement.style.setProperty('--two-thirds', "".concat(windowHeight * 0.66, "px"));
    document.documentElement.style.setProperty('--one-half', "".concat(windowHeight * 0.5, "px"));
    document.documentElement.style.setProperty('--one-third', "".concat(windowHeight * 0.33, "px"));
    document.documentElement.style.setProperty('--one-fifth', "".concat(windowHeight * 0.2, "px"));
    document.documentElement.style.setProperty('--menu-height', "".concat(menuHeight, "px"));
    document.documentElement.style.setProperty('--announcement-height', "".concat(announcementHeight, "px"));
    document.documentElement.style.setProperty('--header-height', "".concat(headerHeight, "px"));
    document.documentElement.style.setProperty('--footer-height', "".concat(footerHeight, "px"));
    document.documentElement.style.setProperty('--content-full', "".concat(windowHeight - headerHeight - logoHeight / 2, "px"));
    document.documentElement.style.setProperty('--menu-height-sticky', "".concat(stickyHeader, "px"));

    // if backfill estimation is within 1px rounded, don't force a layout shift
    var newBackfill = Math.abs(backfillHeight - menuHeight) > 1 ? "".concat(menuHeight, "px") : 'auto';
    document.documentElement.style.setProperty('--menu-backfill-height', newBackfill);
  }
  function resizeVars() {
    // restrict the heights that are changed on resize to avoid iOS jump when URL bar is shown and hidden
    var _readHeights2 = readHeights(),
      windowHeight = _readHeights2.windowHeight,
      announcementHeight = _readHeights2.announcementHeight,
      headerHeight = _readHeights2.headerHeight,
      logoHeight = _readHeights2.logoHeight,
      menuHeight = _readHeights2.menuHeight,
      footerHeight = _readHeights2.footerHeight,
      stickyHeader = _readHeights2.stickyHeader,
      backfillHeight = _readHeights2.backfillHeight;
    document.documentElement.style.setProperty('--scrollbar-width', "".concat(getScrollbarWidth(), "px"));
    document.documentElement.style.setProperty('--full-screen', "".concat(windowHeight, "px"));
    document.documentElement.style.setProperty('--menu-height', "".concat(menuHeight, "px"));
    document.documentElement.style.setProperty('--announcement-height', "".concat(announcementHeight, "px"));
    document.documentElement.style.setProperty('--header-height', "".concat(headerHeight, "px"));
    document.documentElement.style.setProperty('--footer-height', "".concat(footerHeight, "px"));
    document.documentElement.style.setProperty('--content-full', "".concat(windowHeight - headerHeight - logoHeight / 2, "px"));
    document.documentElement.style.setProperty('--menu-height-sticky', "".concat(stickyHeader, "px"));

    // if backfill estimation is within 1px rounded, don't force a layout shift
    var newBackfill = Math.abs(backfillHeight - menuHeight) > 1 ? "".concat(menuHeight, "px") : 'auto';
    document.documentElement.style.setProperty('--menu-backfill-height', newBackfill);
  }
  function getHeight(selector) {
    var el = document.querySelector(selector);
    if (el) {
      return el.clientHeight;
    } else {
      return 0;
    }
  }
  function getFooterLogoWithPadding() {
    var height = getHeight('[data-footer-logo]');
    if (height > 0) {
      return height + 20;
    } else {
      return 0;
    }
  }
  function getScrollbarWidth() {
    // Creating invisible container
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    var inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    var scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }
  function singles(frame, wrappers) {
    // sets the height of any frame passed in with the
    // tallest js-overflow-content as well as any image in that frame
    var padding = 64;
    var tallest = 0;
    wrappers.forEach(function (wrap) {
      if (wrap.offsetHeight > tallest) {
        var getMarginTop = parseInt(window.getComputedStyle(wrap).marginTop);
        var getMarginBottom = parseInt(window.getComputedStyle(wrap).marginBottom);
        var getMargin = getMarginTop + getMarginBottom;
        if (getMargin > padding) {
          padding = getMargin;
        }
        tallest = wrap.offsetHeight;
      }
    });
    var images = frame.querySelectorAll('[data-overflow-background]');
    var frames = [frame].concat(_toConsumableArray(images));
    frames.forEach(function (el) {
      el.style.setProperty('min-height', "calc(".concat(tallest + padding, "px + var(--menu-height))"));
    });
  }
  function doubles(section) {
    var footerLogoH = document.querySelector('[data-footer-logo]') ? document.querySelector('[data-footer-logo]').clientHeight + 20 : 0;
    var lastSection = document.querySelector('#MainContent .shopify-section:last-child [data-section-id]');
    var lastSectionAttrID = lastSection ? lastSection.getAttribute('data-section-id') : null;
    if (lastSectionAttrID !== null && section.getAttribute('data-section-id') !== lastSectionAttrID || !lastSection) {
      footerLogoH = 0;
    }
    if (window.innerWidth < window.theme.sizes.medium) {
      // if we are below the small breakpoint, the double section acts like two independent
      // single frames
      var singleFrames = section.querySelectorAll('[data-overflow-frame]');
      singleFrames.forEach(function (singleframe) {
        var wrappers = singleframe.querySelectorAll('[data-overflow-content]');
        singles(singleframe, wrappers);
      });
      return;
    }

    // Javascript can't execute calc() (from `--outer` variable) - create a new div with width property instead `getPropertyValue('--outer')`
    var htmlObject = document.createElement('div');
    section.prepend(htmlObject);
    htmlObject.style.display = 'none';
    htmlObject.style.width = getComputedStyle(section).getPropertyValue('--outer');
    var padding = parseInt(getComputedStyle(htmlObject).getPropertyValue('width')) * 2;
    section.firstChild.remove();
    var tallest = 0;
    var frames = section.querySelectorAll('[data-overflow-frame]');
    var contentWrappers = section.querySelectorAll('[data-overflow-content]');
    contentWrappers.forEach(function (content) {
      if (content.offsetHeight > tallest) {
        tallest = content.offsetHeight;
      }
    });
    var images = section.querySelectorAll('[data-overflow-background]');
    var applySizes = [].concat(_toConsumableArray(frames), _toConsumableArray(images));
    applySizes.forEach(function (el) {
      el.style.setProperty('min-height', "".concat(tallest + padding, "px"));
    });
    section.style.setProperty('min-height', "".concat(tallest + padding + 2 + footerLogoH, "px"));
  }
  function preventOverflow(container) {
    var singleFrames = container.querySelectorAll('.js-overflow-container');
    if (singleFrames) {
      singleFrames.forEach(function (frame) {
        var wrappers = frame.querySelectorAll('.js-overflow-content');
        singles(frame, wrappers);
        document.addEventListener('theme:resize', function () {
          singles(frame, wrappers);
        });
      });

      // Reload slides if container has slideshow
      var slideshows = container.querySelectorAll('[data-slideshow-wrapper]');
      if (slideshows.length) {
        slideshows.forEach(function (slideshow) {
          var slideshowInstance = FlickityFade.data(slideshow);
          if (typeof slideshowInstance !== 'undefined') {
            slideshowInstance.reloadCells();
          }
        });
      }
    }
    var doubleSections = container.querySelectorAll('[data-overflow-wrapper]');
    if (doubleSections) {
      doubleSections.forEach(function (section) {
        doubles(section);
        document.addEventListener('theme:resize', function () {
          doubles(section);
        });
      });
    }
  }

  // Adapted from https://github.com/component/debounce/blob/master/index.js
  /**
   * Returns a function, that, as long as it continues to be invoked, will not
   * be triggered. The function will be called after it stops being called for
   * N milliseconds. If `immediate` is passed, trigger the function on the
   * leading edge, instead of the trailing. The function also has a property 'clear'
   * that is a function which will clear the timer to prevent previously scheduled executions.
   *
   * @source underscore.js
   * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
   * @param {Function} function to wrap
   * @param {Number} timeout in ms (`100`)
   * @param {Boolean} whether to execute at the beginning (`false`)
   * @api public
   */

  function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var timeout, args, context, timestamp, result;
    if (wait == null) wait = 100;
    function later() {
      var last = Date.now() - timestamp;
      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    }
    var debounced = function debounced() {
      context = this;
      args = arguments;
      timestamp = Date.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }
      return result;
    };
    debounced.clear = function () {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };
    debounced.flush = function () {
      if (timeout) {
        result = func.apply(context, args);
        context = args = null;
        clearTimeout(timeout);
        timeout = null;
      }
    };
    return debounced;
  }
  var lastWindowWidth = window.innerWidth;
  var lastWindowHeight = window.innerHeight;
  function dispatch$1() {
    document.dispatchEvent(new CustomEvent('theme:resize', {
      bubbles: true
    }));
    if (lastWindowWidth !== window.innerWidth) {
      document.dispatchEvent(new CustomEvent('theme:resize:width', {
        bubbles: true
      }));
      lastWindowWidth = window.innerWidth;
    }
    if (lastWindowHeight !== window.innerHeight) {
      document.dispatchEvent(new CustomEvent('theme:resize:height', {
        bubbles: true
      }));
      lastWindowHeight = window.innerHeight;
    }
  }
  var raf$1;
  function resizeListener() {
    window.addEventListener('resize', function () {
      if (raf$1) {
        window.cancelAnimationFrame(raf$1);
      }
      raf$1 = window.requestAnimationFrame(debounce(dispatch$1, 50));
    });
  }
  var prev = window.pageYOffset;
  var up = null;
  var down = null;
  var wasUp = null;
  var wasDown = null;
  var scrollLockTimeout = 0;
  function dispatch() {
    var position = window.pageYOffset;
    if (position > prev) {
      down = true;
      up = false;
    } else if (position < prev) {
      down = false;
      up = true;
    } else {
      up = null;
      down = null;
    }
    prev = position;
    document.dispatchEvent(new CustomEvent('theme:scroll', {
      detail: {
        up: up,
        down: down,
        position: position
      },
      bubbles: false
    }));
    if (up && !wasUp) {
      document.dispatchEvent(new CustomEvent('theme:scroll:up', {
        detail: {
          position: position
        },
        bubbles: false
      }));
    }
    if (down && !wasDown) {
      document.dispatchEvent(new CustomEvent('theme:scroll:down', {
        detail: {
          position: position
        },
        bubbles: false
      }));
    }
    wasDown = down;
    wasUp = up;
  }
  function lock(e) {
    var element = e.target;
    if (e.detail && e.detail instanceof Element) {
      element = e.detail;
    }
    bodyScrollLock.disableBodyScroll(element);
    document.documentElement.setAttribute('data-scroll-locked', '');
  }
  function unlock() {
    // Prevent body scroll lock race conditions
    scrollLockTimeout = setTimeout(function () {
      document.body.removeAttribute('data-drawer-closing');
    }, 20);
    if (document.body.hasAttribute('data-drawer-closing')) {
      document.body.removeAttribute('data-drawer-closing');
      if (scrollLockTimeout) {
        clearTimeout(scrollLockTimeout);
      }
      return;
    } else {
      document.body.setAttribute('data-drawer-closing', '');
    }
    document.documentElement.removeAttribute('data-scroll-locked');
    bodyScrollLock.clearAllBodyScrollLocks();
  }
  var raf;
  function scrollListener() {
    window.addEventListener('scroll', function () {
      if (raf) {
        window.cancelAnimationFrame(raf);
      }
      raf = window.requestAnimationFrame(dispatch);
    }, {
      passive: true
    });
    window.addEventListener('theme:scroll:lock', lock);
    window.addEventListener('theme:scroll:unlock', unlock);
  }
  resizeListener();
  scrollListener();

  // Watch for any load events that bubble up from child elements
  document.addEventListener('load', function (e) {
    var el = e.target;

    // Capture load events from img tags and then remove their `loading-shimmer` class
    handleImageLoaded(el);
  }, true);

  // Tasks to run when the DOM elements are available
  window.addEventListener('DOMContentLoaded', function () {
    setVarsOnResize();
    floatLabels(document);
    errorTabIndex(document);
    moveModals(document);
    if (window.theme.settings.animate_scroll) {
      AOS.refresh();
    }
  });

  // Tasks to run when entire page has finished loading including images, stylesheets, async scripts, etc
  window.addEventListener('load', function () {
    // Catch any images that loaded before our load event listener above and remove "loading-shimmer" class
    removeLoadingClassFromLoadedImages(document);
    // Fix any text overflow in position:absolute elements
    // preventOverflow(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target;
    floatLabels(container);
    errorTabIndex(container);
    moveModals(container);
    // preventOverflow(container);
    if (window.theme.settings.animate_scroll) {
      AOS.refresh();
    }
  });
  document.addEventListener('shopify:section:reorder', function () {
    document.dispatchEvent(new CustomEvent('theme:header:check', {
      bubbles: false
    }));
  });
  var showElement = function showElement(elem) {
    var removeProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'block';
    if (elem) {
      if (removeProp) {
        elem.style.removeProperty('display');
      } else {
        elem.style.display = prop;
      }
    }
  };
  function FetchError(object) {
    this.status = object.status || null;
    this.headers = object.headers || null;
    this.json = object.json || null;
    this.body = object.body || null;
  }
  FetchError.prototype = Error.prototype;
  var selectors$14 = {
    scrollbar: 'data-scrollbar-slider',
    scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
    scrollbarArrowNext: '[data-scrollbar-arrow-next]'
  };
  var classes$G = {
    hidden: 'is-hidden'
  };
  var times$3 = {
    delay: 200
  };
  var NativeScrollbar = /*#__PURE__*/function () {
    /**
     * @param {HTMLElement} scrollbar
     * @param {AbortSignal} [signal] when supplied, listeners this instance registers on
     *   long-lived targets (document) are torn down as soon as the signal aborts.
     *
     *   Without it, resize() below registers a `theme:resize` listener that is never
     *   removed. That matters because refreshFunctionalities() re-runs Siblings on every
     *   filter response, constructing one NativeScrollbar per sibling row — up to 50 per
     *   filter click, each closure pinning a detached DOM node forever.
     *   Optional, so the other call sites (:1806, :11169) are unaffected.
     */
    function NativeScrollbar(scrollbar, signal) {
      _classCallCheck(this, NativeScrollbar);
      this.scrollbar = scrollbar;
      this.signal = signal;
      this.arrowNext = this.scrollbar.parentNode.querySelector(selectors$14.scrollbarArrowNext);
      this.arrowPrev = this.scrollbar.parentNode.querySelector(selectors$14.scrollbarArrowPrev);
      this.init();
      this.resize();
      if (this.scrollbar.hasAttribute(selectors$14.scrollbar)) {
        this.scrollToVisibleElement();
      }
    }
    return _createClass(NativeScrollbar, [{
      key: "init",
      value: function init() {
        if (this.arrowNext && this.arrowPrev) {
          if (window.isRTL) {
            this.togglePrevArrow();
          } else {
            this.toggleNextArrow();
          }
          this.events();
        }
      }
    }, {
      key: "resize",
      value: function resize() {
        var _this = this;
        // `signal` (when passed) is what stops this listener outliving its element.
        // Omitting the option entirely when there is no signal keeps behaviour identical
        // for the call sites that do not pass one.
        document.addEventListener('theme:resize', function () {
          if (window.isRTL) {
            _this.togglePrevArrow();
          } else {
            _this.toggleNextArrow();
          }
        }, this.signal ? {
          signal: this.signal
        } : undefined);
      }
    }, {
      key: "events",
      value: function events() {
        var _this2 = this;
        this.arrowNext.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.goToNext();
        });
        this.arrowPrev.addEventListener('click', function (event) {
          event.preventDefault();
          _this2.goToPrev();
        });
        this.scrollbar.addEventListener('scroll', function () {
          _this2.togglePrevArrow();
          _this2.toggleNextArrow();
        });
      }
    }, {
      key: "goToNext",
      value: function goToNext() {
        var position = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
        this.move(position);
        this.arrowPrev.classList.remove(classes$G.hidden);
        this.toggleNextArrow();
      }
    }, {
      key: "goToPrev",
      value: function goToPrev() {
        var position = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
        this.move(position);
        this.arrowNext.classList.remove(classes$G.hidden);
        this.togglePrevArrow();
      }
    }, {
      key: "toggleNextArrow",
      value: function toggleNextArrow() {
        var _this3 = this;
        setTimeout(function () {
          if (window.isRTL) {
            _this3.arrowNext.classList.toggle(classes$G.hidden, _this3.scrollbar.scrollLeft === 0);
          } else {
            _this3.arrowNext.classList.toggle(classes$G.hidden, Math.round(_this3.scrollbar.scrollLeft + _this3.scrollbar.getBoundingClientRect().width + 1) >= _this3.scrollbar.scrollWidth);
          }
        }, times$3.delay);
      }
    }, {
      key: "togglePrevArrow",
      value: function togglePrevArrow() {
        var _this4 = this;
        setTimeout(function () {
          if (window.isRTL) {
            _this4.arrowPrev.classList.toggle(classes$G.hidden, Math.abs(_this4.scrollbar.scrollLeft) + _this4.scrollbar.getBoundingClientRect().width + 1 >= _this4.scrollbar.scrollWidth);
          } else {
            _this4.arrowPrev.classList.toggle(classes$G.hidden, _this4.scrollbar.scrollLeft <= 0);
          }
        }, times$3.delay);
      }
    }, {
      key: "scrollToVisibleElement",
      value: function scrollToVisibleElement() {
        var _this5 = this;
        [].forEach.call(this.scrollbar.children, function (element) {
          element.addEventListener('click', function (event) {
            if (event.target.tagName.toLowerCase() === 'a' || event.currentTarget && event.currentTarget.tagName.toLowerCase() === 'a' || event.currentTarget && event.currentTarget.querySelector('a')) {
              event.preventDefault();
            }
            _this5.move(element.offsetLeft - element.clientWidth);
          });
        });
      }
    }, {
      key: "move",
      value: function move(offsetLeft) {
        this.scrollbar.scrollTo({
          top: 0,
          left: offsetLeft,
          behavior: 'smooth'
        });
      }
    }]);
  }();
  var selectors$13 = {
    siblingsInnerHolder: '[data-sibling-inner]'
  };
  var Siblings = /*#__PURE__*/function () {
    function Siblings(holder) {
      _classCallCheck(this, Siblings);
      this.holder = holder;
      this.siblings = holder.querySelectorAll(selectors$13.siblingsInnerHolder);
      this.init();
    }
    return _createClass(Siblings, [{
      key: "init",
      value: function init() {
        // Every filter response replaces the grid wholesale and re-runs this via
        // refreshFunctionalities(). The old DOM is garbage, but each NativeScrollbar's
        // `theme:resize` listener stays registered on `document` and pins its detached
        // element — roughly 50 leaked per filter click.
        //
        // Scoped to THIS holder rather than a module-level controller on purpose:
        // Siblings is constructed from five separate sections (:756, :924, :2180, :8202,
        // :9275), and a shared controller would let one section tear down another's arrows.
        if (this.holder.siblingsScrollbarAbort) {
          this.holder.siblingsScrollbarAbort.abort();
        }
        this.holder.siblingsScrollbarAbort = new AbortController();
        var signal = this.holder.siblingsScrollbarAbort.signal;
        this.siblings.forEach(function (sibling) {
          new NativeScrollbar(sibling, signal);
        });
      }
    }]);
  }();
  var siblings = {
    onLoad: function onLoad() {
      new Siblings(this.container);
    }
  };

  // Collection swatch rows are injected on hover by src/js/components/swatch-hover.js
  // rather than server-rendered, because rendering them for all 50 cards cost ~64% of
  // every filter interaction while CSS hid them at opacity:0 until hover.
  //
  // They contain a native scrollbar and prev/next arrows, which are NOT custom elements
  // and therefore do not self-upgrade on innerHTML insertion. Siblings/NativeScrollbar
  // are module-scoped here and unreachable from src/js, so the injecting code announces
  // itself and we do the wiring on this side.
  document.addEventListener('theme:swatches:loaded', function (event) {
    if (!event.detail || !event.detail.container) return;
    var container = event.detail.container;

    // Native scrollbar + prev/next arrows.
    new Siblings(container);

    // Swatch click -> swap the visible product-grid-item-content and price. Those
    // links are bound by ProductGridItem, which captures them when it connects —
    // i.e. before these ones exist. Re-bind now. bindVariantLinks() is idempotent.
    var card = container.closest('product-grid-item');
    if (card && typeof card.bindVariantLinks === 'function') {
      card.bindVariantLinks();
    }
  });
  var cookieDefaultValues = {
    expires: 7,
    path: '/',
    domain: window.location.hostname
  };
  var Cookies = /*#__PURE__*/function () {
    function Cookies() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, Cookies);
      this.options = _objectSpread(_objectSpread({}, cookieDefaultValues), options);
    }

    /**
     * Write cookie
     * @param value - String
     */
    return _createClass(Cookies, [{
      key: "write",
      value: function write(value) {
        document.cookie = "".concat(this.options.name, "=").concat(value, "; expires=").concat(this.options.expires, "; path=").concat(this.options.path, "; domain=").concat(this.options.domain);
      }

      /**
       * Read cookies and returns an array of values
       * @returns Array
       */
    }, {
      key: "read",
      value: function read() {
        var _this6 = this;
        var cookieValuesArr = [];
        var hasCookieWithThisName = document.cookie.split('; ').find(function (row) {
          return row.startsWith(_this6.options.name);
        });
        if (document.cookie.indexOf('; ') !== -1 && hasCookieWithThisName) {
          var cookieValue = document.cookie.split('; ').find(function (row) {
            return row.startsWith(_this6.options.name);
          }).split('=')[1];
          if (cookieValue !== null) {
            cookieValuesArr = cookieValue.split(',');
          }
        }
        return cookieValuesArr;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        document.cookie = "".concat(this.options.name, "=null; expires=").concat(this.options.expires, "; path=").concat(this.options.path, "; domain=").concat(this.options.domain);
      }
    }, {
      key: "remove",
      value: function remove(removedValue) {
        var cookieValue = this.read();
        var position = cookieValue.indexOf(removedValue);
        if (position !== -1) {
          cookieValue.splice(position, 1);
          this.write(cookieValue);
        }
      }
    }]);
  }();
  var config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    wrapper: '[data-recently-viewed-products]',
    limit: 'data-limit',
    recentTabLink: '[data-recent-link-tab]',
    recentWrapper: '[data-recent-wrapper]',
    recentViewedTab: '[data-recently-viewed-tab]',
    tabsHolderScroll: '[data-tabs-holder-scroll]',
    apiContent: '[data-api-content]',
    dataMinimum: 'data-minimum'
  };
  var classes$F = {
    hide: 'hide',
    containerWithoutTabsNav: 'section-without-title--skip'
  };
  var cookieConfig = {
    expires: 90,
    name: 'shopify_recently_viewed'
  };
  var sections$q = [];
  var excludedHandles = [];
  var RecentProducts = /*#__PURE__*/function () {
    function RecentProducts(section) {
      _classCallCheck(this, RecentProducts);
      this.container = section.container;
      this.cookie = new Cookies(cookieConfig);
      this.wrapper = this.container.querySelector(config.wrapper);
      if (this.wrapper === null) {
        return;
      }
      this.howManyToShow = parseInt(this.container.querySelector(config.recentWrapper).getAttribute(config.limit)) || config.howManyToShow;
      this.minimum = parseInt(this.container.querySelector(config.recentWrapper).getAttribute(config.dataMinimum));
      this.recentViewedTab = this.container.querySelector(config.recentViewedTab);
      this.recentViewedLink = this.container.querySelector(config.recentTabLink);
      this.tabsHolderScroll = this.container.querySelector(config.tabsHolderScroll);
      this.renderProducts();
    }
    return _createClass(RecentProducts, [{
      key: "renderProducts",
      value: function renderProducts() {
        var _this7 = this;
        var recentlyViewedHandlesArray = this.cookie.read();
        var arrayURLs = [];
        var counter = 0;
        if (recentlyViewedHandlesArray.length > 0) {
          for (var index = 0; index < recentlyViewedHandlesArray.length; index++) {
            var handle = recentlyViewedHandlesArray[index];
            if (excludedHandles.includes(handle)) {
              continue;
            }
            var url = "".concat(window.theme.routes.root_url, "products/").concat(handle, "?section_id=api-product-grid-item");
            arrayURLs.push(url);
            counter++;
            if (counter === this.howManyToShow || counter === recentlyViewedHandlesArray.length - 1) {
              break;
            }
          }
          if (arrayURLs.length > 0 && arrayURLs.length >= this.minimum) {
            this.container.classList.remove(classes$F.hide);
            if (this.recentViewedLink && this.recentViewedLink.previousElementSibling) {
              this.tabsHolderScroll.classList.remove(classes$F.hide);
              this.container.classList.add(classes$F.containerWithoutTabsNav);
            }
            var fecthRequests = arrayURLs.map(function (url) {
              return fetch(url, {
                mode: 'no-cors'
              }).then(_this7.handleErrors);
            });
            var productMarkups = [];
            Promise.allSettled(fecthRequests).then(function (responses) {
              return Promise.all(responses.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
                  var _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        if (!(response.status === 'fulfilled')) {
                          _context.n = 2;
                          break;
                        }
                        _t = productMarkups;
                        _context.n = 1;
                        return response.value.text();
                      case 1:
                        _t.push.call(_t, _context.v);
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            }).then(function () {
              productMarkups.forEach(function (markup) {
                var buffer = document.createElement('div');
                var slide = document.createElement('div');
                buffer.innerHTML = markup;
                slide.classList.add('product-grid-slide');
                slide.setAttribute('data-carousel-slide', null);
                slide.setAttribute('data-item', null);
                slide.innerHTML = buffer.querySelector(config.apiContent).innerHTML;
                _this7.wrapper.appendChild(slide);
              });
              new Siblings(_this7.container);
            }).then(function () {
              showElement(_this7.wrapper, true);
              _this7.container.dispatchEvent(new CustomEvent('theme:recent-products:added', {
                bubbles: true
              }));
            });
          } else if (this.recentViewedTab) {
            var hasSiblingTabs = Array.prototype.filter.call(this.recentViewedTab.parentNode.children, function (child) {
              return child !== _this7.recentViewedTab;
            }).length > 1;
            if (this.recentViewedLink && this.recentViewedLink.previousElementSibling) {
              this.tabsHolderScroll.classList.add(classes$F.hide);
              this.container.classList.remove(classes$F.containerWithoutTabsNav);
            }
            if (!hasSiblingTabs) {
              this.container.classList.add(classes$F.hide);
            }
          } else {
            this.container.classList.add(classes$F.hide);
          }
        }
      }
    }, {
      key: "handleErrors",
      value: function handleErrors(response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            var e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              text: text
            });
            throw e;
          });
        }
        return response;
      }
    }]);
  }();
  var RecordRecentlyViewed = /*#__PURE__*/function () {
    function RecordRecentlyViewed(handle) {
      _classCallCheck(this, RecordRecentlyViewed);
      this.handle = handle;
      this.cookie = new Cookies(cookieConfig);
      if (typeof this.handle === 'undefined') {
        return;
      }
      excludedHandles.push(this.handle);
      this.updateCookie();
    }
    return _createClass(RecordRecentlyViewed, [{
      key: "updateCookie",
      value: function updateCookie() {
        var recentlyViewed = this.cookie.read();

        // In what position is that product in memory.
        var position = recentlyViewed.indexOf(this.handle);

        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(this.handle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(this.handle);
        }

        // Update cookie.
        this.cookie.write(recentlyViewed);
      }
    }]);
  }();
  var recentProducts = {
    onLoad: function onLoad() {
      sections$q[this.id] = new RecentProducts(this);
    }
  };

  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * https://github.com/Shopify/slate.git.
   *
   */

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (typeof src === 'undefined' || src === null) {
      src = window.theme.assets.noImage;
    }
    if (size === 'master') {
      return removeProtocol(src);
    }
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return removeProtocol("".concat(prefix[0], "_").concat(size).concat(suffix));
    } else {
      return null;
    }
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }
  function Listeners() {
    this.entries = [];
  }
  Listeners.prototype.add = function (element, event, fn) {
    this.entries.push({
      element: element,
      event: event,
      fn: fn
    });
    element.addEventListener(event, fn);
  };
  Listeners.prototype.removeAll = function () {
    this.entries = this.entries.filter(function (listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  /**
   * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
   * @param {Object} product Product JSON object
   * @param {Number} value Accepts Number (e.g. 6908023078973)
   * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
   */

  /**
   * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
   * @param {Object} product Product JSON object
   * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
   * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
   */
  function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);

    // If value is an array of options
    var optionArray = _createOptionArrayFromOptionCollection(product, collection);
    return getVariantFromOptionArray(product, optionArray);
  }

  /**
   * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
   * @param {Object} product Product JSON object
   * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
   * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
   */
  function getVariantFromOptionArray(product, options) {
    _validateProductStructure(product);
    _validateOptionsArray(options);
    var result = product.variants.filter(function (variant) {
      return options.every(function (option, index) {
        return variant.options[index] === option;
      });
    });
    return result[0] || null;
  }

  /**
   * Creates an array of selected options from the object
   * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
   * @param {Object} product Product JSON object
   * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
   * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
   */
  function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product);
    _validateSerializedArray(collection);
    var optionArray = [];
    collection.forEach(function (option) {
      for (var i = 0; i < product.options.length; i++) {
        var name = product.options[i].name || product.options[i];
        if (name.toLowerCase() === option.name.toLowerCase()) {
          optionArray[i] = option.value;
          break;
        }
      }
    });
    return optionArray;
  }

  /**
   * Check if the product data is a valid JS object
   * Error will be thrown if type is invalid
   * @param {object} product Product JSON object
   */
  function _validateProductStructure(product) {
    if (_typeof(product) !== 'object') {
      throw new TypeError(product + ' is not an object.');
    }
    if (Object.keys(product).length === 0 && product.constructor === Object) {
      throw new Error(product + ' is empty.');
    }
  }

  /**
   * Validate the structure of the array
   * It must be formatted like jQuery's serializeArray()
   * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
   */
  function _validateSerializedArray(collection) {
    if (!Array.isArray(collection)) {
      throw new TypeError(collection + ' is not an array.');
    }
    if (collection.length === 0) {
      throw new Error(collection + ' is empty.');
    }
    if (collection[0].hasOwnProperty('name')) {
      if (typeof collection[0].name !== 'string') {
        throw new TypeError('Invalid value type passed for name of option ' + collection[0].name + '. Value should be string.');
      }
    } else {
      throw new Error(collection[0] + 'does not contain name key.');
    }
  }

  /**
   * Validate the structure of the array
   * It must be formatted as list of values
   * @param {Array} collection Array of object (e.g. ['36', 'Black'])
   */
  function _validateOptionsArray(options) {
    if (Array.isArray(options) && _typeof(options[0]) === 'object') {
      throw new Error(options + 'is not a valid array of options.');
    }
  }
  var selectors$12 = {
    idInput: '[name="id"]',
    planInput: '[name="selling_plan"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]'
  };

  /**
   * Constructor class that creates a new instance of a product form controller.
   *
   * @param {Element} element - the outer wrapper containing the product form and all related input elements
   * @param {Object} form - DOM element which is equal to the <form> node to submit the product form inputs
   * @param {Object} product - A product object
   * @param {Object} options - Optional options object
   * @param {Function} options.onOptionChange - Callback for whenever an option input changes
   * @param {Function} options.onPlanChange - Callback for changes to name=selling_plan
   * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
   * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
   * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
   */
  var ProductFormReader = /*#__PURE__*/function () {
    function ProductFormReader(element, form, product, options) {
      _classCallCheck(this, ProductFormReader);
      this.element = element;
      this.form = form.tagName == 'FORM' ? form : form.querySelector('form');
      this.product = this._validateProductObject(product);
      this.variantElement = this.form.querySelector(selectors$12.idInput);
      options = options || {};
      this.clickedElement = null;
      this._listeners = new Listeners();
      this._listeners.add(this.element, 'submit', this._onSubmit.bind(this, options));
      this.optionInputs = this._initInputs(selectors$12.optionInput, options.onOptionChange);
      this.planInputs = this._initInputs(selectors$12.planInput, options.onPlanChange);
      this.quantityInputs = this._initInputs(selectors$12.quantityInput, options.onQuantityChange);
      this.propertyInputs = this._initInputs(selectors$12.propertyInput, options.onPropertyChange);
    }

    /**
     * Cleans up all event handlers that were assigned when the Product Form was constructed.
     * Useful for use when a section needs to be reloaded in the theme editor.
     */
    return _createClass(ProductFormReader, [{
      key: "destroy",
      value: function destroy() {
        this._listeners.removeAll();
      }

      /**
       * Getter method which returns the array of currently selected option values
       *
       * @returns {Array} An array of option values
       */
    }, {
      key: "options",
      value: function options() {
        return this._serializeInputValues(this.optionInputs, function (item) {
          var regex = /(?:^(options\[))(.*?)(?:\])/;
          item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
          return item;
        });
      }

      /**
       * Getter method which returns the currently selected variant, or `null` if variant
       * doesn't exist.
       *
       * @returns {Object|null} Variant object
       */
    }, {
      key: "variant",
      value: function variant() {
        var opts = this.options();
        if (opts.length) {
          return getVariantFromSerializedArray(this.product, opts);
        } else {
          return this.product.variants[0];
        }
      }

      /**
       * Getter method which returns the current selling plan, or `null` if plan
       * doesn't exist.
       *
       * @returns {Object|null} Variant object
       */
    }, {
      key: "plan",
      value: function plan(variant) {
        var _this8 = this;
        var plan = {
          allocation: null,
          group: null,
          detail: null
        };
        var formData = new FormData(this.form);
        var id = formData.get('selling_plan');
        if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
          var uniqueVariantSellingPlanGroupIDs = _toConsumableArray(new Set(variant.selling_plan_allocations.map(function (sellingPlan) {
            return sellingPlan.selling_plan_group_id;
          })));
          var productSubsGroup = this.element.querySelectorAll('[data-subscription-group]');
          if (!productSubsGroup.length) {
            return;
          }
          productSubsGroup.forEach(function (group) {
            return group.style.display = "none";
          });
          uniqueVariantSellingPlanGroupIDs.forEach(function (groupId) {
            _this8.element.querySelector("[data-selling-plan-group=\"".concat(groupId, "\"]")).style.display = "block";
          });
        }
        if (id && variant) {
          plan.allocation = variant.selling_plan_allocations.find(function (item) {
            return item.selling_plan_id.toString() === id.toString();
          });
        }
        if (plan.allocation) {
          plan.group = this.product.selling_plan_groups.find(function (item) {
            return item.id.toString() === plan.allocation.selling_plan_group_id.toString();
          });
        }
        if (plan.group) {
          plan.detail = plan.group.selling_plans.find(function (item) {
            return item.id.toString() === id.toString();
          });
        }
        if (plan && plan.allocation && plan.detail && plan.allocation) {
          return plan;
        } else return null;
      }

      /**
       * Getter method which returns a collection of objects containing name and values
       * of property inputs
       *
       * @returns {Array} Collection of objects with name and value keys
       */
    }, {
      key: "properties",
      value: function properties() {
        return this._serializeInputValues(this.propertyInputs, function (item) {
          var regex = /(?:^(properties\[))(.*?)(?:\])/;
          item.name = regex.exec(item.name)[2]; // Use just the value between 'properties[' and ']'
          return item;
        });
      }

      /**
       * Getter method which returns the current quantity or 1 if no quantity input is
       * included in the form
       *
       * @returns {Array} Collection of objects with name and value keys
       */
    }, {
      key: "quantity",
      value: function quantity() {
        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
      }
    }, {
      key: "getFormState",
      value: function getFormState() {
        var variant = this.variant();
        return {
          options: this.options(),
          variant: variant,
          properties: this.properties(),
          quantity: this.quantity(),
          plan: this.plan(variant)
        };
      }

      // Private Methods
      // -----------------------------------------------------------------------------
    }, {
      key: "_setIdInputValue",
      value: function _setIdInputValue(variant) {
        if (variant && variant.id) {
          this.variantElement.value = variant.id.toString();
        } else {
          this.variantElement.value = '';
        }
        this.variantElement.dispatchEvent(new Event('change'));
      }
    }, {
      key: "_onSubmit",
      value: function _onSubmit(options, event) {
        event.dataset = this.getFormState();
        if (options.onFormSubmit) {
          options.onFormSubmit(event);
        }
      }
    }, {
      key: "_onOptionChange",
      value: function _onOptionChange(event) {
        this._setIdInputValue(event.dataset.variant);
      }
    }, {
      key: "_onFormEvent",
      value: function _onFormEvent(cb) {
        if (typeof cb === 'undefined') {
          return Function.prototype;
        }
        return function (event) {
          event.dataset = this.getFormState();
          this._setIdInputValue(event.dataset.variant);
          cb(event);
        }.bind(this);
      }
    }, {
      key: "_initInputs",
      value: function _initInputs(selector, cb) {
        var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
        return elements.map(function (element) {
          this._listeners.add(element, 'change', this._onFormEvent(cb));
          return element;
        }.bind(this));
      }
    }, {
      key: "_serializeInputValues",
      value: function _serializeInputValues(inputs, transform) {
        return inputs.reduce(function (options, input) {
          if (input.checked ||
          // If input is a checked (means type radio or checkbox)
          input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
          ) {
            options.push(transform({
              name: input.name,
              value: input.value
            }));
          }
          return options;
        }, []);
      }
    }, {
      key: "_validateProductObject",
      value: function _validateProductObject(product) {
        if (_typeof(product) !== 'object') {
          throw new TypeError(product + ' is not an object.');
        }
        if (typeof product.variants[0].options === 'undefined') {
          throw new TypeError('Product object is invalid. Make sure you use the product object that is output from null or from the http://[your-product-url].js route');
        }
        return product;
      }
    }]);
  }();
  function getProductJson(handle) {
    var requestRoute = "".concat(window.theme.routes.root_url, "products/").concat(handle, ".js");
    return window.fetch(requestRoute).then(function (response) {
      return response.json();
    }).catch(function (e) {
      console.error(e);
    });
  }
  function getScript(url, callback, callbackError) {
    var head = document.getElementsByTagName('head')[0];
    var done = false;
    var script = document.createElement('script');
    script.src = url;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
        done = true;
        callback();
      } else {
        callbackError();
      }
    };
    head.appendChild(script);
  }
  var loaders = {};
  function loadScript() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!options.type) {
      options.type = 'json';
    }
    if (options.url) {
      if (loaders[options.url]) {
        return loaders[options.url];
      } else {
        return getScriptWithPromise(options.url, options.type);
      }
    } else if (options.json) {
      if (loaders[options.json]) {
        return Promise.resolve(loaders[options.json]);
      } else {
        return window.fetch(options.json).then(function (response) {
          return response.json();
        }).then(function (response) {
          loaders[options.json] = response;
          return response;
        });
      }
    } else if (options.name) {
      var key = ''.concat(options.name, options.version);
      if (loaders[key]) {
        return loaders[key];
      } else {
        return loadShopifyWithPromise(options);
      }
    } else {
      return Promise.reject();
    }
  }
  function getScriptWithPromise(url, type) {
    var loader = new Promise(function (resolve, reject) {
      if (type === 'text') {
        fetch(url).then(function (response) {
          return response.text();
        }).then(function (data) {
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        getScript(url, function () {
          resolve();
        }, function () {
          reject();
        });
      }
    });
    loaders[url] = loader;
    return loader;
  }
  function loadShopifyWithPromise(options) {
    var key = ''.concat(options.name, options.version);
    var loader = new Promise(function (resolve, reject) {
      try {
        window.Shopify.loadFeatures([{
          name: options.name,
          version: options.version,
          onLoad: function onLoad(err) {
            onLoadFromShopify(resolve, reject, err);
          }
        }]);
      } catch (err) {
        reject(err);
      }
    });
    loaders[key] = loader;
    return loader;
  }
  function onLoadFromShopify(resolve, reject, err) {
    if (err) {
      return reject(err);
    } else {
      return resolve();
    }
  }
  var selectors$11 = {
    wrapper: '[data-swapper-wrapper]',
    target: '[data-swapper-target]',
    hover: 'data-swapper-hover'
  };
  var sections$p = {};
  var Swapper = /*#__PURE__*/function () {
    function Swapper(el) {
      _classCallCheck(this, Swapper);
      this.container = el;
      this.target = this.container.querySelector(selectors$11.target);
      this.hovers = this.container.querySelectorAll("[".concat(selectors$11.hover, "]"));
      if (this.target && this.hovers.length) {
        this.deafaultContent = this.target.innerHTML;
        this.init();
      }
    }
    return _createClass(Swapper, [{
      key: "init",
      value: function init() {
        var _this9 = this;
        this.hovers.forEach(function (hover) {
          hover.addEventListener('mouseenter', function () {
            var newContent = hover.getAttribute(selectors$11.hover);
            this.target.innerHTML = "".concat(newContent);
          }.bind(_this9));
        });
        this.hovers.forEach(function (hover) {
          hover.addEventListener('mouseleave', function () {
            this.target.innerHTML = this.deafaultContent;
          }.bind(_this9));
        });
        this.hovers.forEach(function (hover) {
          hover.addEventListener('click', function () {
            var clickedContent = hover.getAttribute(selectors$11.hover);
            this.deafaultContent = "".concat(clickedContent);
          }.bind(_this9));
        });
      }
    }]);
  }();
  function makeSwappers(container) {
    sections$p[container.id] = [];
    var els = container.querySelectorAll(selectors$11.wrapper);
    els.forEach(function (el) {
      sections$p[container.id].push(new Swapper(el));
    });
  }
  var swapperSection = {
    onLoad: function onLoad() {
      makeSwappers(this.container);
    }
  };
  var defaults = {
    color: 'ash'
  };
  var selectors$10 = {
    swatch: 'data-swatch',
    outerGrid: '[data-grid-item]',
    imageSlide: '[data-grid-image]',
    dataGridImageDefault: 'data-grid-image-default',
    dataGridImageTarget: 'data-grid-image-target',
    dataGridImageTargetDefault: 'data-grid-image-target-default',
    image: 'data-swatch-image',
    imageId: 'data-swatch-image-id',
    variant: 'data-swatch-variant',
    link: '[data-grid-link]',
    wrapper: '[data-grid-swatches]',
    template: '[data-swatch-template]',
    handle: 'data-swatch-handle',
    label: 'data-swatch-label',
    index: 'data-swatch-index',
    dataMediaId: 'data-media-id',
    dataMediaSrcPlaceholder: 'data-media-src-placeholder',
    dataFetchedImage: 'data-fetched-image',
    dataFetchedImageIndex: 'data-fetched-image-index'
  };
  var classes$E = {
    fade: 'is-fade'
  };
  var ColorMatch = /*#__PURE__*/function () {
    function ColorMatch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, ColorMatch);
      this.settings = _objectSpread(_objectSpread({}, defaults), options);
      this.match = this.init();
    }
    return _createClass(ColorMatch, [{
      key: "getColor",
      value: function getColor() {
        return this.match;
      }
    }, {
      key: "init",
      value: function init() {
        var _this0 = this;
        var getColors = loadScript({
          json: window.theme.assets.swatches
        });
        return getColors.then(function (colors) {
          return _this0.matchColors(colors, _this0.settings.color);
        }).catch(function (e) {
          console.log('failed to load swatch colors script');
          console.log(e);
        });
      }
    }, {
      key: "matchColors",
      value: function matchColors(colors, name) {
        var bg = '#E5E5E5';
        var img = null;
        var path = window.theme.assets.base || '/';
        var comparisonName = name.toLowerCase().replace(/\s/g, '');
        var array = colors.colors;
        if (array) {
          var variantNameMatch = function variantNameMatch(nameObject) {
            var indexName = Object.keys(nameObject).toString();
            var neatName = indexName.toLowerCase().replace(/\s/g, '');
            return neatName === comparisonName;
          };
          var position = array.findIndex(variantNameMatch);
          if (position > -1) {
            var value = Object.values(array[position])[0];
            var valueLowerCase = value.toLowerCase();
            if (valueLowerCase.includes('.jpg') || valueLowerCase.includes('.jpeg') || valueLowerCase.includes('.png') || valueLowerCase.includes('.svg')) {
              img = "".concat(path).concat(encodeURIComponent(value));
              bg = '#888888';
            } else {
              bg = value;
            }
          }
        }
        return {
          color: this.settings.color,
          path: img,
          hex: bg
        };
      }
    }]);
  }();
  var RadioSwatch = /*#__PURE__*/function (_HTMLElement) {
    function RadioSwatch() {
      var _this1;
      _classCallCheck(this, RadioSwatch);
      _this1 = _callSuper(this, RadioSwatch);
      _this1.element = _this1.querySelector("[".concat(selectors$10.swatch, "]"));
      _this1.colorString = _this1.element.getAttribute(selectors$10.swatch);
      _this1.image = _this1.element.getAttribute(selectors$10.image);
      _this1.imageId = _this1.element.getAttribute(selectors$10.imageId);
      _this1.variant = _this1.element.getAttribute(selectors$10.variant);
      _this1.outer = _this1.element.closest(selectors$10.outerGrid);
      _this1.media = null;
      _this1.imageSlide = null;
      _this1.imageDefault = null;
      _this1.stopSlideAnimation = false;
      var matcher = new ColorMatch({
        color: _this1.colorString
      });
      matcher.getColor().then(function (result) {
        _this1.colorMatch = result;
        _this1.init();
      });
      return _this1;
    }
    _inherits(RadioSwatch, _HTMLElement);
    return _createClass(RadioSwatch, [{
      key: "init",
      value: function init() {
        var _this10 = this;
        this.setStyles();

        // Change PGI slider image
        if (this.variant && this.outer) {
          // Get images on quickview load
          this.outer.addEventListener('theme:quickview:media', function (e) {
            if (e && e.detail && e.detail.media) {
              _this10.media = e.detail.media;
            }
          });
        }
      }
    }, {
      key: "setStyles",
      value: function setStyles() {
        if (this.colorMatch.hex) {
          this.element.style.setProperty('--swatch', "".concat(this.colorMatch.hex));
        }
        if (this.colorMatch.path) {
          this.element.style.setProperty('background-image', "url(".concat(this.colorMatch.path, ")"));
          this.element.style.setProperty('background-size', 'cover');
        }
      }
    }, {
      key: "replaceImage",
      value: function replaceImage() {
        var _this11 = this;
        // Add new loaded image in PGI slider
        if (this.imageReplace && this.imageSlide && this.imageId) {
          if (this.imageSlide.hasAttribute(selectors$10.dataGridImageTarget) && this.imageSlide.getAttribute(selectors$10.dataGridImageTarget) !== this.imageId) {
            this.imageSlide.classList.add(classes$E.fade);
            var timeoutDelay = parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue('animation-duration')) * 1000;
            setTimeout(function () {
              _this11.imageSlide.classList.remove(classes$E.fade);
            }, timeoutDelay);
          }
          this.imageSlide.setAttribute(selectors$10.dataGridImageTarget, this.imageId);
          this.imageSlide.style.setProperty('background-color', '#fff');
          if (!this.imageSlide.hasAttribute(selectors$10.dataGridImageDefault)) {
            this.imageSlide.setAttribute(selectors$10.dataGridImageDefault, window.getComputedStyle(this.imageSlide).backgroundImage);
          }
          this.imageSlide.style.setProperty('background-image', this.imageReplace);
        }
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var GridSwatch = /*#__PURE__*/function () {
    function GridSwatch(wrap) {
      var _this12 = this;
      _classCallCheck(this, GridSwatch);
      this.template = document.querySelector(selectors$10.template).innerHTML;
      this.wrap = wrap;
      this.handle = wrap.getAttribute(selectors$10.handle);
      var label = wrap.getAttribute(selectors$10.label).trim().toLowerCase();
      getProductJson(this.handle).then(function (product) {
        _this12.product = product;
        _this12.colorOption = product.options.find(function (element) {
          return element.name.toLowerCase() === label || null;
        });
        if (_this12.colorOption) {
          _this12.swatches = _this12.colorOption.values;
          _this12.init();
        }
      });
    }
    return _createClass(GridSwatch, [{
      key: "init",
      value: function init() {
        var _this13 = this;
        this.wrap.innerHTML = '';
        this.swatches.forEach(function (swatch, index) {
          var variant = _this13.product.variants.find(function (variant) {
            return variant.options.includes(swatch);
          });
          var image = variant.featured_media ? variant.featured_media.preview_image.src : '';
          var imageId = variant.featured_media ? variant.featured_media.id : '';
          var rand = Math.floor(Math.random() * 9999);
          _this13.wrap.innerHTML += Sqrl__namespace.render(_this13.template, {
            color: swatch,
            uniq: "".concat(_this13.product.id, "-").concat(variant.id, "-").concat(rand),
            variant: variant.id,
            product_id: _this13.product.id,
            image_id: imageId,
            image: image,
            index: index
          });
        });
        new NativeScrollbar(this.wrap);
      }
    }]);
  }();
  function makeGridSwatches(container) {
    var gridSwatchWrappers = container.querySelectorAll(selectors$10.wrapper);
    gridSwatchWrappers.forEach(function (wrap) {
      new GridSwatch(wrap);
    });
  }
  var swatchGridSection = {
    onLoad: function onLoad() {
      makeGridSwatches(this.container);
      makeSwappers(this.container);
    }
  };
  var selectors$$ = {
    holderItems: '[data-custom-scrollbar-items]',
    scrollbar: '[data-custom-scrollbar]',
    scrollbarTrack: '[data-custom-scrollbar-track]'
  };
  var classes$D = {
    hide: 'hide'
  };
  var sections$o = {};
  var CustomScrollbar = /*#__PURE__*/function () {
    function CustomScrollbar(holder) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      _classCallCheck(this, CustomScrollbar);
      this.holderItems = holder.querySelector(selectors$$.holderItems);
      this.scrollbar = holder.querySelector(selectors$$.scrollbar);
      this.scrollbarTrack = holder.querySelector(selectors$$.scrollbarTrack);
      this.trackWidth = 0;
      this.scrollWidth = 0;
      if (this.scrollbar && this.holderItems) {
        this.children = children || this.holderItems.children;
        this.events();
        this.calculateTrackWidth();
      }
    }
    return _createClass(CustomScrollbar, [{
      key: "events",
      value: function events() {
        this.holderItems.addEventListener('scroll', this.calculatePosition.bind(this));
        this.holderItems.addEventListener('theme:carousel:scroll', this.calculatePosition.bind(this));
        document.addEventListener('theme:resize:width', this.calculateTrackWidth.bind(this));
        document.addEventListener('theme:resize:width', this.calculatePosition.bind(this));
      }
    }, {
      key: "calculateTrackWidth",
      value: function calculateTrackWidth() {
        var _this14 = this;
        // Javascript can't execute calc() (from `--outer` variable) - create a new div with width property instead `getPropertyValue('--outer')` to can get the width of `after` on the holder
        var htmlObject = document.createElement('div');
        this.holderItems.prepend(htmlObject);
        htmlObject.style.display = 'none';
        htmlObject.style.width = getComputedStyle(this.holderItems).getPropertyValue('--outer');
        var widthAfter = parseInt(getComputedStyle(htmlObject).getPropertyValue('width'));
        this.holderItems.firstChild.remove();
        this.scrollbarWidth = this.scrollbar.clientWidth === 0 ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth;
        setTimeout(function () {
          var childWidth = _this14.children[0].clientWidth;
          var childMarginRight = Number(getComputedStyle(_this14.children[0]).marginRight.replace('px', ''));
          var childMarginLeft = Number(getComputedStyle(_this14.children[0]).marginLeft.replace('px', ''));

          // Minus `childMarginRight` is added to the end with minus because the last child doesn't have margin-right
          _this14.scrollWidth = _this14.children.length * (childWidth + childMarginRight + childMarginLeft) + widthAfter - childMarginRight;
          _this14.trackWidth = (_this14.scrollbarWidth + widthAfter) / _this14.scrollWidth * 100;
          _this14.trackWidth = _this14.trackWidth < 5 ? 5 : _this14.trackWidth;
          _this14.scrollbar.style.setProperty('--track-width', "".concat(_this14.trackWidth, "%"));
          var hideScrollbar = Math.ceil(_this14.trackWidth) >= 100;
          _this14.scrollbar.classList.toggle(classes$D.hide, hideScrollbar);
        }, 100);
      }
    }, {
      key: "calculatePosition",
      value: function calculatePosition() {
        var position = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
        position *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth;
        position = position < 0 ? 0 : position;
        position = isNaN(position) ? 0 : position;
        this.scrollbar.style.setProperty('--position', "".concat(Math.round(position), "px"));
        document.dispatchEvent(new CustomEvent('theme:scrollbar:scroll', {
          bubbles: true,
          detail: {
            holder: this.holderItems
          }
        }));
      }
    }]);
  }();
  var customScrollbar = {
    onLoad: function onLoad() {
      sections$o[this.id] = new CustomScrollbar(this.container);
    }
  };
  var selectors$_ = {
    carousel: '[data-carousel]',
    carouselWithProgress: 'data-carousel-progress',
    carouselSlide: '[data-carousel-slide]',
    carouselFirstSlidePhoto: '[data-grid-slide]',
    wrapper: '[data-wrapper]',
    carouselTrack: '[data-carousel-track]',
    slider: '.flickity-slider',
    carouselOptions: 'data-options',
    carouselCustomScrollbar: 'data-custom-scrollbar-items',
    carouselPrev: '.flickity-button.previous',
    carouselNext: '.flickity-button.next',
    recentlyViewHolder: 'data-recently-viewed-products',
    relatedHolder: 'data-related-products',
    sectionHolder: '[data-section-id]'
  };
  var classes$C = {
    wrapper: 'wrapper',
    wrapperModifier: 'wrapper--full',
    notMovedArrows: 'not-moved-arrows',
    hide: 'hide',
    flickityEnabled: 'flickity-enabled',
    hiddenArrows: 'hidden-arrows',
    flickityStatic: 'flickity-static'
  };
  var offsets$1 = {
    additionalOffsetWrapper: 112
  };
  var Carousel = /*#__PURE__*/function (_HTMLElement2) {
    function Carousel() {
      var _this15;
      _classCallCheck(this, Carousel);
      _this15 = _callSuper(this, Carousel);
      _this15.container = _this15;
      return _this15;
    }
    _inherits(Carousel, _HTMLElement2);
    return _createClass(Carousel, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this16 = this;
        this.carousel = this.container.querySelector(selectors$_.carousel);
        this.carouselTrack = this.container.querySelector(selectors$_.carouselTrack);
        this.wrapper = this.container.closest(selectors$_.wrapper);
        this.section = this.container.closest(selectors$_.sectionHolder);
        this.slidesVisible = null;
        this.carouselInstance = null;
        this.carouselPrev = null;
        this.carouselNext = null;
        this.customOptions = {};
        this.toggleWrapperModifierEvent = function () {
          return _this16.toggleWrapperModifier();
        };
        if (this.carousel && this.carousel.hasAttribute(selectors$_.recentlyViewHolder)) {
          // Check carousel in recently viewed products
          this.section.addEventListener('theme:recent-products:added', function () {
            _this16.init();
          });
        } else if (this.carousel && this.carousel.hasAttribute(selectors$_.relatedHolder)) {
          // Check carousel in recommendation products but without overwrite option
          this.section.addEventListener('theme:related-products:added', function () {
            _this16.init();
          });
        } else {
          this.init();
        }
      }
    }, {
      key: "init",
      value: function init() {
        if (!this.carousel) {
          return;
        }
        this.applyRandomOrder();
        this.applyMultiRowLayout();
        this.slidesTotal = this.carousel.querySelectorAll(selectors$_.carouselSlide).length;
        this.getGridLayout();
        this.trackVisibleSlides();
        if (this.carousel.hasAttribute(selectors$_.carouselOptions)) {
          this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(selectors$_.carouselOptions)));
        }
        this.initCarousel();
        this.calculatedArrowsTopPosition();
        this.toggleWrapperModifier();
        document.addEventListener('theme:resize:width', this.toggleWrapperModifierEvent);
        if (this.carousel.hasAttribute(selectors$_.carouselWithProgress)) {
          this.progressBarCalculate();
        }
        if (this.carousel.hasAttribute(selectors$_.carouselCustomScrollbar)) {
          new CustomScrollbar(this.container);
        }
        this.setupGridToggle();
      }
    }, {
      key: "setupGridToggle",
      value: function setupGridToggle() {
        var _this17 = this;
        var toggleButton = this.container.querySelector('[data-grid-toggle]');
        if (!toggleButton || this.gridToggleBound) {
          return;
        }
        this.gridToggleBound = true;
        this.isGridMode = false;
        var labelEl = toggleButton.querySelector('[data-grid-toggle-label]') || toggleButton;
        var setLabel = function setLabel(text) {
          labelEl.textContent = text;
        };
        toggleButton.addEventListener('click', function (e) {
          e.preventDefault();
          var scrollY = window.scrollY || window.pageYOffset;
          var wasGridMode = _this17.isGridMode;
          // Override CSS `scroll-behavior: smooth` so the scroll below snaps instantly
          var htmlEl = document.documentElement;
          var prevBehavior = htmlEl.style.scrollBehavior;
          htmlEl.style.scrollBehavior = 'auto';
          // Lock minimum page height to its pre-toggle value — prevents the browser from
          // auto-scrolling when the collapsed view makes the page shorter than scrollY
          var prevMinHeight = htmlEl.style.minHeight;
          var lockedHeight = htmlEl.scrollHeight;
          htmlEl.style.minHeight = lockedHeight + 'px';
          if (_this17.isGridMode) {
            // Restore carousel
            _this17.carousel.classList.remove('is-grid-mode');
            // Re-apply multi-row wrapping if originally active
            _this17.applyMultiRowLayout();
            _this17.initCarousel();
            if (_this17.carousel.hasAttribute(selectors$_.carouselWithProgress)) {
              _this17.progressBarCalculate();
            }
            if (_this17.carousel.hasAttribute(selectors$_.carouselCustomScrollbar)) {
              new CustomScrollbar(_this17.container);
            }
            setLabel(toggleButton.dataset.labelViewAll || 'View All');
            _this17.isGridMode = false;
          } else {
            // Switch to grid
            if (_this17.carouselInstance && typeof _this17.carouselInstance.destroy === 'function') {
              _this17.carouselInstance.destroy();
            }
            _this17.carouselInstance = null;
            // Unwrap multi-row column groups so grid shows individual cards
            _this17.unwrapMultiRowLayout();
            _this17.carousel.classList.add('is-grid-mode');
            setLabel(toggleButton.dataset.labelViewLess || 'View Less');
            _this17.isGridMode = true;
          }

          // Scroll handling depends on direction:
          // - Grid → Carousel (View Less): scroll to top of the carousel section so the
          //   user lands back where the component starts, not at the bottom of a long grid.
          // - Carousel → Grid (View All): keep scroll where the user was so they don't jump.
          if (wasGridMode) {
            // scrollMarginTop keeps the target clear of the sticky site header AND leaves
            // a bit of breathing room so the section heading is comfortably visible.
            var prevScrollMargin = _this17.container.style.scrollMarginTop;
            _this17.container.style.scrollMarginTop = '400px';
            _this17.container.scrollIntoView({
              block: 'start',
              behavior: 'auto'
            });
            _this17.container.style.scrollMarginTop = prevScrollMargin;
          } else {
            window.scrollTo(0, scrollY);
          }
          // Release height + behavior locks after layout settles (two RAFs for Flickity)
          requestAnimationFrame(function () {
            if (!wasGridMode) {
              window.scrollTo(0, scrollY);
            }
            requestAnimationFrame(function () {
              htmlEl.style.minHeight = prevMinHeight;
              htmlEl.style.scrollBehavior = prevBehavior;
            });
          });
        });
      }
    }, {
      key: "initCarousel",
      value: function initCarousel() {
        var _this18 = this;
        this.options = _objectSpread({
          accessibility: true,
          contain: true,
          freeScroll: true,
          prevNextButtons: true,
          wrapArround: false,
          groupCells: false,
          autoPlay: false,
          pageDots: false,
          cellAlign: window.isRTL ? 'right' : 'left',
          rightToLeft: window.isRTL,
          dragThreshold: 10,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 65,
            y2: 45,
            x3: 20
          },
          on: {
            resize: function resize() {
              _this18.toggleArrows();
              _this18.calculatedArrowsTopPosition();
              setTimeout(function () {
                _this18.visibleSlides();
              }, 100);
            }
          }
        }, this.customOptions);
        this.carouselInstance = new Flickity(this.carousel, this.options);
        this.carouselPrev = this.carousel.querySelector(selectors$_.carouselPrev);
        this.carouselNext = this.carousel.querySelector(selectors$_.carouselNext);

        // A11y fix: Remove tabindex from carousel and viewport to prevent over-announcement
        // Focus should go directly to actionable controls (prev/next buttons)
        this.carousel.removeAttribute('tabindex');
        var viewport = this.carousel.querySelector('.flickity-viewport');
        if (viewport) {
          viewport.removeAttribute('tabindex');
        }
        this.container.addEventListener('theme:tab:change', function () {
          _this18.carouselInstance.resize();
          _this18.carouselPrev = _this18.carousel.querySelector(selectors$_.carouselPrev);
          _this18.carouselNext = _this18.carousel.querySelector(selectors$_.carouselNext);
        });
        this.carouselInstance.on('dragStart', function () {
          _this18.carouselInstance.slider.style.pointerEvents = 'none';
          _this18.containDrag();
        });
        this.carouselInstance.on('dragEnd', function () {
          _this18.carouselInstance.slider.style.pointerEvents = 'auto';
          _this18.containDrag();
        });
        this.carouselInstance.on('change', function (index) {
          return _this18.lockArrows(index);
        });
        setTimeout(function () {
          _this18.visibleSlides();
        }, 100);
        if (Shopify.designMode) {
          setTimeout(function () {
            if (_this18.carouselInstance.options.watchCSS && !_this18.carousel.classList.contains(classes$C.flickityEnabled)) {
              _this18.carouselInstance.destroy();
              _this18.carouselInstance = new Flickity(_this18.carousel, _this18.options);
              _this18.carousel.removeAttribute('tabindex');
              var _viewport = _this18.carousel.querySelector('.flickity-viewport');
              if (_viewport) {
                _viewport.removeAttribute('tabindex');
              }
              _this18.carouselInstance.resize();
              _this18.carouselPrev = _this18.carousel.querySelector(selectors$_.carouselPrev);
              _this18.carouselNext = _this18.carousel.querySelector(selectors$_.carouselNext);
            } else {
              _this18.carouselInstance.resize();
            }
          }, 10);
        }
        this.carousel.classList.toggle(classes$C.flickityStatic, this.smallItems === this.carousel.querySelectorAll(selectors$_.carouselSlide).length);
        makeGridSwatches(this.container);
        new Siblings(this.container);
      }
    }, {
      key: "calculatedArrowsTopPosition",
      value: function calculatedArrowsTopPosition() {
        var carouselFirstSlidePhoto = this.container.querySelector(selectors$_.carouselFirstSlidePhoto);
        if (carouselFirstSlidePhoto) {
          var buttonOffset = carouselFirstSlidePhoto.offsetHeight / 2;
          this.carousel.style.setProperty('--buttons-top', "".concat(buttonOffset, "px"));
        }
      }
    }, {
      key: "toggleWrapperModifier",
      value: function toggleWrapperModifier() {
        if (!this.wrapper) {
          return;
        }
        var scrollbarWidth = Number(getComputedStyle(document.documentElement).getPropertyValue('--scrollbar-width').replace('px', ''));
        var wrapperWidth = this.wrapper.clientWidth;
        this.wrapperWidthWithGutter = wrapperWidth + offsets$1.additionalOffsetWrapper + scrollbarWidth;
        this.wrapper.classList.toggle(classes$C.wrapperModifier, this.wrapperWidthWithGutter >= window.innerWidth);
        this.section.classList.toggle(classes$C.notMovedArrows, !(this.wrapperWidthWithGutter >= window.innerWidth));
      }
    }, {
      key: "progressBarCalculate",
      value: function progressBarCalculate() {
        var _this19 = this;
        if (this.carouselInstance !== null && this.carouselTrack) {
          if (this.carousel.hasAttribute('data-progress-match-mobile')) {
            // Match the mobile CustomScrollbar style: fixed-width thumb sliding via transform
            var scrollbar = this.carouselTrack.parentElement;

            // Clear any previously applied inline width so the CSS variable controls it
            this.carouselTrack.style.width = '';
            var updateTrackWidth = function updateTrackWidth() {
              var total = _this19.carouselInstance.cells && _this19.carouselInstance.cells.length || _this19.slidesTotal || 1;
              var visible = Math.max(1, _this19.slidesVisible || _this19.largeItems || 1);
              var pct = visible / total * 100;
              if (pct < 5) pct = 5;
              if (pct > 100) pct = 100;
              scrollbar.style.setProperty('--track-width', "".concat(pct, "%"));
            };
            updateTrackWidth();
            this.carouselInstance.on('scroll', function (progress) {
              progress = Math.max(0, Math.min(1, progress));
              var scrollbarWidth = scrollbar.clientWidth;
              var trackWidth = _this19.carouselTrack.clientWidth;
              var maxPosition = Math.max(0, scrollbarWidth - trackWidth);
              var position = progress * maxPosition;
              scrollbar.style.setProperty('--position', "".concat(Math.round(position), "px"));
            });
            document.addEventListener('theme:resize:width', updateTrackWidth);
          } else {
            // Original behavior: bar grows from 0% to 100% width as carousel scrolls
            this.carouselInstance.on('scroll', function (progress) {
              progress = Math.max(0, Math.min(1, progress)) * 100 + '%';
              _this19.carouselTrack.style.width = progress;
            });
          }
        }
      }
    }, {
      key: "applyRandomOrder",
      value: function applyRandomOrder() {
        var _this20 = this;
        if (!this.carousel.hasAttribute('data-random-order')) {
          return;
        }
        var cells = Array.from(this.carousel.querySelectorAll(':scope > [data-carousel-slide]'));
        if (cells.length <= 1) {
          return;
        }

        // Fisher-Yates shuffle
        for (var i = cells.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var _ref2 = [cells[j], cells[i]];
          cells[i] = _ref2[0];
          cells[j] = _ref2[1];
        }

        // Optionally trim to the first N after shuffle (random N from a larger pool)
        var showCount = parseInt(this.carousel.dataset.randomShow, 10);
        if (showCount > 0 && cells.length > showCount) {
          cells.slice(showCount).forEach(function (cell) {
            return cell.remove();
          });
          cells.length = showCount;
        }

        // Re-append in shuffled order
        cells.forEach(function (cell) {
          return _this20.carousel.appendChild(cell);
        });
      }
    }, {
      key: "applyMultiRowLayout",
      value: function applyMultiRowLayout() {
        var _this21 = this;
        var rowsL = Number(this.carousel.dataset.rowsLarge || 1);
        var rowsM = Number(this.carousel.dataset.rowsMedium || 1);
        var rowsS = Number(this.carousel.dataset.rowsSmall || 1);
        if (rowsL === 1 && rowsM === 1 && rowsS === 1) {
          return;
        }
        var rows;
        if (window.innerWidth >= window.theme.sizes.large) {
          rows = rowsL;
        } else if (window.innerWidth >= window.theme.sizes.medium) {
          rows = rowsM;
        } else {
          rows = rowsS;
        }
        if (rows <= 1) {
          return;
        }
        var cells = Array.from(this.carousel.querySelectorAll(':scope > [data-carousel-slide]'));
        if (cells.length === 0) {
          return;
        }
        var groups = [];
        for (var i = 0; i < cells.length; i += rows) {
          groups.push(cells.slice(i, i + rows));
        }
        cells.forEach(function (cell) {
          return cell.remove();
        });
        groups.forEach(function (group) {
          var wrapper = document.createElement('div');
          wrapper.className = 'grid__item carousel__column-group';
          wrapper.setAttribute('data-carousel-slide', '');
          wrapper.setAttribute('data-item', '');
          group.forEach(function (cell) {
            cell.removeAttribute('data-carousel-slide');
            cell.removeAttribute('data-item');
            cell.classList.remove('grid__item');
            wrapper.appendChild(cell);
          });
          _this21.carousel.appendChild(wrapper);
        });
        this.multiRowRowCount = rows;
      }
    }, {
      key: "unwrapMultiRowLayout",
      value: function unwrapMultiRowLayout() {
        var _this22 = this;
        var wrappers = Array.from(this.carousel.querySelectorAll(':scope > .carousel__column-group'));
        if (wrappers.length === 0) {
          return;
        }
        wrappers.forEach(function (wrapper) {
          var children = Array.from(wrapper.children);
          children.forEach(function (child) {
            child.classList.add('grid__item');
            child.setAttribute('data-carousel-slide', '');
            child.setAttribute('data-item', '');
            _this22.carousel.insertBefore(child, wrapper);
          });
          wrapper.remove();
        });
        this.multiRowRowCount = null;
      }
    }, {
      key: "getGridLayout",
      value: function getGridLayout() {
        this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue('--grid-large-items')) || 3;
        this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue('--grid-medium-items')) || this.largeItems;
        this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue('--grid-small-items')) || this.mediumItems || this.largeItems;
      }
    }, {
      key: "visibleSlides",
      value: function visibleSlides() {
        if (!this.carousel) {
          return;
        }
        this.getGridLayout();
        var carouselWidth = this.carousel.clientWidth || this.carouselInstance.size.width;
        var slideWidth = this.carouselInstance !== null && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(selectors$_.carouselSlide).clientWidth;
        var countSlides = this.carouselInstance !== null && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(selectors$_.carouselSlide).length;
        var numberOfVisibleSlides = Math.floor(carouselWidth / slideWidth);
        if (this.section) {
          this.section.classList.remove(classes$C.hiddenArrows);
        }
        if (this.carouselPrev && this.carouselNext) {
          this.carouselPrev.classList.remove(classes$C.hide);
          this.carouselNext.classList.remove(classes$C.hide);
        }

        // Desktop
        if (window.innerWidth > window.theme.sizes.large && !this.options.groupCells) {
          if (numberOfVisibleSlides <= this.largeItems && countSlides <= this.largeItems && this.carouselPrev && this.carouselNext) {
            this.hideArrows();
          }
        }

        // Tablet
        if (window.innerWidth >= window.theme.sizes.medium && window.innerWidth <= window.theme.sizes.large && !this.options.groupCells) {
          if (numberOfVisibleSlides <= this.mediumItems && countSlides <= this.mediumItems && this.carouselPrev && this.carouselNext) {
            this.hideArrows();
          }
        }

        // Mobile
        if (window.innerWidth < window.theme.sizes.medium && !this.options.groupCells) {
          if (numberOfVisibleSlides <= this.smallItems && countSlides <= this.smallItems && this.carouselPrev && this.carouselNext) {
            this.hideArrows();
          }
        }
      }
    }, {
      key: "trackVisibleSlides",
      value: function trackVisibleSlides() {
        var _this23 = this;
        var isSmallDown = window.matchMedia("(max-width: ".concat(window.theme.sizes.medium - 1, "px)"));
        var isTablet = window.matchMedia("(min-width: ".concat(window.theme.sizes.medium, "px) and (max-width: ").concat(window.theme.sizes.large - 1, "px)"));
        var isDesktop = window.matchMedia("(min-width: ".concat(window.theme.sizes.large, "px)"));
        isSmallDown.addEventListener('change', function (event) {
          event.matches ? _this23.slidesVisible = _this23.smallItems : true;
        });
        isSmallDown.matches ? this.slidesVisible = this.smallItems : true;
        isTablet.addEventListener('change', function (event) {
          event.matches ? _this23.slidesVisible = _this23.mediumItems : true;
        });
        isTablet.matches ? this.slidesVisible = this.mediumItems : true;
        isDesktop.addEventListener('change', function (event) {
          event.matches ? _this23.slidesVisible = _this23.largeItems : true;
        });
        isDesktop.matches ? this.slidesVisible = this.largeItems : true;
      }
    }, {
      key: "containDrag",
      value: function containDrag() {
        // Dragging agressively in flickity will select the last cell in the list
        // instead of the first cell of the last slide (slide is a set of cells).
        // We detect drag events, and move the selection back to the first cell
        // of the last slide -- the lastSelectableCell.
        var lastSelectableCell = this.slidesTotal - this.slidesVisible;
        if (this.carouselInstance.selectedIndex >= lastSelectableCell) {
          this.carouselInstance.select(lastSelectableCell);
          this.lockArrows(this.carouselInstance.selectedIndex);
        }
      }
    }, {
      key: "lockArrows",
      value: function lockArrows(index) {
        if (this.options.wrapAround || this.options.groupCells) {
          return;
        }
        var nextIndex = parseInt(index);
        var lastSelectableCell = this.slidesTotal - this.slidesVisible;
        this.carouselNext.disabled = nextIndex >= lastSelectableCell;
      }
    }, {
      key: "showArrows",
      value: function showArrows() {
        this.carouselPrev.classList.remove(classes$C.hide);
        this.carouselNext.classList.remove(classes$C.hide);
        if (this.section) {
          //gdd-custom
          this.section.classList.remove(classes$C.hiddenArrows);
        }
      }
    }, {
      key: "hideArrows",
      value: function hideArrows() {
        this.carouselPrev.classList.add(classes$C.hide);
        this.carouselNext.classList.add(classes$C.hide);
        if (this.section) {
          //gdd-custom
          this.section.classList.add(classes$C.hiddenArrows);
        }
      }
    }, {
      key: "toggleArrows",
      value: function toggleArrows() {
        if (this.carouselPrev && this.carouselNext) {
          if (this.carouselPrev.disabled && this.carouselNext.disabled) {
            this.hideArrows();
          } else {
            this.showArrows();
          }
        }
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  if (!customElements.get('flickity-carousel')) {
    customElements.define('flickity-carousel', Carousel);
  }

  /**
   * A11y Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help make your theme more accessible
   */

  /**
   * Moves focus to an HTML element
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects. Used in bindInPageLinks()
   * eg move focus to a modal that is opened. Used in trapFocus()
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */
  function forceFocus(element, options) {
    options = options || {};
    element.focus();
    if (typeof options.className !== 'undefined') {
      element.classList.add(options.className);
    }
    element.addEventListener('blur', callback);
    function callback(event) {
      event.target.removeEventListener(event.type, callback);
      if (typeof options.className !== 'undefined') {
        element.classList.remove(options.className);
      }
    }
  }

  /**
   * If there's a hash in the url, focus the appropriate element
   * This compensates for older browsers that do not move keyboard focus to anchor links.
   * Recommendation: To be called once the page in loaded.
   *
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   * @param {string} options.ignore - Selector for elements to not include.
   */

  function focusHash(options) {
    options = options || {};
    var hash = window.location.hash;
    var element = document.getElementById(hash.slice(1));

    // if we are to ignore this element, early return
    if (element && options.ignore && element.matches(options.ignore)) {
      return false;
    }
    if (hash && element) {
      forceFocus(element, options);
    }
  }

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   * This compensates for older browsers that do not move keyboard focus to anchor links.
   * Recommendation: To be called once the page in loaded.
   *
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   * @param {string} options.ignore - CSS selector for elements to not include.
   */

  function bindInPageLinks(options) {
    options = options || {};
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));
    function queryCheck(selector) {
      return document.getElementById(selector) !== null;
    }
    return links.filter(function (link) {
      if (link.hash === '#' || link.hash === '') {
        return false;
      }
      if (options.ignore && link.matches(options.ignore)) {
        return false;
      }
      if (!queryCheck(link.hash.substr(1))) {
        return false;
      }
      var element = document.querySelector(link.hash);
      if (!element) {
        return false;
      }
      link.addEventListener('click', function () {
        forceFocus(element, options);
      });
      return true;
    });
  }
  function focusable(container) {
    var elements = Array.prototype.slice.call(container.querySelectorAll('[tabindex],' + '[draggable],' + 'a[href],' + 'area,' + 'button:enabled,' + 'input:not([type=hidden]):enabled,' + 'object,' + 'select:enabled,' + 'textarea:enabled' + '[data-focus-element]'));

    // Filter out elements that are not visible.
    // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
    return elements.filter(function (element) {
      return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  /**
   * Traps the focus in a particular container
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Element} elementToFocus - Element to be focused on first
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */

  var trapFocusHandlers = {};
  function trapFocus(container, options) {
    options = options || {};
    var elements = focusable(container);
    var elementToFocus = options.elementToFocus || container;
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = function (event) {
      if (container !== event.target && !container.contains(event.target) && first && first === event.target) {
        first.focus();
      }
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function (event) {
      if (event.code !== 'Tab') return; // If not TAB key

      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    forceFocus(elementToFocus, options);
  }

  /**
   * Removes the trap of focus from the page
   */
  function removeTrapFocus() {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  }
  var throttle = function throttle(fn, wait) {
    var prev, next;
    return function invokeFn() {
      var now = Date.now();
      next = clearTimeout(next);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!prev || now - prev >= wait) {
        // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        prev = now;
      } else {
        next = setTimeout(invokeFn.bind.apply(invokeFn, [null].concat(args)), wait - (now - prev));
      }
    };
  };
  var selectors$Z = {
    sizeButton: '[data-size-button]',
    mediaHolder: '[data-media-slide]'
  };
  var classes$B = {
    classExpanded: 'is-expanded'
  };
  var ImageCaption = /*#__PURE__*/function () {
    function ImageCaption(container) {
      _classCallCheck(this, ImageCaption);
      this.container = container;
      this.sizeButtons = this.container.querySelectorAll(selectors$Z.sizeButton);
      if (this.sizeButtons.length > 0) {
        this.init();
      }
    }
    return _createClass(ImageCaption, [{
      key: "init",
      value: function init() {
        this.sizeButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            button.classList.toggle(classes$B.classExpanded);
            button.closest(selectors$Z.mediaHolder).classList.toggle(classes$B.classExpanded);
          });
        });
      }
    }]);
  }();
  var selectors$Y = {
    dataQuickview: 'data-quickview',
    quickviewHolder: 'data-quickview-holder',
    addButtonWrapper: '[data-add-action-wrapper]',
    modalContent: '[data-product-quickview-ajax]',
    quickviewModal: '[data-quickview-modal]',
    quickviewModalScrolls: '[data-drawer-scrolls]',
    quickviewModalTemplate: '[data-quickview-modal-template]',
    quickviewHead: '[data-quickview-head]',
    quickviewFormArea: '[data-quickview-form-area]',
    toggleButton: '[data-toggle-button]',
    media: '[data-media-slide]',
    mediaId: '[data-media-id]',
    dataPopup: 'data-popup-',
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
  };
  var classes$A = {
    hide: 'hide',
    active: 'is-active',
    expanded: 'is-expanded',
    loading: 'loading'
  };
  var visibleParts = {
    minPart: 250,
    mediumPart: 400
  };
  var ProductQuickView = /*#__PURE__*/function (_HTMLElement3) {
    function ProductQuickView() {
      var _this24;
      _classCallCheck(this, ProductQuickView);
      _this24 = _callSuper(this, ProductQuickView);
      _this24.container = _this24;
      return _this24;
    }
    _inherits(ProductQuickView, _HTMLElement3);
    return _createClass(ProductQuickView, [{
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue) {
          this.disconnectedCallback();
          this.connectedCallback();
        }
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this25 = this;
        this.quickviewHolder = this.container.querySelector("[".concat(selectors$Y.quickviewHolder, "]"));
        this.modalCloseEvent = function () {
          return _this25.modalClose();
        };
        this.clickQuickviewEvent = function (e) {
          return _this25.clickQuickviewButton(e);
        };
        if (this.quickviewHolder) {
          this.modalTemplate = this.quickviewHolder.querySelector(selectors$Y.quickviewModalTemplate);
          this.modal = document.querySelector(selectors$Y.quickviewModal);
          this.modalID = this.quickviewHolder.getAttribute(selectors$Y.quickviewHolder);
          this.modalContent = null;
          this.modalScroll = null;
          this.scrollLockEnable = true;
          this.windowH = window.innerHeight;

          // Sold out quickviews will have no trigger button
          this.triggerButton = this.quickviewHolder.querySelector("[".concat(selectors$Y.dataPopup).concat(this.modalID, "]"));
          this.handle = this.triggerButton ? this.triggerButton.getAttribute("".concat(selectors$Y.dataPopup).concat(this.modalID)) : null;
          if (this.modalTemplate && !this.modal) {
            var modalTemplateInner = this.modalTemplate.innerHTML;
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = modalTemplateInner;
            this.modalHtml = htmlObject.querySelector(selectors$Y.quickviewModal);
            document.body.appendChild(this.modalHtml);
            this.modal = document.querySelector(selectors$Y.quickviewModal);
          }
          if (this.modalTemplate && this.triggerButton) {
            this.triggerButton.addEventListener('click', this.clickQuickviewEvent);
          }
        }
      }
    }, {
      key: "clickQuickviewButton",
      value: function clickQuickviewButton(e) {
        e.preventDefault();
        if (this.modal && this.modalID) {
          // Reset modal ID before html content is loaded
          this.modal.id = this.modalID;
        }
        if (document.documentElement.hasAttribute('data-scroll-locked')) {
          this.scrollLockEnable = false;
        }
        this.container.classList.add(classes$A.loading);
        this.getQuickviewHTML();
      }
    }, {
      key: "getQuickviewHTML",
      value: function getQuickviewHTML() {
        var _this26 = this;
        // console.log(`${this.handle}`);
        window.fetch("".concat(window.theme.routes.root_url, "products/").concat(this.handle, "?section_id=api-product-quickview")).then(this.handleErrors).then(function (response) {
          return response.text();
        }).then(function (response) {
          var fresh = document.createElement('div');
          fresh.innerHTML = response;
          _this26.modalContent = _this26.modal.querySelector(selectors$Y.modalContent);
          _this26.modalContent.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
          _this26.modalScroll = _this26.modal.querySelector(selectors$Y.quickviewModalScrolls);
          var images = _this26.modalContent.querySelector(selectors$Y.mediaId);
          if (images) {
            var imagesHolder = document.createElement('div');
            imagesHolder.innerHTML = images.parentElement.innerHTML;
            _this26.quickviewHolder.dispatchEvent(new CustomEvent('theme:quickview:media', {
              bubbles: true,
              detail: {
                media: imagesHolder
              }
            }));
          }
          _this26.modalCreate();
          _this26.container.classList.remove(classes$A.loading);
        });
      }
    }, {
      key: "modalCreate",
      value: function modalCreate() {
        var _this27 = this;
        MicroModal.show(this.modalID, {
          onShow: function onShow(modal, el, event) {
            _this27.quickviewHead = modal.querySelector(selectors$Y.quickviewHead);
            _this27.quickviewFormArea = modal.querySelector(selectors$Y.quickviewFormArea);
            _this27.toggleButton = modal.querySelector(selectors$Y.toggleButton);
            _this27.toggleForm('loading');
            document.addEventListener('theme:resize', throttle(function () {
              _this27.toggleForm('resize');
            }, 500));
            _this27.clickEventToggleForm();
            var firstFocus = modal.querySelector(selectors$Y.focusable);
            trapFocus(modal, {
              elementToFocus: firstFocus
            });
            _this27.modal.addEventListener('theme:quickview:close', _this27.modalCloseEvent);
            document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
              bubbles: true,
              detail: _this27.modalScroll
            }));
            new ImageCaption(_this27.modal);
          },
          onClose: function onClose(modal, el, event) {
            var allMedia = modal.querySelectorAll(selectors$Y.media);
            allMedia.forEach(function (media) {
              media.dispatchEvent(new CustomEvent('pause'));
            });
            removeTrapFocus();
            el.focus();
            _this27.modal.removeEventListener('theme:quickview:close', _this27.modalCloseEvent);
            if (_this27.scrollLockEnable) {
              document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
                bubbles: true
              }));
            } else {
              _this27.scrollLockEnable = true;
            }
          }
        });
      }
    }, {
      key: "modalClose",
      value: function modalClose() {
        MicroModal.close(this.modalID);
      }
    }, {
      key: "handleErrors",
      value: function handleErrors(response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            var e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              json: json
            });
            throw e;
          });
        }
        return response;
      }
    }, {
      key: "toggleForm",
      value: function toggleForm(event) {
        var _this28 = this;
        if (this.windowH === window.innerHeight && event === 'resize') {
          return;
        }
        if (!this.toggleButton.classList.contains(classes$A.hide)) {
          this.toggleButton.classList.add(classes$A.hide);
        }
        if (!this.quickviewFormArea.classList.contains(classes$A.expanded)) {
          this.quickviewFormArea.classList.add(classes$A.expanded);
        }
        if (event === 'resize') {
          this.quickviewFormArea.classList.add(classes$A.expanded);
          this.toggleButton.classList.add(classes$A.hide);
          this.windowH = window.innerHeight;
        }
        setTimeout(function () {
          var imagesVisiblePartOfImages = window.innerHeight - _this28.quickviewHead.offsetHeight - _this28.quickviewFormArea.offsetHeight;
          var hasMediumVisiblePart = imagesVisiblePartOfImages < visibleParts.mediumPart && imagesVisiblePartOfImages > visibleParts.minPart;
          var missingVisiblePart = imagesVisiblePartOfImages < visibleParts.minPart;
          if (hasMediumVisiblePart || missingVisiblePart) {
            _this28.toggleButton.classList.remove(classes$A.hide);
            _this28.toggleButton.classList.add(classes$A.active);
          } else {
            _this28.toggleButton.classList.add(classes$A.hide);
          }
          if (missingVisiblePart) {
            if (event === 'loading') {
              _this28.quickviewFormArea.classList.add(classes$A.loading);
              setTimeout(function () {
                _this28.quickviewFormArea.classList.remove(classes$A.loading);
              }, 50);
            }
            _this28.quickviewFormArea.classList.remove(classes$A.expanded);
            _this28.toggleButton.classList.remove(classes$A.active);
          } else {
            _this28.quickviewFormArea.classList.add(classes$A.expanded);
          }
        }, 200);
      }
    }, {
      key: "clickEventToggleForm",
      value: function clickEventToggleForm() {
        var _this29 = this;
        if (!this.toggleButton) return;
        this.toggleButton.addEventListener('click', function () {
          _this29.toggleButton.classList.toggle(classes$A.active);
          _this29.quickviewFormArea.classList.toggle(classes$A.expanded);
        });
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        if (this.modalTemplate && this.triggerButton) {
          this.triggerButton.removeEventListener('click', this.clickQuickviewEvent);
        }
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return [selectors$Y.dataQuickview];
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var slideDown = function slideDown(target) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var checkHidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var display = window.getComputedStyle(target).display;
    if (checkHidden && display !== 'none') {
      return;
    }
    target.style.removeProperty('display');
    if (display === 'none') display = 'block';
    target.style.display = display;
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(function () {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      target.style.removeProperty('transition-timing-function');
    }, duration);
  };
  var slideUp = function slideUp(target) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(function () {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      target.style.removeProperty('transition-timing-function');
    }, duration);
  };

  // Memoize the result of a getter function if the result is not undefined
  function memoizeGetter(obj, name) {
    if (!Reflect.has(obj.constructor.prototype, name)) {
      throw new Error("".concat(obj, " does not define property \"").concat(name, "\""));
    }
    if (Reflect.getOwnPropertyDescriptor(obj.constructor.prototype, name).writable) {
      throw new Error("".concat(obj, " does not define property \"").concat(name, "\" as a getter"));
    }
    var result = Reflect.get(obj, name);
    Reflect.defineProperty(obj, name, {
      get: function get() {
        if (result !== undefined) {
          // Delete the existing getter
          Reflect.deleteProperty(obj, name);

          // Redefine a static property on this object with the resulting value
          Reflect.defineProperty(obj, name, {
            value: result
          });
        }
        return result;
      }
    });
  }
  function memoizeGetters(obj) {
    for (var _len2 = arguments.length, names = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      names[_key2 - 1] = arguments[_key2];
    }
    names.forEach(function (name) {
      memoizeGetter(obj, name);
    });
  }
  var selectors$X = {
    wrapper: '[data-add-action-wrapper]',
    addButton: '[data-add-to-cart]',
    errorBoundary: '[data-error-boundary]',
    errorDisplay: '[data-error-display]',
    popdown: '[data-product-add-popdown-wrapper]',
    disabledAjax: '[data-ajax-disable="true"]',
    quickviewModal: '[data-quickview-modal]',
    inputFile: '[type="file"]',
    buttonLabel: '[data-add-to-cart-label]'
  };
  var classes$z = {
    loading: 'loading',
    success: 'has-success'
  };
  var times$2 = {
    durationAddButtonDisable: 3500,
    hideErrorTime: 5000
  };
  var ProductAddButton = /*#__PURE__*/function (_HTMLElement4) {
    function ProductAddButton() {
      var _this30;
      _classCallCheck(this, ProductAddButton);
      _this30 = _callSuper(this, ProductAddButton);
      _this30.wrapper = _this30;
      memoizeGetters(_this30, 'popdown', 'button');
      return _this30;
    }
    _inherits(ProductAddButton, _HTMLElement4);
    return _createClass(ProductAddButton, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        if (this.button) {
          this.initWithForm();
        }
      }
    }, {
      key: "popdown",
      get: function get() {
        return document.querySelector(selectors$X.popdown);
      }
    }, {
      key: "disabledAjax",
      get: function get() {
        return document.querySelector(selectors$X.disabledAjax);
      }
    }, {
      key: "button",
      get: function get() {
        return this.wrapper.querySelector(selectors$X.addButton);
      }
    }, {
      key: "errors",
      get: function get() {
        var errorsEl = this.wrapper.querySelector(selectors$X.errors);
        if (!errorsEl) {
          var container = this.wrapper.closest(selectors$X.errorBoundary);
          if (container) {
            return container.querySelector(selectors$X.errorDisplay);
          }
        }
        return errorsEl;
      }

      /**
       * Has multi variants
       */
    }, {
      key: "initWithForm",
      value: function initWithForm() {
        this.button.addEventListener('click', function (evt) {
          evt.preventDefault();
          var outerForm = evt.target.closest('form');
          if (outerForm.querySelector(selectors$X.inputFile)) {
            return;
          }
          if (!this.disabledAjax) {
            evt.preventDefault();
          }
          this.button.setAttribute('disabled', true);
          this.button.classList.add(classes$z.loading);
          var formData = new FormData(outerForm);
          var formString = new URLSearchParams(formData).toString();
          this.addToCartAction(formString);
        }.bind(this));
      }
    }, {
      key: "addToCartAction",
      value: function addToCartAction(formData) {
        var url = "".concat(window.theme.routes.cart, "/add.js");
        var instance = this;
        axios.post(url, formData, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          instance.onSuccess(response.data);
        }).catch(function (error) {
          console.warn(error);
          instance.onError(error);
        });
      }
    }, {
      key: "onSuccess",
      value: function onSuccess(variant) {
        var _this31 = this;
        var instance = this;
        this.updateHeaderTotal();
        this.button.classList.remove(classes$z.loading);
        this.button.classList.add(classes$z.success);
        setTimeout(function () {
          _this31.button.classList.remove(classes$z.success);
          _this31.button.removeAttribute('disabled');
        }, times$2.durationAddButtonDisable);
        if (this.button.closest(selectors$X.quickviewModal)) {
          this.button.closest(selectors$X.quickviewModal).dispatchEvent(new CustomEvent('theme:quickview:close'));
        }

        // If cart is open, reload the cart instead of opening a popdown
        // if (window.theme.state.cartOpen) {
        setTimeout(function () {
          // force open shade
          window.fetch("".concat(window.theme.routes.cart, ".js")).then(this.handleErrors).then(function (response) {
            return response.json();
          }).then(function (response) {
            window.cart = response;
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: {
                cart: response
              },
              bubbles: true
            }));
            console.log('opening shade...');
            document.dispatchEvent(new CustomEvent('theme:cart:reload', {
              bubbles: true
            })); // reloading cart drawer
            $('.cart__drawer').addClass('drawer--visible').removeClass('display-none');
          });
        }, 500);

        // } else {
        //   this.popdown.dispatchEvent(
        //     new CustomEvent('theme:cart:popdown', {
        //       detail: {
        //         variant: variant,
        //       },
        //       bubbles: true,
        //     })
        //   );
        // }

        instance.liveConnectAddToCart(variant);
        if (this.disabledAjax) {
          window.location.reload();
        }
      }

      /*
       * Render why an add-to-cart failed.
       *
       * LOCAL FIX — keep this through vendor theme updates. This used to receive `error.data`,
       * which does not exist on an axios error (the payload is at `error.response.data`), so the
       * `description` branch below could never match and EVERY failure rendered as the generic
       * network message — including ordinary Shopify 422s that explain themselves perfectly well.
       *
       * Three cases, because each asks something different of the shopper:
       *   no `response`  the request never got a reply. Genuinely a network problem; retrying is
       *                  the right advice.
       *   429            Shopify is rate limiting this IP (seen on shared/datacenter IPs such as
       *                  BrowserStack). Retrying EXTENDS the throttle window, so this message must
       *                  not tell them to try again.
       *   otherwise      Shopify said why in `description` ("You can only add 1 of that to your
       *                  cart"). Show it verbatim — it is more useful than anything we'd write.
       */
    }, {
      key: "onError",
      value: function onError(error) {
        var _this32 = this;
        var response = error && error.response;
        var data = response && response.data;
        var text;
        if (!response) {
          text = 'Network error: please try again';
        } else if (response.status === 429) {
          text = 'Too many requests. Please wait a moment before adding again.';
        } else if (data && data.description) {
          text = data.description;
        } else {
          text = 'Something went wrong: please try again';
        }
        var errorsHTML = "<div class=\"errors\">".concat(text, "</div>");
        this.button.classList.remove(classes$z.loading);
        this.button.removeAttribute('disabled');
        this.errors.innerHTML = errorsHTML;
        slideDown(this.errors);
        setTimeout(function () {
          slideUp(_this32.errors);
        }, times$2.hideErrorTime);
      }
    }, {
      key: "updateHeaderTotal",
      value: function updateHeaderTotal() {
        axios.get("".concat(window.theme.routes.cart, ".js")).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: {
              cart: response.data
            },
            bubbles: true
          }));
        }).catch(function (e) {
          console.error(e);
        });
      }
    }, {
      key: "liveConnectAddToCart",
      value: function liveConnectAddToCart(variant) {
        window.liQ.push({
          "event": "conversion",
          "name": "addToCart",
          "items": [{
            name: variant.product_title,
            quantity: variant.quantity,
            price: variant.price,
            id: variant.id
          }]
        });
        // console.log('liq', window.liQ)
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  if (!customElements.get('')) {
    customElements.define('product-quickview', ProductQuickView);
  }
  if (!customElements.get('product-add-button')) {
    customElements.define('product-add-button', ProductAddButton);
  }
  var selectors$W = {
    templateAddresses: '[data-address-wrapper]',
    addressNewForm: '[data-new-address-form]',
    addressNewFormInner: '[new-address-form-inner]',
    btnNew: '.address-new-toggle',
    btnEdit: '.address-edit-toggle',
    btnDelete: '.address-delete',
    classHide: 'hide',
    dataFormId: 'data-form-id',
    dataConfirmMessage: 'data-confirm-message',
    defaultConfirmMessage: 'Are you sure you wish to delete this address?',
    editAddress: '#EditAddress',
    addressCountryNew: 'AddressCountryNew',
    addressProvinceNew: 'AddressProvinceNew',
    addressProvinceContainerNew: 'AddressProvinceContainerNew',
    addressCountryOption: '.address-country-option',
    addressCountry: 'AddressCountry',
    addressProvince: 'AddressProvince',
    addressProvinceContainer: 'AddressProvinceContainer'
  };
  var Addresses = /*#__PURE__*/function () {
    function Addresses(section) {
      _classCallCheck(this, Addresses);
      this.section = section;
      this.addressNewForm = this.section.querySelector(selectors$W.addressNewForm);
      this.init();
    }
    return _createClass(Addresses, [{
      key: "init",
      value: function init() {
        if (this.addressNewForm) {
          var section = this.section;
          var newAddressFormInner = this.addressNewForm.querySelector(selectors$W.addressNewFormInner);
          this.customerAddresses();
          var newButtons = section.querySelectorAll(selectors$W.btnNew);
          if (newButtons.length) {
            newButtons.forEach(function (element) {
              element.addEventListener('click', function () {
                newAddressFormInner.classList.toggle(selectors$W.classHide);
              });
            });
          }
          var editButtons = section.querySelectorAll(selectors$W.btnEdit);
          if (editButtons.length) {
            editButtons.forEach(function (element) {
              element.addEventListener('click', function () {
                var formId = this.getAttribute(selectors$W.dataFormId);
                section.querySelector("".concat(selectors$W.editAddress, "_").concat(formId)).classList.toggle(selectors$W.classHide);
              });
            });
          }
          var deleteButtons = section.querySelectorAll(selectors$W.btnDelete);
          if (deleteButtons.length) {
            deleteButtons.forEach(function (element) {
              element.addEventListener('click', function () {
                var formId = this.getAttribute(selectors$W.dataFormId);
                var confirmMessage = this.getAttribute(selectors$W.dataConfirmMessage);
                if (confirm(confirmMessage || selectors$W.defaultConfirmMessage)) {
                  Shopify.postLink(window.theme.routes.account_addresses_url + '/' + formId, {
                    parameters: {
                      _method: 'delete'
                    }
                  });
                }
              });
            });
          }
        }
      }
    }, {
      key: "customerAddresses",
      value: function customerAddresses() {
        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify.CountryProvinceSelector) {
          new Shopify.CountryProvinceSelector(selectors$W.addressCountryNew, selectors$W.addressProvinceNew, {
            hideElement: selectors$W.addressProvinceContainerNew
          });
        }

        // Initialize each edit form's country/province selector
        var countryOptions = this.section.querySelectorAll(selectors$W.addressCountryOption);
        countryOptions.forEach(function (element) {
          var formId = element.getAttribute(selectors$W.dataFormId);
          var countrySelector = "".concat(selectors$W.addressCountry, "_").concat(formId);
          var provinceSelector = "".concat(selectors$W.addressProvince, "_").concat(formId);
          var containerSelector = "".concat(selectors$W.addressProvinceContainer, "_").concat(formId);
          new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
          });
        });
      }
    }]);
  }();
  var template = document.querySelector(selectors$W.templateAddresses);
  if (template) {
    new Addresses(template);
  }

  /**
   * Password Template Script
   * ------------------------------------------------------------------------------
   * A file that contains code for the Password template.
   *
   * @namespace password
   */

  (function () {
    var recoverPasswordForm = document.querySelector('#RecoverPassword');
    if (recoverPasswordForm) {
      customerLogin();
    }
    function customerLogin() {
      var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
      };
      checkUrlHash();
      resetPasswordSuccess();
      document.querySelector(config.recoverPasswordForm).addEventListener('click', onShowHidePasswordForm);
      document.querySelector(config.hideRecoverPasswordLink).addEventListener('click', onShowHidePasswordForm);
      function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      }
      function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
          toggleRecoverPasswordForm();
        }
      }

      /**
       *  Show/Hide recover password form
       */
      function toggleRecoverPasswordForm() {
        var emailValue = document.querySelector('#CustomerEmail').value;
        document.querySelector('#RecoverEmail').value = emailValue;
        document.querySelector('#RecoverPasswordForm').classList.toggle('display-none');
        document.querySelector('#CustomerLoginForm').classList.toggle('display-none');
      }

      /**
       *  Show reset password success message
       */
      function resetPasswordSuccess() {
        var formSuccess = document.querySelector('.reset-password-success');
        // check if reset password form was successfully submited.
        if (formSuccess) {
          document.querySelector('#ResetSuccess').classList.remove('display-none');
        }
      }
    }
  })();
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  var registered = window.Shopify.theme.sections.registered;
  var instances = window.Shopify.theme.sections.instances;
  var selectors$V = {
    id: 'data-section-id',
    type: 'data-section-type'
  };
  var Registration = /*#__PURE__*/function () {
    function Registration() {
      var _this33 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      _classCallCheck(this, Registration);
      this.type = type;
      this.components = validateComponentsArray(components);
      this.callStack = {
        onLoad: [],
        onUnload: [],
        onSelect: [],
        onDeselect: [],
        onBlockSelect: [],
        onBlockDeselect: [],
        onReorder: []
      };
      components.forEach(function (comp) {
        for (var _i = 0, _Object$entries = Object.entries(comp); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          var arr = _this33.callStack[key];
          if (Array.isArray(arr) && typeof value === 'function') {
            arr.push(value);
          } else {
            console.warn("Unregisted function: '".concat(key, "' in component: '").concat(_this33.type, "'"));
            console.warn(value);
          }
        }
      });
    }
    return _createClass(Registration, [{
      key: "getStack",
      value: function getStack() {
        return this.callStack;
      }
    }]);
  }();
  var Section = /*#__PURE__*/function () {
    function Section(container, registration) {
      _classCallCheck(this, Section);
      this.container = validateContainerElement(container);
      this.id = container.getAttribute(selectors$V.id);
      this.type = registration.type;
      this.callStack = registration.getStack();
      try {
        this.onLoad();
      } catch (e) {
        console.warn("Error in section: ".concat(this.id));
        console.warn(this);
        console.warn(e);
      }
    }
    return _createClass(Section, [{
      key: "callFunctions",
      value: function callFunctions(key) {
        var _this34 = this;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.callStack[key].forEach(function (func) {
          var props = {
            id: _this34.id,
            type: _this34.type,
            container: _this34.container
          };
          if (e) {
            func.call(props, e);
          } else {
            func.call(props);
          }
        });
      }
    }, {
      key: "onLoad",
      value: function onLoad() {
        this.callFunctions('onLoad');
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        this.callFunctions('onUnload');
      }
    }, {
      key: "onSelect",
      value: function onSelect(e) {
        this.callFunctions('onSelect', e);
      }
    }, {
      key: "onDeselect",
      value: function onDeselect(e) {
        this.callFunctions('onDeselect', e);
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(e) {
        this.callFunctions('onBlockSelect', e);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(e) {
        this.callFunctions('onBlockDeselect', e);
      }
    }, {
      key: "onReorder",
      value: function onReorder(e) {
        this.callFunctions('onReorder', e);
      }
    }]);
  }();
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError('Theme Sections: Attempted to load section. The section container provided is not a DOM element.');
    }
    if (container.getAttribute(selectors$V.id) === null) {
      throw new Error('Theme Sections: The section container provided does not have an id assigned to the ' + selectors$V.id + ' attribute.');
    }
    return container;
  }
  function validateComponentsArray(value) {
    if (typeof value !== 'undefined' && _typeof(value) !== 'object' || value === null) {
      throw new TypeError('Theme Sections: The components object provided is not a valid');
    }
    return value;
  }

  /*
   * @shopify/theme-sections
   * -----------------------------------------------------------------------------
   *
   * A framework to provide structure to your Shopify sections and a load and unload
   * lifecycle. The lifecycle is automatically connected to theme editor events so
   * that your sections load and unload as the editor changes the content and
   * settings of your sections.
   */

  function register(type, components) {
    if (typeof type !== 'string') {
      throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered');
    }
    if (typeof registered[type] !== 'undefined') {
      throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
    }
    if (!Array.isArray(components)) {
      components = [components];
    }
    var section = new Registration(type, components);
    registered[type] = section;
    return registered;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === 'undefined') {
      containers = document.querySelectorAll('[' + selectors$V.type + ']');
    }
    containers = normalizeContainers(containers);
    types.forEach(function (type) {
      var registration = registered[type];
      if (typeof registration === 'undefined') {
        return;
      }
      containers = containers.filter(function (container) {
        // Filter from list of containers because container already has an instance loaded
        if (isInstance(container)) {
          return false;
        }

        // Filter from list of containers because container doesn't have data-section-type attribute
        if (container.getAttribute(selectors$V.type) === null) {
          return false;
        }

        // Keep in list of containers because current type doesn't match
        if (container.getAttribute(selectors$V.type) !== type) {
          return true;
        }
        instances.push(new Section(container, registration));

        // Filter from list of containers because container now has an instance loaded
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function (instance) {
      var index = instances.map(function (e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function reorder(selector) {
    var instancesToReorder = getInstances(selector);
    instancesToReorder.forEach(function (instance) {
      instance.onReorder();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];

    // Fetch first element if its an array
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }

    // If selector element is DOM element
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function (container) {
        filteredInstances = filteredInstances.concat(instances.filter(function (instance) {
          return instance.container === container;
        }));
      });

      // If select is type string
    } else if (typeof selector === 'string' || typeof firstElement === 'string') {
      var types = normalizeType(selector);
      types.forEach(function (type) {
        filteredInstances = filteredInstances.concat(instances.filter(function (instance) {
          return instance.type === type;
        }));
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    // If '*' then fetch all registered section types
    if (types === '*') {
      types = Object.keys(registered);

      // If a single section type string is passed, put it in an array
    } else if (typeof types === 'string') {
      types = [types];

      // If single section constructor is passed, transform to array with section
      // type string
    } else if (types.constructor === Section) {
      types = [types.prototype.type];

      // If array of typed section constructors is passed, transform the array to
      // type strings
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function (Section) {
        return Section.type;
      });
    }
    types = types.map(function (type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    // Nodelist with entries
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);

      // Empty Nodelist
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];

      // Handle null (document.querySelector() returns null with no match)
    } else if (containers === null) {
      containers = [];

      // Single DOM element
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector('[' + selectors$V.id + '="' + id + '"]');
      if (container !== null) {
        load(container.getAttribute(selectors$V.type), container);
      }
    });
    document.addEventListener('shopify:section:reorder', function (event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector('[' + selectors$V.id + '="' + id + '"]');
      var instance = getInstances(container)[0];
      if (_typeof(instance) === 'object') {
        reorder(container);
      }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector('[' + selectors$V.id + '="' + id + '"]');
      var instance = getInstances(container)[0];
      if (_typeof(instance) === 'object') {
        unload(container);
      }
    });
    document.addEventListener('shopify:section:select', function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (_typeof(instance) === 'object') {
        instance.onSelect(event);
      }
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (_typeof(instance) === 'object') {
        instance.onDeselect(event);
      }
    });
    document.addEventListener('shopify:block:select', function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (_typeof(instance) === 'object') {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (_typeof(instance) === 'object') {
        instance.onBlockDeselect(event);
      }
    });
  }
  var selectors$U = {
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
  };
  function modal(unique) {
    var uniqueID = "data-popup-".concat(unique);
    MicroModal.init({
      openTrigger: uniqueID,
      disableScroll: true,
      onShow: function onShow(modal, el, event) {
        event.preventDefault();
        var firstFocus = modal.querySelector(selectors$U.focusable);
        trapFocus(modal, {
          elementToFocus: firstFocus
        });
      },
      onClose: function onClose(modal, el, event) {
        event.preventDefault();
        removeTrapFocus();
        el.focus();
      }
    });
  }
  var selectors$T = {
    trigger: '[data-toggle-password-modal]',
    errors: '.storefront-password-form .errors'
  };
  var sections$n = {};
  var PasswordPage = /*#__PURE__*/function () {
    function PasswordPage(section) {
      _classCallCheck(this, PasswordPage);
      this.container = section.container;
      this.trigger = this.container.querySelector(selectors$T.trigger);
      this.errors = this.container.querySelector(selectors$T.errors);
      this.init();
    }
    return _createClass(PasswordPage, [{
      key: "init",
      value: function init() {
        modal('password');
        if (this.errors) {
          this.trigger.click();
        }
      }
    }]);
  }();
  var passwordSection = {
    onLoad: function onLoad() {
      sections$n[this.id] = new PasswordPage(this);
    }
  };
  register('password', passwordSection);

  /**
   * Gift Card Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Gift Card template.
   */

  (function () {
    var config = {
      qrCode: '#QrCode',
      giftCardCode: '.giftcard__code'
    };

    // init QR code
    var qrCode = document.querySelector(config.qrCode);
    if (qrCode) {
      function loadGiftCard() {
        var qrCodeText = qrCode.getAttribute('data-identifier');
        new QRCode(qrCode, {
          text: qrCodeText,
          width: 120,
          height: 120
        });
      }
      window.addEventListener('load', loadGiftCard);
    }
    var giftCardCode = document.querySelector(config.giftCardCode);
    if (giftCardCode) {
      // Auto-select gift card code on click, based on ID passed to the function
      function selectText() {
        var text = document.querySelector('#GiftCardDigits');
        var range = '';
        if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(text);
          range.select();
        } else if (window.getSelection) {
          var selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
      giftCardCode.addEventListener('click', selectText());
    }
  })();
  var selectors$S = {
    parallaxWrapper: '[data-parallax-wrapper]',
    parallaxImg: '[data-parallax-img]'
  };
  var sections$m = {};
  var parallaxImage = {
    onLoad: function onLoad() {
      var _this35 = this;
      sections$m[this.id] = [];
      var frames = this.container.querySelectorAll(selectors$S.parallaxWrapper);
      frames.forEach(function (frame) {
        var inner = frame.querySelector(selectors$S.parallaxImg);
        sections$m[_this35.id].push(new Rellax(inner, {
          center: true,
          round: true,
          frame: frame
        }));
      });
    },
    onUnload: function onUnload() {
      sections$m[this.id].forEach(function (image) {
        if (typeof image.destroy === 'function') {
          image.destroy();
        }
      });
    }
  };
  register('article', parallaxImage);
  var selectors$R = {
    frame: '[data-ticker-frame]',
    scale: '[data-ticker-scale]',
    text: '[data-ticker-text]',
    clone: 'data-clone',
    animationClass: 'ticker--animated',
    unloadedClass: 'ticker--unloaded',
    comparitorClass: 'ticker__comparitor',
    moveTime: 1.63,
    // 100px going to move for 1.63s
    space: 100 // 100px
  };
  var sections$l = {};
  var Ticker = /*#__PURE__*/function () {
    function Ticker(el) {
      var _this36 = this;
      var stopClone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _classCallCheck(this, Ticker);
      this.frame = el;
      this.stopClone = stopClone;
      this.scale = this.frame.querySelector(selectors$R.scale);
      this.text = this.frame.querySelector(selectors$R.text);
      this.comparitor = this.text.cloneNode(true);
      this.comparitor.classList.add(selectors$R.comparitorClass);
      this.frame.appendChild(this.comparitor);
      this.scale.classList.remove(selectors$R.unloadedClass);
      this.resizeEvent = debounce(function () {
        return _this36.checkWidth();
      }, 300);
      this.listen();
    }
    return _createClass(Ticker, [{
      key: "unload",
      value: function unload() {
        document.removeEventListener('theme:resize', this.resizeEvent);
      }
    }, {
      key: "listen",
      value: function listen() {
        document.addEventListener('theme:resize', this.resizeEvent);
        this.checkWidth();
      }
    }, {
      key: "checkWidth",
      value: function checkWidth() {
        var padding = window.getComputedStyle(this.frame).paddingLeft.replace('px', '') * 2;

        // Ticker disabled - always skip animation
        if (false) // removed by dead control flow
{ var animationTimeFrame, cloneSecond, index; } else {
          this.text.classList.add(selectors$R.animationClass);
          var clone = this.scale.querySelector("[".concat(selectors$R.clone, "]"));
          if (clone) {
            this.scale.removeChild(clone);
          }
          this.text.classList.remove(selectors$R.animationClass);
        }
      }
    }]);
  }();
  var ticker = {
    onLoad: function onLoad() {
      var _this37 = this;
      sections$l[this.id] = [];
      var el = this.container.querySelectorAll(selectors$R.frame);
      el.forEach(function (el) {
        sections$l[_this37.id].push(new Ticker(el));
      });
    },
    onUnload: function onUnload() {
      sections$l[this.id].forEach(function (el) {
        if (typeof el.unload === 'function') {
          el.unload();
        }
      });
    }
  };
  var selectors$Q = {
    speed: 'data-slider-speed',
    slideAttribute: 'data-slide',
    dataSlideIndex: 'data-slide-index'
  };
  var AnnouncementSlider = /*#__PURE__*/function () {
    function AnnouncementSlider(container, el) {
      var _this38 = this;
      _classCallCheck(this, AnnouncementSlider);
      this.container = container;
      this.slideshow = el;
      var speedElement = this.slideshow.getAttribute(selectors$Q.speed);
      this.speed = speedElement ? parseInt(speedElement) : false;
      this.scrollEvent = function () {
        return _this38.scrollEvents();
      };
      this.resizeEvent = function () {
        return _this38.resizeEvents();
      };
      if (!this.slideshow) return;
      this.flkty = null;
      this.init();
    }
    return _createClass(AnnouncementSlider, [{
      key: "init",
      value: function init() {
        var _this39 = this;
        var sliderOptions = {
          initialIndex: 0,
          autoPlay: this.speed,
          contain: true,
          pageDots: false,
          adaptiveHeight: true,
          wrapAround: true,
          groupCells: false,
          cellAlign: 'left',
          freeScroll: false,
          prevNextButtons: true,
          draggable: true,
          rightToLeft: window.isRTL,
          on: {
            ready: function ready() {
              setTimeout(function () {
                _this39.slideshow.dispatchEvent(new CustomEvent('theme:announcement:loaded', {
                  bubbles: true,
                  detail: {
                    slider: _this39
                  }
                }));
              }, 50);
            }
          }
        };
        this.flkty = new Flickity(this.slideshow, sliderOptions);
        if (this.flkty) {
          // Ensure autoplay starts on load
          if (this.speed) {
            this.flkty.playPlayer();
          }
          document.addEventListener('theme:resize', this.resizeEvent);
          document.addEventListener('theme:scroll', this.scrollEvent);
        }
      }
    }, {
      key: "resizeEvents",
      value: function resizeEvents() {
        this.flkty.resize();
      }
    }, {
      key: "scrollEvents",
      value: function scrollEvents() {
        if (this.flkty && this.speed) {
          var slideshow = this.flkty.element;
          var slideshowBottomPosition = slideshow.getBoundingClientRect().top + window.scrollY + slideshow.offsetHeight;
          if (window.pageYOffset > slideshowBottomPosition) {
            if (this.flkty.player.state === 'playing') {
              this.flkty.pausePlayer();
            }
          } else if (this.flkty.player.state === 'paused') {
            this.flkty.playPlayer();
          }
        }
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.slideshow && this.flkty) {
          document.removeEventListener('theme:resize', this.resizeEvent);
          document.removeEventListener('theme:scroll', this.scrollEvent);
          this.flkty.options.watchCSS = false;
          this.flkty.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        if (!this.slideshow) return;
        // Ignore the cloned version
        var slide = this.slideshow.querySelector("[".concat(selectors$Q.slideAttribute, "=\"").concat(evt.detail.blockId, "\"]"));
        if (!slide) return;
        var slideIndex = parseInt(slide.getAttribute(selectors$Q.dataSlideIndex));

        // Go to selected slide, pause autoplay
        this.flkty.selectCell(slideIndex);
        this.flkty.stopPlayer();
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.flkty.playPlayer();
      }
    }]);
  }();
  var selectors$P = {
    cartMessage: '[data-cart-message]',
    cartMessageValue: 'data-cart-message',
    leftToSpend: '[data-left-to-spend]',
    cartProgress: '[data-cart-progress]',
    limit: 'data-limit',
    percent: 'data-percent'
  };
  var classes$y = {
    isHidden: 'is-hidden',
    isSuccess: 'is-success'
  };
  var CartShippingMessage = /*#__PURE__*/function () {
    function CartShippingMessage(section) {
      _classCallCheck(this, CartShippingMessage);
      this.container = section;
      this.cartMessage = this.container.querySelectorAll(selectors$P.cartMessage);
      this.rate = window.Shopify.currency.rate;
      if (this.cartMessage.length > 0) {
        this.init();
      }
    }
    return _createClass(CartShippingMessage, [{
      key: "init",
      value: function init() {
        var _this40 = this;
        $('.cart__message').removeClass('is-success');
        this.cartFreeLimitShipping = Number(this.cartMessage[0].getAttribute(selectors$P.limit)) * 100 * this.rate;
        this.shippingAmount = 0;
        this.circumference = 28 * Math.PI; // radius - stroke * 4 * PI

        this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount);
        this.cartBarProgress();
        this.listen();
        this.waitForEl('#FreeShippingBanner', function () {
          // if global e is detected
          var numberPattern = /\d+/g;
          var text = $('#FreeShippingBanner').text();
          var limitPrice = Number(text.match(numberPattern)) * 100;
          _this40.cartFreeLimitShipping = limitPrice;
          // console.log('ge detected', limitPrice)
          $('.cart__message').attr('data-limit', Number(text.match(numberPattern)));
          _this40.exchangeRateConversions(_this40.cartFreeLimitShipping, _this40.shippingAmount);
          _this40.cartBarProgress();
          _this40.listen();
        });
      }
    }, {
      key: "waitForEl",
      value: function waitForEl(selector, callback) {
        var maxRetries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
        var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
        var attempts = 0;
        function checkElement() {
          if (theme_dev_jQuery(selector).length) {
            callback();
          } else if (attempts < maxRetries) {
            attempts++;
            setTimeout(checkElement, interval);
          } else {
            // console.log('Element not found after maximum retries', selector);
          }
        }
        checkElement();
      }
    }, {
      key: "listen",
      value: function listen() {
        document.addEventListener('theme:cart:change', function (event) {
          this.cart = event.detail.cart;
          this.render();
        }.bind(this));
      }
    }, {
      key: "render",
      value: function render() {
        var totalPrice = this.cart.total_price;
        this.freeShippingMessageHandle(totalPrice);
        if (this.cart && this.cart.total_price) {
          // Build cart again if the quantity of the changed product is 0 or cart discounts are changed
          if (this.cartMessage.length > 0) {
            this.shippingAmount = totalPrice;
            this.updateProgress();
          }
        }
      }
    }, {
      key: "freeShippingMessageHandle",
      value: function freeShippingMessageHandle(total) {
        var _this41 = this;
        if (this.cartMessage.length > 0) {
          this.container.querySelectorAll(selectors$P.cartMessage).forEach(function (message) {
            var hasFreeShipping = message.hasAttribute(selectors$P.cartMessageValue) && message.getAttribute(selectors$P.cartMessageValue) === 'true' && total >= _this41.cartFreeLimitShipping && total !== 0;
            message.classList.toggle(classes$y.isSuccess, hasFreeShipping);
          });
        }
      }
    }, {
      key: "cartBarProgress",
      value: function cartBarProgress() {
        var _this42 = this;
        var progress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.container.querySelectorAll(selectors$P.cartProgress).forEach(function (element) {
          _this42.setProgress(element, progress === null ? element.getAttribute(selectors$P.percent) : progress);
        });
      }
    }, {
      key: "setProgress",
      value: function setProgress(holder, percent) {
        var offset = this.circumference - percent / 100 * this.circumference / 2;
        holder.style.strokeDashoffset = offset;
      }
    }, {
      key: "updateProgress",
      value: function updateProgress() {
        var newPercentValue = this.shippingAmount / this.cartFreeLimitShipping * 100;
        this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount);
        this.cartBarProgress(newPercentValue > 100 ? 100 : newPercentValue);
      }
    }, {
      key: "exchangeRateConversions",
      value: function exchangeRateConversions(cartFreeLimitShipping, shippingAmount) {
        var _this43 = this;
        setTimeout(function () {
          //console.log(cartFreeLimitShipping, window.cart)
          var cartTotal = window.cart.total_price ? window.cart.total_price : 0;
          window.fetch("".concat(window.theme.routes.cart, ".js")).then(_this43.handleErrors).then(function (response) {
            return response.json();
          }).then(function (response) {
            //console.log(response, cartFreeLimitShipping - response.total_price)
            var cart = response;
            if (cartFreeLimitShipping - cart.total_price > 0) {
              var leftToSpend = theme.settings.currency_code_enable ? themeCurrency.formatMoney(cartFreeLimitShipping - cart.total_price, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(cartFreeLimitShipping - cart.total_price, theme.moneyFormat);
              _this43.container.querySelectorAll(selectors$P.leftToSpend).forEach(function (element) {
                element.innerHTML = leftToSpend.replace('.00', '');
              });
              $('.cart__message').removeClass('is-success');
            } else {
              $('.cart__message').addClass('is-success');
            }
          });
        }, 500);
      }
    }]);
  }();
  var selectors$O = {
    bar: '[data-bar]',
    barSlide: '[data-slide]',
    frame: '[data-ticker-frame]',
    header: '[data-header-wrapper]',
    slider: '[data-announcement-slider]',
    slideValue: 'data-slide',
    tickerScale: '[data-ticker-scale]',
    tickerText: '[data-ticker-text]',
    dataTargetReferrer: 'data-target-referrer',
    slideAttribute: 'data-slide'
  };
  var classes$x = {
    mobileClass: 'mobile',
    desktopClass: 'desktop',
    trickerAnimated: 'ticker--animated'
  };
  var sections$k = {};
  var Bar$1 = /*#__PURE__*/function () {
    function Bar$1(section) {
      _classCallCheck(this, Bar$1);
      this.container = section.container;
      this.barHolder = this.container.querySelector(selectors$O.bar);
      this.locationPath = location.href;
      this.slides = this.barHolder.querySelectorAll(selectors$O.barSlide);
      this.slider = this.barHolder.querySelector(selectors$O.slider);
      this.hasDeviceClass = '';
      new CartShippingMessage(this.container);
      this.init();
    }
    return _createClass(Bar$1, [{
      key: "init",
      value: function init() {
        this.removeAnnouncement();
        if (!this.slider) {
          this.initTickers(true);
        } else if (this.slider && this.slides && this.slides.length > 1) {
          this.initSliders();
        } else {
          this.initTickers();
        }
      }

      /**
       * Delete announcement which has a target referrer attribute and it is not contained in page URL
       */
    }, {
      key: "removeAnnouncement",
      value: function removeAnnouncement() {
        for (var index = 0; index < this.slides.length; index++) {
          var element = this.slides[index];
          if (!element.hasAttribute(selectors$O.dataTargetReferrer)) {
            continue;
          }
          if (this.locationPath.indexOf(element.getAttribute(selectors$O.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
            element.parentNode.removeChild(element);
          }
        }
      }

      /**
       * Init slider
       */
    }, {
      key: "initSliders",
      value: function initSliders() {
        var _this44 = this;
        this.slider = new AnnouncementSlider(this.container, this.slider);
        this.slider.flkty.reposition();
        this.barHolder.addEventListener('theme:announcement:loaded', function () {
          _this44.initTickers();
        });
      }

      /**
       * Init tickers in sliders
       */
    }, {
      key: "initTickers",
      value: function initTickers() {
        var stopClone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var frame = this.barHolder.querySelector(selectors$O.frame);
        if (frame) {
          new Ticker(frame, stopClone);
        }
      }
    }, {
      key: "toggleTicker",
      value: function toggleTicker(e, isStoped) {
        var tickerScale = document.querySelector(selectors$O.tickerScale);
        var element = document.querySelector("[".concat(selectors$O.slideValue, "=\"").concat(e.detail.blockId, "\"]"));
        if (isStoped && element) {
          tickerScale.setAttribute('data-stop', '');
          tickerScale.querySelectorAll(selectors$O.tickerText).forEach(function (textHolder) {
            textHolder.classList.remove(classes$x.trickerAnimated);
            textHolder.style.transform = "translate3d(".concat(-(element.offsetLeft - element.clientWidth), "px, 0, 0)");
          });
        }
        if (!isStoped && element) {
          tickerScale.querySelectorAll(selectors$O.tickerText).forEach(function (textHolder) {
            textHolder.classList.add(classes$x.trickerAnimated);
            textHolder.removeAttribute('style');
          });
          tickerScale.removeAttribute('data-stop');
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(e) {
        var _this45 = this;
        if (this.slider && typeof this.slider.onBlockSelect === 'function') {
          this.slider.onBlockSelect(e);
        } else {
          var slides = document.querySelectorAll("[".concat(selectors$O.slideAttribute, "=\"").concat(e.detail.blockId, "\"]"));
          slides.forEach(function (slide) {
            if (slide.classList.contains(classes$x.mobileClass)) {
              _this45.hasDeviceClass = classes$x.mobileClass;
            }
            if (slide.classList.contains(classes$x.desktopClass)) {
              _this45.hasDeviceClass = classes$x.desktopClass;
            }
            if (_this45.hasDeviceClass !== '') {
              slide.classList.remove(_this45.hasDeviceClass);
            }
          });
          this.toggleTicker(e, true);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(e) {
        var _this46 = this;
        if (this.slider && typeof this.slider.onBlockDeselect === 'function') {
          this.slider.onBlockDeselect(e);
        } else {
          if (this.hasDeviceClass !== '') {
            var slides = document.querySelectorAll("[".concat(selectors$O.slideAttribute, "=\"").concat(e.detail.blockId, "\"]"));
            slides.forEach(function (slide) {
              slide.classList.add(_this46.hasDeviceClass);
            });
          }
          this.toggleTicker(e, false);
        }
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.slider && typeof this.slider.onUnload === 'function') {
          this.slider.onUnload();
        }
      }
    }]);
  }();
  var bar = {
    onLoad: function onLoad() {
      sections$k[this.id] = [];
      sections$k[this.id].push(new Bar$1(this));
    },
    onUnload: function onUnload() {
      sections$k[this.id].forEach(function (el) {
        if (typeof el.onUnload === 'function') {
          el.onUnload();
        }
      });
    },
    onBlockSelect: function onBlockSelect(e) {
      sections$k[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(e);
        }
      });
    },
    onBlockDeselect: function onBlockDeselect(e) {
      sections$k[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockDeselect(e);
        }
      });
    }
  };
  register('announcement', bar);
  var selectors$N = {
    frame: '[data-ticker-frame]',
    slideValue: 'data-slide',
    tickerScale: '[data-ticker-scale]',
    tickerText: '[data-ticker-text]'
  };
  var classes$w = {
    trickerAnimated: 'ticker--animated'
  };
  var sections$j = {};
  var Bar = /*#__PURE__*/function () {
    function Bar(section) {
      _classCallCheck(this, Bar);
      this.container = section.container;
      this.init();
    }
    return _createClass(Bar, [{
      key: "init",
      value: function init() {
        this.initTickers(true);
      }

      /**
       * Init tickers in sliders
       */
    }, {
      key: "initTickers",
      value: function initTickers() {
        var stopClone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var frame = this.container.querySelector(selectors$N.frame);
        if (frame) {
          new Ticker(frame, stopClone);
        }
      }
    }, {
      key: "toggleTicker",
      value: function toggleTicker(e, isStoped) {
        var tickerScale = this.container.querySelector(selectors$N.tickerScale);
        var element = this.container.querySelector("[".concat(selectors$N.slideValue, "=\"").concat(e.detail.blockId, "\"]"));
        if (isStoped && element && tickerScale) {
          tickerScale.setAttribute('data-stop', '');
          tickerScale.querySelectorAll(selectors$N.tickerText).forEach(function (textHolder) {
            textHolder.classList.remove(classes$w.trickerAnimated);
            textHolder.style.transform = "translate3d(".concat(-(element.offsetLeft - element.clientWidth), "px, 0, 0)");
          });
        }
        if (!isStoped && element && tickerScale) {
          tickerScale.querySelectorAll(selectors$N.tickerText).forEach(function (textHolder) {
            textHolder.classList.add(classes$w.trickerAnimated);
            textHolder.removeAttribute('style');
          });
          tickerScale.removeAttribute('data-stop');
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(e) {
        this.toggleTicker(e, true);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(e) {
        this.toggleTicker(e, false);
      }
    }]);
  }();
  var logos = {
    onLoad: function onLoad() {
      sections$j[this.id] = [];
      sections$j[this.id].push(new Bar(this));
    },
    onBlockSelect: function onBlockSelect(e) {
      sections$j[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(e);
        }
      });
    },
    onBlockDeselect: function onBlockDeselect(e) {
      sections$j[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockDeselect(e);
        }
      });
    }
  };
  register('logos', logos);
  register('blog', parallaxImage);
  var selectors$M = {
    drawerWrappper: '[data-drawer]',
    drawerScrolls: '[data-drawer-scrolls]',
    underlay: '[data-drawer-underlay]',
    stagger: '[data-stagger-animation]',
    drawerToggle: 'data-drawer-toggle',
    children: ':scope > * > [data-animates]',
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
  };
  var classes$v = {
    isVisible: 'drawer--visible',
    displayNone: 'display-none'
  };
  var sections$i = {};
  var Drawer = /*#__PURE__*/function () {
    function Drawer(el) {
      _classCallCheck(this, Drawer);
      this.drawer = el;
      this.drawerScrolls = this.drawer.querySelector(selectors$M.drawerScrolls);
      this.underlay = this.drawer.querySelector(selectors$M.underlay);
      this.key = this.drawer.dataset.drawer;
      var btnSelector = "[".concat(selectors$M.drawerToggle, "='").concat(this.key, "']");
      this.buttons = document.querySelectorAll(btnSelector);
      this.staggers = this.drawer.querySelectorAll(selectors$M.stagger);
      this.connectToggle();
      this.connectDrawer();
      this.closers();
      this.staggerChildAnimations();
    }
    return _createClass(Drawer, [{
      key: "unload",
      value: function unload() {
        // wipe listeners
      }
    }, {
      key: "connectToggle",
      value: function connectToggle() {
        var _this47 = this;
        this.buttons.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            this.drawer.dispatchEvent(new CustomEvent('theme:drawer:toggle', {
              bubbles: false
            }));
          }.bind(_this47));

          // An <a role="button"> is announced as a button, so Space must activate
          // it. Links only respond to Enter natively, which would page-scroll instead.
          if (btn.tagName === 'A' && btn.getAttribute('role') === 'button') {
            btn.addEventListener('keydown', function (e) {
              if (e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                btn.click();
              }
            });
          }
        });
      }
    }, {
      key: "connectDrawer",
      value: function connectDrawer() {
        this.drawer.addEventListener('theme:drawer:toggle', function () {
          if (this.drawer.classList.contains(classes$v.isVisible)) {
            this.drawer.dispatchEvent(new CustomEvent('theme:drawer:close', {
              bubbles: false
            }));
          } else {
            this.drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
              bubbles: false
            }));
          }
        }.bind(this));
        this.drawer.addEventListener('theme:drawer:close', this.hideDrawer.bind(this));
        this.drawer.addEventListener('theme:drawer:open', this.showDrawer.bind(this));
      }
    }, {
      key: "staggerChildAnimations",
      value: function staggerChildAnimations() {
        this.staggers.forEach(function (el) {
          var children = el.querySelectorAll(selectors$M.children);
          children.forEach(function (child, index) {
            child.style.transitionDelay = "".concat(index * 50 + 10, "ms");
          });
        });
      }
    }, {
      key: "closers",
      value: function closers() {
        this.drawer.addEventListener('keyup', function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideDrawer();
          this.buttons[0].focus();
        }.bind(this));
        this.underlay.addEventListener('click', function () {
          this.hideDrawer();
        }.bind(this));
      }
    }, {
      key: "showDrawer",
      value: function showDrawer() {
        var _this48 = this;
        this.drawer.classList.remove(classes$v.displayNone);
        // animates after display none is removed
        setTimeout(function () {
          _this48.buttons.forEach(function (el) {
            return el.setAttribute('aria-expanded', true);
          });
          _this48.drawer.classList.add(classes$v.isVisible);
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
            bubbles: true,
            detail: _this48.drawerScrolls
          }));
          var firstFocus = _this48.drawer.querySelector(selectors$M.focusable);
          trapFocus(_this48.drawer, {
            elementToFocus: firstFocus
          });
        }, 1);
      }
    }, {
      key: "hideDrawer",
      value: function hideDrawer() {
        var _this49 = this;
        this.buttons.forEach(function (el) {
          return el.setAttribute('aria-expanded', false);
        });
        this.drawer.classList.remove(classes$v.isVisible);
        this.drawerScrolls.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:sliderule:close', {
          bubbles: false
        }));
        removeTrapFocus();

        // adds display none after animations
        setTimeout(function () {
          if (!_this49.drawer.classList.contains(classes$v.isVisible)) {
            _this49.drawer.classList.add(classes$v.displayNone);
          }
        }, 800);
      }
    }]);
  }();
  var drawer = {
    onLoad: function onLoad() {
      var _this50 = this;
      sections$i[this.id] = [];
      var els = this.container.querySelectorAll(selectors$M.drawerWrappper);
      els.forEach(function (el) {
        sections$i[_this50.id].push(new Drawer(el));
      });
    },
    onUnload: function onUnload() {
      sections$i[this.id].forEach(function (el) {
        if (typeof el.unload === 'function') {
          el.unload();
        }
      });
    }
  };
  var selectors$L = {
    announcement: '#shopify-section-announcement',
    transparent: 'data-header-transparent',
    header: '[data-header-wrapper] header'
  };
  var classes$u = {
    stuck: 'js__header__stuck',
    stuckAnimated: 'js__header__stuck--animated',
    triggerAnimation: 'js__header__stuck--trigger-animation',
    stuckBackdrop: 'js__header__stuck__backdrop'
  };
  var sections$h = {};
  var Sticky = /*#__PURE__*/function () {
    function Sticky(el) {
      _classCallCheck(this, Sticky);
      this.wrapper = el;
      this.type = this.wrapper.dataset.headerSticky;
      this.transparent = this.wrapper.dataset.headerTransparent;
      this.sticks = this.type === 'sticky';
      this.animated = this.type === 'directional';
      this.currentlyStuck = false;
      this.cls = this.wrapper.classList;
      var announcementEl = document.querySelector(selectors$L.announcement);
      var announcementHeight = announcementEl ? announcementEl.clientHeight : 0;
      var headerHeight = document.querySelector(selectors$L.header).clientHeight;
      this.blur = headerHeight + announcementHeight;
      this.stickDown = headerHeight + announcementHeight;
      this.stickUp = announcementHeight;
      // gdd custom - sticky filters when header touches them (not abrupt jump)
      this.headerHeight = headerHeight;
      this.filtersWrapper = document.querySelector('.collection__filters__wrapper');
      this.filtersInitialTop = this.filtersWrapper ? this.filtersWrapper.getBoundingClientRect().top + window.scrollY : null;
      this.filtersSticky = false;
      if (this.wrapper.getAttribute(selectors$L.transparent) !== 'false') {
        this.blur = announcementHeight;
      }
      if (this.sticks) {
        this.stickDown = announcementHeight;
        this.scrollDownInit();
      }
      this.listen();
    }
    return _createClass(Sticky, [{
      key: "unload",
      value: function unload() {
        document.removeEventListener('theme:scroll', this.listen);
        document.removeEventListener('theme:scroll:up', this.scrollUpDirectional);
        document.removeEventListener('theme:scroll:down', this.scrollDownDirectional);
      }
    }, {
      key: "listen",
      value: function listen() {
        var _this51 = this;
        if (this.sticks || this.animated) {
          document.addEventListener('theme:scroll', function (e) {
            if (e.detail.down) {
              if (!_this51.currentlyStuck && e.detail.position > _this51.stickDown) {
                _this51.stickSimple();
              }
              if (!_this51.currentlyBlurred && e.detail.position > _this51.blur) {
                _this51.addBlur();
              }
            } else {
              if (e.detail.position <= _this51.stickUp) {
                _this51.unstickSimple();
              }
              if (e.detail.position <= _this51.blur) {
                _this51.removeBlur();
              }
            }
            // gdd custom - handle filter sticky based on header touching filters
            _this51.updateFilterSticky(e.detail.position);
          });
        }
        if (this.animated) {
          document.addEventListener('theme:scroll:up', this.scrollUpDirectional.bind(this));
          document.addEventListener('theme:scroll:down', this.scrollDownDirectional.bind(this));
        }
      }

      // gdd custom - make filters sticky when header touches them (smooth seamless push)
    }, {
      key: "updateFilterSticky",
      value: function updateFilterSticky(scrollPosition) {
        if (!this.filtersWrapper || innerWidth <= 1025) return;

        // Trigger sticky before header reaches filters for seamless push effect
        var buffer = 57; // pixels earlier to trigger for smooth transition
        var shouldBeSticky = scrollPosition >= this.filtersInitialTop - this.headerHeight - buffer;
        if (shouldBeSticky && !this.filtersSticky) {
          this.filtersWrapper.classList.add('is-sticky');
          this.filtersSticky = true;
        } else if (!shouldBeSticky && this.filtersSticky) {
          this.filtersWrapper.classList.remove('is-sticky');
          this.filtersSticky = false;
        }
      }
    }, {
      key: "stickSimple",
      value: function stickSimple() {
        if (this.animated) {
          this.cls.add(classes$u.stuckAnimated);
        }
        // gdd custom - add sticky compensate class to body
        document.body.classList.add('sticky-compensate');
        this.cls.add(classes$u.stuck);
        this.wrapper.setAttribute(selectors$L.transparent, false);
        this.currentlyStuck = true;
      }
    }, {
      key: "unstickSimple",
      value: function unstickSimple() {
        // gdd custom - remove sticky compensate class from body
        document.body.classList.remove('sticky-compensate');
        this.cls.remove(classes$u.stuck);
        this.wrapper.setAttribute(selectors$L.transparent, this.transparent);
        if (this.animated) {
          this.cls.remove(classes$u.stuckAnimated);
        }
        this.currentlyStuck = false;
      }
    }, {
      key: "scrollDownInit",
      value: function scrollDownInit() {
        if (window.scrollY > this.stickDown) {
          this.stickSimple();
        }
        if (window.scrollY > this.blur) {
          this.addBlur();
        }
        // gdd custom - check filter sticky on page load
        this.updateFilterSticky(window.scrollY);
      }
    }, {
      key: "stickDirectional",
      value: function stickDirectional() {
        this.cls.add(classes$u.triggerAnimation);
      }
    }, {
      key: "unstickDirectional",
      value: function unstickDirectional() {
        this.cls.remove(classes$u.triggerAnimation);
      }
    }, {
      key: "scrollDownDirectional",
      value: function scrollDownDirectional() {
        this.unstickDirectional();
      }
    }, {
      key: "scrollUpDirectional",
      value: function scrollUpDirectional() {
        if (window.scrollY <= this.stickDown) {
          this.unstickDirectional();
        } else {
          this.stickDirectional();
        }
      }
    }, {
      key: "addBlur",
      value: function addBlur() {
        this.cls.add(classes$u.stuckBackdrop);
        this.currentlyBlurred = true;
      }
    }, {
      key: "removeBlur",
      value: function removeBlur() {
        this.cls.remove(classes$u.stuckBackdrop);
        this.currentlyBlurred = false;
      }
    }]);
  }();
  var stickyHeader = {
    onLoad: function onLoad() {
      sections$h = new Sticky(this.container);
    },
    onUnload: function onUnload() {
      if (typeof sections$h.unload === 'function') {
        sections$h.unload();
      }
    }
  };
  var selectors$K = {
    disclosureToggle: 'data-hover-disclosure-toggle',
    disclosureWrappper: '[data-hover-disclosure]',
    link: '[data-top-link]',
    wrapper: '[data-header-wrapper]',
    stagger: '[data-stagger]',
    staggerPair: '[data-stagger-first]',
    staggerAfter: '[data-stagger-second]',
    staggerImage: '[data-grid-item], [data-header-image]',
    mainContainer: 'main'
  };
  var classes$t = {
    isVisible: 'is-visible',
    meganavVisible: 'meganav--visible',
    grandparent: 'grandparent'
  };
  var sections$g = {};
  var disclosures = {};
  var allHoverDisclosures = [];
  var HoverDisclosure = /*#__PURE__*/function () {
    function HoverDisclosure(el) {
      _classCallCheck(this, HoverDisclosure);
      this.disclosure = el;
      this.wrapper = el.closest(selectors$K.wrapper);
      this.key = this.disclosure.id;
      var btnSelector = "[".concat(selectors$K.disclosureToggle, "='").concat(this.key, "']");
      this.trigger = document.querySelector(btnSelector);
      this.link = this.trigger.querySelector(selectors$K.link);
      this.grandparent = this.trigger.classList.contains(classes$t.grandparent);
      this.mainContainer = document.querySelector(selectors$K.mainContainer);

      // this.trigger.setAttribute('aria-haspopup', true);
      // this.trigger.setAttribute('aria-expanded', false);
      // this.trigger.setAttribute('aria-controls', this.key);

      this.connectHoverToggle();
      this.handleTablets();
      this.staggerChildAnimations();
      allHoverDisclosures.push(this);
    }
    return _createClass(HoverDisclosure, [{
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        if (this.disclosure.contains(evt.target)) {
          this.showDisclosure();
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(evt) {
        if (this.disclosure.contains(evt.target)) {
          this.hideDisclosure();
        }
      }
    }, {
      key: "showDisclosure",
      value: function showDisclosure() {
        if (this.grandparent) {
          this.wrapper.classList.add(classes$t.meganavVisible);
        } else {
          this.wrapper.classList.remove(classes$t.meganavVisible);
        }
        // this.trigger.setAttribute('aria-expanded', true);
        this.trigger.classList.add(classes$t.isVisible);
        this.disclosure.classList.add(classes$t.isVisible);
        this.mainContainer.classList.add(classes$t.isVisible);
      }
    }, {
      key: "hideDisclosure",
      value: function hideDisclosure() {
        this.disclosure.classList.remove(classes$t.isVisible);
        this.trigger.classList.remove(classes$t.isVisible);
        // this.trigger.setAttribute('aria-expanded', false);
        this.wrapper.classList.remove(classes$t.meganavVisible);
        this.mainContainer.classList.remove(classes$t.isVisible);
      }
    }, {
      key: "staggerChildAnimations",
      value: function staggerChildAnimations() {
        var simple = this.disclosure.querySelectorAll(selectors$K.stagger);
        simple.forEach(function (el, index) {
          el.style.transitionDelay = "".concat(index * 50 + 10, "ms");
        });
        var pairs = this.disclosure.querySelectorAll(selectors$K.staggerPair);
        pairs.forEach(function (child, i) {
          var d1 = i * 150;
          child.style.transitionDelay = "".concat(d1, "ms");
          child.parentElement.querySelectorAll(selectors$K.staggerAfter).forEach(function (grandchild, i2) {
            var di1 = i2 + 1;
            var d2 = di1 * 20;
            grandchild.style.transitionDelay = "".concat(d1 + d2, "ms");
          });
        });
        var images = this.disclosure.querySelectorAll(selectors$K.staggerImage);
        images.forEach(function (el, index) {
          el.style.transitionDelay = "".concat((index + 1) * 80, "ms");
        });
      }
    }, {
      key: "handleTablets",
      value: function handleTablets() {
        // first click opens the popup, second click opens the link
        this.trigger.addEventListener('touchstart', function (e) {
          var isOpen = this.disclosure.classList.contains(classes$t.isVisible);
          if (!isOpen) {
            e.preventDefault();
            this.showDisclosure();
          }
        }.bind(this), {
          passive: true
        });
      }
    }, {
      key: "connectHoverToggle",
      value: function connectHoverToggle() {
        var _this52 = this;
        this.hideTimeout = null;

        // gdd custom to prevent hover on desktop
        this.trigger.addEventListener('mouseenter', function () {
          // Clear all pending hide timeouts and close other dropdowns
          allHoverDisclosures.forEach(function (instance) {
            clearTimeout(instance.hideTimeout);
            if (instance !== _this52) {
              instance.hideDisclosure();
            }
          });
          _this52.showDisclosure();
        });
        // Open disclosure on Enter/Space key instead of focus to comply with WCAG 3.2.1
        this.link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this52.showDisclosure();
          }
        });
        this.trigger.addEventListener('mouseleave', function () {
          clearTimeout(_this52.hideTimeout);
          _this52.hideTimeout = setTimeout(function () {
            _this52.hideDisclosure();
          }, 150);
        });
        this.trigger.addEventListener('focusout', function (e) {
          var inMenu = this.trigger.contains(e.relatedTarget);
          if (!inMenu) {
            this.hideDisclosure();
          }
        }.bind(this));
        this.disclosure.addEventListener('keyup', function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideDisclosure();
        }.bind(this));
      }
    }]);
  }();
  var hoverDisclosure = {
    onLoad: function onLoad() {
      var _this53 = this;
      sections$g[this.id] = [];
      disclosures = this.container.querySelectorAll(selectors$K.disclosureWrappper);
      disclosures.forEach(function (el) {
        sections$g[_this53.id].push(new HoverDisclosure(el));
      });
    },
    onBlockSelect: function onBlockSelect(evt) {
      sections$g[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(evt);
        }
      });
    },
    onBlockDeselect: function onBlockDeselect(evt) {
      sections$g[this.id].forEach(function (el) {
        if (typeof el.onBlockDeselect === 'function') {
          el.onBlockDeselect(evt);
        }
      });
    },
    onUnload: function onUnload() {
      sections$g[this.id].forEach(function (el) {
        if (typeof el.unload === 'function') {
          el.unload();
        }
      });
    }
  };
  var selectors$J = {
    item: '[data-main-menu-text-item]',
    wrapper: '[data-text-items-wrapper]',
    text: '.navtext',
    isActive: 'data-menu-active',
    sectionOuter: '[data-header-wrapper]',
    underlineCurrent: 'data-underline-current',
    defaultItem: '.menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext'
  };
  var sections$f = {};
  var defaultPositions = null;
  var HoverLine = /*#__PURE__*/function () {
    function HoverLine(el) {
      var _this54 = this;
      _classCallCheck(this, HoverLine);
      this.wrapper = el;
      this.itemList = this.wrapper.querySelectorAll(selectors$J.item);
      this.sectionOuter = document.querySelector(selectors$J.sectionOuter);
      this.underlineCurrent = this.sectionOuter.getAttribute(selectors$J.underlineCurrent) === 'true';
      this.defaultItem = null;
      if (this.underlineCurrent) {
        this.defaultItem = this.wrapper.querySelector(selectors$J.defaultItem);
      }
      this.setDefault();
      document.fonts.ready.then(function () {
        _this54.init();
      });
    }
    return _createClass(HoverLine, [{
      key: "init",
      value: function init() {
        if (this.itemList.length) {
          this.listen();
          this.listenResize();
          this.textBottom = null;
          this.setHeight();
          if (defaultPositions) {
            if (this.defaultItem) {
              var startingLeft = this.defaultItem.offsetLeft || 0;
              this.sectionOuter.style.setProperty('--bar-left', "".concat(startingLeft, "px"));
            }
            this.reset();
          } else {
            // initialize at left edge of first item im menu
            var _startingLeft = this.sectionOuter.querySelector(selectors$J.item).offsetLeft;
            this.sectionOuter.style.setProperty('--bar-left', "".concat(_startingLeft, "px"));
            this.sectionOuter.style.setProperty('--bar-width', '0px');
          }
          this.sectionOuter.style.setProperty('--bar-opacity', '1');
        }
      }
    }, {
      key: "unload",
      value: function unload() {
        document.removeEventListener('theme:resize', this.reset);
        defaultPositions = null;
      }
    }, {
      key: "listenResize",
      value: function listenResize() {
        document.addEventListener('theme:resize', this.reset.bind(this));
      }
    }, {
      key: "setDefault",
      value: function setDefault() {
        if (this.defaultItem) {
          defaultPositions = {
            left: this.defaultItem.offsetLeft || null,
            width: this.defaultItem.clientWidth || null
          };
        }
      }
    }, {
      key: "setHeight",
      value: function setHeight() {
        var height = this.wrapper.clientHeight;
        var text = this.itemList[0].querySelector(selectors$J.text);
        var textHeight = text.clientHeight;
        var textBottom = Math.floor(height / 2 - textHeight / 2) - 4 - 10;
        if (this.textBottom !== textBottom) {
          this.sectionOuter.style.setProperty('--bar-text', "".concat(textHeight, "px"));
          this.sectionOuter.style.setProperty('--bar-bottom', "".concat(textBottom, "px"));
          this.textBottom = textBottom;
        }
      }
    }, {
      key: "listen",
      value: function listen() {
        var _this55 = this;
        this.itemList.forEach(function (element) {
          element.addEventListener('mouseenter', function (evt) {
            var item = evt.target.querySelector(selectors$J.text);
            _this55.startBar(item);
          });
        });
        this.wrapper.addEventListener('mouseleave', this.clearBar.bind(this));
      }
    }, {
      key: "startBar",
      value: function startBar(item) {
        var _this56 = this;
        this.setHeight();
        var active = this.sectionOuter.getAttribute(selectors$J.isActive) !== 'false';
        var left = item.offsetLeft;
        var width = item.clientWidth;
        if (active) {
          this.render(width, left);
        } else {
          this.sectionOuter.setAttribute(selectors$J.isActive, true);
          this.render(0, left);
          setTimeout(function () {
            _this56.render(width, left);
          }, 10);
        }
      }
    }, {
      key: "render",
      value: function render(width, left) {
        this.sectionOuter.style.setProperty('--bar-left', "".concat(left, "px"));
        this.sectionOuter.style.setProperty('--bar-width', "".concat(width, "px"));
      }
    }, {
      key: "reset",
      value: function reset() {
        this.setDefault();
        if (defaultPositions && defaultPositions.left && defaultPositions.width) {
          this.sectionOuter.style.setProperty('--bar-left', "".concat(defaultPositions.left, "px"));
          this.sectionOuter.style.setProperty('--bar-width', "".concat(defaultPositions.width, "px"));
        } else {
          this.sectionOuter.style.setProperty('--bar-width', '0px');
        }
      }
    }, {
      key: "clearBar",
      value: function clearBar() {
        var _this57 = this;
        // allow the bar to jump between text sections for cart and main menu
        this.sectionOuter.setAttribute(selectors$J.isActive, false);
        setTimeout(function () {
          var active = _this57.sectionOuter.getAttribute(selectors$J.isActive) !== 'false';
          if (!active) {
            _this57.reset();
          }
        }, 150);
      }
    }]);
  }();
  var hoverUnderline = {
    onLoad: function onLoad() {
      var _this58 = this;
      sections$f[this.id] = [];
      var els = this.container.querySelectorAll(selectors$J.wrapper);
      els.forEach(function (el) {
        sections$f[_this58.id].push(new HoverLine(el));
      });
    },
    onUnload: function onUnload() {
      sections$f[this.id].forEach(function (el) {
        if (typeof el.unload === 'function') {
          el.unload();
        }
      });
      delete sections$f[this.id];
    }
  };
  var selectors$I = {
    price: 'data-header-cart-price',
    count: 'data-header-cart-count',
    dot: 'data-header-cart-full'
  };
  var Totals = /*#__PURE__*/function () {
    function Totals(el) {
      _classCallCheck(this, Totals);
      this.section = el;
      this.counts = this.section.querySelectorAll("[".concat(selectors$I.count, "]"));
      this.prices = this.section.querySelectorAll("[".concat(selectors$I.price, "]"));
      this.dots = this.section.querySelectorAll("[".concat(selectors$I.dot, "]"));
      this.cart = null;
      this.listen();
    }
    return _createClass(Totals, [{
      key: "listen",
      value: function listen() {
        document.addEventListener('theme:cart:change', function (event) {
          this.cart = event.detail.cart;
          this.update();
        }.bind(this));
      }
    }, {
      key: "update",
      value: function update() {
        var _this59 = this;
        if (this.cart) {
          this.prices.forEach(function (price) {
            price.setAttribute(selectors$I.price, _this59.cart.total_price);
            var newTotal = themeCurrency.formatMoney(_this59.cart.total_price, theme.moneyFormat);
            price.innerHTML = newTotal;
          });
          this.counts.forEach(function (count) {
            count.setAttribute(selectors$I.count, _this59.cart.item_count);
            count.innerHTML = "(".concat(_this59.cart.item_count, ")");
          });
          this.dots.forEach(function (dot) {
            var full = _this59.cart.item_count > 0;
            dot.setAttribute(selectors$I.dot, full);
          });
        }
      }
    }]);
  }();
  var headerTotals = {
    onLoad: function onLoad() {
      new Totals(this.container);
    }
  };

  /* ---------------------------------------------------------------------------
   * DISABLED: theme's native predictive-search popdown (#search-popdown).
   *
   * Superseded by Algolia, which owns the search trigger in
   * src/js/components/algolia.js. This block was already inert before being
   * commented out: searchPopdown.onLoad queried
   * '.header__desktop__button [data-popdown-toggle]', but the trigger lives in
   * .header__search__button (sections/header.liquid), so the selector never
   * matched and SearchPopdownTriggers was never constructed.
   *
   * To revive: fix that selector, re-add `searchPopdown` to register('header', [...]),
   * and remove the competing click handler in algolia.js - otherwise both open
   * at once. Note this code also did focus-trapping, focus return and body
   * scroll lock, which Algolia's path may not.
   * ------------------------------------------------------------------------ */
  // const selectors$H = {
  // wrapper: '[data-search-popdown-wrap]',
  // popdownTrigger: 'data-popdown-toggle',
  // close: '[data-close-popdown]',
  // input: '[data-predictive-search-input]',
  // underlay: '[data-search-underlay]',
  // };
  //
  // const classes$s = {
  // underlayVisible: 'underlay--visible',
  // isVisible: 'is-visible',
  // };
  //
  // let sections$e = {};
  //
  // class SearchPopdownTriggers {
  // constructor(trigger) {
  // this.trigger = trigger;
  // this.key = this.trigger.getAttribute(selectors$H.popdownTrigger);
  // this.popdown = document.querySelector(`[id='${this.key}']`);
  // this.input = this.popdown.querySelector(selectors$H.input);
  // this.close = this.popdown.querySelector(selectors$H.close);
  // this.wrapper = this.popdown.closest(selectors$H.wrapper);
  // this.underlay = this.wrapper.querySelector(selectors$H.underlay);
  //
  // this.initTriggerEvents();
  // this.initPopdownEvents();
  // }
  //
  // initTriggerEvents() {
  // this.trigger.setAttribute('aria-haspopup', true);
  // this.trigger.setAttribute('aria-expanded', false);
  // this.trigger.setAttribute('aria-controls', this.key);
  // this.trigger.addEventListener(
  // 'click',
  // function (evt) {
  // evt.preventDefault();
  // this.showPopdown();
  // }.bind(this)
  // );
  // this.trigger.addEventListener(
  // 'keyup',
  // function (evt) {
  // if (evt.which !== window.theme.keyboardKeys.SPACE) {
  // return;
  // }
  // this.showPopdown();
  // }.bind(this)
  // );
  // }
  //
  // initPopdownEvents() {
  // this.popdown.addEventListener(
  // 'keyup',
  // function (evt) {
  // if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
  // return;
  // }
  // this.hidePopdown();
  // }.bind(this)
  // );
  // this.close.addEventListener(
  // 'click',
  // function () {
  // this.hidePopdown();
  // }.bind(this)
  // );
  // this.underlay.addEventListener(
  // 'click',
  // function () {
  // this.hidePopdown();
  // }.bind(this)
  // );
  // }
  //
  // hidePopdown() {
  // this.popdown.classList.remove(classes$s.isVisible);
  // this.underlay.classList.remove(classes$s.underlayVisible);
  // this.trigger.focus();
  // this.input.value = '';
  // removeTrapFocus();
  // this.input.dispatchEvent(new CustomEvent('theme:search:clear', {bubbles: false}));
  // this.popdown.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  // }
  //
  // showPopdown() {
  // this.input.value = '';
  // this.popdown.classList.add(classes$s.isVisible);
  // this.underlay.classList.add(classes$s.underlayVisible);
  // trapFocus(this.popdown, {elementToFocus: this.input});
  // this.popdown.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // }
  // }
  //
  // const searchPopdown = {
  // onLoad() {
  // sections$e[this.id] = {};
  // const buttonLocation = '.header__desktop__button';
  // const trigger = this.container.querySelector(`${buttonLocation} [${selectors$H.popdownTrigger}]`);
  // if (trigger) {
  // sections$e[this.id] = new SearchPopdownTriggers(trigger);
  // }
  // },
  // onUnload: function () {
  // if (typeof sections$e[this.id].unload === 'function') {
  // sections$e[this.id].unload();
  // }
  // },
  // };

  var selectors$G = {
    dataGridItemVariant: 'data-grid-item-variant',
    dataGridImage: 'data-grid-image'
  };
  var ProductGridItem = /*#__PURE__*/function (_HTMLElement5) {
    function ProductGridItem() {
      var _this60;
      _classCallCheck(this, ProductGridItem);
      _this60 = _callSuper(this, ProductGridItem);
      _this60.container = _this60;
      return _this60;
    }
    _inherits(ProductGridItem, _HTMLElement5);
    return _createClass(ProductGridItem, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.bindVariantLinks();
      }

      /**
       * Bind the sibling swatch links.
       *
       * Re-queried on every call rather than captured once in the constructor,
       * because swatch rows are now injected on hover by
       * src/js/components/swatch-hover.js — long after this element is constructed.
       * The old constructor-time NodeList was always empty for those, so clicking an
       * injected swatch did nothing.
       *
       * Idempotent: already-bound links are skipped, so calling this repeatedly (once
       * on connect, again after each injection) does not stack duplicate handlers.
       */
    }, {
      key: "bindVariantLinks",
      value: function bindVariantLinks() {
        var _this61 = this;
        this.container.querySelectorAll("a[".concat(selectors$G.dataGridItemVariant, "]")).forEach(function (element) {
          if (element.dataset.gridVariantBound === 'true') return;
          element.dataset.gridVariantBound = 'true';
          _this61.siblingHoverEvent(element);
          _this61.siblingClickEvent(element);
        });
      }
    }, {
      key: "siblingHoverEvent",
      value: function siblingHoverEvent(element) {
        var _this62 = this;
        element.addEventListener('mouseenter', function () {
          if (element.hasAttribute(selectors$G.dataGridItemVariant)) {
            // Preload image slideshow when hovering
            var product = element.getAttribute(selectors$G.dataGridItemVariant);
            _this62.container.querySelectorAll("product-grid-item-content[".concat(selectors$G.dataGridItemVariant, "]")).forEach(function (siblingElement) {
              if (siblingElement.getAttribute(selectors$G.dataGridItemVariant) === product) {
                siblingElement.querySelectorAll("[".concat(selectors$G.dataGridImage, "]")).forEach(function (image) {
                  image.classList.add('lazyload', 'lazypreload');
                });
              }
            });
          }
        });
      }
    }, {
      key: "siblingClickEvent",
      value: function siblingClickEvent(element) {
        var _this63 = this;
        // Swatches are exposed as role="radio", so Space must select them.
        // Anchors only fire click on Enter; Space would scroll the page instead.
        if (element.getAttribute('role') === 'radio') {
          element.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              element.click();
            }
          });
        }
        element.addEventListener('click', function (e) {
          e.preventDefault();
          var siblingActive = _this63.container.querySelector("a[".concat(selectors$G.dataGridItemVariant, "][aria-current=\"true\"]"));
          if (siblingActive) {
            siblingActive.removeAttribute('aria-current');
            siblingActive.setAttribute('aria-checked', 'false');
          }
          element.setAttribute('aria-current', 'true');
          element.setAttribute('aria-checked', 'true');
          if (element.hasAttribute(selectors$G.dataGridItemVariant)) {
            var product = element.getAttribute(selectors$G.dataGridItemVariant);
            _this63.container.querySelectorAll("product-grid-item-content[".concat(selectors$G.dataGridItemVariant, "]")).forEach(function (siblingElement) {
              if (siblingElement.getAttribute(selectors$G.dataGridItemVariant) === product) {
                siblingElement.removeAttribute('hidden');
              } else {
                siblingElement.setAttribute('hidden', '');
              }
            });
            _this63.container.querySelectorAll('.product__grid__price--wrapper[data-grid-price]').forEach(function (siblingPrice) {
              if (siblingPrice.getAttribute('data-grid-price') === product) {
                siblingPrice.removeAttribute('hidden');
              } else {
                siblingPrice.setAttribute('hidden', '');
              }
            });
          }
        });
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var selectors$F = {
    productGridItemLink: '[data-grid-link]',
    dataGridImages: 'data-grid-images',
    dataGridImage: 'data-grid-image',
    dataGridImageTarget: 'data-grid-image-target',
    dataGridImageTargetDefault: 'data-grid-image-target-default',
    dataGridImageCurrentVariant: 'data-grid-image-current-variant',
    dataGridImageArrowLeft: 'data-grid-images-control-left',
    dataGridImageArrowRight: 'data-grid-images-control-right',
    dataGridPagination: 'data-grid-pagination',
    dataGridPage: 'data-grid-page',
    dataGridItemVariant: 'data-grid-item-variant',
    dataStopSlideshowMobile: 'data-stop-slideshow-mobile',
    dataPopup: 'data-popup-',
    styleWidth: '--width'
  };
  var classes$r = {
    active: 'is-active',
    fade: 'is-fade',
    slideshow: 'is-slideshow',
    mobile: 'is-mobile',
    pagination: 'product-grid-item__pagination',
    productGridItemImage: 'product-grid-item__image'
  };
  var times$1 = {
    timeout: 1500 // miliseconds
  };
  var ProductGridItemContent = /*#__PURE__*/function (_HTMLElement6) {
    function ProductGridItemContent() {
      var _this64;
      _classCallCheck(this, ProductGridItemContent);
      _this64 = _callSuper(this, ProductGridItemContent);
      _this64.container = _this64;
      _this64.mobileStopSlideshow = _this64.container.getAttribute(selectors$F.dataStopSlideshowMobile) === 'true';
      _this64.imagesHolder = _this64.container.querySelector("[".concat(selectors$F.dataGridImages, "]"));
      _this64.images = _this64.container.querySelectorAll("[".concat(selectors$F.dataGridImage, "]"));
      _this64.arrowLeft = _this64.container.querySelector("[".concat(selectors$F.dataGridImageArrowLeft, "]"));
      _this64.arrowRight = _this64.container.querySelector("[".concat(selectors$F.dataGridImageArrowRight, "]"));
      _this64.links = _this64.container.querySelectorAll(selectors$F.productGridItemLink);
      _this64.imagesLimit = _this64.imagesHolder && _this64.imagesHolder.hasAttribute(selectors$F.dataGridImages) ? parseInt(_this64.imagesHolder.getAttribute(selectors$F.dataGridImages)) : 5;
      _this64.imagesCount = _this64.images.length;
      _this64.timeout = times$1.timeout;
      _this64.interval = null;
      _this64.mobileStopProgress = false;
      _this64.pagingProgressPause = false;
      _this64.pagingProgressCounter = 0;
      _this64.siblingsFetchCounter = 0;
      _this64.siblingLoadImageIndex = null;
      return _this64;
    }
    _inherits(ProductGridItemContent, _HTMLElement6);
    return _createClass(ProductGridItemContent, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this65 = this;
        if (this.images.length > 1) {
          // Create slider of PGI images if the images are more than 1
          this.createPaging();

          // Change the image if the swatch is clicked
          this.container.addEventListener('theme:swatch:change', function (e) {
            var id = e.detail.id;
            var target = _this65.container.querySelector("[".concat(selectors$F.dataGridImageTarget, "=\"").concat(id, "\"]"));
            if (target) {
              var index = target.getAttribute(selectors$F.dataGridImage);
              _this65.pagingProgressCounter = 0;
              _this65.changeImage(index);
              if (e.detail.stopSlideAnimation) {
                _this65.stopPaging();
              }
            }
          });
        }
        if (this.images.length > 1) {
          if (this.mobileStopSlideshow) {
            this.checkMobile();
            document.addEventListener('theme:resize:width', function () {
              return _this65.checkMobile();
            });
          }
          this.arrowRight.addEventListener('click', function () {
            _this65.container.querySelectorAll("[".concat(selectors$F.dataGridImage, "]")).forEach(function (image) {
              image.classList.add('lazyload', 'lazypreload');
            });
            var curImg = _this65.container.querySelector("[".concat(selectors$F.dataGridImage, "].").concat(classes$r.active));
            var changedImg = curImg && curImg.nextElementSibling ? curImg.nextElementSibling : _this65.images[0];
            if (curImg) {
              curImg.classList.remove(classes$r.active);
            }
            if (changedImg) {
              var changedImageIdx = changedImg.hasAttribute(selectors$F.dataGridImage) ? changedImg.getAttribute(selectors$F.dataGridImage) : 0;
              var activePage = _this65.container.querySelector("[".concat(selectors$F.dataGridPage, "].").concat(classes$r.active));
              var currentPage = _this65.container.querySelector("[".concat(selectors$F.dataGridPage, "=\"").concat(changedImageIdx, "\"]"));
              if (activePage) {
                activePage.classList.remove(classes$r.active);
              }
              if (currentPage) {
                currentPage.classList.add(classes$r.active);
              }
              changedImg.classList.add(classes$r.active, 'fade-in', 'lazyloaded');
            }
          });
          this.arrowLeft.addEventListener('click', function () {
            _this65.container.querySelectorAll("[".concat(selectors$F.dataGridImage, "]")).forEach(function (image) {
              image.classList.add('lazyload', 'lazypreload');
            });
            var curImg = _this65.container.querySelector("[".concat(selectors$F.dataGridImage, "].").concat(classes$r.active));
            var changedImg = curImg && curImg.previousElementSibling ? curImg.previousElementSibling : _this65.images[_this65.imagesCount - 1];
            if (curImg) {
              curImg.classList.remove(classes$r.active);
            }
            if (changedImg) {
              var changedImageIdx = changedImg.hasAttribute(selectors$F.dataGridImage) ? changedImg.getAttribute(selectors$F.dataGridImage) : 0;
              var activePage = _this65.container.querySelector("[".concat(selectors$F.dataGridPage, "].").concat(classes$r.active));
              var currentPage = _this65.container.querySelector("[".concat(selectors$F.dataGridPage, "=\"").concat(changedImageIdx, "\"]"));
              if (activePage) {
                activePage.classList.remove(classes$r.active);
              }
              if (currentPage) {
                currentPage.classList.add(classes$r.active);
              }
              changedImg.classList.add(classes$r.active, 'fade-in', 'lazyloaded');
            }
          });

          // this.container.addEventListener('mouseenter', () => {
          //   // Preload slideshow images
          //   this.container.querySelectorAll(`[${selectors$F.dataGridImage}]`).forEach((image) => {
          //     image.classList.add('lazyload', 'lazypreload');
          //   });

          //   // Start slideshow
          //   this.pagingProgressPause = this.mobileStopProgress;
          //   this.progressPaging();
          // });

          // Stop slideshow and rewind to first image
          // this.container.addEventListener('mouseleave', () => {
          //   this.pagingProgressPause = true;
          //   this.changeToCurrentVariantImage();
          //   this.progressPaging();
          // });
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name) {
        if (name === 'hidden') {
          // When hiding or showing a PGIC, reset it's slideshow to show the image for the current variant
          this.changeToCurrentVariantImage();
        }
      }
    }, {
      key: "checkMobile",
      value: function checkMobile() {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.mobileStopProgress = windowWidth < window.theme.sizes.medium;
        this.container.classList.toggle(classes$r.mobile, this.mobileStopProgress);
      }
    }, {
      key: "changeToCurrentVariantImage",
      value: function changeToCurrentVariantImage() {
        var currentVariantImage = this.container.querySelector("[".concat(selectors$F.dataGridImageCurrentVariant, "]"));
        if (!currentVariantImage) return;
        var imageIndex = currentVariantImage.getAttribute(selectors$F.dataGridImage);
        if (!imageIndex) return;
        this.pagingProgressPause = true;
        this.changeImage(Number(imageIndex));
      }
    }, {
      key: "changeImage",
      value: function changeImage() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        // Change the image of slider
        var currentImage = this.container.querySelector("[".concat(selectors$F.dataGridImage, "].").concat(classes$r.active));
        var changedImage = index !== null ? this.images[index] : currentImage && currentImage.nextSibling ? currentImage.nextSibling : this.images[0];
        if (currentImage) {
          currentImage.classList.remove(classes$r.active);
        }
        if (changedImage) {
          var changedImageIdx = changedImage.hasAttribute(selectors$F.dataGridImage) ? changedImage.getAttribute(selectors$F.dataGridImage) : 0;
          changedImage.classList.add(classes$r.active, 'fade-in', 'lazyloaded');
          this.changePaging(changedImageIdx);
        }
      }
    }, {
      key: "changePaging",
      value: function changePaging() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        // Change active class on slider pagination
        var activePage = this.container.querySelector("[".concat(selectors$F.dataGridPage, "].").concat(classes$r.active));
        var currentPage = this.container.querySelector("[".concat(selectors$F.dataGridPage, "=\"").concat(index, "\"]"));
        if (activePage) {
          activePage.style.setProperty(selectors$F.styleWidth, '100%');
          activePage.classList.remove(classes$r.active);
        }
        if (currentPage) {
          currentPage.classList.add(classes$r.active);
          this.progressPaging();
        }
      }
    }, {
      key: "progressPaging",
      value: function progressPaging() {
        var _this66 = this;
        // Play/pause the PGI images slider
        var element = this.container.querySelector("[".concat(selectors$F.dataGridPage, "].").concat(classes$r.active));
        if (!element || this.mobileStopProgress) return;
        this.stopPaging();
        if (this.pagingProgressCounter === 0) {
          element.style.setProperty(selectors$F.styleWidth, '0%');
        }
        this.interval = setInterval(function () {
          if (_this66.pagingProgressCounter >= 100 && !_this66.pagingProgressPause) {
            _this66.stopPaging();
            _this66.pagingProgressCounter = 0;
            _this66.changeImage();
          } else if (!_this66.pagingProgressPause) {
            _this66.pagingProgressCounter++;
            element.style.setProperty(selectors$F.styleWidth, "".concat(_this66.pagingProgressCounter, "%"));
          }
        }, this.timeout / 100);
      }
    }, {
      key: "stopPaging",
      value: function stopPaging() {
        // Stop slider
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
    }, {
      key: "createPaging",
      value: function createPaging() {
        // Create pagination of PGI images slider
        if (this.imagesHolder) {
          var pagination = '';
          for (var index = 0; index < this.images.length; index++) {
            var activeClass = '';
            if (index === 0) {
              activeClass = "class=\"".concat(classes$r.active, "\"");
            }
            pagination += "<span ".concat(activeClass, " ").concat(selectors$F.dataGridPage, "=\"").concat(index, "\">").concat(index + 1, "</span>");
          }
          if (pagination !== '') {
            var pagingContainer = this.container.querySelector("[".concat(selectors$F.dataGridPagination, "]"));
            if (!pagingContainer) {
              pagingContainer = document.createElement('div');
              pagingContainer.className = classes$r.pagination;
              pagingContainer.setAttribute(selectors$F.dataGridPagination, '');
            }
            pagingContainer.innerHTML = pagination;
            this.imagesHolder.parentElement.prepend(pagingContainer);
          }
        }
      }
    }, {
      key: "removePaging",
      value: function removePaging() {
        // Remove the slider pagination holder
        var pagingContainer = this.container.querySelector("[".concat(selectors$F.dataGridPagination, "]"));
        if (pagingContainer) {
          pagingContainer.remove();
        }
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ['hidden'];
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var selectors$E = {
    popoutWrapper: '[data-popout]',
    popoutList: '[data-popout-list]',
    popoutListScroll: 'data-popout-list-scroll',
    popoutToggle: 'data-popout-toggle',
    popoutInput: '[data-popout-input]',
    popoutOptions: '[data-popout-option]',
    popoutPrevent: 'data-popout-prevent',
    popoutQuantity: 'data-quantity-field',
    dataValue: 'data-value',
    ariaExpanded: 'aria-expanded',
    ariaCurrent: 'aria-current'
  };
  var classes$q = {
    listVisible: 'popout-list--visible',
    currentSuffix: '--current'
  };
  var PopoutSelect = /*#__PURE__*/function (_HTMLElement7) {
    function PopoutSelect() {
      var _this67;
      _classCallCheck(this, PopoutSelect);
      _this67 = _callSuper(this, PopoutSelect);
      _this67.container = _this67.querySelector(selectors$E.popoutWrapper);
      _this67.popoutList = _this67.container.querySelector(selectors$E.popoutList);
      _this67.popoutToggle = _this67.container.querySelector("[".concat(selectors$E.popoutToggle, "]"));
      _this67.outsidePopupToggle = document.querySelector("[".concat(selectors$E.popoutToggle, "=\"").concat(_this67.popoutList.id, "\"]"));
      _this67.popoutInput = _this67.container.querySelector(selectors$E.popoutInput);
      _this67.popoutOptions = _this67.container.querySelectorAll(selectors$E.popoutOptions);
      _this67.popoutPrevent = _this67.container.getAttribute(selectors$E.popoutPrevent) === 'true';
      _this67._connectOptions();
      _this67._connectToggle();
      _this67._connectCombobox();
      _this67._onFocusOut();
      _this67.popupListMaxWidth();
      if (_this67.popoutInput && _this67.popoutInput.hasAttribute(selectors$E.popoutQuantity)) {
        document.addEventListener('theme:popout:update', _this67.updatePopout.bind(_this67));
      }
      document.addEventListener('theme:resize', function () {
        _this67.popupListMaxWidth();
      });
      return _this67;
    }
    _inherits(PopoutSelect, _HTMLElement7);
    return _createClass(PopoutSelect, [{
      key: "unload",
      value: function unload() {
        var _this68 = this;
        if (this.popoutOptions.length) {
          this.popoutOptions.forEach(function (element) {
            element.removeEventListener('theme:popout:click', _this68.popupOptionsClick.bind(_this68));
            element.removeEventListener('click', _this68._connectOptionsDispatch.bind(_this68));
          });
        }
        this.popoutToggle.removeEventListener('click', this.popupToggleClick.bind(this));
        this.popoutToggle.removeEventListener('focusout', this.popupToggleFocusout.bind(this));
        this.popoutList.removeEventListener('focusout', this.popupListFocusout.bind(this));
        this.container.removeEventListener('keyup', this.containerKeyup.bind(this));
        if (this.outsidePopupToggle) {
          this.outsidePopupToggle.removeEventListener('click', this.popupToggleClick.bind(this));
          this.outsidePopupToggle.removeEventListener('focusout', this.popupToggleFocusout.bind(this));
        }
      }
    }, {
      key: "popupToggleClick",
      value: function popupToggleClick(evt) {
        var _this69 = this;
        var ariaExpanded = evt.currentTarget.getAttribute(selectors$E.ariaExpanded) === 'true';
        evt.currentTarget.setAttribute(selectors$E.ariaExpanded, !ariaExpanded);
        this.popoutList.classList.toggle(classes$q.listVisible);
        this.popupListMaxWidth();
        if (this.popoutList.hasAttribute(selectors$E.popoutListScroll)) {
          setTimeout(function () {
            _this69.popoutList.dispatchEvent(new CustomEvent('theme:scroll:lock', {
              bubbles: true
            }));
          }, 1);
        }
      }
    }, {
      key: "popupToggleFocusout",
      value: function popupToggleFocusout(evt) {
        var popoutLostFocus = this.container.contains(evt.relatedTarget);
        if (!popoutLostFocus) {
          this._hideList();
        }
      }
    }, {
      key: "popupListFocusout",
      value: function popupListFocusout(evt) {
        var childInFocus = evt.currentTarget.contains(evt.relatedTarget);
        var isVisible = this.popoutList.classList.contains(classes$q.listVisible);
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      }
    }, {
      key: "popupListMaxWidth",
      value: function popupListMaxWidth() {
        this.popoutList.style.maxWidth = "".concat(parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left), "px");
      }
    }, {
      key: "popupOptionsClick",
      value: function popupOptionsClick(evt) {
        var link = evt.target.closest(selectors$E.popoutOptions);
        if (link.attributes.href.value === '#') {
          evt.preventDefault();
          var attrValue = '';
          if (evt.currentTarget.getAttribute(selectors$E.dataValue)) {
            attrValue = evt.currentTarget.getAttribute(selectors$E.dataValue);
          }
          this.popoutInput.value = attrValue;
          if (this.popoutPrevent) {
            this.popoutInput.dispatchEvent(new Event('change'));
            if (!evt.detail.preventTrigger && this.popoutInput.hasAttribute(selectors$E.popoutQuantity)) {
              this.popoutInput.dispatchEvent(new Event('input'));
            }
            var currentElement = this.popoutList.querySelector("[class*=\"".concat(classes$q.currentSuffix, "\"]"));
            var targetClass = classes$q.currentSuffix;
            if (currentElement && currentElement.classList.length) {
              var _iterator = _createForOfIteratorHelper(currentElement.classList),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var currentElementClass = _step.value;
                  if (currentElementClass.includes(classes$q.currentSuffix)) {
                    targetClass = currentElementClass;
                    break;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            var listTargetElement = this.popoutList.querySelector(".".concat(targetClass));
            if (listTargetElement) {
              listTargetElement.classList.remove("".concat(targetClass));
              evt.currentTarget.parentElement.classList.add("".concat(targetClass));
            }
            var targetAttribute = this.popoutList.querySelector("[".concat(selectors$E.ariaCurrent, "]"));
            if (targetAttribute && targetAttribute.hasAttribute("".concat(selectors$E.ariaCurrent))) {
              targetAttribute.removeAttribute("".concat(selectors$E.ariaCurrent));
              evt.currentTarget.setAttribute("".concat(selectors$E.ariaCurrent), 'true');
            }
            if (attrValue !== '') {
              this.popoutToggle.textContent = attrValue;
              if (this.outsidePopupToggle) {
                this.outsidePopupToggle.textContent = attrValue;
              }
            }
            this.popupToggleFocusout(evt);
            this.popupListFocusout(evt);
          } else {
            this._submitForm(attrValue);
          }
        }
      }
    }, {
      key: "updatePopout",
      value: function updatePopout(evt) {
        var targetElement = this.popoutList.querySelector("[".concat(selectors$E.dataValue, "=\"").concat(this.popoutInput.value, "\"]"));
        if (targetElement) {
          targetElement.dispatchEvent(new CustomEvent('theme:popout:click', {
            cancelable: true,
            bubbles: true,
            detail: {
              preventTrigger: true
            }
          }));
        }
      }
    }, {
      key: "containerKeyup",
      value: function containerKeyup(evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this._hideList();
        this.popoutToggle.focus();
      }
    }, {
      key: "bodyClick",
      value: function bodyClick(evt) {
        var isOption = this.container.contains(evt.target);
        var isVisible = this.popoutList.classList.contains(classes$q.listVisible);
        this.outsidePopupToggle === evt.target;
        if (isVisible && !isOption) {
          this._hideList();
        }
      }
    }, {
      key: "_connectToggle",
      value: function _connectToggle() {
        this.popoutToggle.addEventListener('click', this.popupToggleClick.bind(this));
        if (this.outsidePopupToggle) {
          this.outsidePopupToggle.addEventListener('click', this.popupToggleClick.bind(this));
        }
      }
    }, {
      key: "_connectOptions",
      value: function _connectOptions() {
        var _this70 = this;
        if (this.popoutOptions.length) {
          this.popoutOptions.forEach(function (element) {
            element.addEventListener('theme:popout:click', _this70.popupOptionsClick.bind(_this70));
            element.addEventListener('click', _this70._connectOptionsDispatch.bind(_this70));
          });
        }
      }
    }, {
      key: "_connectOptionsDispatch",
      value: function _connectOptionsDispatch(evt) {
        var event = new CustomEvent('theme:popout:click', {
          cancelable: true,
          bubbles: true,
          detail: {
            preventTrigger: false
          }
        });
        if (!evt.target.dispatchEvent(event)) {
          evt.preventDefault();
        }
      }
    }, {
      key: "_onFocusOut",
      value: function _onFocusOut() {
        this.popoutToggle.addEventListener('focusout', this.popupToggleFocusout.bind(this));
        if (this.outsidePopupToggle) {
          this.outsidePopupToggle.addEventListener('focusout', this.popupToggleFocusout.bind(this));
        }
        this.popoutList.addEventListener('focusout', this.popupListFocusout.bind(this));
        this.container.addEventListener('keyup', this.containerKeyup.bind(this));
        document.body.addEventListener('click', this.bodyClick.bind(this));
      }
    }, {
      key: "_submitForm",
      value: function _submitForm(value) {
        var form = this.container.closest('form');
        if (form) {
          form.submit();
        }
      }
    }, {
      key: "_hideList",
      value: function _hideList() {
        this.popoutList.classList.remove(classes$q.listVisible);
        this.popoutToggle.setAttribute(selectors$E.ariaExpanded, false);
        if (this.outsidePopupToggle) {
          this.outsidePopupToggle.setAttribute(selectors$E.ariaExpanded, false);
        }
        this._clearActiveOption();
      }

      /**
       * Keyboard support for popouts exposed as a select-only combobox.
       *
       * Only runs when the toggle declares role="combobox", so popouts still using
       * the plain disclosure markup keep their existing behaviour untouched.
       *
       * Real focus stays on the toggle; aria-activedescendant moves a virtual
       * cursor through the options, mirrored visually by .is-active-option.
       */
    }, {
      key: "_connectCombobox",
      value: function _connectCombobox() {
        if (!this.popoutToggle || this.popoutToggle.getAttribute('role') !== 'combobox') return;
        this.comboboxOptions = Array.from(this.popoutList.querySelectorAll('[role="option"]'));
        if (!this.comboboxOptions.length) return;

        // Options must not be tab stops once a virtual cursor is in play, or the
        // user gets two competing focus models. Done here rather than in Liquid so
        // that without JS the options stay reachable.
        this.comboboxOptions.forEach(function (option) {
          return option.setAttribute('tabindex', '-1');
        });
        this.activeOptionIndex = -1;
        this.popoutToggle.addEventListener('keydown', this.comboboxKeydown.bind(this));
      }
    }, {
      key: "_clearActiveOption",
      value: function _clearActiveOption() {
        if (!this.comboboxOptions) return;
        this.comboboxOptions.forEach(function (option) {
          return option.classList.remove('is-active-option');
        });
        this.popoutToggle.removeAttribute('aria-activedescendant');
        this.activeOptionIndex = -1;
      }
    }, {
      key: "_setActiveOption",
      value: function _setActiveOption(index) {
        if (!this.comboboxOptions || !this.comboboxOptions.length) return;
        var bounded = Math.max(0, Math.min(index, this.comboboxOptions.length - 1));
        var option = this.comboboxOptions[bounded];
        this.comboboxOptions.forEach(function (el) {
          return el.classList.remove('is-active-option');
        });
        option.classList.add('is-active-option');
        this.activeOptionIndex = bounded;
        if (option.id) {
          this.popoutToggle.setAttribute('aria-activedescendant', option.id);
        }
        if (typeof option.scrollIntoView === 'function') {
          option.scrollIntoView({
            block: 'nearest'
          });
        }
      }
    }, {
      key: "_isListOpen",
      value: function _isListOpen() {
        return this.popoutList.classList.contains(classes$q.listVisible);
      }
    }, {
      key: "comboboxKeydown",
      value: function comboboxKeydown(evt) {
        var navigationKeys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
        var isOpen = this._isListOpen();
        if (navigationKeys.indexOf(evt.key) !== -1) {
          evt.preventDefault();
          if (!isOpen) {
            this.popoutToggle.click();
            // Open on the current selection so arrowing starts from what is set.
            var selected = this.comboboxOptions.findIndex(function (o) {
              return o.getAttribute('aria-selected') === 'true';
            });
            this._setActiveOption(selected === -1 ? 0 : selected);
            return;
          }
          if (evt.key === 'Home') return this._setActiveOption(0);
          if (evt.key === 'End') return this._setActiveOption(this.comboboxOptions.length - 1);
          var step = evt.key === 'ArrowDown' ? 1 : -1;
          return this._setActiveOption(this.activeOptionIndex + step);
        }
        if ((evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') && isOpen && this.activeOptionIndex > -1) {
          // Stop the button's native activation, which would just close the list.
          evt.preventDefault();
          this.comboboxOptions[this.activeOptionIndex].click();
        }
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var selectors$D = {
    cartNote: '[data-cart-note]'
  };
  var CartNotes = /*#__PURE__*/function () {
    function CartNotes(element) {
      _classCallCheck(this, CartNotes);
      this.inputs = element.querySelectorAll(selectors$D.cartNote);
      this.initInputs();
    }
    return _createClass(CartNotes, [{
      key: "initInputs",
      value: function initInputs() {
        var _this71 = this;
        this.inputs.forEach(function (input) {
          input.addEventListener('change', function (e) {
            var note = e.target.value.toString() || '';
            this.saveNotes(note);
          }.bind(_this71));
        });
      }
    }, {
      key: "saveNotes",
      value: function saveNotes(newNote) {
        window.fetch("".concat(window.theme.routes.cart, "/update.js"), {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            note: newNote
          })
        }).catch(function (e) {
          console.error(e);
        });
      }
    }]);
  }();
  var _getUrlString = function getUrlString(params) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var p = Object.keys(params).map(function (key) {
      var val = params[key];
      if (Object.prototype.toString.call(val) === '[object Object]' || Array.isArray(val)) {
        if (Array.isArray(params)) {
          keys.push('');
        } else {
          keys.push(key);
        }
        return _getUrlString(val, keys, Array.isArray(val));
      } else {
        var tKey = key;
        if (keys.length > 0) {
          var tKeys = isArray ? keys : [].concat(_toConsumableArray(keys), [key]);
          tKey = tKeys.reduce(function (str, k) {
            return str === '' ? k : "".concat(str, "[").concat(k, "]");
          }, '');
        }
        if (isArray) {
          return "".concat(tKey, "[]=").concat(val);
        } else {
          return "".concat(tKey, "=").concat(val);
        }
      }
    }).join('&');
    keys.pop();
    return p;
  };

  /**
   * Module to add a shipping rates calculator to cart page.
   *
   */

  var selectors$C = _defineProperty({
    html: 'html',
    submitButton: '[data-submit-shipping]',
    form: '[data-shipping-estimate-form]',
    template: '[data-response-template]',
    country: '#estimate_address_country',
    province: '#estimate_address_province',
    zip: '#estimate_address_zip',
    wrapper: '[data-response-wrapper]',
    defaultData: 'data-default-fullname',
    lang: 'lang'
  }, "defaultData", 'data-default');
  var classes$p = {
    success: 'shipping--success',
    error: 'errors',
    disable: 'disabled'
  };
  var ShippingCalculator = /*#__PURE__*/function () {
    function ShippingCalculator(section) {
      _classCallCheck(this, ShippingCalculator);
      this.button = section.container.querySelector(selectors$C.submitButton);
      this.template = section.container.querySelector(selectors$C.template).innerHTML;
      this.ratesWrapper = section.container.querySelector(selectors$C.wrapper);
      this.form = section.container.querySelector(selectors$C.form);
      this.country = section.container.querySelector(selectors$C.country);
      this.province = section.container.querySelector(selectors$C.province);
      this.zip = section.container.querySelector(selectors$C.zip);
      this.init();
    }
    return _createClass(ShippingCalculator, [{
      key: "enableButtons",
      value: function enableButtons() {
        this.button.removeAttribute('disabled');
        this.button.classList.remove(classes$p.disable);
      }
    }, {
      key: "disableButtons",
      value: function disableButtons() {
        this.button.setAttribute('disabled', 'disabled');
        this.button.classList.add(classes$p.disable);
      }
    }, {
      key: "render",
      value: function render(rates) {
        if (this.template && this.ratesWrapper) {
          var rendered = Sqrl__namespace.render(this.template, rates);
          this.ratesWrapper.innerHTML = rendered;
        }
        this.enableButtons();
        this.ratesWrapper.style.removeProperty('display');
      }
    }, {
      key: "estimate",
      value: function estimate(shipping_address) {
        var encodedShippingAddressData = encodeURI(_getUrlString({
          shipping_address: shipping_address
        }));
        var url = "".concat(window.theme.routes.cart, "/shipping_rates.json?").concat(encodedShippingAddressData);
        var instance = this;
        axios.get(url).then(function (response) {
          // handle success
          var items = instance.sanitize(response);
          instance.render(items);
          instance.enableButtons();
          instance.ratesWrapper.style.removeProperty('display');
        }).catch(function (error) {
          // handle errors
          var errors = instance.sanitizeErrors(error);
          instance.render(errors);
        });
      }
    }, {
      key: "sanitize",
      value: function sanitize(response) {
        var sanitized = {};
        sanitized.class = classes$p.success;
        sanitized.items = [];
        if (response.data.shipping_rates && response.data.shipping_rates.length > 0) {
          var rates = response.data.shipping_rates;
          rates.forEach(function (r) {
            var item = {};
            item.title = r.presentment_name;
            item.value = themeCurrency.formatMoney(r.price, theme.moneyFormat);
            sanitized.items.push(item);
          });
        } else {
          sanitized.items[0] = {
            value: theme.strings.noShippingAvailable
          };
        }
        return sanitized;
      }
    }, {
      key: "sanitizeErrors",
      value: function sanitizeErrors(response) {
        var errors = {};
        errors.class = classes$p.error;
        errors.items = [];
        if (_typeof(response.data) === 'object') {
          for (var _i2 = 0, _Object$entries2 = Object.entries(response.data); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              key = _Object$entries2$_i[0],
              value = _Object$entries2$_i[1];
            var item = {};
            item.title = key.toString();
            item.value = value.toString();
            errors.items.push(item);
          }
        } else {
          errors.items[0] = {
            value: theme.strings.noShippingAvailable
          };
        }
        return errors;
      }
    }, {
      key: "init",
      value: function init() {
        var htmlEl = document.querySelector(selectors$C.html);
        var locale = 'en';
        if (htmlEl.hasAttribute(selectors$C.lang) && htmlEl.getAttribute(selectors$C.lang) !== '') {
          locale = htmlEl.getAttribute(selectors$C.lang);
        }
        if (this.form) {
          themeAddresses.AddressForm(this.form, locale, {
            shippingCountriesOnly: true
          });
        }
        if (this.country && this.country.hasAttribute(selectors$C.defaultData) && this.province && this.province.hasAttribute(selectors$C.defaultData)) {
          this.country.addEventListener('change', function () {
            this.country.removeAttribute(selectors$C.defaultData);
            this.province.removeAttribute(selectors$C.defaultData);
          });
        }
        if (this.button) {
          this.button.addEventListener('click', function (e) {
            e.preventDefault();
            this.disableButtons();
            while (this.ratesWrapper.firstChild) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
            this.ratesWrapper.style.display = 'none';
            var shippingAddress = {};
            var elemCountryVal = this.country.value;
            var elemProvinceVal = this.province.value;
            var elemCountryData = this.country.getAttribute(selectors$C.defaultData);
            if (elemCountryVal === '' && elemCountryData && elemCountryData !== '') {
              elemCountryVal = elemCountryData;
            }
            var elemProvinceData = this.province.getAttribute(selectors$C.defaultData);
            if (elemProvinceVal === '' && elemProvinceData && elemProvinceData !== '') {
              elemProvinceVal = elemProvinceData;
            }
            shippingAddress.zip = this.zip.value || '';
            shippingAddress.country = elemCountryVal || '';
            shippingAddress.province = elemProvinceVal || '';
            this.estimate(shippingAddress);
          }.bind(this));
        }
      }
    }]);
  }();
  var selectors$B = {
    wrapper: '[data-quantity-selector]',
    increase: '[data-increase-quantity]',
    decrease: '[data-decrease-quantity]',
    input: '[data-quantity-input]'
  };
  var Quantity = /*#__PURE__*/function () {
    function Quantity(wrapper) {
      _classCallCheck(this, Quantity);
      this.wrapper = wrapper;
      this.increase = this.wrapper.querySelector(selectors$B.increase);
      this.decrease = this.wrapper.querySelector(selectors$B.decrease);
      this.input = this.wrapper.querySelector(selectors$B.input);
      this.min = parseInt(this.input.getAttribute('min'), 10);
      this.initButtons();
    }
    return _createClass(Quantity, [{
      key: "initButtons",
      value: function initButtons() {
        this.increase.addEventListener('click', function (e) {
          e.preventDefault();
          var v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v++;
          this.input.value = v;
          this.input.dispatchEvent(new Event('change'));
        }.bind(this));
        this.decrease.addEventListener('click', function (e) {
          e.preventDefault();
          var v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v--;
          v = Math.max(this.min, v);
          this.input.value = v;
          this.input.dispatchEvent(new Event('change'));
        }.bind(this));
      }
    }]);
  }();
  function initQtySection(container) {
    var quantityWrappers = container.querySelectorAll(selectors$B.wrapper);
    quantityWrappers.forEach(function (qty) {
      new Quantity(qty);
    });
  }
  var selectors$A = {
    drawer: '[data-drawer="drawer-cart"]',
    shipping: '[data-shipping-estimate-form]',
    loader: '[data-cart-loading]',
    form: '[data-cart-form]',
    emptystate: '[data-cart-empty]',
    progress: '[data-cart-progress]',
    items: '[data-line-items]',
    subtotal: '[data-cart-subtotal]',
    bottom: '[data-cart-bottom]',
    quantity: '[data-quantity-selector]',
    errors: '[data-form-errors]',
    item: '[data-cart-item]',
    finalPrice: '[data-cart-final]',
    key: 'data-update-cart',
    remove: 'data-remove-key',
    pageUpsellWrapper: '[data-cart-page-upsell-wrapper]',
    cartPage: '[data-section-type="cart"]',
    bar: '[data-cart-bar]',
    ship: '[data-cart-message]',
    itemLoadbar: '[data-item-loadbar]',
    cartMessageContainer: '[data-cart-message-container]',
    apiContent: '[data-api-content]'
  };
  var classes$o = {
    hidden: 'cart--hidden',
    loading: 'cart--loading'
  };
  var CartItems = /*#__PURE__*/function () {
    function CartItems(section) {
      _classCallCheck(this, CartItems);
      this.section = section;
      this.container = section.container;
      this.cartMessages = document.querySelectorAll(selectors$A.cartMessageContainer);
      this.bar = this.container.querySelector(selectors$A.bar);
      this.ship = this.container.querySelector(selectors$A.ship);
      this.drawer = this.container.querySelector(selectors$A.drawer);
      this.form = this.container.querySelector(selectors$A.form);
      this.loader = this.container.querySelector(selectors$A.loader);
      this.bottom = this.container.querySelector(selectors$A.bottom);
      this.items = this.container.querySelector(selectors$A.items);
      this.subtotal = this.container.querySelector(selectors$A.subtotal);
      this.errors = this.container.querySelector(selectors$A.errors);
      this.finalPrice = this.container.querySelector(selectors$A.finalPrice);
      this.emptystate = this.container.querySelector(selectors$A.emptystate);
      this.progress = this.container.querySelector(selectors$A.progress);
      this.latestClick = null;
      this.cart = null;
      this.stale = true;
      this.cartPage = document.querySelector(selectors$A.cartPage);
      this.listen();
    }
    return _createClass(CartItems, [{
      key: "listen",
      value: function listen() {
        document.addEventListener('theme:cart:change', function (event) {
          this.cart = event.detail.cart;
          this.stale = true;
        }.bind(this));
        document.addEventListener('theme:cart:init', function () {
          this.init();
        }.bind(this));
        document.addEventListener('theme:cart:reload', function () {
          var _this72 = this;
          this.stale = true;
          if (this.cart) {
            this.loadHTML();
          } else {
            this.init().then(function () {
              return _this72.loadHTML();
            });
          }
        }.bind(this));
        if (this.drawer) {
          this.drawer.addEventListener('theme:drawer:open', function () {
            var _this73 = this;
            if (this.cart) {
              this.loadHTML();
            } else {
              this.init().then(function () {
                return _this73.loadHTML();
              });
            }
            // tell the add to cart whether to open a popdown
            window.theme.state.cartOpen = true;
          }.bind(this));
          this.drawer.addEventListener('theme:drawer:close', function () {
            window.theme.state.cartOpen = false;
          });
        }
        new CartNotes(this.container);
        new CartShippingMessage(this.container);
      }
    }, {
      key: "init",
      value: function init() {
        var _this74 = this;
        return window.fetch("".concat(window.theme.routes.cart, ".js")).then(this.handleErrors).then(function (response) {
          console.log(response);
          return response.json();
        }).then(function (response) {
          _this74.cart = response;
          window.cart = _this74.cart;
          console.log('init', response);
          _this74.fireChange(response);
          _this74.setCartCount(window.cart.item_count, '.js-cart-number');
          return response;
        }).catch(function (e) {
          console.error(e);
        });
      }
    }, {
      key: "loadHTML",
      value: function loadHTML() {
        if (this.stale) {
          if (this.cart && this.cart.item_count > 0) {
            this.loadForm();
          } else {
            this.showEmpty();
            this.cartMessages.forEach(function (message) {
              new CartShippingMessage(message);
            });
          }
        }
        this.stale = false;
        if (localStorage.pdpAddtoCart) {
          this.loadForm();
          localStorage.removeItem('pdpAddtoCart');
        }
      }
    }, {
      key: "initInputs",
      value: function initInputs() {
        var _this75 = this;
        this.inputs = this.container.querySelectorAll("[".concat(selectors$A.key, "]"));
        this.inputs.forEach(function (input) {
          var key = input.getAttribute(selectors$A.key);
          input.addEventListener('change', function (e) {
            var quantity = parseInt(e.target.value, 10);
            this.latestClick = e.target.closest(selectors$A.item);
            this.lockState();
            this.updateCart(key, quantity);
          }.bind(_this75));
        });
      }
    }, {
      key: "initRemove",
      value: function initRemove() {
        var _this76 = this;
        this.removers = this.container.querySelectorAll("[".concat(selectors$A.remove, "]"));
        this.removers.forEach(function (remover) {
          var key = remover.getAttribute(selectors$A.remove);
          remover.addEventListener('click', function (e) {
            e.preventDefault();
            this.latestClick = e.target.closest(selectors$A.item);
            this.lockState();
            this.updateCart(key, 0);
          }.bind(_this76));
        });
      }
    }, {
      key: "lockState",
      value: function lockState() {
        this.latestClick.querySelector(selectors$A.itemLoadbar).style.display = 'block';
        this.loader.classList.add(classes$o.loading);
      }
    }, {
      key: "updateCart",
      value: function updateCart(clickedKey, newQuantity) {
        var _this77 = this;
        var oldCount = null;
        var newCount = null;
        var newItem = null;
        window.fetch("".concat(window.theme.routes.cart, ".js")).then(this.handleErrors).then(function (response) {
          return response.json();
        }).then(function (response) {
          var matchKeys = function matchKeys(item) {
            return item.key === clickedKey;
          };
          var index = response.items.findIndex(matchKeys);
          oldCount = response.item_count;
          newItem = response.items[index].title;
          var data = {
            line: "".concat(index + 1),
            quantity: newQuantity
          };
          return window.fetch("".concat(window.theme.routes.cart, "/change.js"), {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
        }).then(this.handleErrors).catch(function (e) {
          console.error(e);
          _this77.showError("<p>Error: ".concat(e.message || 'Could not update your cart, please try again in a second', "</p>"));
          _this77.loadHTML();
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          _this77.cart = response;
          window.cart = response;
          newCount = response.item_count;
          if (oldCount === newCount) {
            _this77.stockoutError(newItem);
            _this77.stale = true;
          } else {
            slideUp(_this77.errors);
            _this77.fireChange(response);
            _this77.stale = true;
          }
          _this77.loadHTML();
          _this77.updateTotal(_this77.cart);
        }).catch(function (e) {
          console.error(e);
          var heading = '';
          if (typeof e.status !== 'undefined') {
            heading = "<p>".concat(e.status, "</p>");
          }
          var paragraph = e.json.description || '';
          _this77.showError("".concat(heading + paragraph));
          _this77.loadHTML();
          _this77.updateTotal(_this77.cart);
        });
      }
    }, {
      key: "fireChange",
      value: function fireChange(newCart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: {
            cart: newCart
          },
          bubbles: true
        }));
      }
    }, {
      key: "updateTotal",
      value: function updateTotal(cart) {
        var _this78 = this;
        // console.log('update total', cart)
        var price = themeCurrency.formatMoney(cart.total_price, theme.moneyFormat);
        this.finalPrice.innerHTML = price;
        this.setCartCount(cart.item_count, '.js-cart-number');
        if (this.subtotal && this.cart) {
          window.fetch("".concat(window.theme.routes.root_url, "?section_id=api-cart-subtotal")).then(this.handleErrors).then(function (response) {
            return response.text();
          }).then(function (response) {
            var fresh = document.createElement('div');
            fresh.innerHTML = response;
            _this78.subtotal.innerHTML = fresh.querySelector(selectors$A.apiContent).innerHTML;
          });
        }
      }
    }, {
      key: "setCartCount",
      value: function setCartCount(newCount, elm) {
        if (!newCount) newCount = 0; // eslint-disable-line curly

        if (newCount === 0) {
          setTimeout(function () {
            return $(elm).text(newCount);
          }, 250);
        } else {
          $(elm).text(newCount);
        }
        this.setCartLabel(newCount);
      }

      /**
       * The cart control is named by aria-label, so its inner count text is not
       * announced. Re-render that label whenever the count changes, using the
       * localised singular/plural templates rendered onto the element.
       */
    }, {
      key: "setCartLabel",
      value: function setCartLabel(newCount) {
        document.querySelectorAll('[data-cart-label-other]').forEach(function (el) {
          var template = newCount === 1 ? el.dataset.cartLabelOne : el.dataset.cartLabelOther;
          if (template) {
            el.setAttribute('aria-label', template.replace('[count]', newCount));
          }
        });
      }
    }, {
      key: "showError",
      value: function showError(message) {
        var _this79 = this;
        slideUp(this.errors);
        this.errors.innerHTML = message;
        window.setTimeout(function () {
          slideDown(_this79.errors);
        }, 600);
      }
    }, {
      key: "stockoutError",
      value: function stockoutError(itemTitle) {
        var heading = "<p><strong>".concat(window.theme.strings.stockout, "</strong></p>");
        var paragraph = "<p>".concat(itemTitle, "</p>");
        this.showError("".concat(heading + paragraph));
      }
    }, {
      key: "loadForm",
      value: function loadForm() {
        var _this80 = this;
        window.fetch("".concat(window.theme.routes.root_url, "?section_id=api-cart-items")).then(this.handleErrors).then(function (response) {
          return response.text();
        }).then(function (response) {
          var fresh = document.createElement('div');
          fresh.innerHTML = response;
          _this80.items.innerHTML = fresh.querySelector(selectors$A.apiContent).innerHTML;
          _this80.showForm();
          _this80.initQuantity();
          _this80.initQuickview();
          _this80.updateTotal(_this80.cart);
        });
      }
    }, {
      key: "initQuickview",
      value: function initQuickview() {
        var pageUpsellWrapper = this.items.querySelector(selectors$A.pageUpsellWrapper);
        var oldPageUpsellWrapper = this.bottom.querySelector(selectors$A.pageUpsellWrapper);
        if (oldPageUpsellWrapper) {
          oldPageUpsellWrapper.remove();
        }
        if (this.cartPage && pageUpsellWrapper) {
          this.bottom.insertBefore(pageUpsellWrapper, this.bottom.firstChild);
        }
      }
    }, {
      key: "initQuantity",
      value: function initQuantity() {
        initQtySection(this.container);
        this.initInputs();
        this.initRemove();
      }
    }, {
      key: "showForm",
      value: function showForm() {
        if (this.bar) {
          this.bar.classList.remove(classes$o.hidden);
        }
        if (this.ship) {
          this.ship.classList.remove(classes$o.hidden);
        }
        if (this.progress) {
          this.progress.classList.remove(classes$o.hidden);
        }
        this.form.classList.remove(classes$o.hidden);
        this.bottom.classList.remove(classes$o.hidden);
        this.loader.classList.remove(classes$o.loading);
        this.emptystate.classList.add(classes$o.hidden);
      }
    }, {
      key: "showEmpty",
      value: function showEmpty() {
        if (this.bar) {
          this.bar.classList.add(classes$o.hidden);
        }
        if (this.ship) {
          this.ship.classList.add(classes$o.hidden);
        }
        if (this.progress) {
          this.progress.classList.add(classes$o.hidden);
        }
        this.emptystate.classList.remove(classes$o.hidden);
        this.loader.classList.remove(classes$o.loading);
        this.form.classList.add(classes$o.hidden);
        this.bottom.classList.add(classes$o.hidden);
      }
    }, {
      key: "handleErrors",
      value: function handleErrors(response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            var e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              json: json
            });
            throw e;
          });
        }
        return response;
      }
    }]);
  }();
  var cartDrawer = {
    onLoad: function onLoad() {
      var isDrawerCart = this.container.querySelector(selectors$A.drawer);
      if (isDrawerCart) {
        this.cart = new CartItems(this);
      }
      var hasShipping = this.container.querySelector(selectors$A.shipping);
      if (hasShipping) {
        new ShippingCalculator(this);
      }
    },
    onUnload: function onUnload() {
      if (this.cart && typeof this.cart.unload === 'function') {
        this.cart.unload();
      }
    }
  };
  var selectors$z = {
    accordionGroup: '[data-accordion-group]',
    accordionToggle: 'data-accordion-trigger',
    accordionBody: '[data-accordion-body]',
    accordionBodyMobile: 'data-accordion-body-mobile',
    rangeSlider: 'data-range-holder',
    section: '[data-section-id]'
  };
  var classes$n = {
    open: 'accordion-is-open'
  };
  var sections$d = {};
  var Accordion = /*#__PURE__*/function () {
    function Accordion(el) {
      var _this81 = this;
      _classCallCheck(this, Accordion);
      this.body = el;
      this.key = this.body.id;
      var btnSelector = "[".concat(selectors$z.accordionToggle, "='").concat(this.key, "']");
      this.trigger = document.querySelector(btnSelector);
      this.toggleEvent = function (e) {
        return _this81.clickEvents(e);
      };
      this.keyboardEvent = function (e) {
        return _this81.keyboardEvents(e);
      };
      this.hideEvent = function () {
        return _this81.hideEvents();
      };
      this.syncBodies = this.getSiblings();
      if (this.body.hasAttribute(selectors$z.accordionBodyMobile)) {
        this.mobileAccordions();
      } else {
        this.init();
      }
    }
    return _createClass(Accordion, [{
      key: "mobileAccordions",
      value: function mobileAccordions() {
        var _this82 = this;
        if (window.innerWidth < window.theme.sizes.medium) {
          this.init();
          this.setDefaultState();
        } else {
          this.resetMobileAccordions();
          this.body.removeAttribute('style');
        }
        document.addEventListener('theme:resize', function () {
          if (window.innerWidth < window.theme.sizes.medium) {
            _this82.init();
            _this82.setDefaultState();
          } else {
            _this82.resetMobileAccordions();
            _this82.body.removeAttribute('style');
          }
        });
      }
    }, {
      key: "init",
      value: function init() {
        var _this83 = this;
        // No aria-haspopup: this is a disclosure, not a menu. Setting it here also
        // silently re-added the attribute after it was removed from the templates.
        this.trigger.setAttribute('aria-expanded', false);
        this.trigger.setAttribute('aria-controls', this.key);
        this.setDefaultState();
        this.trigger.addEventListener('click', this.toggleEvent);

        // Triggers that aren't native buttons get no keyboard activation for free.
        if (this.trigger.tagName !== 'BUTTON' && this.trigger.getAttribute('role') === 'button') {
          this.trigger.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              _this83.toggleState();
            }
          });
        }
        this.body.addEventListener('keyup', this.keyboardEvent);
        this.body.addEventListener('theme:accordion:close', this.hideEvent);
      }
    }, {
      key: "hideEvents",
      value: function hideEvents() {
        this.hideAccordion();
      }
    }, {
      key: "clickEvents",
      value: function clickEvents(e) {
        e.preventDefault();
        this.toggleState();
      }
    }, {
      key: "keyboardEvents",
      value: function keyboardEvents(e) {
        if (e.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hideAccordion();
        this.trigger.focus();
      }
    }, {
      key: "resetMobileAccordions",
      value: function resetMobileAccordions() {
        this.trigger.removeEventListener('click', this.toggleEvent);
        this.body.removeEventListener('keyup', this.keyboardEvent);
        this.body.removeEventListener('theme:accordion:close', this.hideEvent);
      }
    }, {
      key: "setDefaultState",
      value: function setDefaultState() {
        if (this.trigger.classList.contains(classes$n.open)) {
          this.trigger.setAttribute('aria-expanded', true);
          showElement(this.body);
        } else {
          this.hideAccordion();
        }
      }
    }, {
      key: "getSiblings",
      value: function getSiblings() {
        var _this84 = this;
        var section = this.body.closest(selectors$z.section);
        var groupsArray = _toConsumableArray(section.querySelectorAll(selectors$z.accordionGroup));
        var syncWrapper = groupsArray.filter(function (el) {
          return el.contains(_this84.body);
        }).shift();
        if (syncWrapper) {
          var allChilden = _toConsumableArray(syncWrapper.querySelectorAll(selectors$z.accordionBody));
          var onlySiblings = allChilden.filter(function (el) {
            return !el.contains(_this84.body);
          });
          return onlySiblings;
        } else return [];
      }
    }, {
      key: "closeSiblings",
      value: function closeSiblings() {
        this.syncBodies.forEach(function (accordionBody) {
          accordionBody.dispatchEvent(new CustomEvent('theme:accordion:close', {
            bubbles: false
          }));
        });
      }
    }, {
      key: "toggleState",
      value: function toggleState() {
        if (this.trigger.classList.contains(classes$n.open)) {
          this.hideAccordion();
        } else {
          this.showAccordion();
          this.closeSiblings();

          // Collection filters
          // Accordion with range slider custom event to reload
          if (this.body.hasAttribute(selectors$z.rangeSlider)) {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('theme:price-range:reset', {
                bubbles: false
              }));
            }, 400);
          }
        }
      }
    }, {
      key: "hideAccordion",
      value: function hideAccordion() {
        this.trigger.classList.remove(classes$n.open);
        this.trigger.setAttribute('aria-expanded', false);
        slideUp(this.body);
      }
    }, {
      key: "showAccordion",
      value: function showAccordion() {
        var _this85 = this;
        this.trigger.classList.add(classes$n.open);
        this.trigger.setAttribute('aria-expanded', true);
        slideDown(this.body);
        setTimeout(function () {
          _this85.checkInViewportAndScrollTo();
        }, 600);
      }
    }, {
      key: "checkInViewportAndScrollTo",
      value: function checkInViewportAndScrollTo() {
        var rect = this.trigger.getBoundingClientRect();
        var windowScrollY = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
        var inViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        if (!inViewport) {
          window.scrollTo({
            top: windowScrollY + rect.top,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        if (this.body.contains(evt.target)) {
          this.showAccordion();
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(evt) {
        if (this.body.contains(evt.target)) {
          this.hideAccordion();
        }
      }
    }]);
  }();
  var accordion = {
    onLoad: function onLoad() {
      var _this86 = this;
      sections$d[this.id] = [];
      var els = this.container.querySelectorAll(selectors$z.accordionBody);
      els.forEach(function (el) {
        sections$d[_this86.id].push(new Accordion(el));
      });
    },
    onUnload: function onUnload() {
      sections$d[this.id].forEach(function (el) {
        if (typeof el.unload === 'function') {
          el.unload();
        }
      });
    },
    onSelect: function onSelect() {
      if (this.type === 'accordion-single') {
        this.container.querySelector("[".concat(selectors$z.accordionToggle, "]")).click();
      }
    },
    onDeselect: function onDeselect() {
      if (this.type === 'accordion-single') {
        this.container.querySelector("[".concat(selectors$z.accordionToggle, "]")).click();
      }
    },
    onBlockSelect: function onBlockSelect(evt) {
      sections$d[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(evt);
        }
      });
    },
    onBlockDeselect: function onBlockDeselect(evt) {
      sections$d[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockDeselect(evt);
        }
      });
    }
  };
  var selectors$y = {
    saleClass: 'on-sale',
    soldClass: 'sold-out'
  };
  function formatPrices(product) {
    // Apprend classes for on sale and sold out
    var on_sale = product.price < product.compare_at_price_min;
    var classes = on_sale ? selectors$y.saleClass : '';
    classes += product.available ? '' : selectors$y.soldClass;
    // Add 'from' before min price if price varies
    product.price = theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.price, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.price, theme.moneyFormat);
    if (product.price_min !== product.price_max) {
      var min = theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.price_min, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.price_min, theme.moneyFormat);
      product.price = "".concat(window.theme.strings.from, " ").concat(min);
    }
    var formatted = _objectSpread(_objectSpread({}, product), {}, {
      classes: classes,
      on_sale: on_sale,
      sold_out: !product.available,
      sold_out_translation: window.theme.strings.soldOut,
      compare_at_price: theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.compare_at_price_min, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.compare_at_price_min, theme.moneyFormat),
      compare_at_price_max: theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.compare_at_price_max, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.compare_at_price_max, theme.moneyFormat),
      compare_at_price_min: theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.compare_at_price_min, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.compare_at_price_min, theme.moneyFormat),
      price_max: theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.price_max, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.price_max, theme.moneyFormat),
      price_min: theme.settings.currency_code_enable ? themeCurrency.formatMoney(product.price_min, theme.moneyFormat) + " ".concat(theme.currencyCode) : themeCurrency.formatMoney(product.price_min, theme.moneyFormat)
    });
    return formatted;
  }
  var selectors$x = {
    wrapper: '[data-search-popdown-wrap]',
    results: '[data-predictive-search-results]',
    input: '[data-predictive-search-input]',
    productTemplate: '[data-search-product-template]',
    otherTemplate: '[data-search-other-template]',
    titleTemplate: '[data-predictive-search-title-template]',
    ariaTemplate: '[data-predictive-search-aria-template]',
    productTitleWrapper: '[data-product-title-wrap]',
    productWrapper: '[data-product-wrap]',
    collectionWrapper: '[data-collection-wrap]',
    articleWrapper: '[data-article-wrap]',
    pageWrapper: '[data-page-wrap]',
    ariaWrapper: '[data-predictive-search-aria]',
    outerWrapper: '[data-popdown-outer]',
    loader: '[data-loading-indicator]'
  };
  var classes$m = {
    dirtyClass: 'dirty',
    noResults: 'search--empty'
  };
  var sections$c = {};
  Sqrl__namespace.filters.define('animationDelay', function (index) {
    return index * 90 + 10;
  });
  var SearchPredictive = /*#__PURE__*/function () {
    function SearchPredictive(wrapper) {
      _classCallCheck(this, SearchPredictive);
      this.wrapper = wrapper;
      this.input = this.wrapper.querySelector(selectors$x.input);
      this.loader = this.wrapper.querySelector(selectors$x.loader);
      this.results = this.wrapper.querySelector(selectors$x.results);
      this.outer = this.input.closest(selectors$x.outerWrapper);
      this.productTemplate = this.wrapper.querySelector(selectors$x.productTemplate).innerHTML;
      this.otherTemplate = this.wrapper.querySelector(selectors$x.otherTemplate).innerHTML;
      this.titleTemplate = this.wrapper.querySelector(selectors$x.titleTemplate).innerHTML;
      this.ariaTemplate = this.wrapper.querySelector(selectors$x.ariaTemplate).innerHTML;
      this.productTitleWrapper = this.results.querySelector(selectors$x.productTitleWrapper);
      this.productWrapper = this.results.querySelector(selectors$x.productWrapper);
      this.collectionWrapper = this.results.querySelector(selectors$x.collectionWrapper);
      this.articleWrapper = this.results.querySelector(selectors$x.articleWrapper);
      this.pageWrapper = this.results.querySelector(selectors$x.pageWrapper);
      this.ariaWrapper = this.results.querySelector(selectors$x.ariaWrapper);
      this.initSearch();
    }
    return _createClass(SearchPredictive, [{
      key: "initSearch",
      value: function initSearch() {
        this.input.addEventListener('input', debounce(function (event) {
          var val = event.target.value;
          if (val && val.length > 1) {
            this.loader.style.display = 'block';
            this.render(val);
          } else {
            this.resetTemplates();
            this.outer.classList.remove(classes$m.dirtyClass);
          }
        }.bind(this), 300));
        this.input.addEventListener('theme:search:clear', this.reset.bind(this));
      }
    }, {
      key: "render",
      value: function render(terms) {
        var _this87 = this;
        var resources = '';
        resources += window.theme.settings.search_products ? 'product,' : '';
        resources += window.theme.settings.search_collections ? 'collection,' : '';
        resources += window.theme.settings.search_articles ? 'article,' : '';
        resources += window.theme.settings.search_pages ? 'page,' : '';
        resources = resources.slice(0, -1);
        var serialized = "".concat(window.theme.routes.root_url, "search/suggest.json?q=").concat(terms, "&resources[type]=").concat(resources, "&resources[options][unavailable_products]=last");
        fetch(serialized).then(this.handleErrors).then(function (response) {
          return response.json();
        }).then(function (response) {
          _this87.resetTemplates();
          _this87.outer.classList.add(classes$m.dirtyClass);
          var results = response.resources.results;
          var combined = [];
          for (var key in results) {
            if ({}.hasOwnProperty.call(results, key)) {
              combined.push.apply(combined, _toConsumableArray(results[key]));
            }
          }
          if (combined.length) {
            _this87.outer.classList.remove(classes$m.noResults);
            _this87.injectOther(results);
            _this87.injectProduct(results.products);
          } else {
            _this87.noResults(terms);
          }
          _this87.injectAria(terms, combined);
          trapFocus(_this87.outer, {
            elementToFocus: _this87.input
          });
        }).catch(function (e) {
          console.error(e);
        }).finally(function () {
          _this87.loader.style.display = 'none';
        });
      }
    }, {
      key: "injectAria",
      value: function injectAria(terms, combined) {
        var title = window.theme.strings.noResultsFor;
        var count = null;
        if (combined.length) {
          count = combined.length;
          title = window.theme.strings.resultsFor;
        }
        this.ariaWrapper.innerHTML = Sqrl__namespace.render(this.ariaTemplate, {
          count: count,
          title: title,
          query: terms
        });
      }
    }, {
      key: "noResults",
      value: function noResults() {
        this.resetTemplates();
        this.outer.classList.add(classes$m.dirtyClass);
        this.outer.classList.add(classes$m.noResults);
      }
    }, {
      key: "resetTemplates",
      value: function resetTemplates() {
        this.productTitleWrapper.innerHTML = '';
        this.collectionWrapper.innerHTML = '';
        this.articleWrapper.innerHTML = '';
        this.productWrapper.innerHTML = '';
        this.pageWrapper.innerHTML = '';
        this.ariaWrapper.innerHTML = '';
      }
    }, {
      key: "reset",
      value: function reset() {
        this.resetTemplates();
        this.outer.classList.remove(classes$m.dirtyClass);
        this.outer.classList.remove(classes$m.noResults);
        this.input.val = '';
      }
    }, {
      key: "injectOther",
      value: function injectOther(results) {
        var collections = results.collections;
        this.productTitleWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
          title: window.theme.strings.products,
          count: results.products.length
        });
        if (collections && collections.length) {
          var _loop = function _loop(index) {
            var collection = collections[index];
            theme.settings.excluded_collections_strict.forEach(function (excludedCollectionStrict) {
              if (excludedCollectionStrict.trim() == collection.handle) {
                collections.splice(index, 1);
              }
            });
            theme.settings.excluded_collections.forEach(function (excludedCollection) {
              if (collection.handle.includes(excludedCollection.trim())) {
                collections.splice(index, 1);
              }
            });
          };
          for (var index = collections.length - 1; index >= 0; index--) {
            _loop(index);
          }
          this.collectionWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
            title: window.theme.strings.collections,
            count: collections.length
          });
          this.collectionWrapper.innerHTML += Sqrl__namespace.render(this.otherTemplate, collections);
        }
        if (results.pages && results.pages.length) {
          this.pageWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
            title: window.theme.strings.pages,
            count: results.pages.length
          });
          this.pageWrapper.innerHTML += Sqrl__namespace.render(this.otherTemplate, results.pages);
        }
        if (results.articles && results.articles.length) {
          this.articleWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
            title: window.theme.strings.articles,
            count: results.articles.length
          });
          this.articleWrapper.innerHTML += Sqrl__namespace.render(this.otherTemplate, results.articles);
        }
      }
    }, {
      key: "injectProduct",
      value: function injectProduct(products) {
        var formatted = [];
        products.forEach(function (p) {
          var product = p;
          product = formatPrices(product);
          product.image = null;
          if (product.featured_image) {
            product.thumb = getSizedImageUrl(product.featured_image.url, '360x360');
          }
          formatted.push(product);
        });
        var productHTML = Sqrl__namespace.render(this.productTemplate, formatted);
        this.productWrapper.innerHTML += productHTML;
      }
    }, {
      key: "handleErrors",
      value: function handleErrors(response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            var e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              json: json
            });
            throw e;
          });
        }
        return response;
      }
    }]);
  }();
  var searchResultsGlobal = {
    onLoad: function onLoad() {
      var _this88 = this;
      sections$c[this.id] = [];
      var els = document.querySelectorAll(selectors$x.wrapper);
      els.forEach(function (el) {
        sections$c[_this88.id].push(new SearchPredictive(el));
      });
    },
    onUnload: function onUnload() {
      sections$c[this.id].forEach(function (el) {
        if (typeof el.unload === 'function') {
          el.unload();
        }
      });
    }
  };
  var selectors$w = {
    outer: '[data-drawer-search]',
    wrapper: '[data-search-popdown-wrap]',
    input: '[data-predictive-search-input]',
    clear: '[data-clear-input]'
  };
  var SearchDrawer = /*#__PURE__*/function () {
    function SearchDrawer(section) {
      _classCallCheck(this, SearchDrawer);
      this.outer = section.container.querySelector(selectors$w.outer);
      if (this.outer) {
        this.wrapper = this.outer.querySelector(selectors$w.wrapper);
        this.input = this.outer.querySelector(selectors$w.input);
        this.clear = this.outer.querySelector(selectors$w.clear);
        this.init();
      }
    }
    return _createClass(SearchDrawer, [{
      key: "init",
      value: function init() {
        this.clear.addEventListener('click', function (evt) {
          evt.preventDefault();
          this.clearInput();
        }.bind(this));
      }
    }, {
      key: "clearInput",
      value: function clearInput() {
        this.input.value = '';
        this.input.dispatchEvent(new CustomEvent('theme:search:clear', {
          bubbles: false
        }));
        this.input.focus();
      }
    }]);
  }();
  var searchDrawer = {
    onLoad: function onLoad() {
      this.searchDrawer = new SearchDrawer(this);
    },
    onUnload: function onUnload() {
      if (this.searchDrawer && typeof this.searchDrawer.unload === 'function') {
        this.searchDrawer.unload();
      }
    }
  };
  var selectors$v = {
    drawer: 'data-drawer-scrolls',
    slideruleOpen: 'data-sliderule-open',
    slideruleClose: 'data-sliderule-close',
    sliderulePane: 'data-sliderule-pane',
    slideruleWrappper: '[data-sliderule]',
    dataAnimates: 'data-animates',
    children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *"
  };
  var classes$l = {
    isVisible: 'is-visible',
    isHiding: 'is-hiding',
    isHidden: 'is-hidden'
  };
  var sections$b = {};
  var HeaderMobileSliderule = /*#__PURE__*/function () {
    function HeaderMobileSliderule(el) {
      _classCallCheck(this, HeaderMobileSliderule);
      this.sliderule = el;
      this.wrapper = el.closest(selectors$v.wrapper);
      this.key = this.sliderule.id;
      var btnSelector = "[".concat(selectors$v.slideruleOpen, "='").concat(this.key, "']");
      var exitSelector = "[".concat(selectors$v.slideruleClose, "='").concat(this.key, "']");
      this.trigger = document.querySelector(btnSelector);
      this.drawer = document.querySelector("[".concat(selectors$v.drawer, "]"));
      this.exit = document.querySelectorAll(exitSelector);
      this.pane = document.querySelector("[".concat(selectors$v.sliderulePane, "]"));
      this.children = this.sliderule.querySelectorAll(selectors$v.children);
      this.trigger.setAttribute('aria-haspopup', true);
      this.trigger.setAttribute('aria-expanded', false);
      this.trigger.setAttribute('aria-controls', this.key);
      this.clickEvents();
      this.staggerChildAnimations();
      document.addEventListener('theme:sliderule:close', this.closeSliderule.bind(this));
    }
    return _createClass(HeaderMobileSliderule, [{
      key: "clickEvents",
      value: function clickEvents() {
        var _this89 = this;
        this.trigger.addEventListener('click', function () {
          this.showSliderule();
        }.bind(this));
        this.exit.forEach(function (element) {
          element.addEventListener('click', function () {
            this.hideSliderule();
          }.bind(_this89));
        });
      }
    }, {
      key: "keyboardEvents",
      value: function keyboardEvents() {
        this.trigger.addEventListener('keyup', function (evt) {
          if (evt.which !== window.theme.keyboardKeys.SPACE) {
            return;
          }
          this.showSliderule();
        }.bind(this));
        this.sliderule.addEventListener('keyup', function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideSliderule();
          this.buttons[0].focus();
        }.bind(this));
      }
    }, {
      key: "staggerChildAnimations",
      value: function staggerChildAnimations() {
        var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var childrenArr = reverse ? Array.prototype.slice.call(this.children).slice().reverse() : this.children;
        childrenArr.forEach(function (child, index) {
          child.style.transitionDelay = index * 50 + 10 + 'ms';
        });
      }
    }, {
      key: "hideSliderule",
      value: function hideSliderule() {
        var _this90 = this;
        var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var paneStyle = window.getComputedStyle(this.pane);
        var paneTransitionDuration = parseFloat(paneStyle.getPropertyValue('transition-duration')) * 1000;
        var children = close ? this.pane.querySelectorAll(".".concat(classes$l.isVisible)) : this.children;
        this.pane.style.setProperty('--sliderule-height', 'auto');
        this.staggerChildAnimations(true);
        this.pane.classList.add(classes$l.isHiding);
        this.sliderule.classList.add(classes$l.isHiding);
        this.sliderule.classList.remove(classes$l.isVisible);
        children.forEach(function (el) {
          el.classList.remove(classes$l.isVisible);
        });
        var newPosition = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
        this.pane.setAttribute(selectors$v.sliderulePane, newPosition);
        var hidedSelector = close ? "[".concat(selectors$v.dataAnimates, "].").concat(classes$l.isHidden) : "[".concat(selectors$v.dataAnimates, "=\"").concat(newPosition, "\"].").concat(classes$l.isHidden);
        var hidedItems = this.pane.querySelectorAll(hidedSelector);
        if (hidedItems.length) {
          hidedItems.forEach(function (element) {
            element.classList.remove(classes$l.isHidden);
          });
        }
        setTimeout(function () {
          _this90.pane.classList.remove(classes$l.isHiding);
          _this90.sliderule.classList.remove(classes$l.isHiding);
          _this90.staggerChildAnimations();
        }, paneTransitionDuration);
      }
    }, {
      key: "showSliderule",
      value: function showSliderule() {
        this.pane.style.setProperty('--sliderule-height', 'auto');
        this.sliderule.classList.add(classes$l.isVisible);
        this.children.forEach(function (el) {
          el.classList.add(classes$l.isVisible);
        });
        var oldPosition = parseInt(this.pane.dataset.sliderulePane, 10);
        var newPosition = oldPosition + 1;
        this.pane.setAttribute(selectors$v.sliderulePane, newPosition);
        var hidedItems = this.pane.querySelectorAll("[".concat(selectors$v.dataAnimates, "=\"").concat(oldPosition, "\"]"));
        if (hidedItems.length) {
          var hidedItemsTransition = parseFloat(window.getComputedStyle(hidedItems[0]).getPropertyValue('transition-duration')) * 1000;
          setTimeout(function () {
            hidedItems.forEach(function (element) {
              element.classList.add(classes$l.isHidden);
            });
          }, hidedItemsTransition);
        }
        var newHeight = parseInt(this.trigger.nextElementSibling.offsetHeight);
        this.pane.style.setProperty('--sliderule-height', "".concat(newHeight, "px"));
        var drawerScrollY = this.drawer.scrollTop;
        var scrollToElement = this.pane.offsetTop;
        var enableScrollTo = scrollToElement < drawerScrollY && this.pane.offsetHeight >= this.drawer.offsetHeight;
        if (enableScrollTo) {
          this.drawer.scrollTo({
            top: scrollToElement,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    }, {
      key: "closeSliderule",
      value: function closeSliderule() {
        if (this.pane && this.pane.hasAttribute(selectors$v.sliderulePane) && parseInt(this.pane.getAttribute(selectors$v.sliderulePane)) > 0) {
          this.hideSliderule(true);
          if (parseInt(this.pane.getAttribute(selectors$v.sliderulePane)) > 0) {
            this.pane.setAttribute(selectors$v.sliderulePane, 0);
          }
        }
      }
    }]);
  }();
  var headerMobileSliderule = {
    onLoad: function onLoad() {
      var _this91 = this;
      sections$b[this.id] = [];
      var els = this.container.querySelectorAll(selectors$v.slideruleWrappper);
      els.forEach(function (el) {
        sections$b[_this91.id].push(new HeaderMobileSliderule(el));
      });
    }
  };
  var selectors$u = {
    wrapper: '[data-product-add-popdown-wrapper]',
    closeDrawer: '[data-close-popdown]',
    apiContent: '[data-api-content]',
    cartSectionAjax: '[data-ajax-disable="false"]',
    ajaxDisabled: '[data-ajax-disable="true"]',
    cartToggleButton: '[data-drawer-toggle="drawer-cart"]',
    cartDrawer: '[data-drawer="drawer-cart"]'
  };
  var classes$k = {
    visible: 'is-visible'
  };
  var globalTimer;
  var CartPopdown = /*#__PURE__*/function () {
    function CartPopdown() {
      var _this92 = this;
      _classCallCheck(this, CartPopdown);
      this.drawer = document.querySelector(selectors$u.wrapper);
      this.cartSectionAjax = document.querySelector(selectors$u.cartSectionAjax);
      this.ajaxDisabled = document.querySelector(selectors$u.ajaxDisabled);
      document.addEventListener('theme:cart:popdown', function (e) {
        if (_this92.cartSectionAjax) {
          // if we are on the cart page, refresh the cart without popdown
          _this92.cartSectionAjax.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
          }));
        } else if (_this92.ajaxDisabled) {
          // ajax is disabled, refresh the whole page
          window.location.reload();
        } else {
          _this92.renderPopdown(e);
        }
      });
    }
    return _createClass(CartPopdown, [{
      key: "renderPopdown",
      value: function renderPopdown(event) {
        var variant = event.detail.variant;
        var url = "".concat(window.theme.routes.root_url, "variants/").concat(variant.id, "/?section_id=api-product-popdown");
        var instance = this;
        axios.get(url).then(function (response) {
          // handle success
          var fresh = document.createElement('div');
          fresh.innerHTML = response.data;
          instance.drawer.innerHTML = fresh.querySelector(selectors$u.apiContent).innerHTML;
          instance.connectCartButton();
          instance.connectCloseButton();
        }).catch(function (error) {
          console.warn(error);
        });
      }
    }, {
      key: "connectCloseButton",
      value: function connectCloseButton() {
        // Enable close button
        this.drawer.classList.add(classes$k.visible);
        var closer = this.drawer.querySelector(selectors$u.closeDrawer);
        closer.addEventListener('click', function (e) {
          e.preventDefault();
          this.drawer.classList.remove(classes$k.visible);
        }.bind(this));
        this.popdownTimer();
      }
    }, {
      key: "connectCartButton",
      value: function connectCartButton() {
        // Hook into cart drawer
        var cartButton = this.drawer.querySelector(selectors$u.cartToggleButton);
        var cartDrawer = document.querySelector(selectors$u.cartDrawer);
        if (cartDrawer) {
          cartButton.addEventListener('click', function (e) {
            e.preventDefault();
            this.drawer.classList.remove(classes$k.visible);
            cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
              bubbles: false
            }));
          }.bind(this));
        }
      }
    }, {
      key: "popdownTimer",
      value: function popdownTimer() {
        var _this93 = this;
        clearTimeout(globalTimer);
        globalTimer = setTimeout(function () {
          _this93.drawer.classList.remove(classes$k.visible);
        }, 5000);
      }
    }]);
  }();
  var cartPopdown = {
    onLoad: function onLoad() {
      new CartPopdown(this);
    }
  };
  var selectors$t = {
    widthContent: '[data-takes-space]',
    desktop: '[data-header-desktop]',
    cloneClass: 'js__header__clone',
    showMobileClass: 'js__show__mobile',
    backfill: '[data-header-backfill]',
    transparent: 'data-header-transparent',
    overrideBorder: 'header-override-border',
    firstSectionHasImage: '.main-content > .shopify-section:first-child [data-overlay-header]',
    preventTransparentHeader: '.main-content > .shopify-section:first-child [data-prevent-transparent-header]',
    deadLink: '.navlink[href="#"]'
  };
  var classes$j = {
    hasOverlay: 'has-overlay'
  };
  var sections$a = {};
  var Header = /*#__PURE__*/function () {
    function Header(el) {
      _classCallCheck(this, Header);
      this.wrapper = el;
      this.style = this.wrapper.dataset.style;
      this.desktop = this.wrapper.querySelector(selectors$t.desktop);
      this.transparent = this.wrapper.getAttribute(selectors$t.transparent) !== 'false';
      this.overlayedImages = document.querySelectorAll(selectors$t.firstSectionHasImage);
      this.deadLinks = document.querySelectorAll(selectors$t.deadLink);
      this.killDeadLinks();
      if (this.style !== 'drawer' && this.desktop) {
        this.minWidth = this.getMinWidth();
        this.listenWidth();
      }
      this.checkForImage();
      window.dispatchEvent(new Event('resize'));
      document.addEventListener('theme:header:check', this.checkForImage.bind(this));
    }
    return _createClass(Header, [{
      key: "unload",
      value: function unload() {
        document.removeEventListener('theme:resize', this.checkWidth);
      }
    }, {
      key: "checkForImage",
      value: function checkForImage() {
        this.overlayedImages = document.querySelectorAll(selectors$t.firstSectionHasImage);
        var preventTransparentHeader = document.querySelectorAll(selectors$t.preventTransparentHeader).length;
        if (this.overlayedImages.length && !preventTransparentHeader && this.transparent) {
          // is transparent and has image, overlay the image
          document.querySelector(selectors$t.backfill).style.display = 'none';
          this.listenOverlay();
        } else {
          this.wrapper.setAttribute(selectors$t.transparent, false);
        }
        if (this.overlayedImages.length && !preventTransparentHeader && !this.transparent) {
          // Have image but not transparent, remove border bottom
          this.wrapper.classList.add(selectors$t.overrideBorder);
          this.subtractHeaderHeight();
        }
      }
    }, {
      key: "listenOverlay",
      value: function listenOverlay() {
        document.addEventListener('theme:resize', this.checkWidth.bind(this));
        this.subtractAnnouncementHeight();
      }
    }, {
      key: "listenWidth",
      value: function listenWidth() {
        document.addEventListener('theme:resize', this.checkWidth.bind(this));
        this.checkWidth();
      }
    }, {
      key: "killDeadLinks",
      value: function killDeadLinks() {
        this.deadLinks.forEach(function (el) {
          el.onclick = function (e) {
            e.preventDefault();
          };
        });
      }
    }, {
      key: "subtractAnnouncementHeight",
      value: function subtractAnnouncementHeight() {
        var _readHeights3 = readHeights(),
          windowHeight = _readHeights3.windowHeight,
          announcementHeight = _readHeights3.announcementHeight;
        this.overlayedImages.forEach(function (el) {
          el.style.setProperty('--full-screen', "".concat(windowHeight - announcementHeight, "px"));
          el.classList.add(classes$j.hasOverlay);
        });
      }
    }, {
      key: "subtractHeaderHeight",
      value: function subtractHeaderHeight() {
        var _readHeights4 = readHeights(),
          windowHeight = _readHeights4.windowHeight,
          headerHeight = _readHeights4.headerHeight;
        this.overlayedImages.forEach(function (el) {
          el.style.setProperty('--full-screen', "".concat(windowHeight - headerHeight, "px"));
        });
      }
    }, {
      key: "checkWidth",
      value: function checkWidth() {
        if (document.body.clientWidth < this.minWidth) {
          this.wrapper.classList.add(selectors$t.showMobileClass);
        } else {
          this.wrapper.classList.remove(selectors$t.showMobileClass);
        }
      }
    }, {
      key: "getMinWidth",
      value: function getMinWidth() {
        var comparitor = this.wrapper.cloneNode(true);
        comparitor.classList.add(selectors$t.cloneClass);
        document.body.appendChild(comparitor);
        var wideElements = comparitor.querySelectorAll(selectors$t.widthContent);
        var minWidth = 0;
        if (wideElements.length === 3) {
          minWidth = _sumSplitWidths(wideElements);
        } else {
          minWidth = _sumWidths(wideElements);
        }
        document.body.removeChild(comparitor);
        return minWidth + wideElements.length * 20;
      }
    }]);
  }();
  function _sumSplitWidths(nodes) {
    var arr = [];
    nodes.forEach(function (el) {
      arr.push(el.clientWidth);
    });
    if (arr[0] > arr[2]) {
      arr[2] = arr[0];
    } else {
      arr[0] = arr[2];
    }
    var width = arr.reduce(function (a, b) {
      return a + b;
    });
    return width;
  }
  function _sumWidths(nodes) {
    var width = 0;
    nodes.forEach(function (el) {
      width += el.clientWidth;
    });
    return width;
  }
  var header = {
    onLoad: function onLoad() {
      sections$a = new Header(this.container);
    },
    onUnload: function onUnload() {
      if (typeof sections$a.unload === 'function') {
        sections$a.unload();
      }
    }
  };
  register('header', [header, drawer, headerMobileSliderule, stickyHeader, hoverDisclosure, hoverUnderline, headerTotals,
  // searchPopdown, // disabled - see SearchPopdownTriggers block above
  searchResultsGlobal, searchDrawer, swatchGridSection, cartDrawer, cartPopdown, accordion, ticker]);
  if (!customElements.get('popout-select')) {
    customElements.define('popout-select', PopoutSelect);
  }
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  var selectors$s = {
    newsletterForm: '[data-newsletter-form]'
  };
  var classes$i = {
    success: 'has-success',
    error: 'has-error'
  };
  var sections$9 = {};
  var NewsletterCheckForResult = /*#__PURE__*/function () {
    function NewsletterCheckForResult(newsletter) {
      var _this94 = this;
      _classCallCheck(this, NewsletterCheckForResult);
      this.sessionStorage = window.sessionStorage;
      this.newsletter = newsletter;
      this.stopSubmit = true;
      this.isChallengePage = false;
      this.formID = null;
      this.checkForChallengePage();
      this.newsletterSubmit = function (e) {
        return _this94.newsletterSubmitEvent(e);
      };
      if (!this.isChallengePage) {
        this.init();
      }
    }
    return _createClass(NewsletterCheckForResult, [{
      key: "init",
      value: function init() {
        this.newsletter.addEventListener('submit', this.newsletterSubmit);
        this.showMessage();
      }
    }, {
      key: "newsletterSubmitEvent",
      value: function newsletterSubmitEvent(e) {
        if (this.stopSubmit) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.removeStorage();
          this.writeStorage();
          this.stopSubmit = false;
          this.newsletter.submit();
        }
      }
    }, {
      key: "checkForChallengePage",
      value: function checkForChallengePage() {
        this.isChallengePage = window.location.pathname === '/challenge';
      }
    }, {
      key: "writeStorage",
      value: function writeStorage() {
        if (this.sessionStorage !== undefined) {
          this.sessionStorage.setItem('newsletter_form_id', this.newsletter.id);
        }
      }
    }, {
      key: "readStorage",
      value: function readStorage() {
        this.formID = this.sessionStorage.getItem('newsletter_form_id');
      }
    }, {
      key: "removeStorage",
      value: function removeStorage() {
        this.sessionStorage.removeItem('newsletter_form_id');
      }
    }, {
      key: "showMessage",
      value: function showMessage() {
        this.readStorage();
        if (this.newsletter.id === this.formID) {
          var newsletter = document.getElementById(this.formID);
          if (window.location.search.indexOf('?customer_posted=true') !== -1) {
            newsletter.classList.remove(classes$i.error);
            newsletter.classList.add(classes$i.success);
          } else if (window.location.search.indexOf('accepts_marketing') !== -1) {
            newsletter.classList.remove(classes$i.success);
            newsletter.classList.add(classes$i.error);
          }

          // Prevents the form from scrolling subsequent pagloads
          this.removeStorage();
          this.scrollToForm(newsletter);
        }
      }
    }, {
      key: "scrollToForm",
      value: function scrollToForm(newsletter) {
        var rect = newsletter.getBoundingClientRect();
        var isVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        if (!isVisible) {
          setTimeout(function () {
            window.scroll({
              top: rect.top,
              left: 0,
              behavior: 'smooth'
            });
          }, 400);
        }
      }
    }, {
      key: "unload",
      value: function unload() {
        this.newsletter.removeEventListener('submit', this.newsletterSubmit);
      }
    }]);
  }();
  var newsletterCheckForResultSection = {
    onLoad: function onLoad() {
      var _this95 = this;
      sections$9[this.id] = [];
      var newsletters = this.container.querySelectorAll(selectors$s.newsletterForm);
      newsletters.forEach(function (form) {
        sections$9[_this95.id].push(new NewsletterCheckForResult(form));
      });
    },
    onUnload: function onUnload() {
      sections$9[this.id].forEach(function (form) {
        if (typeof form.unload === 'function') {
          form.unload();
        }
      });
    }
  };
  register('footer', [accordion, newsletterCheckForResultSection]);
  if (!customElements.get('popout-select')) {
    customElements.define('popout-select', PopoutSelect);
  }
  function isTouch() {
    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    document.documentElement.classList.toggle('supports-touch', isTouch);
    return isTouch;
  }
  isTouch();
  var defaultOptions$1 = {
    cc_load_policy: 1,
    iv_load_policy: 3,
    modestbranding: 1,
    playsinline: 1,
    controls: 1,
    showinfo: 0,
    ecver: 2,
    fs: 1,
    rel: 0
  };
  var selectors$r = {
    player: 'iframe, [data-replace]',
    videoId: 'data-video-id'
  };
  function embedYoutube(uniqueKey, options) {
    var playerOptions = _objectSpread(_objectSpread({}, defaultOptions$1), options);
    var playerWrapper = document.querySelector("[data-player=\"".concat(uniqueKey, "\"]"));
    var playerElement = playerWrapper.querySelector(selectors$r.player);
    var youtubeKey = playerWrapper.querySelector("[".concat(selectors$r.videoId, "]")).getAttribute(selectors$r.videoId);
    loadScript({
      url: 'https://www.youtube.com/iframe_api'
    });
    var playerPromise = window.youtubeLoaderPromise.then(function () {
      var player = new window.YT.Player(playerElement, {
        videoId: youtubeKey,
        playerVars: _objectSpread({}, playerOptions)
      });
      playerWrapper.addEventListener('pause', function () {
        try {
          if (player.pauseVideo) {
            player.pauseVideo();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('theme:media:play-desktop', function () {
        if (!isTouch()) {
          playerWrapper.dispatchEvent(new Event('play'));
        }
      });
      playerWrapper.addEventListener('play', function () {
        try {
          if (player.playVideo) {
            player.playVideo();
          } else {
            player.addEventListener('onReady', function (event) {
              event.target.playVideo();
            });
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('destroy', function () {
        try {
          if (player.destroy) {
            player.destroy();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      return player;
    }).catch(function (err) {
      console.error(err);
    });
    return playerPromise;
  }
  window.youtubeLoaderPromise = new Promise(function (resolve) {
    window.onYouTubeIframeAPIReady = function () {
      resolve();
    };
  });
  var defaultOptions = {
    autoplay: true,
    loop: true,
    controls: true,
    muted: false,
    playsinline: true
  };
  var selectors$q = {
    player: 'iframe, [data-replace]',
    videoId: 'data-video-id'
  };
  function embedVimeo(uniqueKey, options) {
    var playerOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
    var playerWrapper = document.querySelector("[data-player=\"".concat(uniqueKey, "\"]"));
    var playerElement = playerWrapper.querySelector(selectors$q.player);
    var vimeoKey = playerWrapper.querySelector("[".concat(selectors$q.videoId, "]")).getAttribute(selectors$q.videoId);
    var loadedPromise = loadScript({
      url: 'https://player.vimeo.com/api/player.js'
    });
    var vimeoSelector = "select-".concat(uniqueKey);
    playerElement.setAttribute('id', vimeoSelector);
    var returnPlayer = loadedPromise.then(function () {
      var player = new window.Vimeo.Player(vimeoSelector, _objectSpread(_objectSpread({}, playerOptions), {}, {
        id: vimeoKey
      }));
      playerWrapper.addEventListener('pause', function () {
        try {
          if (player.pause) {
            player.pause();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('theme:media:play-desktop', function () {
        if (!isTouch()) {
          playerWrapper.dispatchEvent(new Event('play'));
        }
      });
      playerWrapper.addEventListener('play', function () {
        if (player.play) {
          player.play();
        }
      });
      playerWrapper.addEventListener('destroy', function () {
        try {
          if (player.destroy) {
            player.destroy();
          }
        } catch (e) {
          console.log(e);
        }
      });
      return player;
    }).catch(function (err) {
      console.error(err);
    });
    return returnPlayer;
  }
  var selectors$p = {
    videoPopup: '[data-video-popup]',
    videoAutoplay: '[data-video-autoplay]',
    attrUnique: 'data-unique',
    attrVideoId: 'data-video-id',
    attrVideoType: 'data-video-type',
    attrPlayer: 'data-player'
  };
  var PopupVideo = /*#__PURE__*/function () {
    function PopupVideo(section) {
      _classCallCheck(this, PopupVideo);
      this.container = section.container;
      this.triggers = this.container.querySelectorAll(selectors$p.videoPopup);
      this.backgroundVideo = this.container.querySelector(selectors$p.videoAutoplay);
      this.init();
    }
    return _createClass(PopupVideo, [{
      key: "init",
      value: function init() {
        var _this96 = this;
        this.triggers.forEach(function (trigger) {
          var unique = trigger.getAttribute(selectors$p.attrUnique);
          var video = trigger.getAttribute(selectors$p.attrVideoId);
          var type = trigger.getAttribute(selectors$p.attrVideoType);

          // Find the modal body, which has been moved to the document root
          // and append a unique ID for youtube and vimeo to init players.
          var uniqueKey = "".concat(video, "-").concat(unique);
          var player = document.querySelector("[".concat(selectors$p.attrPlayer, "=\"").concat(uniqueKey, "\"]"));

          // Modal Event Logic:
          // When a modal opens it creates and plays the video
          // When a modal opens it pauses background videos in this section
          // --
          // When a modal closes it destroys the player
          // When a modal closes it plays background videos anywhere on the page
          MicroModal.init({
            onShow: function onShow() {
              if (_this96.backgroundVideo && typeof _this96.backgroundVideo.pause === 'function') {
                _this96.backgroundVideo.pause();
              }
              var playerPromise = {};
              if (type === 'youtube') {
                playerPromise = embedYoutube(uniqueKey);
              } else if (type === 'vimeo') {
                playerPromise = embedVimeo(uniqueKey);
              }
              playerPromise.then(function () {
                player.dispatchEvent(new CustomEvent('play'));
              });
            },
            onClose: function onClose(modal, el, event) {
              event.preventDefault();
              player.dispatchEvent(new CustomEvent('destroy'));
              if (_this96.backgroundVideo && typeof _this96.backgroundVideo.play === 'function') {
                _this96.backgroundVideo.play();
              }
            },
            openTrigger: "data-trigger-".concat(video, "-").concat(unique)
          });
        });
      }
    }]);
  }();
  var popupVideoSection = {
    onLoad: function onLoad() {
      new PopupVideo(this);
    }
  };
  var selectors$o = {
    button: '[data-scroll-down]'
  };
  var ScrollButton = /*#__PURE__*/function () {
    function ScrollButton(el) {
      _classCallCheck(this, ScrollButton);
      this.wrapper = el;
      this.init();
    }
    return _createClass(ScrollButton, [{
      key: "init",
      value: function init() {
        var _this97 = this;
        var buttons = this.wrapper.querySelectorAll(selectors$o.button);
        if (buttons) {
          buttons.forEach(function (btn) {
            btn.addEventListener('click', _this97.scroll.bind(_this97));
          });
        }
      }
    }, {
      key: "scroll",
      value: function scroll() {
        var bottom = this.wrapper.offsetTop + this.wrapper.clientHeight;
        window.scroll({
          top: bottom,
          left: 0,
          behavior: 'smooth'
        });
      }
    }]);
  }();
  var scrollButton = {
    onLoad: function onLoad() {
      this.scrollButton = new ScrollButton(this.container);
    },
    onUnload: function onUnload() {
      delete this.scrollButton;
    }
  };
  register('video', [parallaxImage, scrollButton, popupVideoSection]);
  register('page-faq', accordion);
  register('hero', [parallaxImage, scrollButton, customScrollbar]);
  var selectors$n = {
    slider: '[data-slider]',
    photo: '[data-grid-slide]',
    wrapper: '[data-wrapper]',
    carouselCustomScrollbar: 'data-custom-scrollbar-items'
  };
  var attributes = {
    showDots: 'data-show-dots'
  };
  var classes$h = {
    wrapper: 'wrapper',
    wrapperModifier: 'wrapper--full',
    hide: 'hide'
  };
  var offsets = {
    scrollbarWidth: window.innerWidth - document.documentElement.clientWidth,
    additionalOffsetWrapper: 112
  };
  var sections$8 = {};
  var Slider = /*#__PURE__*/function () {
    function Slider(container, el) {
      _classCallCheck(this, Slider);
      this.container = container;
      this.slideshow = el;
      this.wrapper = this.container.closest(selectors$n.wrapper);
      this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue('--LAYOUT-WIDTH').replace('px', ''));
      this.wrapperWidthWithGutter = this.wrapperWidth + offsets.additionalOffsetWrapper + offsets.scrollbarWidth;
      this.pageDots = this.slideshow.getAttribute(attributes.showDots) === 'true';
      this.firstPhoto = this.container.querySelector(selectors$n.photo);
      if (this.firstPhoto) {
        var buttonOffset = this.firstPhoto.offsetHeight / 2;
        this.slideshow.style.setProperty('--buttons-top', "".concat(buttonOffset, "px"));
      }
      if (!this.slideshow) return;
      this.flkty = null;
      this.init();
    }
    return _createClass(Slider, [{
      key: "init",
      value: function init() {
        var _this98 = this;
        var instance = this;
        var sliderOptions = {
          initialIndex: 0,
          accessibility: true,
          autoPlay: false,
          contain: true,
          pageDots: this.pageDots,
          adaptiveHeight: false,
          wrapAround: false,
          groupCells: false,
          cellAlign: 'left',
          freeScroll: true,
          prevNextButtons: true,
          draggable: true,
          rightToLeft: window.isRTL,
          watchCSS: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 65,
            y2: 45,
            x3: 20
          },
          on: {
            ready: function ready() {
              instance.removeIncorrectAria();
            }
          }
        };
        this.flkty = new Flickity(this.slideshow, sliderOptions);
        this.container.addEventListener('theme:tab:change', function () {
          _this98.flkty.resize();
        });
        this.toggleWrapperModifier();
        document.addEventListener('theme:resize:width', this.toggleWrapperModifier.bind(this));
        if (this.slideshow.hasAttribute(selectors$n.carouselCustomScrollbar)) {
          new CustomScrollbar(this.container);
        }
        new Siblings(this.container);
      }
    }, {
      key: "toggleWrapperModifier",
      value: function toggleWrapperModifier() {
        if (!this.wrapper.classList.contains(classes$h.wrapper)) {
          return;
        }
        this.wrapper.classList.toggle(classes$h.wrapperModifier, this.wrapperWidthWithGutter >= window.innerWidth);
      }
    }, {
      key: "removeIncorrectAria",
      value: function removeIncorrectAria() {
        var slidesHidden = this.slideshow.querySelectorAll('[aria-hidden="true"]');
        slidesHidden.forEach(function (el) {
          return el.removeAttribute('aria-hidden');
        });
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.slideshow && this.flkty) {
          this.flkty.options.watchCSS = false;
          this.flkty.destroy();
        }
      }
    }]);
  }();
  var productSliderSection = {
    onLoad: function onLoad() {
      var _this99 = this;
      sections$8[this.id] = [];
      var els = this.container.querySelectorAll(selectors$n.slider);
      els.forEach(function (el) {
        sections$8[_this99.id].push(new Slider(_this99.container, el));
      });
    },
    onUnload: function onUnload(e) {
      sections$8[this.id].forEach(function (el) {
        if (typeof el.onUnload === 'function') {
          el.onUnload(e);
        }
      });
    }
  };
  register('custom-content', [parallaxImage, popupVideoSection, swatchGridSection, productSliderSection]);
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  var sections$7 = [];
  var selectors$m = {
    wrapper: '[data-slideshow-wrapper]',
    speed: 'data-slideshow-speed',
    autoplay: 'data-slideshow-autoplay',
    slideCount: 'data-slideshow-slides',
    prevButton: '[data-slide-custom-prev]',
    nextButton: '[data-slide-custom-next]',
    slideshoIndex: 'data-slideshow-index'
  };
  var classes$g = {
    isEnable: 'flickity-enabled'
  };
  var Slideshow = /*#__PURE__*/function () {
    function Slideshow(section) {
      var _this100 = this;
      _classCallCheck(this, Slideshow);
      this.container = section.container;
      this.wrapper = section.container.querySelector(selectors$m.wrapper);
      this.speed = this.wrapper.getAttribute(selectors$m.speed);
      this.autoplay = this.wrapper.getAttribute(selectors$m.autoplay) === 'true';
      this.slideCount = parseInt(this.wrapper.getAttribute(selectors$m.slideCount), 10);
      this.prevButtons = this.wrapper.querySelectorAll(selectors$m.prevButton);
      this.nextButtons = this.wrapper.querySelectorAll(selectors$m.nextButton);
      this.flkty = null;
      this.scrollEvent = function () {
        return _this100.scrollEvents();
      };
      this.init();
    }
    return _createClass(Slideshow, [{
      key: "init",
      value: function init() {
        var _this101 = this;
        var settings = {
          autoPlay: this.autoplay && this.speed ? parseInt(this.speed) : false,
          contain: false,
          pageDots: true,
          adaptiveHeight: true,
          accessibility: true,
          wrapAround: this.slideCount !== 2,
          prevNextButtons: false,
          draggable: true,
          fade: true,
          rightToLeft: window.isRTL
        };
        this.flkty = new FlickityFade(this.wrapper, settings);
        if (this.prevButtons.length) {
          this.prevButtons.forEach(function (e) {
            e.onclick = function () {
              _this101.flkty.previous(true, false);
            };
          });
        }
        if (this.nextButtons.length) {
          this.nextButtons.forEach(function (e) {
            e.onclick = function () {
              _this101.flkty.next(true, false);
            };
          });
        }
        document.addEventListener('theme:scroll', this.scrollEvent);
      }
    }, {
      key: "scrollEvents",
      value: function scrollEvents() {
        if (this.flkty && this.autoplay && this.speed) {
          var slideshow = this.flkty.element;
          var slideshowBottomPosition = slideshow.getBoundingClientRect().top + window.scrollY + slideshow.offsetHeight;
          if (window.pageYOffset > slideshowBottomPosition) {
            if (this.flkty.player.state === 'playing') {
              this.flkty.pausePlayer();
            }
          } else if (this.flkty.player.state === 'paused') {
            this.flkty.playPlayer();
          }
        }
      }
    }, {
      key: "unload",
      value: function unload() {
        document.removeEventListener('theme:scroll', this.scrollEvent);
        if (this.flkty && this.wrapper && this.wrapper.classList.contains(classes$g.isEnable)) {
          this.flkty.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        var indexEl = evt.target.closest("[".concat(selectors$m.slideshoIndex, "]"));
        var slideIndex = indexEl.getAttribute(selectors$m.slideshoIndex);
        var select = parseInt(slideIndex);
        this.flkty.selectCell(select);
        this.flkty.stopPlayer();
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        if (this.autoplay) {
          this.flkty.playPlayer();
        }
      }
    }]);
  }();
  var slideshowSection = {
    onLoad: function onLoad() {
      sections$7[this.id] = new Slideshow(this);
    },
    onUnload: function onUnload() {
      if (typeof sections$7[this.id].unload === 'function') {
        sections$7[this.id].unload();
      }
    },
    onBlockSelect: function onBlockSelect(evt) {
      if (typeof sections$7[this.id].onBlockSelect === 'function') {
        sections$7[this.id].onBlockSelect(evt);
      }
    },
    onBlockDeselect: function onBlockDeselect(evt) {
      if (typeof sections$7[this.id].onBlockSelect === 'function') {
        sections$7[this.id].onBlockDeselect(evt);
      }
    }
  };
  register('slideshow', [slideshowSection, parallaxImage, scrollButton]);
  var selectors$l = {
    rangeSlider: '[data-range-slider]',
    rangeDotLeft: '[data-range-left]',
    rangeDotRight: '[data-range-right]',
    rangeLine: '[data-range-line]',
    rangeHolder: '[data-range-holder]',
    dataMin: 'data-se-min',
    dataMax: 'data-se-max',
    dataMinValue: 'data-se-min-value',
    dataMaxValue: 'data-se-max-value',
    dataStep: 'data-se-step',
    dataFilterUpdate: 'data-range-filter-update',
    priceMin: '[data-field-price-min]',
    priceMax: '[data-field-price-max]'
  };
  var classes$f = {
    isInitialized: 'is-initialized'
  };
  var RangeSlider = /*#__PURE__*/function () {
    function RangeSlider(section) {
      var _this102 = this;
      _classCallCheck(this, RangeSlider);
      this.container = section.container;
      this.slider = section.querySelector(selectors$l.rangeSlider);
      if (this.slider) {
        this.onMoveEvent = function (event) {
          return _this102.onMove(event);
        };
        this.onStopEvent = function (event) {
          return _this102.onStop(event);
        };
        this.onStartEvent = function (event) {
          return _this102.onStart(event);
        };
        this.startX = 0;
        this.x = 0;

        // retrieve touch button
        this.touchLeft = this.slider.querySelector(selectors$l.rangeDotLeft);
        this.touchRight = this.slider.querySelector(selectors$l.rangeDotRight);
        this.lineSpan = this.slider.querySelector(selectors$l.rangeLine);

        // get some properties
        this.min = parseFloat(this.slider.getAttribute(selectors$l.dataMin));
        this.max = parseFloat(this.slider.getAttribute(selectors$l.dataMax));
        this.step = 0.0;

        // normalize flag
        this.normalizeFact = 26;
        this.init();
        document.addEventListener('theme:price-range:reset', function () {
          _this102.setDefaultValues();
        });
      }
    }
    return _createClass(RangeSlider, [{
      key: "init",
      value: function init() {
        this.setDefaultValues();

        // link events
        this.touchLeft.addEventListener('mousedown', this.onStartEvent);
        this.touchRight.addEventListener('mousedown', this.onStartEvent);
        this.touchLeft.addEventListener('touchstart', this.onStartEvent);
        this.touchRight.addEventListener('touchstart', this.onStartEvent);

        // initialize
        this.slider.classList.add(classes$f.isInitialized);
      }
    }, {
      key: "setDefaultValues",
      value: function setDefaultValues() {
        // retrieve default values
        var defaultMinValue = this.min;
        if (this.slider.hasAttribute(selectors$l.dataMinValue)) {
          defaultMinValue = parseFloat(this.slider.getAttribute(selectors$l.dataMinValue));
        }
        var defaultMaxValue = this.max;
        if (this.slider.hasAttribute(selectors$l.dataMaxValue)) {
          defaultMaxValue = parseFloat(this.slider.getAttribute(selectors$l.dataMaxValue));
        }

        // check values are correct
        if (defaultMinValue < this.min) {
          defaultMinValue = this.min;
        }
        if (defaultMaxValue > this.max) {
          defaultMaxValue = this.max;
        }
        if (defaultMinValue > defaultMaxValue) {
          defaultMinValue = defaultMaxValue;
        }
        if (this.slider.getAttribute(selectors$l.dataStep)) {
          this.step = Math.abs(parseFloat(this.slider.getAttribute(selectors$l.dataStep)));
        }

        // initial reset
        this.reset();

        // usefull values, min, max, normalize fact is the width of both touch buttons
        this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth;
        this.selectedTouch = null;
        this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact;

        // set defualt values
        this.setMinValue(defaultMinValue);
        this.setMaxValue(defaultMaxValue);
      }
    }, {
      key: "reset",
      value: function reset() {
        this.touchLeft.style.left = '0px';
        this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px';
        this.lineSpan.style.marginLeft = '0px';
        this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px';
        this.startX = 0;
        this.x = 0;
      }
    }, {
      key: "setMinValue",
      value: function setMinValue(minValue) {
        var ratio = (minValue - this.min) / (this.max - this.min);
        this.touchLeft.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + 'px';
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
        this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
        this.slider.setAttribute(selectors$l.dataMinValue, minValue);
      }
    }, {
      key: "setMaxValue",
      value: function setMaxValue(maxValue) {
        var ratio = (maxValue - this.min) / (this.max - this.min);
        this.touchRight.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + 'px';
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
        this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';
        this.slider.setAttribute(selectors$l.dataMaxValue, maxValue);
      }
    }, {
      key: "onStart",
      value: function onStart(event) {
        // Prevent default dragging of selected content
        event.preventDefault();
        var eventTouch = event;
        if (event.touches) {
          eventTouch = event.touches[0];
        }
        if (event.currentTarget === this.touchLeft) {
          this.x = this.touchLeft.offsetLeft;
        } else if (event.currentTarget === this.touchRight) {
          this.x = this.touchRight.offsetLeft;
        }
        this.startX = eventTouch.pageX - this.x;
        this.selectedTouch = event.currentTarget;
        document.addEventListener('mousemove', this.onMoveEvent);
        document.addEventListener('mouseup', this.onStopEvent);
        document.addEventListener('touchmove', this.onMoveEvent);
        document.addEventListener('touchend', this.onStopEvent);
      }
    }, {
      key: "onMove",
      value: function onMove(event) {
        var eventTouch = event;
        if (event.touches) {
          eventTouch = event.touches[0];
        }
        this.x = eventTouch.pageX - this.startX;
        if (this.selectedTouch === this.touchLeft) {
          if (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) {
            this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10;
          } else if (this.x < 0) {
            this.x = 0;
          }
          this.selectedTouch.style.left = this.x + 'px';
        } else if (this.selectedTouch === this.touchRight) {
          if (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) {
            this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10;
          } else if (this.x > this.maxX) {
            this.x = this.maxX;
          }
          this.selectedTouch.style.left = this.x + 'px';
        }

        // update line span
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + 'px';
        this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px';

        // write new value
        this.calculateValue();

        // call on change
        if (this.slider.getAttribute('on-change')) {
          var fn = new Function('min, max', this.slider.getAttribute('on-change'));
          fn(this.slider.getAttribute(selectors$l.dataMinValue), this.slider.getAttribute(selectors$l.dataMaxValue));
        }
        this.onChange(this.slider.getAttribute(selectors$l.dataMinValue), this.slider.getAttribute(selectors$l.dataMaxValue));
      }
    }, {
      key: "onStop",
      value: function onStop(event) {
        document.removeEventListener('mousemove', this.onMoveEvent);
        document.removeEventListener('mouseup', this.onStopEvent);
        document.removeEventListener('touchmove', this.onMoveEvent);
        document.removeEventListener('touchend', this.onStopEvent);
        this.selectedTouch = null;

        // write new value
        this.calculateValue();

        // call did changed
        this.onChanged(this.slider.getAttribute(selectors$l.dataMinValue), this.slider.getAttribute(selectors$l.dataMaxValue));
      }
    }, {
      key: "onChange",
      value: function onChange(min, max) {
        var rangeHolder = this.slider.closest(selectors$l.rangeHolder);
        if (rangeHolder) {
          var priceMin = rangeHolder.querySelector(selectors$l.priceMin);
          var priceMax = rangeHolder.querySelector(selectors$l.priceMax);
          if (priceMin && priceMax) {
            priceMin.value = min;
            priceMax.value = max;
          }
        }
      }
    }, {
      key: "onChanged",
      value: function onChanged(min, max) {
        if (this.slider.hasAttribute(selectors$l.dataFilterUpdate)) {
          this.slider.dispatchEvent(new CustomEvent('theme:range:update', {
            bubbles: true
          }));
        }
      }
    }, {
      key: "calculateValue",
      value: function calculateValue() {
        var newValue = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
        var minValue = this.lineSpan.offsetLeft / this.initialValue;
        var maxValue = minValue + newValue;
        minValue = minValue * (this.max - this.min) + this.min;
        maxValue = maxValue * (this.max - this.min) + this.min;
        if (this.step !== 0.0) {
          var multi = Math.floor(minValue / this.step);
          minValue = this.step * multi;
          multi = Math.floor(maxValue / this.step);
          maxValue = this.step * multi;
        }
        if (this.selectedTouch === this.touchLeft) {
          this.slider.setAttribute(selectors$l.dataMinValue, minValue);
        }
        if (this.selectedTouch === this.touchRight) {
          this.slider.setAttribute(selectors$l.dataMaxValue, maxValue);
        }
      }
    }]);
  }();
  var selectors$k = {
    filtersWrappper: 'data-filters',
    underlay: '[data-filters-underlay]',
    filtersHideDesktop: 'data-default-hide',
    filtersToggle: 'data-filters-toggle',
    focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    groupHeading: 'data-group-heading',
    showMore: 'data-show-more'
  };
  var classes$e = {
    show: 'drawer--visible',
    defaultVisible: 'filters--default-visible',
    hide: 'hidden',
    expand: 'is-expanded',
    hidden: 'is-hidden',
    focusEnable: 'focus-enabled'
  };
  var sections$6 = {};
  var Filters = /*#__PURE__*/function () {
    function Filters(filters) {
      var _this103 = this;
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _classCallCheck(this, Filters);
      this.container = filters;
      this.underlay = this.container.querySelector(selectors$k.underlay);
      this.groupHeadings = this.container.querySelectorAll("[".concat(selectors$k.groupHeading, "]"));
      this.showMoreButtons = this.container.querySelectorAll("[".concat(selectors$k.showMore, "]"));
      this.triggerKey = this.container.getAttribute(selectors$k.filtersWrappper);
      this.selector = "[".concat(selectors$k.filtersToggle, "='").concat(this.triggerKey, "']");
      this.filtersToggleButtons = document.querySelectorAll(this.selector);
      this.connectToggleMemory = function (evt) {
        return _this103.connectToggleFunction(evt);
      };
      this.connectShowHiddenOptions = function (evt) {
        return _this103.showHiddenOptions(evt);
      };
      this.connectToggle(refresh);
      this.onFocusOut();
      this.expandingEvents();
      this.filterOverride();
      if (this.getShowOnLoad()) {
        this.showFilters();
      } else {
        // this.hideFilters();
      }
    }
    return _createClass(Filters, [{
      key: "unload",
      value: function unload() {
        var _this104 = this;
        if (this.filtersToggleButtons.length) {
          this.filtersToggleButtons.forEach(function (element) {
            element.removeEventListener('click', _this104.connectToggleMemory);
          });
        }
        if (this.showMoreButtons.length) {
          this.showMoreButtons.forEach(function (button) {
            button.removeEventListener('click', _this104.connectShowHiddenOptions);
          });
        }
      }
    }, {
      key: "expandingEvents",
      value: function expandingEvents() {
        var _this105 = this;
        if (this.showMoreButtons.length) {
          this.showMoreButtons.forEach(function (button) {
            button.addEventListener('click', throttle(_this105.connectShowHiddenOptions, 500));
          });
        }
      }
    }, {
      key: "showHiddenOptions",
      value: function showHiddenOptions(evt) {
        // const element = evt.target.hasAttribute(selectors$k.showMore) ? evt.target : evt.target.closest(`[${selectors$k.showMore}]`);

        // element.classList.add(classes$e.hidden);

        // element.previousElementSibling.querySelectorAll(`.${classes$e.hidden}`).forEach((option) => {
        //   option.classList.remove(classes$e.hidden);
        // });
      }
    }, {
      key: "filterOverride",
      value: function filterOverride() {
        $(window).click(function () {
          if ($('.accordion-is-open').length) {
            $('.accordion-is-open').removeClass('accordion-is-open').siblings('.sidebar__navigation__list').hide();
          }
        });
        $('.sidebar__filter__group, .sidebar__navigation__list').click(function (event) {
          if ($('.accordion-is-open').length) {
            event.stopPropagation();
          }
        });

        // close other filters when another filter is clicked
        $('.sidebar__filter__group').on('click', function () {
          var _this106 = this;
          setTimeout(function () {
            // console.log($(this).siblings().find('.accordion-is-open'));
            $(_this106).siblings().find('.accordion-is-open').removeClass('accordion-is-open').parent().find('ul').hide();
          }, 100);
        });
        if (innerWidth < 1025) {
          $('.collection__filters__wrapper').removeClass('drawer--visible');
        } else {
          $('.collection__filters__wrapper').addClass('drawer--visible');
        }
        $('.collection__active__filters__wrapper').removeClass('is-hidden');
      }
    }, {
      key: "connectToggle",
      value: function connectToggle() {
        var _this107 = this;
        var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        this.filtersToggleButtons.forEach(function (button) {
          var isDynamic = button.closest("[".concat(selectors$k.filtersWrappper, "]")) !== null;
          if (isDynamic && refresh || isDynamic && !refresh || !isDynamic && !refresh) {
            button.addEventListener('click', _this107.connectToggleMemory.bind(_this107));
          }
        });
      }
    }, {
      key: "connectToggleFunction",
      value: function connectToggleFunction(evt) {
        var ariaExpanded = evt.currentTarget.getAttribute('aria-expanded') === 'true';
        if (ariaExpanded) {
          this.hideFilters();
        } else {
          this.showFilters();
        }
      }
    }, {
      key: "onFocusOut",
      value: function onFocusOut() {
        this.container.addEventListener('focusout', function (evt) {
          if (window.innerWidth >= window.theme.sizes.medium) {
            return;
          }
          var childInFocus = evt.currentTarget.contains(evt.relatedTarget);
          var isVisible = this.container.classList.contains(classes$e.show);
          var isFocusEnabled = document.body.classList.contains(classes$e.focusEnable);
          if (isFocusEnabled && isVisible && !childInFocus) {
            this.hideFilters();
          }
        }.bind(this));
        this.container.addEventListener('keyup', function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideFilters();
          this.filtersToggleButtons[0].focus();
        }.bind(this));
        this.underlay.addEventListener('click', function () {
          this.hideFilters();
        }.bind(this));
      }
    }, {
      key: "getShowOnLoad",
      value: function getShowOnLoad() {
        var selector = "[".concat(selectors$k.filtersHideDesktop, "='false']");
        var showOnDesktop = document.querySelector(selector);
        var isDesktop = window.innerWidth >= window.theme.sizes.medium;
        if (showOnDesktop && isDesktop) {
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: "showFilters",
      value: function showFilters() {
        var _this108 = this;
        this.filtersToggleButtons = document.querySelectorAll(this.selector);
        this.container.classList.remove(classes$e.hide);
        // animates after display none is removed
        setTimeout(function () {
          _this108.filtersToggleButtons.forEach(function (btn) {
            return btn.setAttribute('aria-expanded', true);
          });
          _this108.filtersToggleButtons.forEach(function (btn) {
            return btn.classList.add(classes$e.show);
          });
          _this108.container.classList.add(classes$e.show);
          _this108.container.querySelector(selectors$k.focusable).focus();
        }, 1);
      }
    }, {
      key: "hideFilters",
      value: function hideFilters() {
        var _this109 = this;
        if (innerWidth < 1025) {
          this.filtersToggleButtons = document.querySelectorAll(this.selector);
          this.filtersToggleButtons.forEach(function (btn) {
            return btn.setAttribute('aria-expanded', false);
          });
          this.container.classList.remove(classes$e.show);
          this.container.classList.remove(classes$e.defaultVisible);
          this.filtersToggleButtons.forEach(function (btn) {
            return btn.classList.remove(classes$e.show);
          });
          this.filtersToggleButtons.forEach(function (btn) {
            return btn.classList.remove(classes$e.defaultVisible);
          });
          // adds display none after animations
          setTimeout(function () {
            if (!_this109.container.classList.contains(classes$e.show)) {
              _this109.container.classList.add(classes$e.hide);
            }
          }, 800);
        }
      }
    }]);
  }();
  var collectionFiltersSidebar = {
    onLoad: function onLoad() {
      var _this110 = this;
      sections$6[this.id] = [];
      var wrappers = this.container.querySelectorAll("[".concat(selectors$k.filtersWrappper, "]"));
      wrappers.forEach(function (wrapper) {
        sections$6[_this110.id].push(new Filters(wrapper));
      });
    },
    onUnload: function onUnload() {
      sections$6[this.id].forEach(function (filters) {
        if (typeof filters.unload === 'function') {
          filters.unload();
        }
      });
    }
  };
  var selectors$j = {
    collectionSidebar: '[data-collection-sidebar]',
    form: '[data-sidebar-filter-form]',
    inputs: 'input, select, label, textarea',
    priceMin: 'data-field-price-min',
    priceMax: 'data-field-price-max',
    rangeMin: 'data-se-min-value',
    rangeMax: 'data-se-max-value',
    rangeMinDefault: 'data-se-min',
    rangeMaxDefault: 'data-se-max',
    productsContainer: '[data-products-grid]',
    filterUpdateUrlButton: '[data-filter-update-url]',
    activeFiltersHolder: '[data-active-filters]',
    activeFiltersCount: '[data-active-filters-count]',
    productsCount: '[data-products-count]',
    dataSort: 'data-sort-enabled',
    collectionTools: '[data-collection-tools]',
    filtersWrappper: '[data-filters]',
    headerSticky: '[data-header-sticky="sticky"]',
    headerHeight: '[data-header-height]',
    gridLarge: 'data-grid-large',
    gridSmall: 'data-grid-small',
    accordionBody: '[data-accordion-body]',
    checkedOption: 'input:checked',
    optionHolder: '[data-option-holder]',
    applyButton: '[data-apply]'
  };
  var classes$d = {
    classHidden: 'is-hidden',
    classLoading: 'is-loading'
  };
  var times = {
    // Was 1000ms. The grid content is swapped *before* this timer starts, so this
    // was holding the loading overlay over already-rendered products for a full
    // second. 150ms is enough for the overlay to fade rather than pop.
    loadingDelay: 150,
    scrollTime: 1000
  };

  // Filter responses keyed by search string. Filter-then-undo and browser
  // back/forward are extremely common and currently cost a full round trip each.
  //
  // NOTE: `window.Map`, not `Map` — this file declares its own `class Map` for the
  // store locator (see ~line 12104), which shadows the global across the whole
  // module. A bare `new Map()` here resolves to that class, not the built-in.
  var filterCache = new window.Map();
  var FILTER_CACHE_MAX = 20;
  var FiltersForm = /*#__PURE__*/function () {
    function FiltersForm(section) {
      var _this111 = this;
      _classCallCheck(this, FiltersForm);
      this.section = section;
      this.container = this.section.container;
      this.sidebar = this.container.querySelector(selectors$j.collectionSidebar);
      this.apply = this.container.querySelector(selectors$j.applyButton);
      this.form = section.container.querySelector(selectors$j.form);
      this.sort = this.container.querySelector("[".concat(selectors$j.dataSort, "]"));
      this.productsContainer = this.container.querySelector(selectors$j.productsContainer);
      this.activeFiltersHolder = this.container.querySelector(selectors$j.activeFiltersHolder);
      this.activeFiltersCount = this.container.querySelector(selectors$j.activeFiltersCount);
      this.productsCount = this.container.querySelector(selectors$j.productsCount);
      this.headerIsSticky = document.querySelector(selectors$j.headerSticky) !== null;
      this.layoutLarge = this.container.querySelector("[".concat(selectors$j.gridLarge, "]"));
      this.layoutSmall = this.container.querySelector("[".concat(selectors$j.gridSmall, "]"));
      if (this.productsContainer && this.sidebar) {
        this.init();
      }
      if (this.sort) {
        this.container.addEventListener('theme:form:filter', function (e) {
          return _this111.filtering(e);
        });
      }
      if (this.sidebar || this.sort) {
        window.addEventListener('popstate', function (e) {
          return _this111.filtering(e);
        });
      }
    }
    return _createClass(FiltersForm, [{
      key: "init",
      value: function init() {
        var _this112 = this;
        this.showAllOptions();
        if (this.form) {
          new RangeSlider(this.form);

          // The price range slider fires `input` continuously while dragging, so it
          // needs a debounce. Checkboxes and swatches fire once and should feel
          // immediate — a single 1500ms trailing debounce for both meant a 1.5s dead
          // zone after every checkbox click. Same handler, two delays.
          var handleFilterInput = function handleFilterInput(e) {
            //console.log('submitting')
            var type = e.type;
            var target = e.target;
            if (!selectors$j.inputs.includes(type) || !_this112.form || typeof _this112.form.submit !== 'function') {
              return;
            }
            var priceMin = _this112.form.querySelector("[".concat(selectors$j.priceMin, "]"));
            var priceMax = _this112.form.querySelector("[".concat(selectors$j.priceMax, "]"));
            if (target.hasAttribute(selectors$j.priceMin) || target.hasAttribute(selectors$j.priceMax)) {
              var rangeMin = _this112.form.querySelector("[".concat(selectors$j.rangeMin, "]"));
              var rangeMax = _this112.form.querySelector("[".concat(selectors$j.rangeMax, "]"));
              parseInt(rangeMin.getAttribute(selectors$j.rangeMinDefault));
              var rangeMaxDefault = parseInt(rangeMax.getAttribute(selectors$j.rangeMaxDefault));
              if (priceMin.value && !priceMax.value) {
                priceMax.value = rangeMaxDefault;
              }
              if (priceMax.value && !priceMin.value) {
                priceMin.value = rangeMinDefault;
              }
              if (priceMin.value <= rangeMinDefault && priceMax.value >= rangeMaxDefault) {
                priceMin.placeholder = rangeMinDefault;
                priceMax.placeholder = rangeMaxDefault;
                priceMin.value = '';
                priceMax.value = '';
              }
            }
            _this112.filtering(e);
          };
          var debouncedRangeInput = debounce(handleFilterInput, 400);
          var debouncedChoiceInput = debounce(handleFilterInput, 150);
          this.sidebar.addEventListener('input', function (e) {
            var target = e.target;
            var isRangeInput = target.hasAttribute(selectors$j.priceMin) || target.hasAttribute(selectors$j.priceMax);
            (isRangeInput ? debouncedRangeInput : debouncedChoiceInput)(e);
          });

          // this.apply.addEventListener(
          //   'click',
          //   debounce((e) => {
          //     const type = e.type;
          //     const target = e.target;

          //     if (!selectors$j.inputs.includes(type) || !this.form || typeof this.form.submit !== 'function') {
          //       return;
          //     }

          //     const priceMin = this.form.querySelector(`[${selectors$j.priceMin}]`);
          //     const priceMax = this.form.querySelector(`[${selectors$j.priceMax}]`);

          //     if (target.hasAttribute(selectors$j.priceMin) || target.hasAttribute(selectors$j.priceMax)) {
          //       const rangeMin = this.form.querySelector(`[${selectors$j.rangeMin}]`);
          //       const rangeMax = this.form.querySelector(`[${selectors$j.rangeMax}]`);
          //       parseInt(rangeMin.getAttribute(selectors$j.rangeMinDefault));
          //       const rangeMaxDefault = parseInt(rangeMax.getAttribute(selectors$j.rangeMaxDefault));

          //       if (priceMin.value && !priceMax.value) {
          //         priceMax.value = rangeMaxDefault;
          //       }

          //       if (priceMax.value && !priceMin.value) {
          //         priceMin.value = rangeMinDefault;
          //       }

          //       if (priceMin.value <= rangeMinDefault && priceMax.value >= rangeMaxDefault) {
          //         priceMin.placeholder = rangeMinDefault;
          //         priceMax.placeholder = rangeMaxDefault;
          //         priceMin.value = '';
          //         priceMax.value = '';
          //       }
          //     }

          //     this.filtering(e);
          //   }, 1500)
          // );

          this.form.addEventListener('theme:range:update', function (e) {
            return _this112.updateRange(e);
          });
        }
        if (this.sidebar) {
          this.sidebar.addEventListener('click', function (e) {
            return _this112.updateFilterFromUrl(e);
          });
          this.sidebar.addEventListener('keydown', function (e) {
            return _this112.activateFilterFromKey(e);
          });
        }
        if (this.activeFiltersHolder) {
          this.activeFiltersHolder.addEventListener('click', function (e) {
            return _this112.updateFilterFromUrl(e);
          });
          this.activeFiltersHolder.addEventListener('keydown', function (e) {
            return _this112.activateFilterFromKey(e);
          });
        }
        if (this.productsContainer) {
          this.productsContainer.addEventListener('click', function (e) {
            return _this112.updateFilterFromUrl(e);
          });
          this.productsContainer.addEventListener('keydown', function (e) {
            return _this112.activateFilterFromKey(e);
          });
        }

        // Color swatches tooltips
        makeSwappers(this.sidebar);
      }

      /**
       * Update range slider (price money)
       * @param {Object} e
       */
    }, {
      key: "updateRange",
      value: function updateRange(e) {
        if (this.form && typeof this.form.submit === 'function') {
          var rangeMin = this.form.querySelector("[".concat(selectors$j.rangeMin, "]"));
          var rangeMax = this.form.querySelector("[".concat(selectors$j.rangeMax, "]"));
          var priceMin = this.form.querySelector("[".concat(selectors$j.priceMin, "]"));
          var priceMax = this.form.querySelector("[".concat(selectors$j.priceMax, "]"));
          var checkElements = rangeMin && rangeMax && priceMin && priceMax;
          if (checkElements && rangeMin.hasAttribute(selectors$j.rangeMin) && rangeMax.hasAttribute(selectors$j.rangeMax)) {
            var priceMinValue = parseInt(priceMin.placeholder);
            var priceMaxValue = parseInt(priceMax.placeholder);
            var rangeMinValue = parseInt(rangeMin.getAttribute(selectors$j.rangeMin));
            var rangeMaxValue = parseInt(rangeMax.getAttribute(selectors$j.rangeMax));
            if (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) {
              priceMin.value = rangeMinValue;
              priceMax.value = rangeMaxValue;
              this.filtering(e);
            }
          }
        }
      }

      /**
       * Update filter on last clicked element
       * @param {Object} e
       */
      /**
       * These controls are anchors exposed as role="button" (filters-active.liquid), so
       * Space has to activate them. A link fires click on Enter but not Space, which would
       * otherwise scroll the page. Delegated alongside the click binding.
       */
    }, {
      key: "activateFilterFromKey",
      value: function activateFilterFromKey(e) {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;
        var button = e.target.closest(selectors$j.filterUpdateUrlButton);
        if (!button || button.getAttribute('role') !== 'button') return;
        e.preventDefault();
        button.click();
      }
    }, {
      key: "updateFilterFromUrl",
      value: function updateFilterFromUrl(e) {
        var target = e.target;
        if (target.matches(selectors$j.filterUpdateUrlButton) || target.closest(selectors$j.filterUpdateUrlButton) && target) {
          e.preventDefault();
          var button = target.matches(selectors$j.filterUpdateUrlButton) ? target : target.closest(selectors$j.filterUpdateUrlButton);
          this.filtering(e, button.getAttribute('href'));
          window.scrollTo(0, 0);
        }
      }

      /**
       * Add filters to history api
       *
       * @param {Object} e
       * @param {String} replaceHref
       */
    }, {
      key: "addToHistory",
      value: function addToHistory(e) {
        var replaceHref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var sortValue = this.sort ? this.sort.getAttribute(selectors$j.dataSort) : '';
        if (!e || e && e.type !== 'popstate') {
          if (replaceHref === '') {
            var searchParams = new window.URL(window.location.href).searchParams;
            var filterUrlParams = Object.fromEntries(searchParams);
            var filterUrlRemoveString = searchParams.toString();
            if (filterUrlRemoveString.includes('filter.') || filterUrlRemoveString.includes('sort_by') || filterUrlRemoveString.includes('page')) {
              for (var key in filterUrlParams) {
                if (key.includes('filter.') || key.includes('sort_by') || key.includes('page')) {
                  searchParams.delete(key);
                }
              }
            }
            if (this.form) {
              var formParams = new URLSearchParams(new FormData(this.form));
              var _iterator2 = _createForOfIteratorHelper(formParams.entries()),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _step2$value = _slicedToArray(_step2.value, 2),
                    _key3 = _step2$value[0],
                    val = _step2$value[1];
                  if (_key3.includes('filter.') && val) {
                    searchParams.append(_key3, val);
                  }
                }

                // if submitted price equal to price range min and max remove price parameters
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              var rangeMin = this.form.querySelector("[".concat(selectors$j.rangeMin, "]"));
              var rangeMax = this.form.querySelector("[".concat(selectors$j.rangeMax, "]"));
              var priceMin = this.form.querySelector("[".concat(selectors$j.priceMin, "]"));
              var priceMax = this.form.querySelector("[".concat(selectors$j.priceMax, "]"));
              var checkElements = rangeMin && rangeMax && priceMin && priceMax;
              if (checkElements && rangeMin.hasAttribute(selectors$j.rangeMinDefault) && rangeMax.hasAttribute(selectors$j.rangeMaxDefault)) {
                var _rangeMinDefault = parseFloat(rangeMin.getAttribute(selectors$j.rangeMinDefault), 10);
                var rangeMaxDefault = parseFloat(rangeMax.getAttribute(selectors$j.rangeMaxDefault), 10);
                var priceMinValue = priceMin.value === '' ? parseFloat(priceMin.placeholder, 10) : parseFloat(priceMin.value, 10);
                var priceMaxValue = priceMax.value === '' ? parseFloat(priceMax.placeholder, 10) : parseFloat(priceMax.value, 10);
                if (priceMinValue <= _rangeMinDefault && priceMaxValue >= rangeMaxDefault) {
                  searchParams.delete('filter.v.price.gte');
                  searchParams.delete('filter.v.price.lte');
                }
              }
            }
            if (sortValue || e && e.detail && e.detail.href) {
              var sortString = sortValue ? sortValue : e.detail.params;
              searchParams.set('sort_by', sortString);
            }
            var filterUrlString = searchParams.toString();
            var filterNewParams = filterUrlString ? "?".concat(filterUrlString) : location.pathname;
            window.history.pushState(null, '', filterNewParams);
            return;
          }
          window.history.pushState(null, '', replaceHref);
        }
      }

      /**
       * Get filter result and append them to their holders
       */
    }, {
      key: "applyFilterResponse",
      value: function applyFilterResponse(responseText) {
        var _this113 = this;
        var responseHolder = document.createElement('div');
        responseHolder.innerHTML = responseText;
        if (this.sidebar) {
          this.sidebar.innerHTML = responseHolder.querySelector(selectors$j.collectionSidebar).innerHTML;
        }
        if (this.activeFiltersCount) {
          this.activeFiltersCount.innerHTML = responseHolder.querySelector(selectors$j.activeFiltersCount).innerHTML;
        }
        this.productsContainer.innerHTML = responseHolder.querySelector(selectors$j.productsContainer).innerHTML;

        // Show active filters holder
        this.activeFiltersHolder.innerHTML = responseHolder.querySelector(selectors$j.activeFiltersHolder).innerHTML;
        this.activeFiltersHolder.parentNode.classList.toggle(classes$d.classHidden, this.activeFiltersHolder.innerHTML === '');
        if (this.productsCount) {
          // Preserve count during pagination - only update if new count is not 0 or current is already 0
          var newCountEl = responseHolder.querySelector(selectors$j.productsCount);
          var newCount = newCountEl ? newCountEl.getAttribute('data-visible-count') : '0';
          var currentCount = this.productsCount.getAttribute('data-visible-count');
          if (newCount !== '0' || currentCount === '0') {
            this.productsCount.innerHTML = newCountEl.innerHTML;
          }
          // hide filter if inputs are all disabled - gdd custom
          document.querySelectorAll("ul.sidebar__navigation__list").forEach(function (ul) {
            var inputs = ul.querySelectorAll("input");
            if (inputs.length > 0 && Array.from(inputs).every(function (input) {
              return input.disabled;
            })) {
              ul.parentElement.style.display = "none";
            }
          });
        }
        this.setGridValues();
        this.refreshFunctionalities();

        // The grid swap above discards anything injected into it client-side. Anything
        // that decorates the grid after render — the promo cards in sections/collection.liquid
        // are the current case — listens for this instead of trying to re-run itself.
        document.dispatchEvent(new CustomEvent('theme:filters:applied', {
          bubbles: true
        }));
        setTimeout(function () {
          _this113.productsContainer.classList.remove(classes$d.classLoading);
        }, times.loadingDelay);
      }

      /**
       * Cheap sanity check on a Section Rendering response.
       *
       * A wrong or stale section id does NOT error — it returns a healthy 200 with the
       * sidebar quietly missing, and applyFilterResponse would then throw on the grid or
       * blank the filters. Deliberately a string scan and not a DOM parse: parsing here
       * would pay the innerHTML cost twice, which is the cost this change exists to cut.
       */
    }, {
      key: "isUsableFilterResponse",
      value: function isUsableFilterResponse(responseText) {
        if (responseText.indexOf('data-products-grid') === -1) return false;
        if (responseText.indexOf('data-active-filters') === -1) return false;
        if (this.sidebar && responseText.indexOf('data-collection-sidebar') === -1) return false;
        return true;
      }
    }, {
      key: "getFilterResult",
      value: function getFilterResult(options) {
        var _this114 = this;
        var fullPage = Boolean(options && options.fullPage);
        this.productsContainer.classList.add(classes$d.classLoading);
        this.getGridValues();

        // Section Rendering: ask for this section alone rather than the whole document.
        // The id MUST come from the DOM — `section_id=collection` returns a 200 rendered
        // from schema defaults with no sidebar, `section_id=main` 404s, and the real id
        // (`template--<template id>__main`) differs per template; this repo has ~70
        // collection templates. See the assessment doc §10.13.
        var sectionEl = this.productsContainer.closest('.shopify-section');
        var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
        if (!sectionId && !fullPage) {
          console.warn('[filters] no .shopify-section ancestor found — using the full-page fetch');
        }

        // section_id belongs on the request only. The address bar is written separately
        // via pushState, so it never leaks into the URL the customer sees or shares.
        var requestUrl = "".concat(window.location.pathname).concat(window.location.search);
        if (sectionId && !fullPage) {
          var requestParams = new URLSearchParams(window.location.search);
          requestParams.set('section_id', sectionId);
          requestUrl = "".concat(window.location.pathname, "?").concat(requestParams.toString());
        }

        // Key on the URL actually fetched, so a section-scoped response can never be
        // served for a full-page key or the other way round.
        var cacheKey = requestUrl;

        // Cancel any request still in flight. Without this, overlapping filter
        // changes race and whichever response *arrives* last wins — which is not
        // necessarily the one the user asked for last. This must happen BEFORE the
        // cache check too: a cache hit renders synchronously, and an unaborted
        // request would land afterwards and overwrite it with stale results.
        if (this.filterAbort) {
          this.filterAbort.abort();
          this.filterAbort = null;
        }
        if (filterCache.has(cacheKey)) {
          this.applyFilterResponse(filterCache.get(cacheKey));
          return;
        }
        this.filterAbort = new AbortController();
        fetch(requestUrl, {
          signal: this.filterAbort.signal
        }).then(function (response) {
          return response.text();
        }).then(function (response) {
          // Guard, not an optimisation: see isUsableFilterResponse. Retry once on the
          // full URL so a bad section id degrades to today's behavior instead of
          // wiping the grid. `fullPage` stops that retry from recursing.
          if (!fullPage && sectionId && !_this114.isUsableFilterResponse(response)) {
            console.warn("[filters] section response for \"".concat(sectionId, "\" is missing the grid or sidebar \u2014 refetching the full page"));
            _this114.getFilterResult({
              fullPage: true
            });
            return;
          }
          if (filterCache.size >= FILTER_CACHE_MAX) {
            filterCache.delete(filterCache.keys().next().value);
          }
          filterCache.set(cacheKey, response);
          _this114.applyFilterResponse(response);
        }).catch(function (error) {
          // An aborted request means a newer one is already running and will clear
          // the loading state itself — nothing to do and nothing to report.
          if (error.name === 'AbortError') return;
          console.error('[filters] request failed', error);
          _this114.productsContainer.classList.remove(classes$d.classLoading);
        });
      }

      /**
       * Refresh functionalities
       */
    }, {
      key: "refreshFunctionalities",
      value: function refreshFunctionalities() {
        var _this115 = this;
        // Init range slider
        this.form = this.container.querySelector(selectors$j.form);
        if (this.form) {
          new RangeSlider(this.form);
          this.form.addEventListener('theme:range:update', function (e) {
            return _this115.updateRange(e);
          });
        }

        // Init filters
        var filters = this.container.querySelectorAll(selectors$j.filtersWrappper);
        filters.forEach(function (filter) {
          new Filters(filter, true);
        });

        // Init accordions
        var accordions = this.container.querySelectorAll(selectors$j.accordionBody);
        accordions.forEach(function (accordion) {
          new Accordion(accordion);
        });

        // Init siblings
        new Siblings(this.container);

        // Color swatches tooltips
        if (this.sidebar) {
          makeSwappers(this.sidebar);
        }

        // Init product swatches
        makeGridSwatches(this.container);
        this.showAllOptions();
      }

      // Get grid values
    }, {
      key: "getGridValues",
      value: function getGridValues() {
        if (this.layoutLarge) {
          this.layoutLargeValue = this.layoutLarge.getAttribute(selectors$j.gridLarge);
        }
        if (this.layoutSmall) {
          this.layoutSmallValue = this.layoutSmall.getAttribute(selectors$j.gridSmall);
        }
      }

      // Set grid values on AJAX
    }, {
      key: "setGridValues",
      value: function setGridValues() {
        if (this.layoutLarge) {
          this.layoutLarge = this.container.querySelector("[".concat(selectors$j.gridLarge, "]"));
          this.layoutLarge.setAttribute(selectors$j.gridLarge, this.layoutLargeValue);
        }
        if (this.layoutSmall) {
          this.layoutSmall = this.container.querySelector("[".concat(selectors$j.gridSmall, "]"));
          this.layoutSmall.setAttribute(selectors$j.gridSmall, this.layoutSmallValue);
        }
      }

      // Show all options if in the filter have selected option but it is hidden
    }, {
      key: "showAllOptions",
      value: function showAllOptions() {
        var checkedOptions = this.container.querySelectorAll(selectors$j.checkedOption);
        checkedOptions.forEach(function (option) {
          if (option.closest(selectors$j.optionHolder) && option.closest(selectors$j.optionHolder).classList.contains(classes$d.classHidden)) {
            var button = option.closest(selectors$j.accordionBody).nextElementSibling;
            if (!button.classList.contains(selectors$j.classHidden)) {
              button.dispatchEvent(new Event('click'));
            }
          }
        });
      }

      /**
       * Filtering method and scroll at the top on the section
       * @param {Object} e
       * @param {String} replaceHref
       */
    }, {
      key: "filtering",
      value: function filtering(e) {
        var _this116 = this;
        var replaceHref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        // Scroll to filter tools
        var windowScrollY = window.scrollY || window.pageYOffset;
        var headerH = this.headerIsSticky ? document.querySelector(selectors$j.headerHeight).getBoundingClientRect().height : 0;
        var collectionTools = this.container.querySelector(selectors$j.collectionTools);
        var scrollToElement = collectionTools.offsetTop - headerH;
        var enableScrollTo = collectionTools.offsetTop + collectionTools.getBoundingClientRect().height < windowScrollY - headerH;
        if (enableScrollTo) {
          window.scrollTo({
            top: scrollToElement,
            left: 0,
            behavior: 'smooth'
          });
        }
        if (!location.href.includes('/search')) {
          // gdd custom - dont run on search
          setTimeout(function () {
            _this116.addToHistory(e, replaceHref);
            _this116.getFilterResult();
            // this.unavailableCheck();
          }, enableScrollTo ? times.scrollTime : 10);
        }
      }
    }, {
      key: "unavailableCheck",
      value: function unavailableCheck() {
        $('.sidebar__navigation__list').each(function () {
          var itemCount = $(this).find('li').length - 1; // don't count apply
          var inputHiddenCount = $(this).find('input[disabled]').length;
          if (itemCount == inputHiddenCount) {
            $(this).parent().addClass('hide');
          } else {
            $(this).parent().removeClass('hide');
          }
        });
      }
    }]);
  }();
  var collectionFiltersForm = {
    onLoad: function onLoad() {
      this.filterForm = new FiltersForm(this);
    },
    onUnload: function onUnload() {
      if (this.filterForm && typeof this.filterForm.unload === 'function') {
        this.filterForm.unload();
      }
    }
  };
  register('search-page', [collectionFiltersSidebar, collectionFiltersForm, swatchGridSection, accordion]);
  if (!customElements.get('popout-select')) {
    customElements.define('popout-select', PopoutSelect);
  }
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  var selectors$i = {
    zoomImage: '[data-image-zoom]',
    modalContainer: '[data-modal-container]',
    attrUnique: 'data-unique',
    image: 'data-src'
  };
  var GalleryZoom = /*#__PURE__*/function () {
    function GalleryZoom(container) {
      _classCallCheck(this, GalleryZoom);
      this.container = container;
      this.triggers = this.container.querySelectorAll(selectors$i.zoomImage);
      this.modalContainer = document.querySelector(selectors$i.modalContainer);
      this.init();
    }
    return _createClass(GalleryZoom, [{
      key: "init",
      value: function init() {
        var _this117 = this;
        this.triggers.forEach(function (trigger) {
          var unique = trigger.getAttribute(selectors$i.attrUnique);
          var modalIsAdded = _this117.modalContainer.querySelector("#zoom-".concat(unique));
          if (modalIsAdded) {
            var newModal = _this117.container.querySelector("#zoom-".concat(unique));
            if (newModal) {
              modalIsAdded.parentNode.removeChild(modalIsAdded);
              _this117.modalContainer.appendChild(newModal);
            }
          }
          MicroModal.init({
            disableScroll: true,
            openTrigger: "data-popup-".concat(unique),
            onShow: function onShow(modal) {
              var images = modal.querySelectorAll("[".concat(selectors$i.image, "]"), modal);
              images.forEach(function (image) {
                if (image.getAttribute('src') === null) {
                  var bigImage = image.getAttribute(selectors$i.image);
                  image.setAttribute('src', bigImage);
                }
              });
            },
            onClose: function onClose(modal, el, event) {
              event.preventDefault();
            }
          });
        });
      }
    }]);
  }();
  var galleryZoomSection = {
    onLoad: function onLoad() {
      new GalleryZoom(this.container);
    }
  };
  register('gallery', [galleryZoomSection, popupVideoSection, customScrollbar]);
  var tokensReducer = function tokensReducer(acc, token) {
    var el = acc.el,
      elStyle = acc.elStyle,
      elHeight = acc.elHeight,
      rowsLimit = acc.rowsLimit,
      rowsWrapped = acc.rowsWrapped,
      options = acc.options;
    var oldBuffer = acc.buffer;
    var newBuffer = oldBuffer;
    if (rowsWrapped === rowsLimit + 1) {
      return _objectSpread({}, acc);
    }
    var textBeforeWrap = oldBuffer;
    var newRowsWrapped = rowsWrapped;
    var newHeight = elHeight;
    el.innerHTML = newBuffer = oldBuffer.length ? "".concat(oldBuffer).concat(options.delimiter).concat(token).concat(options.replaceStr) : "".concat(token).concat(options.replaceStr);
    if (parseFloat(elStyle.height) > parseFloat(elHeight)) {
      newRowsWrapped++;
      newHeight = elStyle.height;
      if (newRowsWrapped === rowsLimit + 1) {
        el.innerHTML = newBuffer = textBeforeWrap[textBeforeWrap.length - 1] === '.' && options.replaceStr === '...' ? "".concat(textBeforeWrap, "..") : "".concat(textBeforeWrap).concat(options.replaceStr);
        return _objectSpread(_objectSpread({}, acc), {}, {
          elHeight: newHeight,
          rowsWrapped: newRowsWrapped
        });
      }
    }
    el.innerHTML = newBuffer = textBeforeWrap.length ? "".concat(textBeforeWrap).concat(options.delimiter).concat(token) : "".concat(token);
    return _objectSpread(_objectSpread({}, acc), {}, {
      buffer: newBuffer,
      elHeight: newHeight,
      rowsWrapped: newRowsWrapped
    });
  };
  var ellipsis = function ellipsis() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var defaultOptions = {
      replaceStr: '...',
      debounceDelay: 250,
      delimiter: ' '
    };
    var opts = _objectSpread(_objectSpread({}, defaultOptions), options);
    var elements = selector && (selector instanceof NodeList ? selector : selector.nodeType === 1 // if node type is Node.ELEMENT_NODE
    ? [selector] // wrap it in (NodeList) if it is a single node
    : document.querySelectorAll(selector));
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var elementHtml = el.innerHTML;
      var commentRegex = /<!--[\s\S]*?-->/g;
      var htmlWithoutComments = elementHtml.replace(commentRegex, '');
      var splittedText = htmlWithoutComments.split(opts.delimiter);
      el.innerHTML = '';
      var elStyle = window.getComputedStyle(el);
      splittedText.reduce(tokensReducer, {
        el: el,
        buffer: el.innerHTML,
        elStyle: elStyle,
        elHeight: 0,
        rowsLimit: rows,
        rowsWrapped: 0,
        options: opts
      });
    }
  };
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};
  var selectors$h = {
    productSlideshow: '[data-product-slideshow]',
    productXr: '[data-shopify-xr]',
    dataMediaId: 'data-media-id',
    dataModelId: 'data-model-id',
    modelViewer: 'model-viewer',
    dataModel3d: 'data-shopify-model3d-id',
    modelJson: '#ModelJson-'
  };
  function initSectionModels(modelViewerContainer, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };
    var mediaId = modelViewerContainer.getAttribute(selectors$h.dataMediaId);
    var modelViewerElement = modelViewerContainer.querySelector(selectors$h.modelViewer);
    var modelId = modelViewerElement.getAttribute(selectors$h.dataModelId);
    if (modelViewerContainer.closest(selectors$h.productSlideshow) !== null) {
      var xrButton = modelViewerContainer.closest(selectors$h.productSlideshow).parentElement.querySelector(selectors$h.productXr);
      xrButtons[sectionId] = {
        $element: xrButton,
        defaultId: modelId
      };
    }
    models[mediaId] = {
      modelId: modelId,
      mediaId: mediaId,
      sectionId: sectionId,
      $container: modelViewerContainer,
      $element: modelViewerElement
    };
    window.Shopify.loadFeatures([{
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr
    }, {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUi
    }]);
  }
  function setupShopifyXr(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function () {
        setupShopifyXr();
      });
      return;
    }
    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;
        var modelJson = document.querySelector("".concat(selectors$h.modelJson).concat(sectionId));
        if (modelJson) {
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
    }
    window.ShopifyXR.setupXRElements();
  }
  function setupModelViewerUi(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }
  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.$container.addEventListener('pause', function () {
      if (model.modelViewerUi.pause) {
        model.modelViewerUi.pause();
      }
    });
    model.$container.addEventListener('theme:media:play-desktop', function () {
      if (model.modelViewerUi.play && !isTouch()) {
        model.modelViewerUi.play();
      }
      if (xrButton && xrButton.$element && model && model.modelId && selectors$h.dataModel3d) {
        xrButton.$element.setAttribute(selectors$h.dataModel3d, model.modelId);
      }
    });
    model.$container.addEventListener('play', function () {
      if (model.modelViewerUi.play) {
        model.modelViewerUi.play();
      }
    });
  }
  function productNativeVideo(_x2) {
    return _productNativeVideo.apply(this, arguments);
  }
  function _productNativeVideo() {
    _productNativeVideo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(uniqueKey) {
      var playerElement, videoElement, videoLoad, player;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            playerElement = document.querySelector("[data-player=\"".concat(uniqueKey, "\"]"));
            videoElement = playerElement.querySelector('video');
            videoLoad = {
              name: 'video-ui',
              version: '1.0'
            };
            _context2.n = 1;
            return loadScript(videoLoad);
          case 1:
            player = new window.Shopify.Plyr(videoElement);
            playerElement.addEventListener('pause', function () {
              if (player.pause) {
                player.pause();
              }
            });
            playerElement.addEventListener('theme:media:play-desktop', function () {
              if (player.play && !isTouch()) {
                playerElement.dispatchEvent(new CustomEvent('play'));
              }
            });
            playerElement.addEventListener('play', function () {
              try {
                if (player.play) {
                  player.play();
                } else {
                  player.addEventListener('onReady', function (event) {
                    event.target.play();
                  });
                }
              } catch (e) {
                console.warn(e);
              }
            });
            playerElement.addEventListener('destroy', function () {
              try {
                if (player.destroy) {
                  player.destroy();
                }
              } catch (e) {
                console.warn(e);
              }
            });
            return _context2.a(2, player);
        }
      }, _callee2);
    }));
    return _productNativeVideo.apply(this, arguments);
  }
  var selectors$g = {
    productSlideshow: '[data-product-slideshow]',
    slideshowMobileStyle: 'data-slideshow-mobile-style',
    slideshowDesktopStyle: 'data-slideshow-desktop-style',
    productThumbs: '[data-product-thumbs]',
    leftThumbsHolder: '[data-thumbs-holder]',
    thumbImage: '[data-slideshow-thumbnail]',
    mediaSlide: '[data-media-slide]',
    dataMediaId: 'data-media-id',
    dataMediaSelect: 'data-media-select',
    mediaType: 'data-type',
    videoPlayerExternal: '[data-type="external_video"]',
    videoPlayerNative: '[data-type="video"]',
    modelViewer: '[data-type="model"]',
    allPlayers: '[data-player]',
    loopVideo: 'data-enable-video-looping',
    verticalAlignment: '[data-thumbnails-left]',
    arrowPrev: '[data-thumbs-arrow-prev]',
    arrowNext: '[data-thumbs-arrow-next]',
    aspectRatio: 'data-aspect-ratio',
    flickitylockHeight: 'flickity-lock-height'
  };
  var classes$c = {
    flickityDisableClass: 'flickity-disabled-mobile',
    flickityEnabled: 'flickity-enabled',
    selected: 'is-selected',
    active: 'is-activated',
    show: 'show'
  };
  var Media = /*#__PURE__*/function () {
    function Media(section) {
      _classCallCheck(this, Media);
      this.section = section;
      this.container = section.container;
      this.slideshow = this.container.querySelector(selectors$g.productSlideshow);
      this.mobileStyle = this.slideshow.getAttribute(selectors$g.slideshowMobileStyle);
      this.desktopStyle = this.slideshow.getAttribute(selectors$g.slideshowDesktopStyle);
      this.arrowPrev = this.container.querySelector(selectors$g.arrowPrev);
      this.arrowNext = this.container.querySelector(selectors$g.arrowNext);
      this.leftThumbsHolder = this.container.querySelector(selectors$g.leftThumbsHolder);
      this.thumbWrapper = this.container.querySelector(selectors$g.productThumbs);
      this.thumbImages = this.container.querySelectorAll(selectors$g.thumbImage);
      this.loopVideo = this.container.getAttribute(selectors$g.loopVideo) === 'true';
      this.verticalAlignment = Boolean(this.container.querySelector(selectors$g.verticalAlignment));
      this.flkty = null;
      this.thumbs = this.container.querySelector(selectors$g.productThumbs);
      this.currentSlide = null;
      this.init();
    }
    return _createClass(Media, [{
      key: "init",
      value: function init() {
        var _this118 = this;
        this.storeEvents();
        this.connectSliderMediaEvents();
        this.detectVideo();
        this.detectYouTube();
        this.detect3d();
        this.scrollThumbs();
        document.addEventListener('theme:resize:width', function () {
          _this118.scrollThumbs();
        });
      }
    }, {
      key: "connectSliderMediaEvents",
      value: function connectSliderMediaEvents() {
        var _this119 = this;
        var isMobile = "(max-width: ".concat(window.theme.sizes.medium, "px)");
        var isMobileMQL = window.matchMedia(isMobile);
        isMobileMQL.addEventListener('change', function (event) {
          event.matches ? _this119.createMobileSlider() : _this119.createDesktopSlider();
        });
        isMobileMQL.matches ? this.createMobileSlider() : this.createDesktopSlider();
      }
    }, {
      key: "createMobileSlider",
      value: function createMobileSlider() {
        if (this.flkty) {
          this.destroySlider();
        }

        // defaults to "thumbs" option
        var mobileOptions = {
          autoPlay: false,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          accessibility: true,
          watchCSS: false,
          wrapAround: true,
          rightToLeft: window.isRTL,
          dragThreshold: 80,
          contain: true,
          fade: true
        };
        if (this.mobileStyle == 'carousel') {
          mobileOptions.contain = false;
          mobileOptions.dragThreshold = 5;
          mobileOptions.fade = false;
        }
        if (this.mobileStyle == 'slideshow') {
          mobileOptions.pageDots = true;
          mobileOptions.fade = false;
          mobileOptions.dragThreshold = 5;
        }
        console.log('mobile threshold', mobileOptions.dragThreshold);
        this.createSlider(mobileOptions);
      }
    }, {
      key: "createDesktopSlider",
      value: function createDesktopSlider() {
        if (this.flkty) {
          this.destroySlider();
        }
        if (this.desktopStyle == 'none') {
          return;
        }
        var desktopOptions = {
          autoPlay: false,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          accessibility: true,
          watchCSS: false,
          wrapAround: true,
          rightToLeft: window.isRTL,
          dragThreshold: 80,
          contain: true,
          fade: true
        };
        this.createSlider(desktopOptions);
      }
    }, {
      key: "createSlider",
      value: function createSlider(options) {
        this.flkty = new Flickity(this.slideshow, options);
        this.flkty.resize();
        this.currentSlide = this.slideshow.querySelectorAll(selectors$g.mediaSlide)[0];
        this.setDraggable();
        this.addEventListeners();
      }
    }, {
      key: "destroySlider",
      value: function destroySlider() {
        this.removeEventListeners();
        this.flkty.destroy();
      }
    }, {
      key: "storeEvents",
      value: function storeEvents() {
        var _this120 = this;
        this.storeFlktyChange = function (e) {
          return _this120.doFlktyChange(e);
        };
        this.storeFlktySettle = function (e) {
          return _this120.doFlktySettle(e);
        };
        this.storeImageChange = function (e) {
          return _this120.doImageChange(e);
        };
        this.storeArrowPrevClick = function (e) {
          return _this120.doArrowPrevClick(e);
        };
        this.storeArrowNextClick = function (e) {
          return _this120.doArrowNextClick(e);
        };
        this.storeThumbClick = function (e) {
          return _this120.doThumbClick(e);
        };
        this.storeThumbContainerScroll = function (e) {
          return _this120.doThumbContainerScroll(e);
        };
      }
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this$arrowPrev,
          _this$arrowNext,
          _this$thumbs,
          _this121 = this;
        this.flkty.on('change', this.storeFlktyChange);
        this.flkty.on('settle', this.storeFlktySettle);
        this.slideshow.addEventListener('theme:image:change', this.storeImageChange);
        (_this$arrowPrev = this.arrowPrev) === null || _this$arrowPrev === void 0 || _this$arrowPrev.addEventListener('click', this.storeArrowPrevClick);
        (_this$arrowNext = this.arrowNext) === null || _this$arrowNext === void 0 || _this$arrowNext.addEventListener('click', this.storeArrowNextClick);
        (_this$thumbs = this.thumbs) === null || _this$thumbs === void 0 || _this$thumbs.addEventListener('scroll', this.storeThumbContainerScroll);
        this.thumbImages.forEach(function (thumb) {
          thumb.addEventListener('click', _this121.storeThumbClick);
        });
      }
    }, {
      key: "removeEventListeners",
      value: function removeEventListeners() {
        var _this$arrowPrev2,
          _this$arrowNext2,
          _this$thumbs2,
          _this122 = this;
        this.flkty.on('change', this.storeFlktyChange);
        this.flkty.on('settle', this.storeFlktySettle);
        this.slideshow.removeEventListener('theme:image:change', this.storeImageChange);
        (_this$arrowPrev2 = this.arrowPrev) === null || _this$arrowPrev2 === void 0 || _this$arrowPrev2.removeEventListener('click', this.storeArrowPrevClick);
        (_this$arrowNext2 = this.arrowNext) === null || _this$arrowNext2 === void 0 || _this$arrowNext2.removeEventListener('click', this.storeArrowNextClick);
        (_this$thumbs2 = this.thumbs) === null || _this$thumbs2 === void 0 || _this$thumbs2.removeEventListener('scroll', this.storeThumbContainerScroll);
        this.thumbImages.forEach(function (thumb) {
          thumb.removeEventListener('click', _this122.storeThumbClick);
        });
      }
    }, {
      key: "doFlktyChange",
      value: function doFlktyChange(index) {
        var _this$thumbWrapper, _this$thumbWrapper2;
        this.currentSlide.dispatchEvent(new CustomEvent('pause'));
        this.currentSlide = this.flkty.cells[index].element;
        this.slideshow.classList.remove(selectors$g.flickitylockHeight);
        var id = this.currentSlide.getAttribute(selectors$g.dataMediaId);
        var currentThumb = (_this$thumbWrapper = this.thumbWrapper) === null || _this$thumbWrapper === void 0 ? void 0 : _this$thumbWrapper.querySelector("[".concat(selectors$g.dataMediaSelect, "=\"").concat(id, "\"]"));
        (_this$thumbWrapper2 = this.thumbWrapper) === null || _this$thumbWrapper2 === void 0 || _this$thumbWrapper2.querySelector(".".concat(classes$c.active)).classList.remove(classes$c.active);
        currentThumb === null || currentThumb === void 0 || currentThumb.classList.add(classes$c.active);
        this.scrollThumbs();
      }
    }, {
      key: "doFlktySettle",
      value: function doFlktySettle(index) {
        this.allSlides = this.flkty.cells;
        this.currentSlide = this.flkty.cells[index].element;
        this.setDraggable();
        this.currentSlide.dispatchEvent(new CustomEvent('theme:media:play-desktop'));
        var isFocusEnabled = document.body.classList.contains(selectors$g.focusEnabled);
        if (isFocusEnabled) this.currentSlide.dispatchEvent(new Event('focus'));
        this.scrollThumbs();
      }
    }, {
      key: "doImageChange",
      value: function doImageChange(event) {
        var mediaId = event.detail.id;
        var mediaIdString = "[".concat(selectors$g.dataMediaId, "=\"").concat(mediaId, "\"]");
        var matchesMedia = function matchesMedia(cell) {
          return cell.element.matches(mediaIdString);
        };
        var index = this.flkty.cells.findIndex(matchesMedia);
        this.flkty.select(index);
        this.scrollThumbs();
      }
    }, {
      key: "doThumbContainerScroll",
      value: function doThumbContainerScroll() {
        this.scrollThumbs('scroll');
      }
    }, {
      key: "doArrowPrevClick",
      value: function doArrowPrevClick() {
        this.scrollThumbs('clickPrev');
      }
    }, {
      key: "doArrowNextClick",
      value: function doArrowNextClick() {
        this.scrollThumbs('clickNext');
      }
    }, {
      key: "doThumbClick",
      value: function doThumbClick(event) {
        var id = event.currentTarget.getAttribute(selectors$g.dataMediaSelect);
        this.slideshow.dispatchEvent(new CustomEvent('theme:image:change', {
          detail: {
            id: id
          }
        }));
      }
    }, {
      key: "setDraggable",
      value: function setDraggable() {
        if (this.currentSlide) {
          var mediaType = this.currentSlide.getAttribute(selectors$g.mediaType);
          if (mediaType === 'model' || mediaType === 'video' || mediaType === 'external_video') {
            // fisrt boolean sets value, second option false to prevent refresh
            // this.flkty.options.draggable = false;
            // this.flkty.updateDraggable();
          } else {
            this.flkty.options.draggable = true;
            this.flkty.updateDraggable();
          }
        }
      }
    }, {
      key: "detect3d",
      value: function detect3d() {
        var _this123 = this;
        var modelViewerElements = this.container.querySelectorAll(selectors$g.modelViewer);
        if (modelViewerElements) {
          modelViewerElements.forEach(function (element) {
            initSectionModels(element, _this123.section.id);
          });
          document.addEventListener('shopify_xr_launch', function () {
            this.container.querySelectorAll(selectors$g.allPlayers).forEach(function (player) {
              player.dispatchEvent(new CustomEvent('pause'));
            });
          }.bind(this));
        }
      }
    }, {
      key: "detectVideo",
      value: function detectVideo() {
        var playerElements = this.section.container.querySelectorAll(selectors$g.videoPlayerNative);
        var _iterator3 = _createForOfIteratorHelper(playerElements),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var player = _step3.value;
            var uniqueKey = player.dataset.player;
            var nativePlayerPromise = productNativeVideo(uniqueKey);
            if (this.loopVideo === true) {
              nativePlayerPromise.then(function (nativePlayer) {
                nativePlayer.loop = true;
                return nativePlayer;
              }).catch(function (err) {
                console.error(err);
              });
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "detectYouTube",
      value: function detectYouTube() {
        var playerElements = this.section.container.querySelectorAll(selectors$g.videoPlayerExternal);
        var _iterator4 = _createForOfIteratorHelper(playerElements),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var player = _step4.value;
            var uniqueKey = player.dataset.player;
            var youtubePlayerPromise = embedYoutube(uniqueKey);
            if (this.loopVideo === true) {
              youtubePlayerPromise.then(function (youtubePlayer) {
                return _setToLoop(youtubePlayer);
              }).catch(function (err) {
                console.error(err);
              });
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }, {
      key: "pauseAllMedia",
      value: function pauseAllMedia() {
        var all = this.container.querySelector(selectors$g.mediaSlide);
        all.dispatchEvent(new CustomEvent('pause'));
      }
    }, {
      key: "pauseOtherMedia",
      value: function pauseOtherMedia(uniqueKey) {
        var otherMedia = this.container.querySelector("".concat(selectors$g.mediaSlide, ":not([data-player=\"").concat(uniqueKey, "\"])"));
        otherMedia.dispatchEvent(new CustomEvent('pause'));
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.container.querySelectorAll(selectors$g.allPlayers).forEach(function (player) {
          player.dispatchEvent(new CustomEvent('destroy'));
        });
      }
    }, {
      key: "scrollThumbs",
      value: function scrollThumbs(event) {
        this.thumbs = this.container.querySelector(selectors$g.productThumbs);
        if (this.thumbs) {
          this.thumb = this.thumbs.querySelector(".".concat(classes$c.active));
          this.thumbItems = this.container.querySelectorAll(selectors$g.thumbImage);
          this.lastThumb = this.thumbItems[this.thumbItems.length - 1];
          if (!this.thumb) return;
          this.thumbsScrollTop = this.thumbs.scrollTop;
          this.thumbsScrollLeft = this.thumbs.scrollLeft;
          this.thumbsWidth = this.thumbs.offsetWidth;
          this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(selectors$g.aspectRatio);
          this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight;
          this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth;
          this.checkThumbPositions();
          this.toggleToActiveThumb(event);
          this.toggleArrows();
        }
      }
    }, {
      key: "checkThumbPositions",
      value: function checkThumbPositions() {
        this.thumbWidth = this.thumb.offsetWidth;
        this.thumbHeight = this.thumb.offsetHeight;
        this.thumbPosTop = this.thumb.offsetTop;
        this.thumbPosLeft = this.thumb.offsetLeft;
        this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth;
        this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight;
        this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2;
        this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2;
        this.topCheck = this.thumbsScrollTop > 0;
        this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos;
        this.leftCheck = this.thumbsScrollLeft > 0;
        this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos;
        this.verticalCheck = this.bottomCheck || this.topCheck;
        this.horizontalCheck = this.rightCheck || this.leftCheck;
      }
    }, {
      key: "toggleToActiveThumb",
      value: function toggleToActiveThumb(event) {
        if (event !== 'scroll') {
          if (event == 'clickPrev') {
            if (this.verticalCheck) {
              this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight;
              this.scrollLeftPosition = 0;
            } else {
              this.scrollTopPosition = 0;
              this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth;
            }
          }
          if (event == 'clickNext') {
            if (this.verticalCheck) {
              this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight;
              this.scrollLeftPosition = 0;
            } else {
              this.scrollTopPosition = 0;
              this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth;
            }
          }
          this.thumbs.scrollTo({
            top: this.scrollTopPosition,
            left: this.scrollLeftPosition,
            behavior: 'smooth'
          });
        }
      }
    }, {
      key: "toggleArrows",
      value: function toggleArrows() {
        if (this.verticalCheck || this.verticalAlignment && !this.verticalCheck) {
          this.arrowPrev.classList.toggle(classes$c.show, this.topCheck);
          this.arrowNext.classList.toggle(classes$c.show, this.bottomCheck);
        }
        if (this.horizontalCheck || !this.verticalAlignment && !this.horizontalCheck) {
          this.arrowPrev.classList.toggle(classes$c.show, this.leftCheck);
          this.arrowNext.classList.toggle(classes$c.show, this.rightCheck);
        }
      }
    }]);
  }();
  function _setToLoop(youtubePlayer) {
    youtubePlayer.addEventListener('onStateChange', function (event) {
      if (event.data === 0) {
        // video is over, replay
        event.target.playVideo();
      }
    });
    return youtubePlayer;
  }
  var selectors$f = {
    pickupContainer: 'data-store-availability-container',
    shopifySection: '[data-api-content]',
    drawer: '[data-pickup-drawer]',
    drawerOpen: '[data-pickup-drawer-open]',
    drawerClose: '[data-pickup-drawer-close]',
    drawerBody: '[data-pickup-body]'
  };
  var classes$b = {
    isVisible: 'drawer--visible',
    isHidden: 'hide',
    isPickupVisible: 'is-pickup-visible'
  };
  var sections$5 = {};
  var PickupAvailability = /*#__PURE__*/function () {
    function PickupAvailability(section) {
      var _this124 = this;
      _classCallCheck(this, PickupAvailability);
      this.container = section.container;
      this.drawer = null;
      this.buttonDrawerOpen = null;
      this.buttonDrawerClose = null;
      this.drawerBody = null;
      this.fetchPickupAvailability();
      this.container.addEventListener('theme:variant:change', function (event) {
        return _this124.fetchPickupAvailability(event);
      });
    }
    return _createClass(PickupAvailability, [{
      key: "fetchPickupAvailability",
      value: function fetchPickupAvailability(event) {
        var _this125 = this;
        var container = this.container.querySelector("[".concat(selectors$f.pickupContainer, "]"));
        if (!container) return;
        var variantID = event && event.detail.variant ? event.detail.variant.id : container.getAttribute(selectors$f.pickupContainer);
        if (event && !event.detail.variant) {
          container.classList.add(classes$b.isHidden);
          return;
        }
        if (variantID) {
          fetch("".concat(window.theme.routes.root_url, "variants/").concat(variantID, "/?section_id=api-pickup-availability")).then(this.handleErrors).then(function (response) {
            return response.text();
          }).then(function (text) {
            var pickupAvailabilityHTML = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors$f.shopifySection).innerHTML;
            container.innerHTML = pickupAvailabilityHTML;
            container.classList.remove(classes$b.isHidden);
            _this125.drawer = _this125.container.querySelector(selectors$f.drawer);
            _this125.buttonDrawerOpen = _this125.container.querySelector(selectors$f.drawerOpen);
            _this125.buttonDrawerClose = _this125.container.querySelectorAll(selectors$f.drawerClose);
            _this125.drawerBody = _this125.container.querySelector(selectors$f.drawerBody);
            if (_this125.buttonDrawerOpen) {
              _this125.buttonDrawerOpen.addEventListener('click', function () {
                return _this125.openDrawer();
              });
            }
            if (_this125.buttonDrawerClose.length) {
              _this125.buttonDrawerClose.forEach(function (element) {
                element.addEventListener('click', function () {
                  return _this125.closeDrawer();
                });
              });
            }
          }).catch(function (e) {
            console.error(e);
          });
        }
      }
    }, {
      key: "openDrawer",
      value: function openDrawer() {
        if (this.drawer) {
          document.body.classList.add(classes$b.isPickupVisible);
          this.drawer.classList.add(classes$b.isVisible);
          this.drawer.dispatchEvent(new CustomEvent('theme:scroll:lock', {
            bubbles: true
          }));
          this.drawerBody.dispatchEvent(new CustomEvent('theme:scroll:lock', {
            bubbles: true
          }));
        }
      }
    }, {
      key: "closeDrawer",
      value: function closeDrawer() {
        if (this.drawer) {
          document.body.classList.remove(classes$b.isPickupVisible);
          this.drawer.classList.remove(classes$b.isVisible);
          this.drawer.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
            bubbles: true
          }));
          this.drawerBody.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
            bubbles: true
          }));
        }
      }
    }, {
      key: "handleErrors",
      value: function handleErrors(response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            var e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              json: json
            });
            throw e;
          });
        }
        return response;
      }
    }]);
  }();
  var pickupAvailability = {
    onLoad: function onLoad() {
      sections$5[this.id] = new PickupAvailability(this);
    }
  };
  var hideElement = function hideElement(elem) {
    if (elem) {
      elem.style.display = 'none';
    }
  };
  var selectors$e = {
    form: '[data-product-form]',
    optionPosition: 'data-option-position',
    optionInput: '[name^="options"], [data-popout-option]',
    selectOptionValue: 'data-value'
  };
  var classes$a = {
    soldOut: 'sold-out',
    unavailable: 'unavailable'
  };

  /**
   * Variant Sellout Precrime Click Preview
   * I think of this like the precrime machine in Minority report.  It gives a preview
   * of every possible click action, given the current form state.  The logic is:
   *
   * for each clickable name=options[] variant selection element
   * find the value of the form if the element were clicked
   * lookup the variant with those value in the product json
   * clear the classes, add .unavailable if it's not found,
   * and add .sold-out if it is out of stock
   *
   * Caveat: we rely on the option position so we don't need
   * to keep a complex map of keys and values.
   */
  var SelloutVariants = /*#__PURE__*/function () {
    function SelloutVariants(section, productJSON) {
      _classCallCheck(this, SelloutVariants);
      this.container = section;
      this.productJSON = productJSON;
      this.form = this.container.querySelector(selectors$e.form);
      this.formData = new FormData(this.form);
      this.optionElements = this.container.querySelectorAll(selectors$e.optionInput);
      if (this.productJSON && this.form) {
        this.init();
      }
    }
    return _createClass(SelloutVariants, [{
      key: "init",
      value: function init() {
        this.update();
      }
    }, {
      key: "update",
      value: function update() {
        var _this126 = this;
        this.getCurrentState();
        this.optionElements.forEach(function (el) {
          var val = el.value || el.getAttribute(selectors$e.selectOptionValue);
          var positionString = el.closest("[".concat(selectors$e.optionPosition, "]")) ? el.closest("[".concat(selectors$e.optionPosition, "]")).getAttribute(selectors$e.optionPosition) : null;
          // subtract one because option.position in liquid does not count form zero, but JS arrays do
          var position = parseInt(positionString, 10) - 1;
          var newVals = _toConsumableArray(_this126.selections);
          newVals[position] = val;
          var found = _this126.productJSON.variants.find(function (element) {
            // only return true if every option matches our hypothetical selection
            var perfectMatch = true;
            for (var index = 0; index < newVals.length; index++) {
              if (element.options[index] !== newVals[index]) {
                perfectMatch = false;
              }
            }
            return perfectMatch;
          });
          el.classList.remove(classes$a.soldOut, classes$a.unavailable);
          if (typeof found === 'undefined') {
            el.classList.add(classes$a.unavailable);
          } else if (found && found.available === false) {
            el.classList.add(classes$a.soldOut);
          }
        });
      }
    }, {
      key: "getCurrentState",
      value: function getCurrentState() {
        this.formData = new FormData(this.form);
        this.selections = [];
        var _iterator5 = _createForOfIteratorHelper(this.formData.entries()),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var value = _step5.value;
            if (value[0].includes('options[')) {
              // push the current state of the form, dont worry about the group name
              // we will be using the array position instead of the name to match values
              this.selections.push(value[1]);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }]);
  }();
  var selectors$d = {
    outerSection: '[data-section-id]',
    quickviewModal: '[data-quickview-modal]',
    productForm: '[data-product-form]',
    productSlideshow: '[data-product-slideshow]',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    buttonsWrapper: '[data-buttons-wrapper]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    priceButton: '[data-button-price]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    unitPrice: '[data-product-unit-price]',
    unitBase: '[data-product-base]',
    unitWrapper: '[data-product-unit]',
    dataEnableHistoryState: 'data-enable-history-state',
    optionPosition: 'data-option-position',
    optionValue: '[data-option-value]',
    subPrices: '[data-subscription-watch-price]',
    subSelectors: '[data-subscription-selectors]',
    priceOffWrap: '[data-price-off]',
    priceOffType: '[data-price-off-type]',
    priceOffAmount: '[data-price-off-amount]',
    subsToggle: '[data-toggles-group]',
    subsChild: 'data-group-toggle',
    subDescription: '[data-plan-description]',
    remainingCount: '[data-remaining-count]',
    remainingMax: 'data-remaining-max',
    remainingWrapper: '[data-remaining-wrapper]',
    remainingJSON: '[data-product-remaining-json]',
    isPreOrder: '[data-product-preorder]',
    idInput: '[name="id"]'
  };
  var classes$9 = {
    hide: 'hide',
    variantSoldOut: 'variant--soldout',
    variantUnavailable: 'variant--unavailable',
    productPriceSale: 'product__price--sale',
    remainingLow: 'count-is-low',
    remainingIn: 'count-is-in',
    remainingOut: 'count-is-out',
    remainingUnavailable: 'count-is-unavailable'
  };
  var ProductForm = /*#__PURE__*/function (_HTMLElement8) {
    function ProductForm() {
      var _this127;
      _classCallCheck(this, ProductForm);
      _this127 = _callSuper(this, ProductForm);
      _this127.container = _this127;
      return _this127;
    }
    _inherits(ProductForm, _HTMLElement8);
    return _createClass(ProductForm, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.outerSection = this.container.closest(selectors$d.outerSection);
        this.quickview = this.container.closest(selectors$d.quickviewModal);
        this.outerWrapper = this.quickview ? this.quickview : this.outerSection;
        this.productFormElement = this.container.querySelector(selectors$d.productForm);
        this.productForm = this.container.querySelector(selectors$d.productForm);
        this.slideshow = this.outerWrapper.querySelector(selectors$d.productSlideshow);
        this.enableHistoryState = this.outerSection && this.outerSection.hasAttribute(selectors$d.dataEnableHistoryState) ? this.outerSection.getAttribute(selectors$d.dataEnableHistoryState) === 'true' : false;
        this.hasUnitPricing = this.outerWrapper.querySelector(selectors$d.unitWrapper);
        this.subSelectors = this.outerWrapper.querySelector(selectors$d.subSelectors);
        this.subPrices = this.outerWrapper.querySelector(selectors$d.subPrices);
        this.priceOffWrap = this.outerWrapper.querySelector(selectors$d.priceOffWrap);
        this.priceOffAmount = this.outerWrapper.querySelector(selectors$d.priceOffAmount);
        this.priceOffType = this.outerWrapper.querySelector(selectors$d.priceOffType);
        this.planDecription = this.outerWrapper.querySelector(selectors$d.subDescription);
        this.isPreOrder = this.container.querySelector(selectors$d.isPreOrder);
        this.remainingWrapper = this.outerWrapper.querySelector(selectors$d.remainingWrapper);
        var remainingMaxWrap = this.outerWrapper.querySelector("[".concat(selectors$d.remainingMax, "]"));
        this.sellout = null;
        if (this.remainingWrapper && remainingMaxWrap) {
          this.remainingMaxInt = parseInt(remainingMaxWrap.getAttribute(selectors$d.remainingMax), 10);
          this.remainingCount = this.outerWrapper.querySelector(selectors$d.remainingCount);
          this.remainingJSONWrapper = this.outerWrapper.querySelector(selectors$d.remainingJSON);
          this.remainingJSON = null;
          if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== '') {
            this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML);
          } else {
            console.warn('Missing product quantity JSON');
          }
        }
        initQtySection(this.outerWrapper);
        var productJSONText = null;
        this.productJSON = null;
        var productElemJSON = this.outerWrapper.querySelector(selectors$d.productJson);
        if (productElemJSON) {
          productJSONText = productElemJSON.innerHTML;
        }
        if (productJSONText && this.productForm) {
          this.productJSON = JSON.parse(productJSONText);
          this.sellout = new SelloutVariants(this.outerWrapper, this.productJSON);
          this.linkForm();
        } else {
          console.warn('Missing product form or product JSON');
        }

        // Add cookie for recent products
        if (this.productJSON) {
          new RecordRecentlyViewed(this.productJSON.handle);
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.productForm.destroy();
      }
    }, {
      key: "linkForm",
      value: function linkForm() {
        this.productForm = new ProductFormReader(this.outerWrapper, this.productFormElement, this.productJSON, {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
          onQuantityChange: this.onQuantityChange.bind(this)
        });
        this.pushState(this.productForm.getFormState(), true);
        this.subsToggleListeners();
      }
    }, {
      key: "onOptionChange",
      value: function onOptionChange(evt) {
        this.pushState(evt.dataset);
      }
    }, {
      key: "onPlanChange",
      value: function onPlanChange(evt) {
        if (this.subPrices) {
          this.pushState(evt.dataset);
        }
      }
    }, {
      key: "onQuantityChange",
      value: function onQuantityChange(evt) {
        var formState = evt.dataset;
        this.productState = this.setProductState(formState);
        this.updateButtonPrices(formState);
      }
    }, {
      key: "pushState",
      value: function pushState(formState) {
        var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        this.productState = this.setProductState(formState);
        this.updateProductImage(formState);
        this.updateAddToCartState(formState);
        this.updateProductPrices(formState);
        this.updateSaleText(formState);
        this.updateSubscriptionText(formState);
        this.updateLegend(formState);
        this.updateRemaining(formState);
        this.fireHookEvent(formState);
        if (this.sellout) {
          this.sellout.update(formState);
        }
        if (this.enableHistoryState && !init) {
          this.updateHistoryState(formState);
        }
      }
    }, {
      key: "updateAddToCartState",
      value: function updateAddToCartState(formState) {
        var variant = formState.variant;
        var addText = theme.strings.addToCart;
        var priceWrapper = this.outerWrapper.querySelectorAll(selectors$d.priceWrapper);
        var buttonsWrapper = this.outerWrapper.querySelector(selectors$d.buttonsWrapper);
        var addToCart = buttonsWrapper.querySelectorAll(selectors$d.addToCart);
        var addToCartText = buttonsWrapper.querySelectorAll(selectors$d.addToCartText);
        if (this.isPreOrder) {
          addText = theme.strings.preOrder;
        }
        if (priceWrapper.length && variant) {
          priceWrapper.forEach(function (element) {
            element.classList.remove(classes$9.hide);
          });
        }
        if (addToCart.length) {
          addToCart.forEach(function (element) {
            if (variant) {
              if (variant.available) {
                element.disabled = false;
              } else {
                element.disabled = true;
              }
            } else {
              element.disabled = true;
            }
          });
        }
        if (addToCartText.length) {
          addToCartText.forEach(function (element) {
            if (variant) {
              if (variant.available) {
                element.innerHTML = addText;
              } else {
                element.innerHTML = theme.strings.soldOut;
              }
            } else {
              element.innerHTML = theme.strings.unavailable;
            }
          });
        }
        if (buttonsWrapper) {
          if (variant) {
            if (variant.available) {
              buttonsWrapper.classList.remove(classes$9.variantSoldOut, classes$9.variantUnavailable);
            } else {
              buttonsWrapper.classList.add(classes$9.variantSoldOut);
              buttonsWrapper.classList.remove(classes$9.variantUnavailable);
            }
            var formSelect = buttonsWrapper.querySelector(selectors$d.originalSelectorId);
            if (formSelect) {
              formSelect.value = variant.id;
            }
          } else {
            buttonsWrapper.classList.add(classes$9.variantUnavailable);
            buttonsWrapper.classList.remove(classes$9.variantSoldOut);
          }
        }
      }
    }, {
      key: "updateLegend",
      value: function updateLegend(formState) {
        var _this128 = this;
        var variant = formState.variant;
        if (variant) {
          var vals = this.container.parentNode.querySelectorAll(selectors$d.optionValue);
          vals.forEach(function (val) {
            var wrapper = val.closest("[".concat(selectors$d.optionPosition, "]"));
            if (wrapper) {
              var position = wrapper.getAttribute(selectors$d.optionPosition);
              var index = parseInt(position, 10) - 1;
              _this128.newValue = variant.options[index];
              val.innerHTML = _this128.newValue;
            }
          });
        }
      }
    }, {
      key: "updateHistoryState",
      value: function updateHistoryState(formState) {
        var variant = formState.variant;
        var plan = formState.plan;
        var location = window.location.href;
        if (variant && location.includes('/product')) {
          var url = new window.URL(location);
          var params = url.searchParams;
          params.set('variant', variant.id);
          if (plan && plan.detail && plan.detail.id && this.productState.hasPlan) {
            params.set('selling_plan', plan.detail.id);
          } else {
            params.delete('selling_plan');
          }
          url.search = params.toString();
          var urlString = url.toString();
          window.history.replaceState({
            path: urlString
          }, '', urlString);
        }
      }
    }, {
      key: "updateRemaining",
      value: function updateRemaining(formState) {
        var variant = formState.variant;
        if (variant && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
          var newQuantity = this.remainingJSON[variant.id];
          if (newQuantity && newQuantity <= this.remainingMaxInt && newQuantity > 0) {
            this.remainingWrapper.classList.remove(classes$9.remainingIn, classes$9.remainingOut, classes$9.remainingUnavailable);
            this.remainingWrapper.classList.add(classes$9.remainingLow);
            this.remainingCount.innerHTML = newQuantity;
          } else if (this.productState.soldOut) {
            this.remainingWrapper.classList.remove(classes$9.remainingLow, classes$9.remainingIn, classes$9.remainingUnavailable);
            this.remainingWrapper.classList.add(classes$9.remainingOut);
          } else if (this.productState.available) {
            this.remainingWrapper.classList.remove(classes$9.remainingLow, classes$9.remainingOut, classes$9.remainingUnavailable);
            this.remainingWrapper.classList.add(classes$9.remainingIn);
          }
        } else if (this.remainingWrapper) {
          this.remainingWrapper.classList.remove(classes$9.remainingIn, classes$9.remainingOut, classes$9.remainingLow);
          this.remainingWrapper.classList.add(classes$9.remainingUnavailable);
        }
      }
    }, {
      key: "getBaseUnit",
      value: function getBaseUnit(variant) {
        return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
      }
    }, {
      key: "subsToggleListeners",
      value: function subsToggleListeners() {
        var _this129 = this;
        var toggles = this.outerWrapper.querySelectorAll(selectors$d.subsToggle);
        toggles.forEach(function (toggle) {
          toggle.addEventListener('change', function (e) {
            var val = e.target.value.toString();
            var selected = this.outerWrapper.querySelector("[".concat(selectors$d.subsChild, "=\"").concat(val, "\"]"));
            var groups = this.outerWrapper.querySelectorAll("[".concat(selectors$d.subsChild, "]"));
            if (selected) {
              selected.classList.remove(classes$9.hide);
              var first = selected.querySelector("[name=\"selling_plan\"]");
              first.checked = true;
              first.dispatchEvent(new Event('change'));
            }
            groups.forEach(function (group) {
              if (group !== selected) {
                group.classList.add(classes$9.hide);
                var plans = group.querySelectorAll("[name=\"selling_plan\"]");
                plans.forEach(function (plan) {
                  plan.checked = false;
                  plan.dispatchEvent(new Event('change'));
                });
              }
            });
          }.bind(_this129));
        });
      }
    }, {
      key: "updateSaleText",
      value: function updateSaleText(formState) {
        if (this.productState.planSale) {
          this.updateSaleTextSubscription(formState);
        } else if (this.productState.onSale) {
          this.updateSaleTextStandard(formState);
        } else if (this.priceOffWrap) {
          this.priceOffWrap.classList.add(classes$9.hide);
        }
      }
    }, {
      key: "updateSaleTextStandard",
      value: function updateSaleTextStandard(formState) {
        if (!this.priceOffType) return;
        this.priceOffType.innerHTML = window.theme.strings.sale || 'sale';
        var variant = formState.variant;
        if (window.theme.settings.badge_sale_type && window.theme.settings.badge_sale_type === 'percentage') {
          var discountFloat = (variant.compare_at_price - variant.price) / variant.compare_at_price;
          var discountInt = Math.floor(discountFloat * 100);
          this.priceOffAmount.innerHTML = "".concat(discountInt, "%");
        } else {
          var discount = variant.compare_at_price - variant.price;
          this.priceOffAmount.innerHTML = this.formattingMoney(discount);
        }
        this.priceOffWrap.classList.remove(classes$9.hide);
      }
    }, {
      key: "updateSaleTextSubscription",
      value: function updateSaleTextSubscription(formState) {
        this.priceOffType.innerHTML = window.theme.strings.subscription || 'subscripton';
        var variant = formState.variant;
        var adjustment = formState.plan.detail.price_adjustments[0];
        var discount = adjustment.value;
        if (adjustment && adjustment.value_type === 'percentage') {
          this.priceOffAmount.innerHTML = "".concat(discount, "%");
        } else if (adjustment && adjustment.value_type === 'price') {
          this.priceOffAmount.innerHTML = this.formattingMoney(variant.price - adjustment.value);
        } else {
          this.priceOffAmount.innerHTML = this.formattingMoney(discount);
        }
        this.priceOffWrap.classList.remove(classes$9.hide);
      }
    }, {
      key: "updateSubscriptionText",
      value: function updateSubscriptionText(formState) {
        if (formState.plan && this.planDecription && formState.plan.detail.description !== null) {
          this.planDecription.innerHTML = formState.plan.detail.description;
          this.planDecription.classList.remove(classes$9.hide);
        } else if (this.planDecription) {
          this.planDecription.classList.add(classes$9.hide);
        }
      }
    }, {
      key: "getPrices",
      value: function getPrices(formState) {
        var variant = formState.variant;
        var plan = formState.plan;
        var comparePrice = '';
        var price = '';
        if (this.productState.available) {
          comparePrice = variant.compare_at_price;
          price = variant.price;
        }
        if (this.productState.hasPlan) {
          price = plan.allocation.price;
        }
        if (this.productState.planSale) {
          comparePrice = plan.allocation.compare_at_price;
          price = plan.allocation.price;
        }
        return {
          price: price,
          comparePrice: comparePrice
        };
      }
    }, {
      key: "updateButtonPrices",
      value: function updateButtonPrices(formState) {
        var _this130 = this;
        var priceButtons = this.outerWrapper.querySelectorAll(selectors$d.priceButton);
        var _this$getPrices = this.getPrices(formState),
          price = _this$getPrices.price;
        if (priceButtons.length) {
          priceButtons.forEach(function (btn) {
            var btnPrice = formState.quantity * price;
            btn.innerHTML = _this130.formattingMoney(btnPrice);
          });
        }
      }
    }, {
      key: "updateProductPrices",
      value: function updateProductPrices(formState) {
        var _this131 = this;
        var variant = formState.variant;
        var priceWrappers = this.outerWrapper.querySelectorAll(selectors$d.priceWrapper);
        var priceButtons = this.outerWrapper.querySelectorAll(selectors$d.priceButton);
        var _this$getPrices2 = this.getPrices(formState),
          price = _this$getPrices2.price,
          comparePrice = _this$getPrices2.comparePrice;
        priceWrappers.forEach(function (wrap) {
          var comparePriceEl = wrap.querySelector(selectors$d.comparePrice);
          var productPriceEl = wrap.querySelector(selectors$d.productPrice);
          var comparePriceText = wrap.querySelector(selectors$d.comparePriceText);
          if (comparePriceEl) {
            if (_this131.productState.onSale || _this131.productState.planSale) {
              comparePriceEl.classList.remove(classes$9.hide);
              comparePriceText.classList.remove(classes$9.hide);
              productPriceEl.classList.add(classes$9.productPriceSale);
            } else {
              comparePriceEl.classList.add(classes$9.hide);
              comparePriceText.classList.add(classes$9.hide);
              productPriceEl.classList.remove(classes$9.productPriceSale);
            }
            comparePriceEl.innerHTML = _this131.formattingMoney(comparePrice);
          }
          if (productPriceEl) {
            if (variant) {
              productPriceEl.innerHTML = _this131.formattingMoney(price);
            } else {
              productPriceEl.innerHTML = '&nbsp;';
            }
          }
        });
        if (priceButtons.length) {
          priceButtons.forEach(function (btn) {
            var btnPrice = formState.quantity * price;
            btn.innerHTML = _this131.formattingMoney(btnPrice);
          });
        }
        if (this.hasUnitPricing) {
          this.updateProductUnits(formState);
        }
      }
    }, {
      key: "updateProductUnits",
      value: function updateProductUnits(formState) {
        var variant = formState.variant;
        var plan = formState.plan;
        var unitPrice = null;
        if (variant && variant.unit_price) {
          unitPrice = variant.unit_price;
        }
        if (plan && plan.allocation && plan.allocation.unit_price) {
          unitPrice = plan.allocation.unit_price;
        }
        if (unitPrice) {
          var base = this.getBaseUnit(variant);
          this.outerWrapper.querySelector(selectors$d.unitPrice).innerHTML = this.formattingMoney(unitPrice);
          this.outerWrapper.querySelector(selectors$d.unitBase).innerHTML = base;
          showElement(this.outerWrapper.querySelector(selectors$d.unitWrapper));
        } else {
          hideElement(this.outerWrapper.querySelector(selectors$d.unitWrapper));
        }
      }
    }, {
      key: "fireHookEvent",
      value: function fireHookEvent(formState) {
        var variant = formState.variant;
        this.container.dispatchEvent(new CustomEvent('theme:variant:change', {
          detail: {
            variant: variant
          },
          bubbles: true
        }));
      }

      /**
       * Tracks aspects of the product state that are relevant to UI updates
       * @param {object} evt - variant change event
       * @return {object} productState - represents state of variant + plans
       *  productState.available - current variant and selling plan options result in valid offer
       *  productState.soldOut - variant is sold out
       *  productState.onSale - variant is on sale
       *  productState.showUnitPrice - variant has unit price
       *  productState.requiresPlan - all the product variants requires a selling plan
       *  productState.hasPlan - there is a valid selling plan
       *  productState.planSale - plan has a discount to show next to price
       *  productState.planPerDelivery - plan price does not equal per_delivery_price - a prepaid subscribtion
       */
    }, {
      key: "setProductState",
      value: function setProductState(dataset) {
        var variant = dataset.variant;
        var plan = dataset.plan;
        var productState = {
          available: true,
          soldOut: false,
          onSale: false,
          showUnitPrice: false,
          requiresPlan: false,
          hasPlan: false,
          planPerDelivery: false,
          planSale: false
        };
        if (!variant || variant.requires_selling_plan && !plan) {
          productState.available = false;
        } else {
          if (!variant.available) {
            productState.soldOut = true;
          }
          if (variant.compare_at_price > variant.price) {
            productState.onSale = true;
          }
          if (variant.unit_price) {
            productState.showUnitPrice = true;
          }
          if (this.productJSON && this.productJSON.requires_selling_plan) {
            productState.requiresPlan = true;
          }
          if (plan && this.subPrices) {
            productState.hasPlan = true;
            if (plan.allocation.per_delivery_price !== plan.allocation.price) {
              productState.planPerDelivery = true;
            }
            if (variant.price > plan.allocation.price) {
              productState.planSale = true;
            }
          }
        }
        return productState;
      }
    }, {
      key: "updateProductImage",
      value: function updateProductImage(formState) {
        var variant = formState.variant;
        if (variant) {
          if (this.slideshow && variant.featured_media && variant.featured_media.id) {
            // Update variant image, if one is set
            this.slideshow.dispatchEvent(new CustomEvent('theme:image:change', {
              detail: {
                id: variant.featured_media.id
              }
            }));
          }
        }
      }
    }, {
      key: "formattingMoney",
      value: function formattingMoney(money) {
        if (theme.settings.currency_code_enable) {
          return themeCurrency.formatMoney(money, theme.moneyFormat) + " ".concat(theme.currencyCode);
        } else {
          return themeCurrency.formatMoney(money, theme.moneyFormat);
        }
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var ProductComplimentary = /*#__PURE__*/function (_HTMLElement9) {
    function ProductComplimentary() {
      _classCallCheck(this, ProductComplimentary);
      return _callSuper(this, ProductComplimentary);
    }
    _inherits(ProductComplimentary, _HTMLElement9);
    return _createClass(ProductComplimentary, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this132 = this;
        fetch(this.dataset.url).then(function (response) {
          return response.text();
        }).then(function (text) {
          var fresh = document.createElement('div');
          fresh.innerHTML = text;
          var newContent = fresh.querySelector('[data-api-content]');
          if (newContent) {
            _this132.innerHTML = newContent.innerHTML;
          }
          var loader = _this132.closest('[data-product-complimentary-loaded]');
          if (loader && newContent.innerHTML.trim() !== '') {
            // js-unloaded state hides the wrapper pre-render and
            // keeps it hidden for empty recommendations
            loader.classList.remove('js-unloaded');
          }
        }).catch(function (e) {
          console.error(e);
        });
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var selectors$c = {
    slideshow: '[data-product-slideshow]',
    singeImage: '[data-product-image]',
    zoomButton: '[data-zoom-button]',
    zoomWrapper: '[data-zoom-wrapper]',
    mediaId: 'data-media-id'
  };
  function productPhotoswipeZoom(container, json) {
    var loadedPromise = loadScript({
      url: window.theme.assets.photoswipe
    });
    var returnZoom = loadedPromise.then(function () {
      var PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
      var PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
      var triggers = container.querySelectorAll(selectors$c.zoomButton);
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          var el = container.querySelector(selectors$c.zoomWrapper);
          var dataId = event.target.closest("[".concat(selectors$c.mediaId, "]")).getAttribute(selectors$c.mediaId).toString();
          // Store reference to the trigger button for focus return on close
          var triggerButton = event.target.closest(selectors$c.zoomButton);
          var items = [];
          // AMP82: Use product title as fallback alt text
          var productTitle = json.title || '';

          // AMP82: Describe WHICH view each image shows, mirroring snippets/media.liquid.
          //
          // Repeating the bare product title on every slide is a textual equivalent but not a
          // descriptive one — a screen-reader user moving between slides hears the same string
          // and learns nothing about what changed. The inline gallery already appends this;
          // the zoom did not, which is why AMP82 came back as Partially Fixed.
          //
          // Keep in step with media.liquid: same wording, same positions.
          var viewDescription = function viewDescription(position) {
            if (position === 1) return ', front view';
            if (position === 2) return ', alternate view';
            return ', view ' + position;
          };

          // Alt text in this store may carry an image-filter token after a '#'
          // (media.liquid: `alt_text | split: '#'`, first part is the human-readable half,
          // the remainder drives data-image-filter). Reading that token aloud is noise.
          var baseAltFor = function baseAltFor(media) {
            var raw = (media.alt || '').split('#')[0].trim();
            return raw || productTitle;
          };
          for (var i = 0; i < json.media.length; i++) {
            if (json.media[i].media_type === 'image') {
              // Prefer the media's own position so the wording matches the inline gallery even
              // when a video sits among the images; fall back to image order if it is absent.
              var position = json.media[i].position || items.length + 1;
              items[items.length] = {
                src: json.media[i].src,
                w: json.media[i].width,
                h: json.media[i].height,
                id: json.media[i].id,
                // AMP82: descriptive alt — "<product>, front view" etc.
                alt: baseAltFor(json.media[i]) + viewDescription(position)
              };
            }
          }
          var findImage = function findImage(element) {
            return element.id.toString() === dataId;
          };
          var index = items.findIndex(findImage);
          var options = {
            index: index,
            showHideOpacity: true,
            showAnimationDuration: 150,
            hideAnimationDuration: 250,
            bgOpacity: 1,
            spacing: 0,
            allowPanToNext: false,
            maxSpreadZoom: 3,
            history: false,
            loop: true,
            pinchToClose: false,
            modal: false,
            closeOnScroll: false,
            closeOnVerticalDrag: true,
            getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
              if (isMouseClick) {
                return 1.67;
              } else {
                return item.initialZoomLevel < 0.7 ? 1 : 1.3;
              }
            },
            getThumbBoundsFn: function getThumbBoundsFn() {
              var imageLocation = container.querySelector(selectors$c.slideshow);
              if (!imageLocation) {
                imageLocation = container.querySelector(selectors$c.singeImage);
              }
              var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
              var rect = imageLocation.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          };
          el.dispatchEvent(new CustomEvent('theme:scroll:lock', {
            bubbles: true
          }));
          // Initializes and opens PhotoSwipe
          var gallery = new PhotoSwipe(el, PhotoSwipeUI, items, options);
          gallery.init();

          // AMP82: Set alt text on PhotoSwipe images for accessibility
          var setAllImageAlts = function setAllImageAlts() {
            items.forEach(function (item) {
              if (item.src && item.alt !== undefined) {
                var filename = item.src.split('?')[0].split('/').pop();
                var pswpImages = el.querySelectorAll('.pswp__img:not(.pswp__img--placeholder)');
                pswpImages.forEach(function (img) {
                  if (img.src && img.src.includes(filename)) {
                    img.setAttribute('alt', item.alt);
                  }
                });
              }
            });
          };

          // Use MutationObserver to catch dynamically created images
          var imgObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                  if (node.classList && node.classList.contains('pswp__img')) {
                    setAllImageAlts();
                  }
                  var imgs = node.querySelectorAll ? node.querySelectorAll('.pswp__img') : [];
                  if (imgs.length > 0) {
                    setAllImageAlts();
                  }
                }
              });
            });
          });
          imgObserver.observe(el, {
            childList: true,
            subtree: true
          });

          // Set alt on slide changes and image load
          gallery.listen('afterChange', setAllImageAlts);
          gallery.listen('imageLoadComplete', setAllImageAlts);

          // Initial set after gallery opens
          setTimeout(setAllImageAlts, 100);
          setTimeout(setAllImageAlts, 500);

          // AMP: Trap focus within PhotoSwipe dialog for accessibility
          // Focus the close button initially for keyboard users
          var closeButton = el.querySelector('.pswp__button--close');
          if (closeButton) {
            setTimeout(function () {
              trapFocus(el, {
                elementToFocus: closeButton
              });
            }, 100);
          }
          gallery.listen('close', function () {
            // AMP82: Disconnect observer on close
            imgObserver.disconnect();
            // AMP: Remove focus trap on close
            removeTrapFocus();
            document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
              bubbles: true
            }));
            // Return focus to the button that opened the zoom dialog
            if (triggerButton) {
              triggerButton.focus();
            }
          });
        });
      });
    }).catch(function (e) {
      return console.error(e);
    });
    return returnZoom;
  }
  var selectors$b = {
    body: 'body',
    dataRelatedSectionElem: '[data-related-section]',
    dataTabsHolder: '[data-tabs-holder]',
    dataTab: 'data-tab',
    dataTabIndex: 'data-tab-index',
    blockId: 'data-block-id',
    tabsLi: '.tabs > button',
    tabLink: '.tab-link',
    tabLinkRecent: '.tab-link__recent',
    tabContent: '.tab-content',
    scrollbarHolder: '[data-scrollbar]',
    scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
    scrollbarArrowNext: '[data-scrollbar-arrow-next]',
    firstElement: 'a:first-child, input:first-child'
  };
  var classes$8 = {
    classCurrent: 'current',
    classHide: 'hide',
    classAlt: 'alt',
    isFocused: 'is-focused'
  };
  var sections$4 = {};
  var GlobalTabs = /*#__PURE__*/function () {
    function GlobalTabs(holder) {
      _classCallCheck(this, GlobalTabs);
      this.container = holder;
      this.body = document.querySelector(selectors$b.body);
      this.accessibility = window.accessibility;
      if (this.container) {
        this.scrollbarHolder = this.container.querySelectorAll(selectors$b.scrollbarHolder);
        this.init();

        // Init native scrollbar
        this.initNativeScrollbar();
      }
    }
    return _createClass(GlobalTabs, [{
      key: "init",
      value: function init() {
        var _this133 = this;
        var ctx = this.container;
        var tabsNavList = ctx.querySelectorAll(selectors$b.tabsLi);
        var firstTabLink = ctx.querySelector("".concat(selectors$b.tabLink, "-0"));
        var firstTabContent = ctx.querySelector("".concat(selectors$b.tabContent, "-0"));
        if (firstTabContent) {
          firstTabContent.classList.add(classes$8.classCurrent);
        }
        if (firstTabLink) {
          firstTabLink.classList.add(classes$8.classCurrent);
        }
        this.checkVisibleTabLinks();
        this.syncTabState();
        this.container.addEventListener('theme:tabs:check', function () {
          return _this133.checkRecentTab();
        });
        this.container.addEventListener('theme:tabs:hide', function () {
          return _this133.hideRelatedTab();
        });
        if (tabsNavList.length) {
          tabsNavList.forEach(function (element) {
            var tabId = parseInt(element.getAttribute(selectors$b.dataTab));
            var tab = ctx.querySelector("".concat(selectors$b.tabContent, "-").concat(tabId));
            element.addEventListener('click', function () {
              _this133.tabChange(element, tab);
            });
            element.addEventListener('keyup', function (event) {
              if ((event.which === window.theme.keyboardKeys.SPACE || event.which === window.theme.keyboardKeys.ENTER) && _this133.body.classList.contains(classes$8.isFocused)) {
                _this133.tabChange(element, tab);
                if (tab.querySelector('a, input')) {
                  _this133.accessibility.lastFocused = element;
                  _this133.accessibility.a11y.trapFocus(tab, {
                    elementToFocus: tab.querySelector(selectors$b.firstElement)
                  });
                }
              }
            });
          });
        }
      }
    }, {
      key: "tabChange",
      value: function tabChange(element, tab) {
        this.container.querySelector("".concat(selectors$b.tabsLi, ".").concat(classes$8.classCurrent)).classList.remove(classes$8.classCurrent);
        this.container.querySelector("".concat(selectors$b.tabContent, ".").concat(classes$8.classCurrent)).classList.remove(classes$8.classCurrent);
        element.classList.add(classes$8.classCurrent);
        tab.classList.add(classes$8.classCurrent);
        if (element.classList.contains(classes$8.classHide)) {
          tab.classList.add(classes$8.classHide);
        }
        this.checkVisibleTabLinks();
        this.syncTabState();
        this.container.dispatchEvent(new CustomEvent('theme:tab:change'));
      }

      /**
       * Mirror the `current` class onto aria-selected so screen readers are told
       * which tab is active. Scoped to [role="tab"], so tab groups that have not
       * been given ARIA roles yet are left untouched.
       */
    }, {
      key: "syncTabState",
      value: function syncTabState() {
        var tabs = this.container.querySelectorAll("".concat(selectors$b.tabsLi, "[role=\"tab\"]"));
        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.classList.contains(classes$8.classCurrent) ? 'true' : 'false');
        });
      }
    }, {
      key: "initNativeScrollbar",
      value: function initNativeScrollbar() {
        if (this.scrollbarHolder.length) {
          this.scrollbarHolder.forEach(function (scrollbar) {
            new NativeScrollbar(scrollbar);
          });
        }
      }
    }, {
      key: "checkVisibleTabLinks",
      value: function checkVisibleTabLinks() {
        var tabsNavList = this.container.querySelectorAll(selectors$b.tabsLi);
        var tabsNavListHided = this.container.querySelectorAll("".concat(selectors$b.tabLink, ".").concat(classes$8.classHide));
        var difference = tabsNavList.length - tabsNavListHided.length;
        if (difference < 2) {
          this.container.classList.add(classes$8.classAlt);
        } else {
          this.container.classList.remove(classes$8.classAlt);
        }
      }
    }, {
      key: "checkRecentTab",
      value: function checkRecentTab() {
        var tabLink = this.container.querySelector(selectors$b.tabLinkRecent);
        if (tabLink) {
          tabLink.classList.remove(classes$8.classHide);
          var tabLinkIdx = parseInt(tabLink.getAttribute(selectors$b.dataTab));
          var tabContent = this.container.querySelector("".concat(selectors$b.tabContent, "[").concat(selectors$b.dataTabIndex, "=\"").concat(tabLinkIdx, "\"]"));
          if (tabContent) {
            tabContent.classList.remove(classes$8.classHide);
          }
          this.checkVisibleTabLinks();
          this.initNativeScrollbar();
        }
      }
    }, {
      key: "hideRelatedTab",
      value: function hideRelatedTab() {
        var relatedSection = this.container.querySelector(selectors$b.dataRelatedSectionElem);
        if (!relatedSection) {
          return;
        }
        var parentTabContent = relatedSection.closest("".concat(selectors$b.tabContent, ".").concat(classes$8.classCurrent));
        if (!parentTabContent) {
          return;
        }
        var parentTabContentIdx = parseInt(parentTabContent.getAttribute(selectors$b.dataTabIndex));
        var tabsNavList = this.container.querySelectorAll(selectors$b.tabsLi);
        if (tabsNavList.length > parentTabContentIdx) {
          var nextTabsNavLink = tabsNavList[parentTabContentIdx].nextSibling;
          if (nextTabsNavLink) {
            tabsNavList[parentTabContentIdx].classList.add(classes$8.classHide);
            nextTabsNavLink.dispatchEvent(new Event('click'));
            this.initNativeScrollbar();
          }
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        var element = this.container.querySelector("".concat(selectors$b.tabLink, "[").concat(selectors$b.blockId, "=\"").concat(evt.detail.blockId, "\"]"));
        if (element) {
          element.dispatchEvent(new Event('click'));
          element.parentNode.scrollTo({
            top: 0,
            left: element.offsetLeft - element.clientWidth,
            behavior: 'smooth'
          });
        }
      }
    }]);
  }();
  var tabs = {
    onLoad: function onLoad() {
      var _this134 = this;
      sections$4[this.id] = [];
      var tabHolders = this.container.querySelectorAll(selectors$b.dataTabsHolder);
      tabHolders.forEach(function (holder) {
        sections$4[_this134.id].push(new GlobalTabs(holder));
      });
    },
    onBlockSelect: function onBlockSelect(e) {
      sections$4[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(e);
        }
      });
    }
  };
  var selectors$a = {
    urlInput: '[data-share-url]',
    section: 'data-section-type',
    shareDetails: '[data-share-details]',
    shareSummary: '[data-share-summary]',
    shareCopy: '[data-share-copy]',
    shareButton: '[data-share-button]',
    closeButton: '[data-close-button]',
    successMessage: '[data-success-message]',
    shareHolder: '[data-share-holder]'
  };
  var classes$7 = {
    hidden: 'is-hidden'
  };
  var ShareButton = /*#__PURE__*/function (_HTMLElement0) {
    function ShareButton() {
      var _this135;
      _classCallCheck(this, ShareButton);
      _this135 = _callSuper(this, ShareButton);
      _this135.container = _this135.closest("[".concat(selectors$a.section, "]"));
      _this135.mainDetailsToggle = _this135.querySelector(selectors$a.shareDetails);
      _this135.shareButton = _this135.querySelector(selectors$a.shareButton);
      _this135.shareCopy = _this135.querySelector(selectors$a.shareCopy);
      _this135.shareSummary = _this135.querySelector(selectors$a.shareSummary);
      _this135.closeButton = _this135.querySelector(selectors$a.closeButton);
      _this135.successMessage = _this135.querySelector(selectors$a.successMessage);
      _this135.shareHolder = _this135.querySelector(selectors$a.shareHolder);
      _this135.urlInput = _this135.querySelector(selectors$a.urlInput);
      _this135.urlToShare = _this135.urlInput ? _this135.urlInput.value : document.location.href;
      _this135.init();
      _this135.updateShareLink();
      return _this135;
    }
    _inherits(ShareButton, _HTMLElement0);
    return _createClass(ShareButton, [{
      key: "init",
      value: function init() {
        var _this136 = this;
        if (navigator.share) {
          this.mainDetailsToggle.classList.add(classes$7.hidden);
          this.shareButton.classList.remove(classes$7.hidden);
          this.shareButton.addEventListener('click', function () {
            navigator.share({
              url: _this136.urlToShare,
              title: document.title
            });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle.addEventListener('focusout', function () {
            setTimeout(function () {
              if (!_this136.contains(document.activeElement)) {
                _this136.close();
              }
            });
          });
          this.shareCopy.addEventListener('click', this.copyToClipboard.bind(this));
          this.closeButton.addEventListener('click', this.close.bind(this));
          this.container.addEventListener('keyup', this.keyboardEvents.bind(this));
        }
      }
    }, {
      key: "updateShareLink",
      value: function updateShareLink() {
        var _this137 = this;
        if (this.container.getAttribute(selectors$a.section) == 'product') {
          this.container.addEventListener('theme:variant:change', function (event) {
            if (event.detail.variant) {
              _this137.urlToShare = "".concat(_this137.urlToShare.split('?')[0], "?variant=").concat(event.detail.variant.id);
              if (_this137.urlInput) {
                _this137.urlInput.value = "".concat(_this137.urlToShare.split('?')[0], "?variant=").concat(event.detail.variant.id);
              }
            }
          });
        }
      }
    }, {
      key: "toggleDetails",
      value: function toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.successMessage.classList.add(classes$7.hidden);
          this.successMessage.textContent = '';
          this.closeButton.classList.add(classes$7.hidden);
          this.shareCopy.focus();
        }
      }
    }, {
      key: "copyToClipboard",
      value: function copyToClipboard() {
        var _this138 = this;
        navigator.clipboard.writeText(this.urlInput.value).then(function () {
          _this138.successMessage.classList.remove(classes$7.hidden);
          _this138.successMessage.textContent = theme.strings.successMessage;
          _this138.closeButton.classList.remove(classes$7.hidden);
          _this138.closeButton.focus();
        });
      }
    }, {
      key: "close",
      value: function close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.shareSummary.setAttribute('aria-expanded', false);
      }
    }, {
      key: "keyboardEvents",
      value: function keyboardEvents(e) {
        if (e.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.mainDetailsToggle.focus();
        this.close();
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  var selectors$9 = {
    groupImage: 'data-image-filter',
    slider: '[data-product-slideshow]',
    thumbSlider: '[data-product-thumbs]',
    thumbs: '[data-slideshow-thumbnail]',
    slides: '[data-media-slide]'
  };
  var classes$6 = {
    hide: 'hide',
    flickityEnable: 'flickity-enabled'
  };
  var GroupVariantImages = /*#__PURE__*/function () {
    function GroupVariantImages(section) {
      _classCallCheck(this, GroupVariantImages);
      this.section = section;
      this.container = section.container;
      this.slider = this.container.querySelector(selectors$9.slider);
      this.thumbSlider = this.container.querySelector(selectors$9.thumbSlider);
      this.thumbs = this.container.querySelectorAll(selectors$9.thumbs);
      this.slides = this.container.querySelectorAll(selectors$9.slides);
      this.variantImage = null;
      this.listen();
    }
    return _createClass(GroupVariantImages, [{
      key: "listen",
      value: function listen() {
        var _this139 = this;
        this.container.addEventListener('theme:variant:change', function (event) {
          if (event.detail.variant) {
            _this139.variantImage = event.detail.variant.featured_image;
            _this139.filterImages();
          }
        });
      }
    }, {
      key: "filterImages",
      value: function filterImages() {
        if (this.variantImage !== null && this.variantImage.alt !== null) {
          this.variantImageAlt = this.variantImage.alt.split('#')[1];
          this.showImages();
        } else {
          this.resetImages();
        }
        this.refreshSliders();
      }
    }, {
      key: "resetImages",
      value: function resetImages() {
        this.thumbs.forEach(function (thumb) {
          return thumb.classList.remove(classes$6.hide);
        });
        this.slides.forEach(function (slide) {
          return slide.classList.remove(classes$6.hide);
        });
      }
    }, {
      key: "showImages",
      value: function showImages() {
        var _this140 = this;
        this.thumbs.forEach(function (thumb) {
          if (thumb.getAttribute(selectors$9.groupImage) === '' || thumb.getAttribute(selectors$9.groupImage) === _this140.variantImageAlt) {
            thumb.classList.remove(classes$6.hide);
          } else {
            thumb.classList.add(classes$6.hide);
          }
        });
        this.slides.forEach(function (slide) {
          if (slide.getAttribute(selectors$9.groupImage) === '' || slide.getAttribute(selectors$9.groupImage) === _this140.variantImageAlt) {
            slide.classList.remove(classes$6.hide);
          } else {
            slide.classList.add(classes$6.hide);
          }
        });
      }
    }, {
      key: "refreshSliders",
      value: function refreshSliders() {
        if (this.slider !== null) {
          if (this.slider.classList.contains(classes$6.flickityEnable)) {
            var slider = FlickityFade.data(this.slider);
            if (typeof slider !== 'undefined') {
              slider.reloadCells();
            }
          }
        }
        if (this.thumbSlider !== null) {
          if (this.thumbSlider.classList.contains(classes$6.flickityEnable)) {
            var thumbSlider = FlickitySync.data(this.thumbSlider);
            if (typeof thumbSlider !== 'undefined') {
              thumbSlider.reloadCells();
            }
          }
        }
      }
    }]);
  }();
  var selectors$8 = {
    productJson: '[data-product-json]',
    zoomButton: '[data-zoom-button]',
    toggleTruncateHolder: '[data-truncated-holder]',
    toggleTruncateButton: '[data-truncated-button]',
    toggleTruncateContent: 'data-truncated-content'
  };
  var classes$5 = {
    classExpanded: 'is-expanded',
    classVisible: 'is-visible'
  };
  var sections$3 = [];
  var ProductTemplate = /*#__PURE__*/function () {
    function ProductTemplate(section) {
      var _this141 = this;
      _classCallCheck(this, ProductTemplate);
      this.section = section;
      this.id = section.id;
      this.container = section.container;
      this.settings = section.settings;
      modal(this.id);
      this.media = new Media(section);
      new GroupVariantImages(section);
      var productJSON = this.container.querySelector(selectors$8.productJson);
      if (productJSON && productJSON.innerHTML !== '') {
        this.product = JSON.parse(productJSON.innerHTML);
      } else {
        console.error('Missing product JSON');
        return;
      }
      this.truncateElementHolder = this.container.querySelector(selectors$8.toggleTruncateHolder);
      this.truncateElement = this.container.querySelector("[".concat(selectors$8.toggleTruncateContent, "]"));
      this.resizeEventTruncate = function () {
        return _this141.truncateText();
      };
      this.init();
    }
    return _createClass(ProductTemplate, [{
      key: "init",
      value: function init() {
        this.zoomEnabled = this.container.querySelector(selectors$8.zoomButton) !== null;
        if (this.zoomEnabled) {
          productPhotoswipeZoom(this.container, this.product);
        }
        if (this.truncateElementHolder && this.truncateElement) {
          setTimeout(this.resizeEventTruncate, 50);
          document.addEventListener('theme:resize', this.resizeEventTruncate);
        }
        new ImageCaption(this.container);
      }
    }, {
      key: "truncateText",
      value: function truncateText() {
        var _this142 = this;
        if (this.truncateElementHolder.classList.contains(classes$5.classVisible)) return;
        var styles = this.truncateElement.querySelectorAll('style');
        if (styles.length) {
          styles.forEach(function (style) {
            _this142.truncateElementHolder.prepend(style);
          });
        }
        var truncateElementCloned = this.truncateElement.cloneNode(true);
        var truncateElementClass = this.truncateElement.getAttribute(selectors$8.toggleTruncateContent);
        var truncateNextElement = this.truncateElement.nextElementSibling;
        if (truncateNextElement) {
          truncateNextElement.remove();
        }
        this.truncateElement.parentElement.append(truncateElementCloned);
        var truncateAppendedElement = this.truncateElement.nextElementSibling;
        truncateAppendedElement.classList.add(truncateElementClass);
        truncateAppendedElement.removeAttribute(selectors$8.toggleTruncateContent);
        showElement(truncateAppendedElement);
        ellipsis(truncateAppendedElement, 5, {
          replaceStr: '',
          delimiter: ' '
        });
        hideElement(truncateAppendedElement);
        if (this.truncateElement.innerHTML !== truncateAppendedElement.innerHTML) {
          this.truncateElementHolder.classList.add(classes$5.classExpanded);
        } else {
          truncateAppendedElement.remove();
          this.truncateElementHolder.classList.remove(classes$5.classExpanded);
        }
        this.toggleTruncatedContent(this.truncateElementHolder);
      }
    }, {
      key: "toggleTruncatedContent",
      value: function toggleTruncatedContent(holder) {
        var toggleButton = holder.querySelector(selectors$8.toggleTruncateButton);
        if (toggleButton) {
          toggleButton.addEventListener('click', function (e) {
            e.preventDefault();
            holder.classList.remove(classes$5.classExpanded);
            holder.classList.add(classes$5.classVisible);
          });
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        var block = this.container.querySelector("[data-block-id=\"".concat(event.detail.blockId, "\"]"));
        if (block) {
          block.dispatchEvent(new Event('click'));
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        var block = this.container.querySelector("[data-block-id=\"".concat(event.detail.blockId, "\"]"));
        if (block) {
          block.dispatchEvent(new Event('click'));
        }
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        this.media.destroy();
        if (this.truncateElementHolder && this.truncateElement) {
          document.removeEventListener('theme:resize', this.resizeEventTruncate);
        }
      }
    }]);
  }();
  var productSection = {
    onLoad: function onLoad() {
      sections$3[this.id] = new ProductTemplate(this);
    },
    onUnload: function onUnload() {
      if (typeof sections$3[this.id].unload === 'function') {
        sections$3[this.id].unload();
      }
    },
    onBlockSelect: function onBlockSelect(evt) {
      if (typeof sections$3[this.id].onBlockSelect === 'function') {
        sections$3[this.id].onBlockSelect(evt);
      }
    },
    onBlockDeselect: function onBlockDeselect(evt) {
      if (typeof sections$3[this.id].onBlockDeselect === 'function') {
        sections$3[this.id].onBlockDeselect(evt);
      }
    }
  };
  register('product', [productSection, pickupAvailability, accordion, tabs, swapperSection]);
  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
  if (!customElements.get('product-complimentary')) {
    customElements.define('product-complimentary', ProductComplimentary);
  }
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('popout-select')) {
    customElements.define('popout-select', PopoutSelect);
  }
  if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton);
  }
  var selectors$7 = {
    toggle: 'data-toggle-grid',
    large: 'data-grid-large',
    small: 'data-grid-small'
  };
  var classes$4 = {
    active: 'is-active'
  };
  var options = {
    breakpoint: window.theme.sizes.small
  };
  var sections$2 = {};
  var Toggle = /*#__PURE__*/function () {
    function Toggle(toggle, container) {
      var _this143 = this;
      _classCallCheck(this, Toggle);
      this.container = container || document;
      this.toggle = toggle;
      this.value = this.toggle.getAttribute(selectors$7.toggle);
      this.toggleFunction = function (evt) {
        return _this143.toggleEvent(evt);
      };
      this.init();
    }
    return _createClass(Toggle, [{
      key: "init",
      value: function init() {
        this.toggle.addEventListener('click', this.toggleFunction);
        document.addEventListener('theme:resize:width', this.toggleFunction);
        this.toggleEvent(false);
      }
    }, {
      key: "unload",
      value: function unload() {
        this.toggle.removeEventListener('click', this.toggleFunction);
        document.removeEventListener('theme:resize:width', this.toggleFunction);
      }
    }, {
      key: "toggleEvent",
      value: function toggleEvent() {
        var evt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var clickEvent = evt && evt.type === 'click';
        var isLarge = window.innerWidth >= options.breakpoint;
        var selector = isLarge ? selectors$7.large : selectors$7.small;
        var grid = this.container.querySelector("[".concat(selector, "]"));
        var gridNumber = grid.getAttribute(selector);
        var activeToggle = this.toggle.parentElement.querySelector("[".concat(selectors$7.toggle, "].").concat(classes$4.active));
        var currentToggle = this.toggle.parentElement.querySelector("[".concat(selectors$7.toggle, "=\"").concat(gridNumber, "\"]"));
        if (clickEvent) {
          currentToggle = this.toggle;
          grid.setAttribute(selector, this.value);
          if (window.lazySizes) {
            window.lazySizes.autoSizer.checkElems();
          }
        }
        if (activeToggle) {
          activeToggle.classList.remove(classes$4.active);
        }
        if (currentToggle) {
          currentToggle.classList.add(classes$4.active);
        }
      }
    }]);
  }();
  var toggleSection = {
    onLoad: function onLoad() {
      var _this144 = this;
      sections$2[this.id] = [];
      var buttons = this.container.querySelectorAll("[".concat(selectors$7.toggle, "]"));
      buttons.forEach(function (button) {
        sections$2[_this144.id].push(new Toggle(button, _this144.container));
      });
    },
    onUnload: function onUnload() {
      sections$2[this.id].forEach(function (toggle) {
        if (typeof toggle.unload === 'function') {
          toggle.unload();
        }
      });
    }
  };
  var selectors$6 = {
    sort: 'data-sort-enabled',
    sortLinks: '[data-sort-link]',
    sortButtonText: '[data-sort-button-text]',
    sortValue: 'data-value'
  };
  var classes$3 = {
    active: 'popout-list__item--current'
  };
  var Sort = /*#__PURE__*/function () {
    function Sort(section) {
      _classCallCheck(this, Sort);
      this.container = section.container;
      this.sort = this.container.querySelector("[".concat(selectors$6.sort, "]"));
      this.sortLinks = this.container.querySelectorAll(selectors$6.sortLinks);
      this.sortButtonText = this.container.querySelector(selectors$6.sortButtonText);
      if (this.sort) {
        this.init();
      }
    }
    return _createClass(Sort, [{
      key: "init",
      value: function init() {
        var _this145 = this;
        this.sortLinks.forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            _this145.sortingResults(e);
          });
        });
      }
    }, {
      key: "sortingResults",
      value: function sortingResults(e) {
        var link = e.currentTarget;
        var sort = link.getAttribute(selectors$6.sortValue);
        var text = link.innerText;
        this.sortButtonText.innerText = text;
        this.sortButtonText.parentNode.dispatchEvent(new Event('click'));
        this.sort.querySelector(".".concat(classes$3.active)).classList.remove(classes$3.active);
        link.parentNode.classList.add(classes$3.active);

        // The list is exposed as a listbox, so the selected option has to move with
        // the active class - the class alone means nothing to assistive tech.
        this.sortLinks.forEach(function (option) {
          var isCurrent = option === link;
          if (option.getAttribute('role') === 'option') {
            option.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
          }
          if (isCurrent) {
            option.setAttribute('aria-current', 'true');
          } else {
            option.removeAttribute('aria-current');
          }
        });
        this.sort.setAttribute(selectors$6.sort, sort);

        // Announce sort change to screen readers
        var sortStatus = document.querySelector('[data-sort-status]');
        if (sortStatus) {
          sortStatus.textContent = "Sorted by ".concat(text);
        }
        this.container.dispatchEvent(new CustomEvent('theme:form:filter', {
          bubbles: true,
          detail: {
            params: sort
          }
        }));
      }
    }]);
  }();
  var selectors$5 = {
    collectionNavGrouped: '[data-tag-group]',
    linkAdd: '.link--add',
    linkRemove: '.link--remove',
    swatch: 'data-swatch'
  };
  var Collection = /*#__PURE__*/function () {
    function Collection(section) {
      _classCallCheck(this, Collection);
      this.section = section;
      this.container = this.section.container;
      this.swatches = this.container.querySelectorAll("[".concat(selectors$5.swatch, "]"));
      this.init();
    }
    return _createClass(Collection, [{
      key: "init",
      value: function init() {
        new Sort(this.section);
        this.removeUnusableFilters();
      }
    }, {
      key: "removeUnusableFilters",
      value: function removeUnusableFilters() {
        // temp tag filters
        var collectionNavGrouped = this.container.querySelectorAll(selectors$5.collectionNavGrouped);
        if (collectionNavGrouped.length > 0) {
          collectionNavGrouped.forEach(function (element) {
            var linkAdd = element.querySelector(selectors$5.linkAdd);
            var linkRemove = element.querySelector(selectors$5.linkRemove);
            if (!linkAdd && !linkRemove) {
              hideElement(element);
            }
          });
        }
      }
    }]);
  }();
  var collectionSection = {
    onLoad: function onLoad() {
      this.collection = new Collection(this);
    }
  };
  register('collection', [collectionSection, collectionFiltersSidebar, collectionFiltersForm, toggleSection, swatchGridSection, accordion, siblings]);
  if (!customElements.get('popout-select')) {
    customElements.define('popout-select', PopoutSelect);
  }
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  register('collection-row', [swatchGridSection, siblings, customScrollbar]);
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  register('collection-tabs', [tabs, productSliderSection, swatchGridSection]);
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  var styles = {};
  styles.basic = [];
  /* eslint-disable */
  styles.light = [{
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{
      visibility: 'on'
    }, {
      lightness: '64'
    }, {
      hue: '#ff0000'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#bdbdbd'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{
      color: '#f0f0f0'
    }, {
      visibility: 'simplified'
    }]
  }, {
    featureType: 'landscape.natural.landcover',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'landscape.natural.terrain',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{
      lightness: '100'
    }]
  }, {
    featureType: 'poi.park',
    elementType: 'all',
    stylers: [{
      visibility: 'on'
    }]
  }, {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{
      saturation: '-41'
    }, {
      color: '#e8ede7'
    }]
  }, {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road',
    elementType: 'all',
    stylers: [{
      saturation: '-100'
    }]
  }, {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{
      lightness: '25'
    }, {
      gamma: '1.06'
    }, {
      saturation: '-100'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      gamma: '10.00'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }, {
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
      gamma: '10.00'
    }, {
      lightness: '100'
    }, {
      weight: '0.4'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{
      visibility: 'simplified'
    }, {
      weight: '0.01'
    }, {
      lightness: '39'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'labels.text.stroke',
    stylers: [{
      weight: '0.50'
    }, {
      gamma: '10.00'
    }, {
      lightness: '100'
    }]
  }, {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'water',
    elementType: 'all',
    stylers: [{
      color: '#cfe5ee'
    }, {
      visibility: 'on'
    }]
  }];
  styles.light_blank = [{
    featureType: 'all',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }, {
      lightness: '64'
    }, {
      hue: '#ff0000'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#bdbdbd'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{
      color: '#f0f0f0'
    }, {
      visibility: 'simplified'
    }]
  }, {
    featureType: 'landscape.natural.landcover',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'landscape.natural.terrain',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{
      lightness: '100'
    }]
  }, {
    featureType: 'poi.park',
    elementType: 'all',
    stylers: [{
      visibility: 'on'
    }]
  }, {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{
      saturation: '-41'
    }, {
      color: '#e8ede7'
    }]
  }, {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road',
    elementType: 'all',
    stylers: [{
      saturation: '-100'
    }]
  }, {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{
      lightness: '25'
    }, {
      gamma: '1.06'
    }, {
      saturation: '-100'
    }, {
      visibility: 'off'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      gamma: '10.00'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }, {
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
      gamma: '10.00'
    }, {
      lightness: '100'
    }, {
      weight: '0.4'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }, {
      weight: '0.01'
    }, {
      lightness: '39'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'labels.text.stroke',
    stylers: [{
      weight: '0.50'
    }, {
      gamma: '10.00'
    }, {
      lightness: '100'
    }]
  }, {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'water',
    elementType: 'all',
    stylers: [{
      color: '#cfe5ee'
    }, {
      visibility: 'on'
    }]
  }];
  styles.white_blank = [{
    featureType: 'all',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#444444'
    }]
  }, {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{
      color: '#f2f2f2'
    }]
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road',
    elementType: 'all',
    stylers: [{
      saturation: -100
    }, {
      lightness: 45
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'water',
    elementType: 'all',
    stylers: [{
      color: '#e4e4e4'
    }, {
      visibility: 'on'
    }]
  }];
  styles.white_label = [{
    featureType: 'all',
    elementType: 'all',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'all',
    elementType: 'labels',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{
      gamma: '3.86'
    }, {
      lightness: '100'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#cccccc'
    }]
  }, {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{
      color: '#f2f2f2'
    }]
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road',
    elementType: 'all',
    stylers: [{
      saturation: -100
    }, {
      lightness: 45
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'labels.text',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'water',
    elementType: 'all',
    stylers: [{
      color: '#e4e4e4'
    }, {
      visibility: 'on'
    }]
  }];
  styles.dark_blank = [{
    featureType: 'all',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [{
      saturation: 36
    }, {
      color: '#000000'
    }, {
      lightness: 40
    }]
  }, {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [{
      visibility: 'on'
    }, {
      color: '#000000'
    }, {
      lightness: 16
    }]
  }, {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 20
    }]
  }, {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 17
    }, {
      weight: 1.2
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 20
    }]
  }, {
    featureType: 'landscape',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 21
    }]
  }, {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 17
    }, {
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 29
    }, {
      weight: '0.01'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 18
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 16
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 19
    }]
  }, {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 17
    }]
  }];
  styles.dark_label = [{
    featureType: 'all',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [{
      saturation: 36
    }, {
      color: '#000000'
    }, {
      lightness: 40
    }]
  }, {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [{
      visibility: 'on'
    }, {
      color: '#000000'
    }, {
      lightness: 16
    }]
  }, {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 20
    }]
  }, {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 17
    }, {
      weight: 1.2
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{
      visibility: 'simplified'
    }, {
      lightness: '-82'
    }]
  }, {
    featureType: 'administrative',
    elementType: 'labels.text.stroke',
    stylers: [{
      invert_lightness: true
    }, {
      weight: '7.15'
    }]
  }, {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 20
    }]
  }, {
    featureType: 'landscape',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 21
    }]
  }, {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{
      visibility: 'simplified'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 17
    }, {
      weight: '0.8'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 29
    }, {
      weight: '0.01'
    }]
  }, {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 18
    }]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 16
    }]
  }, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
      weight: '0.01'
    }]
  }, {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{
      visibility: 'off'
    }]
  }, {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 19
    }]
  }, {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{
      color: '#000000'
    }, {
      lightness: 17
    }]
  }];
  /* eslint-enable */

  function mapStyle(key) {
    return styles[key];
  }
  window.theme.allMaps = window.theme.allMaps || {};
  var allMaps = window.theme.allMaps;
  var selectors$4 = {
    mapContainer: '[data-map-container]',
    style: 'data-style',
    apiKey: 'data-api-key',
    zoom: 'data-zoom',
    address: 'data-address',
    latLongCorrection: 'data-latlong-correction',
    lat: 'data-lat',
    long: 'data-long'
  };
  var Map = /*#__PURE__*/function () {
    function Map(section) {
      _classCallCheck(this, Map);
      this.container = section.container;
      this.mapWrap = this.container.querySelector(selectors$4.mapContainer);
      this.styleString = this.container.getAttribute(selectors$4.style) || '';
      this.key = this.container.getAttribute(selectors$4.apiKey);
      this.zoomString = this.container.getAttribute(selectors$4.zoom) || 14;
      this.address = this.container.getAttribute(selectors$4.address);
      this.enableCorrection = this.container.getAttribute(selectors$4.latLongCorrection);
      this.lat = this.container.getAttribute(selectors$4.lat);
      this.long = this.container.getAttribute(selectors$4.long);
      if (this.key) {
        this.initMaps();
      }
    }
    return _createClass(Map, [{
      key: "initMaps",
      value: function initMaps() {
        var _this146 = this;
        var urlKey = "https://maps.googleapis.com/maps/api/js?key=".concat(this.key);
        loadScript({
          url: urlKey
        }).then(function () {
          return _this146.enableCorrection === 'true' && _this146.lat !== '' && _this146.long !== '' ? new window.google.maps.LatLng(_this146.lat, _this146.long) : geocodeAddressPromise(_this146.address);
        }).then(function (center) {
          var zoom = parseInt(_this146.zoomString, 10);
          var styles = mapStyle(_this146.styleString);
          var mapOptions = {
            zoom: zoom,
            styles: styles,
            center: center,
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            zoomControl: false,
            disableDefaultUI: true
          };
          var map = createMap(_this146.mapWrap, mapOptions);
          return map;
        }).then(function (map) {
          _this146.map = map;
          allMaps[_this146.id] = map;
        }).catch(function (e) {
          console.log('Failed to load Google Map');
          console.log(e);
        });
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (typeof window.google !== 'undefined') {
          window.google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    }]);
  }();
  function createMap(container, options) {
    var map = new window.google.maps.Map(container, options);
    var center = map.getCenter();
    new window.google.maps.Marker({
      map: map,
      position: center
    });
    window.google.maps.event.addDomListener(window, 'resize', function () {
      window.google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    });
    return map;
  }
  function geocodeAddressPromise(address) {
    return new Promise(function (resolve, reject) {
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        address: address
      }, function (results, status) {
        if (status == 'OK') {
          var latLong = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          };
          resolve(latLong);
        } else {
          reject(status);
        }
      });
    });
  }
  var mapSection = {
    onLoad: function onLoad() {
      allMaps[this.id] = new Map(this);
    },
    onUnload: function onUnload() {
      if (typeof allMaps[this.id].unload === 'function') {
        allMaps[this.id].unload();
      }
    }
  };
  register('section-map', mapSection);
  register('section-columns', [popupVideoSection, customScrollbar]);
  var selectors$3 = {
    dataRelatedSectionElem: '[data-related-section]',
    dataRelatedProduct: '[data-grid-item]',
    carousel: '[data-carousel]',
    dataLimit: 'data-limit',
    dataMinimum: 'data-minimum',
    dataLargeLayout: 'data-layout-desktop',
    dataMediumLayout: 'data-layout-tablet',
    dataSmallLayout: 'data-layout-mobile',
    recentlyViewed: '[data-recent-wrapper]',
    recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
    productId: 'data-product-id'
  };
  var Related = /*#__PURE__*/function () {
    function Related(section) {
      var _this147 = this;
      _classCallCheck(this, Related);
      this.section = section;
      this.container = section.container;
      this.init();
      this.container.addEventListener('theme:recent-products:added', function () {
        _this147.recent();
      });
    }
    return _createClass(Related, [{
      key: "init",
      value: function init() {
        var relatedSection = this.container.querySelector(selectors$3.dataRelatedSectionElem);
        if (!relatedSection) {
          return;
        }
        var productId = relatedSection.getAttribute(selectors$3.productId);
        var limit = relatedSection.getAttribute(selectors$3.dataLimit);
        var layoutLarge = relatedSection.getAttribute(selectors$3.dataLargeLayout);
        var layoutMedium = relatedSection.getAttribute(selectors$3.dataMediumLayout);
        var layoutSmall = relatedSection.getAttribute(selectors$3.dataSmallLayout);
        var route = window.theme.routes.product_recommendations_url || '/recommendations/products/';
        var requestUrl = "".concat(route, "?section_id=related&limit=").concat(limit, "&product_id=").concat(productId);
        axios.get(requestUrl).then(function (response) {
          var fresh = document.createElement('div');
          fresh.innerHTML = response.data;
          var inner = fresh.querySelector(selectors$3.dataRelatedSectionElem);
          if (inner.querySelector(selectors$3.dataRelatedProduct)) {
            var innerHtml = inner.innerHTML;
            relatedSection.innerHTML = innerHtml;
            relatedSection.querySelector(selectors$3.carousel).style.setProperty('--grid-large-items', layoutLarge);
            relatedSection.querySelector(selectors$3.carousel).style.setProperty('--grid-medium-items', layoutMedium);
            relatedSection.querySelector(selectors$3.carousel).style.setProperty('--grid-small-items', layoutSmall);
            relatedSection.dispatchEvent(new CustomEvent('theme:related-products:added', {
              bubbles: true
            }));
          } else {
            relatedSection.dispatchEvent(new CustomEvent('theme:tabs:hide', {
              bubbles: true
            }));
          }
        }).catch(function (error) {
          console.warn(error);
        });
      }
    }, {
      key: "recent",
      value: function recent() {
        var recentlyViewedHolder = this.container.querySelector(selectors$3.recentlyViewed);
        var recentlyViewedWrapper = this.container.querySelector(selectors$3.recentlyViewedWrapper);
        var recentProducts = this.container.querySelectorAll(selectors$3.dataRelatedProduct);
        var minimumNumberProducts = recentlyViewedHolder.hasAttribute(selectors$3.dataMinimum) ? parseInt(recentlyViewedHolder.getAttribute(selectors$3.dataMinimum)) : 4;
        var checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
        var checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;
        if (checkRecentInRelated || checkRecentOutsideRelated) {
          recentlyViewedHolder.dispatchEvent(new CustomEvent('theme:tabs:check', {
            bubbles: true
          }));
        }
      }
    }]);
  }();
  var relatedSection = {
    onLoad: function onLoad() {
      this.section = new Related(this);
    }
  };
  register('related', [relatedSection, tabs, recentProducts]);
  if (!customElements.get('radio-swatch')) {
    customElements.define('radio-swatch', RadioSwatch);
  }
  if (!customElements.get('product-grid-item')) {
    customElements.define('product-grid-item', ProductGridItem);
  }
  if (!customElements.get('product-grid-item-content')) {
    customElements.define('product-grid-item-content', ProductGridItemContent);
  }
  var selectors$2 = {
    ajaxDisable: 'data-ajax-disable',
    shipping: '[data-shipping-estimate-form]',
    input: '[data-update-cart]',
    update: '[data-update-button]',
    bottom: '[data-cart-bottom]',
    upsellWrapper: '[data-cart-page-upsell-wrapper]'
  };
  var classes$2 = {
    dirty: 'cart--dirty',
    heartBeat: 'heart-beat'
  };
  var cartSection = {
    onLoad: function onLoad() {
      var _this148 = this;
      var hasShipping = this.container.querySelector(selectors$2.shipping);
      if (hasShipping) {
        new ShippingCalculator(this);
      }
      this.disabled = this.container.getAttribute(selectors$2.ajaxDisable) == 'true';
      if (this.disabled) {
        this.cart = new DisabledCart(this);
        return;
      }
      this.cart = new CartItems(this);
      var initPromise = this.cart.init();
      initPromise.then(function () {
        _this148.cart.loadHTML();
      });
    }
  };
  var DisabledCart = /*#__PURE__*/function () {
    function DisabledCart(section) {
      _classCallCheck(this, DisabledCart);
      window.theme.state.cartOpen = true;
      this.section = section;
      this.container = section.container;
      this.inputs = this.container.querySelectorAll(selectors$2.input);
      this.quantityWrappers = this.container.querySelectorAll(selectors$2.qty);
      this.updateBtn = this.container.querySelector(selectors$2.update);
      this.upsellWrapper = this.container.querySelector(selectors$2.upsellWrapper);
      this.initQuantity();
      this.initInputs();
      if (this.upsellWrapper) {
        this.moveUpsell();
      }
    }
    return _createClass(DisabledCart, [{
      key: "initQuantity",
      value: function initQuantity() {
        initQtySection(this.container);
      }
    }, {
      key: "moveUpsell",
      value: function moveUpsell() {
        var bottom = this.container.querySelector(selectors$2.bottom);
        bottom.insertBefore(this.upsellWrapper, bottom.firstChild);
      }
    }, {
      key: "initInputs",
      value: function initInputs() {
        var _this149 = this;
        this.inputs.forEach(function (input) {
          input.addEventListener('change', function () {
            this.updateBtn.classList.add(classes$2.dirty);
            this.updateBtn.classList.add(classes$2.heartBeat);
            setTimeout(function () {
              this.updateBtn.classList.remove(classes$2.heartBeat);
            }.bind(this), 1300);
          }.bind(_this149));
        });
      }
    }]);
  }();
  register('cart', [cartSection, accordion]);
  register('accordion-single', accordion);
  var fadeIn = function fadeIn(el, display) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    el.style.opacity = 0;
    el.style.display = display || 'block';
    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
      if (val === 1 && typeof callback === 'function') {
        callback();
      }
    })();
  };
  var fadeOut = function fadeOut(el) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    el.style.opacity = 1;
    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = 'none';
      } else {
        requestAnimationFrame(fade);
      }
      if (parseFloat(el.style.opacity) === 0 && typeof callback === 'function') {
        callback();
      }
    })();
  };
  var selectors$1 = {
    tracking: '[data-tracking-consent]',
    trackingAccept: '[data-confirm-cookies]',
    close: '[data-close-modal]',
    popupInner: '[data-popup-inner]',
    newsletterPopup: '[data-newsletter]',
    newsletterPopupHolder: '[data-newsletter-holder]',
    newsletterField: '[data-newsletter-field]',
    newsletterForm: '[data-newsletter-form]',
    promoPopup: '[data-promo-text]',
    delayAttribite: 'data-popup-delay',
    cookieNameAttribute: 'data-cookie-name',
    dataTargetReferrer: 'data-target-referrer'
  };
  var classes$1 = {
    hide: 'hide',
    hasValue: 'has-value',
    success: 'has-success',
    desktop: 'desktop',
    mobile: 'mobile'
  };
  var sections$1 = {};
  var PopupCookie = /*#__PURE__*/function () {
    function PopupCookie(name, value) {
      _classCallCheck(this, PopupCookie);
      this.configuration = {
        expires: null,
        // session cookie
        path: '/',
        domain: window.location.hostname
      };
      this.name = name;
      this.value = value;
    }
    return _createClass(PopupCookie, [{
      key: "write",
      value: function write() {
        var _this150 = this;
        var hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find(function (row) {
          return row.startsWith(_this150.name);
        });
        if (hasCookie || document.cookie.indexOf('; ') === -1) {
          document.cookie = "".concat(this.name, "=").concat(this.value, "; expires=").concat(this.configuration.expires, "; path=").concat(this.configuration.path, "; domain=").concat(this.configuration.domain);
        }
      }
    }, {
      key: "read",
      value: function read() {
        var _this151 = this;
        if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find(function (row) {
          return row.startsWith(_this151.name);
        })) {
          var returnCookie = document.cookie.split('; ').find(function (row) {
            return row.startsWith(_this151.name);
          }).split('=')[1];
          return returnCookie;
        } else return false;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        var _this152 = this;
        if (document.cookie.split('; ').find(function (row) {
          return row.startsWith(_this152.name);
        })) {
          document.cookie = "".concat(this.name, "=null; expires=").concat(this.configuration.expires, "; path=").concat(this.configuration.path, "; domain=").concat(this.configuration.domain);
        }
      }
    }]);
  }();
  var DelayShow = /*#__PURE__*/function () {
    function DelayShow(holder, element) {
      _classCallCheck(this, DelayShow);
      this.element = element;
      this.delay = holder.getAttribute(selectors$1.delayAttribite);
      if (this.delay === 'always') {
        this.always();
      }
      if (this.delay === 'delayed') {
        this.delayed();
      }
      if (this.delay === 'bottom') {
        this.bottom();
      }
      if (this.delay === 'idle') {
        this.idle();
      }
    }
    return _createClass(DelayShow, [{
      key: "always",
      value: function always() {
        fadeIn(this.element);
      }
    }, {
      key: "delayed",
      value: function delayed() {
        var _this153 = this;
        // Show popup after 10s
        setTimeout(function () {
          fadeIn(_this153.element);
        }, 10000);
      }

      // Scroll to the bottom of the page
    }, {
      key: "bottom",
      value: function bottom() {
        var _this154 = this;
        var raf;
        var _onScroll = function onScroll() {
          if (raf) {
            window.cancelAnimationFrame(raf);
          }
          raf = window.requestAnimationFrame(function () {
            window.requestIdleCallback(function () {
              if (Math.round(window.scrollY + window.innerHeight) >= Math.round(document.body.clientHeight)) {
                fadeIn(_this154.element);
                window.removeEventListener('scroll', _onScroll, {
                  passive: true
                });
              }
            }, {
              timeout: 300
            });
          });
        };
        window.addEventListener('scroll', _onScroll, {
          passive: true
        });
      }
    }, {
      key: "onScroll",
      value: function onScroll() {}

      // Idle for 1 min
    }, {
      key: "idle",
      value: function idle() {
        var _this155 = this;
        var timer = 0;
        var idleTime = 60000;
        var documentEvents = ['mousemove', 'mousedown', 'click', 'touchmove', 'touchstart', 'touchend', 'keydown', 'keypress'];
        var windowEvents = ['load', 'resize', 'scroll'];
        var startTimer = function startTimer() {
          timer = setTimeout(function () {
            timer = 0;
            fadeIn(_this155.element);
          }, idleTime);
          documentEvents.forEach(function (eventType) {
            document.addEventListener(eventType, _resetTimer);
          });
          windowEvents.forEach(function (eventType) {
            window.addEventListener(eventType, _resetTimer);
          });
        };
        var _resetTimer = function resetTimer() {
          if (timer) {
            clearTimeout(timer);
          }
          documentEvents.forEach(function (eventType) {
            document.removeEventListener(eventType, _resetTimer);
          });
          windowEvents.forEach(function (eventType) {
            window.removeEventListener(eventType, _resetTimer);
          });
          startTimer();
        };
        startTimer();
      }
    }]);
  }();
  var TargetReferrer = /*#__PURE__*/function () {
    function TargetReferrer(el) {
      _classCallCheck(this, TargetReferrer);
      this.el = el;
      this.locationPath = location.href;
      if (!this.el.hasAttribute(selectors$1.dataTargetReferrer)) {
        return;
      }
      this.init();
    }
    return _createClass(TargetReferrer, [{
      key: "init",
      value: function init() {
        if (this.locationPath.indexOf(this.el.getAttribute(selectors$1.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
          this.el.parentNode.removeChild(this.el);
        }
      }
    }]);
  }();
  var Tracking = /*#__PURE__*/function () {
    function Tracking(el) {
      var _this156 = this;
      _classCallCheck(this, Tracking);
      this.popup = el;
      this.modal = document.querySelector(selectors$1.tracking);
      this.modalInner = this.popup.querySelector(selectors$1.popupInner);
      this.close = this.modal.querySelector(selectors$1.close);
      this.acceptButton = this.modal.querySelector(selectors$1.trackingAccept);
      this.enable = this.modal.getAttribute('data-enable') === 'true';
      this.showPopup = false;
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1'
      }], function (error) {
        if (error) {
          throw error;
        }
        var userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        var userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
        _this156.showPopup = !userCanBeTracked && userTrackingConsent === 'no_interaction' && _this156.enable;
        if (window.Shopify.designMode) {
          _this156.showPopup = true;
        }
        _this156.init();
      });
    }
    return _createClass(Tracking, [{
      key: "init",
      value: function init() {
        if (this.showPopup) {
          fadeIn(this.modalInner);
        }
        this.clickEvents();
      }
    }, {
      key: "clickEvents",
      value: function clickEvents() {
        var _this157 = this;
        this.close.addEventListener('click', function (event) {
          event.preventDefault();
          window.Shopify.customerPrivacy.setTrackingConsent(false, function () {
            return fadeOut(_this157.modalInner);
          });
        });
        this.acceptButton.addEventListener('click', function (event) {
          event.preventDefault();
          window.Shopify.customerPrivacy.setTrackingConsent(true, function () {
            return fadeOut(_this157.modalInner);
          });
        });
        document.addEventListener('trackingConsentAccepted', function () {
          console.log('trackingConsentAccepted event fired');
        });
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        if (this.popup.contains(evt.target) && this.showPopup) {
          fadeIn(this.modalInner);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(evt) {
        if (this.popup.contains(evt.target)) {
          fadeOut(this.modalInner);
        }
      }
    }]);
  }();
  var PromoText = /*#__PURE__*/function () {
    function PromoText(el) {
      _classCallCheck(this, PromoText);
      this.popup = el;
      this.popupInner = this.popup.querySelector(selectors$1.popupInner);
      this.close = this.popup.querySelector(selectors$1.close);
      this.cookie = new PopupCookie(this.popup.getAttribute(selectors$1.cookieNameAttribute), 'user_has_closed');
      this.isTargeted = new TargetReferrer(this.popup);
      this.hasDeviceClass = '';
      this.init();
    }
    return _createClass(PromoText, [{
      key: "init",
      value: function init() {
        var cookieExists = this.cookie.read() !== false;
        if (!cookieExists || window.Shopify.designMode) {
          if (!window.Shopify.designMode) {
            new DelayShow(this.popup, this.popupInner);
          } else {
            fadeIn(this.popupInner);
          }
          this.clickEvents();
        }
      }
    }, {
      key: "clickEvents",
      value: function clickEvents() {
        var _this158 = this;
        this.close.addEventListener('click', function (event) {
          event.preventDefault();
          fadeOut(_this158.popupInner);
          _this158.cookie.write();
        });
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        if (this.popup.classList.contains(classes$1.mobile)) {
          this.hasDeviceClass = classes$1.mobile;
        }
        if (this.popup.classList.contains(classes$1.desktop)) {
          this.hasDeviceClass = classes$1.desktop;
        }
        if (this.hasDeviceClass !== '') {
          this.popup.classList.remove(this.hasDeviceClass);
        }
        if (this.popup.contains(evt.target)) {
          fadeIn(this.popupInner);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(evt) {
        if (this.popup.contains(evt.target)) {
          fadeOut(this.popupInner);
        }
        if (this.hasDeviceClass !== '') {
          this.popup.classList.add(this.hasDeviceClass);
        }
      }
    }]);
  }();
  var NewsletterPopup = /*#__PURE__*/function () {
    function NewsletterPopup(el) {
      _classCallCheck(this, NewsletterPopup);
      this.popup = el;
      this.popupInner = this.popup.querySelector(selectors$1.popupInner);
      this.holder = this.popup.querySelector(selectors$1.newsletterPopupHolder);
      this.close = this.popup.querySelector(selectors$1.close);
      this.newsletterField = this.popup.querySelector(selectors$1.newsletterField);
      this.cookie = new PopupCookie(this.popup.getAttribute(selectors$1.cookieNameAttribute), 'newsletter_is_closed');
      this.form = this.popup.querySelector(selectors$1.newsletterForm);
      this.isTargeted = new TargetReferrer(this.popup);
      this.init();
    }
    return _createClass(NewsletterPopup, [{
      key: "init",
      value: function init() {
        var cookieExists = this.cookie.read() !== false;
        if (!cookieExists || window.Shopify.designMode) {
          this.show();
          if (this.form.classList.contains(classes$1.success)) {
            this.checkForSuccess();
          }
        }
      }
    }, {
      key: "show",
      value: function show() {
        if (!window.Shopify.designMode) {
          new DelayShow(this.popup, this.popupInner);
        } else {
          fadeIn(this.popupInner);
        }
        this.inputField();
        this.closePopup();
      }
    }, {
      key: "checkForSuccess",
      value: function checkForSuccess() {
        fadeIn(this.popupInner);
        this.cookie.write();
      }
    }, {
      key: "closePopup",
      value: function closePopup() {
        var _this159 = this;
        this.close.addEventListener('click', function (event) {
          event.preventDefault();
          fadeOut(_this159.popupInner);
          _this159.cookie.write();
        });
      }
    }, {
      key: "inputField",
      value: function inputField() {
        var _this160 = this;
        this.newsletterField.addEventListener('input', function () {
          if (_this160.newsletterField.value !== '') {
            _this160.holder.classList.add(classes$1.hasValue, _this160.newsletterField.value !== '');
          }
        });
        this.newsletterField.addEventListener('focus', function () {
          if (_this160.newsletterField.value !== '') {
            _this160.holder.classList.add(classes$1.hasValue, _this160.newsletterField.value !== '');
          }
        });
        this.newsletterField.addEventListener('focusout', function () {
          setTimeout(function () {
            _this160.holder.classList.remove(classes$1.hasValue);
          }, 2000);
        });
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(evt) {
        if (this.popup.contains(evt.target)) {
          fadeIn(this.popupInner);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(evt) {
        if (this.popup.contains(evt.target)) {
          fadeOut(this.popupInner);
        }
      }
    }]);
  }();
  var popupSection = {
    onLoad: function onLoad() {
      var _this161 = this;
      sections$1[this.id] = [];
      var tracking = this.container.querySelectorAll(selectors$1.tracking);
      tracking.forEach(function (el) {
        sections$1[_this161.id].push(new Tracking(el));
      });
      var newsletterPopup = this.container.querySelectorAll(selectors$1.newsletterPopup);
      newsletterPopup.forEach(function (el) {
        sections$1[_this161.id].push(new NewsletterPopup(el));
      });
      var promoPopup = this.container.querySelectorAll(selectors$1.promoPopup);
      promoPopup.forEach(function (el) {
        sections$1[_this161.id].push(new PromoText(el));
      });
    },
    onBlockSelect: function onBlockSelect(evt) {
      sections$1[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(evt);
        }
      });
    },
    onBlockDeselect: function onBlockDeselect(evt) {
      sections$1[this.id].forEach(function (el) {
        if (typeof el.onBlockDeselect === 'function') {
          el.onBlockDeselect(evt);
        }
      });
    }
  };
  register('popups', [newsletterCheckForResultSection, popupSection]);
  register('tabs', tabs);
  var selectors = {
    dot: 'data-look-dot',
    productsHolder: 'data-products-holder',
    slider: '[data-carousel]',
    buttonClose: '[data-button-close-holder]',
    slideIndex: 'data-carousel-index',
    blockId: 'data-block-id',
    focusable: 'button'
  };
  var classes = {
    active: 'is-active',
    expand: 'is-expanded'
  };
  var sections = {};
  var Look = /*#__PURE__*/function () {
    function Look(section) {
      _classCallCheck(this, Look);
      this.section = section;
      this.container = this.section.container;
      this.dots = this.container.querySelectorAll("[".concat(selectors.dot, "]"));
      this.productsHolder = this.container.querySelector("[".concat(selectors.productsHolder, "]"));
      this.slider = this.container.querySelector(selectors.slider);
      this.buttonClose = this.container.querySelector(selectors.buttonClose);
      this.currentDot = this.container.querySelector("[".concat(selectors.dot, "].").concat(classes.active));
      this.hasDefaultOpen = Boolean(this.currentDot);
      this.init();
    }
    return _createClass(Look, [{
      key: "init",
      value: function init() {
        var _this162 = this;
        this.keyEvents = function (e) {
          return _this162.keyboardEventShowProductHolder(e);
        };
        this.keyCloseEvent = function (e) {
          return _this162.hideProductsHolder(e);
        };
        this.clickEventsDot = function (e) {
          return _this162.clickEventShowProductsHolder(e);
        };
        this.clickEventToClose = function (e) {
          return _this162.clickEventCloseProductsHolder(e);
        };
        this.toggleOnResize = function (e) {
          return debounce(_this162.onResize(e), 200);
        };
        this.initSlider();
        this.addEvents();
      }

      /**
       * Init slider and add event for select slide
       */
    }, {
      key: "initSlider",
      value: function initSlider() {
        var _this163 = this;
        if (!this.slider) {
          return;
        }
        this.carousel = Flickity.data(this.slider);
        this.carousel.options.wrapAround = true;
        this.carousel.options.freeScroll = false;
        this.carousel.resize();
        this.carousel.on('change', function (index) {
          _this163.currentDot = _this163.container.querySelector("[".concat(selectors.dot, "=\"").concat(index, "\"]"));
          _this163.currentDot.classList.add(classes.active);
          _this163.removeClassOnSiblingDots();
        });
      }

      /**
       * Add events
       */
    }, {
      key: "addEvents",
      value: function addEvents() {
        var _this164 = this;
        this.dots.forEach(function (dot) {
          dot.addEventListener('click', _this164.clickEventsDot);
          dot.addEventListener('keyup', _this164.keyEvents);
        });
        document.addEventListener('keyup', this.keyCloseEvent);
        document.addEventListener('theme:resize', this.toggleOnResize);
        if (this.buttonClose) {
          this.buttonClose.addEventListener('click', this.clickEventToClose);
        }
      }

      /**
       * Show products holder
       */
    }, {
      key: "showProductsHolder",
      value: function showProductsHolder() {
        var selectCellAnimate = !this.productsHolder.classList.contains(classes.expand);
        this.currentDot.classList.toggle(classes.active);
        this.productsHolder.classList.toggle(classes.expand, this.currentDot.classList.contains(classes.active));
        if (this.currentDot.classList.contains(classes.active)) {
          this.hasDefaultOpen = true;
          this.carousel.selectCell(Number(this.currentDot.getAttribute(selectors.dot)), true, selectCellAnimate);
        }
        this.removeClassOnSiblingDots();
      }

      /**
       * Hide products holder on keypress button 'escape'
       * @param {Object} e
       * @returns
       */
    }, {
      key: "hideProductsHolder",
      value: function hideProductsHolder(e) {
        if (e.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.removeClasses();
        removeTrapFocus();
        this.currentDot.focus();
      }

      /**
       * Remove classes on productsHolder and currentDot
       */
    }, {
      key: "removeClasses",
      value: function removeClasses() {
        this.productsHolder.classList.remove(classes.expand);
        this.currentDot.classList.remove(classes.active);
        this.hasDefaultOpen = false;
      }

      /**
       * Click event method for show products holder
       * @param {Object} e
       */
    }, {
      key: "clickEventShowProductsHolder",
      value: function clickEventShowProductsHolder(e) {
        this.currentDot = e.currentTarget;
        this.showProductsHolder();
      }

      /**
       * Click event method for hide products holder
       */
    }, {
      key: "clickEventCloseProductsHolder",
      value: function clickEventCloseProductsHolder() {
        this.removeClasses();
      }

      /**
       * Keyboard event method for show products holder and active trapfocus
       * @param {Object} e
       * @returns
       */
    }, {
      key: "keyboardEventShowProductHolder",
      value: function keyboardEventShowProductHolder(e) {
        var _this165 = this;
        if (e.which !== window.theme.keyboardKeys.ENTER && e.which !== window.theme.keyboardKeys.SPACE) {
          return;
        }
        setTimeout(function () {
          var firstFocus = _this165.productsHolder.querySelector(selectors.focusable);
          trapFocus(_this165.productsHolder, {
            elementToFocus: firstFocus
          });
        }, 400);
      }

      /**
       * Hide default expanded for mobile devices and show if exists for larger devices
       */
    }, {
      key: "onResize",
      value: function onResize() {
        if (this.currentDot) {
          if (window.innerWidth < window.theme.sizes.medium) {
            this.currentDot.classList.remove(classes.active);
            this.productsHolder.classList.remove(classes.expand);
          } else if (this.hasDefaultOpen) {
            this.currentDot.classList.add(classes.active);
            this.productsHolder.classList.add(classes.expand);
          }
        }
      }

      /**
       * Remove events
       */
    }, {
      key: "removeEvents",
      value: function removeEvents() {
        var _this166 = this;
        this.dots.forEach(function (dot) {
          dot.removeEventListener('click', _this166.clickEventsDot);
          dot.removeEventListener('keyup', _this166.keyEvents);
        });
        document.removeEventListener('keyup', this.keyCloseEvent);
        document.removeEventListener('theme:resize', this.toggleOnResize);
        if (this.buttonClose) {
          this.buttonClose.removeEventListener('click', this.clickEventToClose);
        }
      }

      /**
       * Remove active class on sibling dots
       */
    }, {
      key: "removeClassOnSiblingDots",
      value: function removeClassOnSiblingDots() {
        var _iterator6 = _createForOfIteratorHelper(this.currentDot.parentNode.children),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var sibling = _step6.value;
            if (sibling !== this.currentDot) {
              sibling.classList.remove(classes.active);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.slider && this.carousel) {
          this.carousel.destroy();
        }
        this.removeEvents();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(e) {
        if (this.slider && this.carousel) {
          var slide = this.container.querySelector("[".concat(selectors.blockId, "=\"").concat(e.detail.blockId, "\"]"));
          this.productsHolder.classList.add(classes.expand);
          this.carousel.selectCell(Number(slide.getAttribute(selectors.slideIndex)), true, true);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        if (window.innerWidth < window.theme.sizes.medium) {
          this.productsHolder.classList.remove(classes.expand);
          this.currentDot.classList.remove(classes.active);
        }
      }
    }]);
  }();
  var lookSection = {
    onLoad: function onLoad() {
      sections[this.id] = [];
      sections[this.id].push(new Look(this));
    },
    onUnload: function onUnload() {
      sections[this.id].forEach(function (el) {
        if (typeof el.onUnload === 'function') {
          el.onUnload();
        }
      });
    },
    onBlockSelect: function onBlockSelect(e) {
      sections[this.id].forEach(function (el) {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(e);
        }
      });
    },
    onBlockDeselect: function onBlockDeselect(e) {
      sections[this.id].forEach(function (el) {
        if (typeof el.onBlockDeselect === 'function') {
          el.onBlockDeselect(e);
        }
      });
    }
  };
  register('look', [lookSection]);
  var wrap = function wrap(toWrap) {
    var wrapperClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var wrapper = arguments.length > 2 ? arguments[2] : undefined;
    wrapper = wrapper || document.createElement('div');
    wrapper.classList.add(wrapperClass);
    toWrap.parentNode.insertBefore(wrapper, toWrap);
    return wrapper.appendChild(toWrap);
  };

  // Animate on scroll
  if (window.theme.settings.animate_scroll) {
    AOS.init({
      once: true
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    // Detect menu height early to prevent CLS
    var menuEl = document.querySelector('[data-header-height]');
    if (menuEl) {
      var menuHeight = menuEl.clientHeight || 0;
      document.documentElement.style.setProperty('--menu-height', "".concat(menuHeight, "px"));
    }

    // Load all registered sections on the page.
    load('*');

    // Animate on hover
    if (window.theme.settings.animate_hover) {
      document.body.classList.add('theme-animate-hover');
    }

    // When images load, clear the background color
    document.addEventListener('lazyloaded', function (event) {
      var lazyImage = event.target.parentNode;
      if (lazyImage.classList.contains('lazy-image')) {
        lazyImage.style.backgroundImage = 'none';
      }
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';
    var tables = document.querySelectorAll(tableSelectors);
    tables.forEach(function (table) {
      wrap(table, 'rte__table-wrapper');
    });

    // Target iframes to make them responsive
    var iframeSelectors = '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
    var frames = document.querySelectorAll(iframeSelectors);
    frames.forEach(function (frame) {
      wrap(frame, 'rte__video-wrapper');
    });
    document.addEventListener('mousedown', function () {
      document.body.classList.remove('focus-enabled');
    });
    document.addEventListener('keyup', function (event) {
      if (event.code === 'Tab') {
        document.body.classList.add('focus-enabled');
      }
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (window.navigator.cookieEnabled) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Common a11y fixes
    focusHash();
    bindInPageLinks();
    var hasNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    if (!hasNativeSmoothScroll) {
      loadScript({
        url: window.theme.assets.smoothscroll
      });
    }
  });
})(themeVendor.AOS, themeVendor.FlickityFade, themeVendor.BodyScrollLock, themeVendor.Flickity, themeVendor.Sqrl, themeVendor.MicroModal, themeVendor.axios, themeVendor.Rellax, themeVendor.themeCurrency, themeVendor.themeAddresses, themeVendor.FlickitySync);
/******/ })()
;